/**
 * vis-timeline and vis-graph2d
 * https://visjs.github.io/vis-timeline/
 *
 * Create a fully customizable, interactive timeline with items and ranges.
 *
 * @version 7.4.6
 * @date    2021-01-15T09:01:47.377Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).vis = t.vis || {});
}(this, function (t) {
  "use strict";

  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function i() {
    throw new Error("Dynamic requires are not currently supported by rollup-plugin-commonjs");
  }

  function n(t, e) {
    return t(e = {
      exports: {}
    }, e.exports), e.exports;
  }

  function o(t) {
    return t && t.default || t;
  }

  var r = n(function (t, e) {
    t.exports = function () {
      var e, n;

      function o() {
        return e.apply(null, arguments);
      }

      function r(t) {
        e = t;
      }

      function s(t) {
        return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t);
      }

      function a(t) {
        return null != t && "[object Object]" === Object.prototype.toString.call(t);
      }

      function l(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }

      function h(t) {
        if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
        var e;

        for (e in t) {
          if (l(t, e)) return !1;
        }

        return !0;
      }

      function u(t) {
        return void 0 === t;
      }

      function c(t) {
        return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t);
      }

      function d(t) {
        return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t);
      }

      function p(t, e) {
        var i,
            n = [];

        for (i = 0; i < t.length; ++i) {
          n.push(e(t[i], i));
        }

        return n;
      }

      function f(t, e) {
        for (var i in e) {
          l(e, i) && (t[i] = e[i]);
        }

        return l(e, "toString") && (t.toString = e.toString), l(e, "valueOf") && (t.valueOf = e.valueOf), t;
      }

      function m(t, e, i, n) {
        return Xi(t, e, i, n, !0).utc();
      }

      function v() {
        return {
          empty: !1,
          unusedTokens: [],
          unusedInput: [],
          overflow: -2,
          charsLeftOver: 0,
          nullInput: !1,
          invalidEra: null,
          invalidMonth: null,
          invalidFormat: !1,
          userInvalidated: !1,
          iso: !1,
          parsedDateParts: [],
          era: null,
          meridiem: null,
          rfc2822: !1,
          weekdayMismatch: !1
        };
      }

      function g(t) {
        return null == t._pf && (t._pf = v()), t._pf;
      }

      function y(t) {
        if (null == t._isValid) {
          var e = g(t),
              i = n.call(e.parsedDateParts, function (t) {
            return null != t;
          }),
              o = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && i);
          if (t._strict && (o = o && 0 === e.charsLeftOver && 0 === e.unusedTokens.length && void 0 === e.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return o;
          t._isValid = o;
        }

        return t._isValid;
      }

      function b(t) {
        var e = m(NaN);
        return null != t ? f(g(e), t) : g(e).userInvalidated = !0, e;
      }

      n = Array.prototype.some ? Array.prototype.some : function (t) {
        var e,
            i = Object(this),
            n = i.length >>> 0;

        for (e = 0; e < n; e++) {
          if (e in i && t.call(this, i[e], e, i)) return !0;
        }

        return !1;
      };

      var _ = o.momentProperties = [],
          w = !1;

      function k(t, e) {
        var i, n, o;
        if (u(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), u(e._i) || (t._i = e._i), u(e._f) || (t._f = e._f), u(e._l) || (t._l = e._l), u(e._strict) || (t._strict = e._strict), u(e._tzm) || (t._tzm = e._tzm), u(e._isUTC) || (t._isUTC = e._isUTC), u(e._offset) || (t._offset = e._offset), u(e._pf) || (t._pf = g(e)), u(e._locale) || (t._locale = e._locale), _.length > 0) for (i = 0; i < _.length; i++) {
          u(o = e[n = _[i]]) || (t[n] = o);
        }
        return t;
      }

      function x(t) {
        k(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === w && (w = !0, o.updateOffset(this), w = !1);
      }

      function D(t) {
        return t instanceof x || null != t && null != t._isAMomentObject;
      }

      function S(t) {
        !1 === o.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t);
      }

      function C(t, e) {
        var i = !0;
        return f(function () {
          if (null != o.deprecationHandler && o.deprecationHandler(null, t), i) {
            var n,
                r,
                s,
                a = [];

            for (r = 0; r < arguments.length; r++) {
              if (n = "", "object" == typeof arguments[r]) {
                for (s in n += "\n[" + r + "] ", arguments[0]) {
                  l(arguments[0], s) && (n += s + ": " + arguments[0][s] + ", ");
                }

                n = n.slice(0, -2);
              } else n = arguments[r];

              a.push(n);
            }

            S(t + "\nArguments: " + Array.prototype.slice.call(a).join("") + "\n" + new Error().stack), i = !1;
          }

          return e.apply(this, arguments);
        }, e);
      }

      var T,
          M = {};

      function O(t, e) {
        null != o.deprecationHandler && o.deprecationHandler(t, e), M[t] || (S(e), M[t] = !0);
      }

      function E(t) {
        return "undefined" != typeof Function && t instanceof Function || "[object Function]" === Object.prototype.toString.call(t);
      }

      function P(t) {
        var e, i;

        for (i in t) {
          l(t, i) && (E(e = t[i]) ? this[i] = e : this["_" + i] = e);
        }

        this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
      }

      function A(t, e) {
        var i,
            n = f({}, t);

        for (i in e) {
          l(e, i) && (a(t[i]) && a(e[i]) ? (n[i] = {}, f(n[i], t[i]), f(n[i], e[i])) : null != e[i] ? n[i] = e[i] : delete n[i]);
        }

        for (i in t) {
          l(t, i) && !l(e, i) && a(t[i]) && (n[i] = f({}, n[i]));
        }

        return n;
      }

      function L(t) {
        null != t && this.set(t);
      }

      o.suppressDeprecationWarnings = !1, o.deprecationHandler = null, T = Object.keys ? Object.keys : function (t) {
        var e,
            i = [];

        for (e in t) {
          l(t, e) && i.push(e);
        }

        return i;
      };
      var I = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      };

      function N(t, e, i) {
        var n = this._calendar[t] || this._calendar.sameElse;
        return E(n) ? n.call(e, i) : n;
      }

      function R(t, e, i) {
        var n = "" + Math.abs(t),
            o = e - n.length;
        return (t >= 0 ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + n;
      }

      var F = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
          Y = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
          j = {},
          H = {};

      function z(t, e, i, n) {
        var o = n;
        "string" == typeof n && (o = function o() {
          return this[n]();
        }), t && (H[t] = o), e && (H[e[0]] = function () {
          return R(o.apply(this, arguments), e[1], e[2]);
        }), i && (H[i] = function () {
          return this.localeData().ordinal(o.apply(this, arguments), t);
        });
      }

      function G(t) {
        return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
      }

      function W(t) {
        var e,
            i,
            n = t.match(F);

        for (e = 0, i = n.length; e < i; e++) {
          H[n[e]] ? n[e] = H[n[e]] : n[e] = G(n[e]);
        }

        return function (e) {
          var o,
              r = "";

          for (o = 0; o < i; o++) {
            r += E(n[o]) ? n[o].call(e, t) : n[o];
          }

          return r;
        };
      }

      function B(t, e) {
        return t.isValid() ? (e = V(e, t.localeData()), j[e] = j[e] || W(e), j[e](t)) : t.localeData().invalidDate();
      }

      function V(t, e) {
        var i = 5;

        function n(t) {
          return e.longDateFormat(t) || t;
        }

        for (Y.lastIndex = 0; i >= 0 && Y.test(t);) {
          t = t.replace(Y, n), Y.lastIndex = 0, i -= 1;
        }

        return t;
      }

      var U = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
      };

      function X(t) {
        var e = this._longDateFormat[t],
            i = this._longDateFormat[t.toUpperCase()];

        return e || !i ? e : (this._longDateFormat[t] = i.match(F).map(function (t) {
          return "MMMM" === t || "MM" === t || "DD" === t || "dddd" === t ? t.slice(1) : t;
        }).join(""), this._longDateFormat[t]);
      }

      var q = "Invalid date";

      function Z() {
        return this._invalidDate;
      }

      var $ = "%d",
          K = /\d{1,2}/;

      function J(t) {
        return this._ordinal.replace("%d", t);
      }

      var Q = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      };

      function tt(t, e, i, n) {
        var o = this._relativeTime[i];
        return E(o) ? o(t, e, i, n) : o.replace(/%d/i, t);
      }

      function et(t, e) {
        var i = this._relativeTime[t > 0 ? "future" : "past"];
        return E(i) ? i(e) : i.replace(/%s/i, e);
      }

      var it = {};

      function nt(t, e) {
        var i = t.toLowerCase();
        it[i] = it[i + "s"] = it[e] = t;
      }

      function ot(t) {
        return "string" == typeof t ? it[t] || it[t.toLowerCase()] : void 0;
      }

      function rt(t) {
        var e,
            i,
            n = {};

        for (i in t) {
          l(t, i) && (e = ot(i)) && (n[e] = t[i]);
        }

        return n;
      }

      var st = {};

      function at(t, e) {
        st[t] = e;
      }

      function lt(t) {
        var e,
            i = [];

        for (e in t) {
          l(t, e) && i.push({
            unit: e,
            priority: st[e]
          });
        }

        return i.sort(function (t, e) {
          return t.priority - e.priority;
        }), i;
      }

      function ht(t) {
        return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
      }

      function ut(t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      }

      function ct(t) {
        var e = +t,
            i = 0;
        return 0 !== e && isFinite(e) && (i = ut(e)), i;
      }

      function dt(t, e) {
        return function (i) {
          return null != i ? (ft(this, t, i), o.updateOffset(this, e), this) : pt(this, t);
        };
      }

      function pt(t, e) {
        return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN;
      }

      function ft(t, e, i) {
        t.isValid() && !isNaN(i) && ("FullYear" === e && ht(t.year()) && 1 === t.month() && 29 === t.date() ? (i = ct(i), t._d["set" + (t._isUTC ? "UTC" : "") + e](i, t.month(), te(i, t.month()))) : t._d["set" + (t._isUTC ? "UTC" : "") + e](i));
      }

      function mt(t) {
        return E(this[t = ot(t)]) ? this[t]() : this;
      }

      function vt(t, e) {
        if ("object" == typeof t) {
          var i,
              n = lt(t = rt(t));

          for (i = 0; i < n.length; i++) {
            this[n[i].unit](t[n[i].unit]);
          }
        } else if (E(this[t = ot(t)])) return this[t](e);

        return this;
      }

      var gt,
          yt = /\d/,
          bt = /\d\d/,
          _t = /\d{3}/,
          wt = /\d{4}/,
          kt = /[+-]?\d{6}/,
          xt = /\d\d?/,
          Dt = /\d\d\d\d?/,
          St = /\d\d\d\d\d\d?/,
          Ct = /\d{1,3}/,
          Tt = /\d{1,4}/,
          Mt = /[+-]?\d{1,6}/,
          Ot = /\d+/,
          Et = /[+-]?\d+/,
          Pt = /Z|[+-]\d\d:?\d\d/gi,
          At = /Z|[+-]\d\d(?::?\d\d)?/gi,
          Lt = /[+-]?\d+(\.\d{1,3})?/,
          It = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

      function Nt(t, e, i) {
        gt[t] = E(e) ? e : function (t, n) {
          return t && i ? i : e;
        };
      }

      function Rt(t, e) {
        return l(gt, t) ? gt[t](e._strict, e._locale) : new RegExp(Ft(t));
      }

      function Ft(t) {
        return Yt(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (t, e, i, n, o) {
          return e || i || n || o;
        }));
      }

      function Yt(t) {
        return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      gt = {};
      var jt = {};

      function Ht(t, e) {
        var i,
            n = e;

        for ("string" == typeof t && (t = [t]), c(e) && (n = function n(t, i) {
          i[e] = ct(t);
        }), i = 0; i < t.length; i++) {
          jt[t[i]] = n;
        }
      }

      function zt(t, e) {
        Ht(t, function (t, i, n, o) {
          n._w = n._w || {}, e(t, n._w, n, o);
        });
      }

      function Gt(t, e, i) {
        null != e && l(jt, t) && jt[t](e, i._a, i, t);
      }

      var Wt,
          Bt = 0,
          Vt = 1,
          Ut = 2,
          Xt = 3,
          qt = 4,
          Zt = 5,
          $t = 6,
          Kt = 7,
          Jt = 8;

      function Qt(t, e) {
        return (t % e + e) % e;
      }

      function te(t, e) {
        if (isNaN(t) || isNaN(e)) return NaN;
        var i = Qt(e, 12);
        return t += (e - i) / 12, 1 === i ? ht(t) ? 29 : 28 : 31 - i % 7 % 2;
      }

      Wt = Array.prototype.indexOf ? Array.prototype.indexOf : function (t) {
        var e;

        for (e = 0; e < this.length; ++e) {
          if (this[e] === t) return e;
        }

        return -1;
      }, z("M", ["MM", 2], "Mo", function () {
        return this.month() + 1;
      }), z("MMM", 0, 0, function (t) {
        return this.localeData().monthsShort(this, t);
      }), z("MMMM", 0, 0, function (t) {
        return this.localeData().months(this, t);
      }), nt("month", "M"), at("month", 8), Nt("M", xt), Nt("MM", xt, bt), Nt("MMM", function (t, e) {
        return e.monthsShortRegex(t);
      }), Nt("MMMM", function (t, e) {
        return e.monthsRegex(t);
      }), Ht(["M", "MM"], function (t, e) {
        e[Vt] = ct(t) - 1;
      }), Ht(["MMM", "MMMM"], function (t, e, i, n) {
        var o = i._locale.monthsParse(t, n, i._strict);

        null != o ? e[Vt] = o : g(i).invalidMonth = t;
      });
      var ee = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          ie = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          ne = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
          oe = It,
          re = It;

      function se(t, e) {
        return t ? s(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || ne).test(e) ? "format" : "standalone"][t.month()] : s(this._months) ? this._months : this._months.standalone;
      }

      function ae(t, e) {
        return t ? s(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[ne.test(e) ? "format" : "standalone"][t.month()] : s(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
      }

      function le(t, e, i) {
        var n,
            o,
            r,
            s = t.toLocaleLowerCase();
        if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n) {
          r = m([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(r, "").toLocaleLowerCase(), this._longMonthsParse[n] = this.months(r, "").toLocaleLowerCase();
        }
        return i ? "MMM" === e ? -1 !== (o = Wt.call(this._shortMonthsParse, s)) ? o : null : -1 !== (o = Wt.call(this._longMonthsParse, s)) ? o : null : "MMM" === e ? -1 !== (o = Wt.call(this._shortMonthsParse, s)) || -1 !== (o = Wt.call(this._longMonthsParse, s)) ? o : null : -1 !== (o = Wt.call(this._longMonthsParse, s)) || -1 !== (o = Wt.call(this._shortMonthsParse, s)) ? o : null;
      }

      function he(t, e, i) {
        var n, o, r;
        if (this._monthsParseExact) return le.call(this, t, e, i);

        for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
          if (o = m([2e3, n]), i && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp("^" + this.months(o, "").replace(".", "") + "$", "i"), this._shortMonthsParse[n] = new RegExp("^" + this.monthsShort(o, "").replace(".", "") + "$", "i")), i || this._monthsParse[n] || (r = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[n] = new RegExp(r.replace(".", ""), "i")), i && "MMMM" === e && this._longMonthsParse[n].test(t)) return n;
          if (i && "MMM" === e && this._shortMonthsParse[n].test(t)) return n;
          if (!i && this._monthsParse[n].test(t)) return n;
        }
      }

      function ue(t, e) {
        var i;
        if (!t.isValid()) return t;
        if ("string" == typeof e) if (/^\d+$/.test(e)) e = ct(e);else if (!c(e = t.localeData().monthsParse(e))) return t;
        return i = Math.min(t.date(), te(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i), t;
      }

      function ce(t) {
        return null != t ? (ue(this, t), o.updateOffset(this, !0), this) : pt(this, "Month");
      }

      function de() {
        return te(this.year(), this.month());
      }

      function pe(t) {
        return this._monthsParseExact ? (l(this, "_monthsRegex") || me.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (l(this, "_monthsShortRegex") || (this._monthsShortRegex = oe), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
      }

      function fe(t) {
        return this._monthsParseExact ? (l(this, "_monthsRegex") || me.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (l(this, "_monthsRegex") || (this._monthsRegex = re), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
      }

      function me() {
        function t(t, e) {
          return e.length - t.length;
        }

        var e,
            i,
            n = [],
            o = [],
            r = [];

        for (e = 0; e < 12; e++) {
          i = m([2e3, e]), n.push(this.monthsShort(i, "")), o.push(this.months(i, "")), r.push(this.months(i, "")), r.push(this.monthsShort(i, ""));
        }

        for (n.sort(t), o.sort(t), r.sort(t), e = 0; e < 12; e++) {
          n[e] = Yt(n[e]), o[e] = Yt(o[e]);
        }

        for (e = 0; e < 24; e++) {
          r[e] = Yt(r[e]);
        }

        this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + n.join("|") + ")", "i");
      }

      function ve(t) {
        return ht(t) ? 366 : 365;
      }

      z("Y", 0, 0, function () {
        var t = this.year();
        return t <= 9999 ? R(t, 4) : "+" + t;
      }), z(0, ["YY", 2], 0, function () {
        return this.year() % 100;
      }), z(0, ["YYYY", 4], 0, "year"), z(0, ["YYYYY", 5], 0, "year"), z(0, ["YYYYYY", 6, !0], 0, "year"), nt("year", "y"), at("year", 1), Nt("Y", Et), Nt("YY", xt, bt), Nt("YYYY", Tt, wt), Nt("YYYYY", Mt, kt), Nt("YYYYYY", Mt, kt), Ht(["YYYYY", "YYYYYY"], Bt), Ht("YYYY", function (t, e) {
        e[Bt] = 2 === t.length ? o.parseTwoDigitYear(t) : ct(t);
      }), Ht("YY", function (t, e) {
        e[Bt] = o.parseTwoDigitYear(t);
      }), Ht("Y", function (t, e) {
        e[Bt] = parseInt(t, 10);
      }), o.parseTwoDigitYear = function (t) {
        return ct(t) + (ct(t) > 68 ? 1900 : 2e3);
      };
      var ge = dt("FullYear", !0);

      function ye() {
        return ht(this.year());
      }

      function be(t, e, i, n, o, r, s) {
        var a;
        return t < 100 && t >= 0 ? (a = new Date(t + 400, e, i, n, o, r, s), isFinite(a.getFullYear()) && a.setFullYear(t)) : a = new Date(t, e, i, n, o, r, s), a;
      }

      function _e(t) {
        var e, i;
        return t < 100 && t >= 0 ? ((i = Array.prototype.slice.call(arguments))[0] = t + 400, e = new Date(Date.UTC.apply(null, i)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t)) : e = new Date(Date.UTC.apply(null, arguments)), e;
      }

      function we(t, e, i) {
        var n = 7 + e - i;
        return -(7 + _e(t, 0, n).getUTCDay() - e) % 7 + n - 1;
      }

      function ke(t, e, i, n, o) {
        var r,
            s,
            a = 1 + 7 * (e - 1) + (7 + i - n) % 7 + we(t, n, o);
        return a <= 0 ? s = ve(r = t - 1) + a : a > ve(t) ? (r = t + 1, s = a - ve(t)) : (r = t, s = a), {
          year: r,
          dayOfYear: s
        };
      }

      function xe(t, e, i) {
        var n,
            o,
            r = we(t.year(), e, i),
            s = Math.floor((t.dayOfYear() - r - 1) / 7) + 1;
        return s < 1 ? n = s + De(o = t.year() - 1, e, i) : s > De(t.year(), e, i) ? (n = s - De(t.year(), e, i), o = t.year() + 1) : (o = t.year(), n = s), {
          week: n,
          year: o
        };
      }

      function De(t, e, i) {
        var n = we(t, e, i),
            o = we(t + 1, e, i);
        return (ve(t) - n + o) / 7;
      }

      function Se(t) {
        return xe(t, this._week.dow, this._week.doy).week;
      }

      z("w", ["ww", 2], "wo", "week"), z("W", ["WW", 2], "Wo", "isoWeek"), nt("week", "w"), nt("isoWeek", "W"), at("week", 5), at("isoWeek", 5), Nt("w", xt), Nt("ww", xt, bt), Nt("W", xt), Nt("WW", xt, bt), zt(["w", "ww", "W", "WW"], function (t, e, i, n) {
        e[n.substr(0, 1)] = ct(t);
      });
      var Ce = {
        dow: 0,
        doy: 6
      };

      function Te() {
        return this._week.dow;
      }

      function Me() {
        return this._week.doy;
      }

      function Oe(t) {
        var e = this.localeData().week(this);
        return null == t ? e : this.add(7 * (t - e), "d");
      }

      function Ee(t) {
        var e = xe(this, 1, 4).week;
        return null == t ? e : this.add(7 * (t - e), "d");
      }

      function Pe(t, e) {
        return "string" != typeof t ? t : isNaN(t) ? "number" == typeof (t = e.weekdaysParse(t)) ? t : null : parseInt(t, 10);
      }

      function Ae(t, e) {
        return "string" == typeof t ? e.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t;
      }

      function Le(t, e) {
        return t.slice(e, 7).concat(t.slice(0, e));
      }

      z("d", 0, "do", "day"), z("dd", 0, 0, function (t) {
        return this.localeData().weekdaysMin(this, t);
      }), z("ddd", 0, 0, function (t) {
        return this.localeData().weekdaysShort(this, t);
      }), z("dddd", 0, 0, function (t) {
        return this.localeData().weekdays(this, t);
      }), z("e", 0, 0, "weekday"), z("E", 0, 0, "isoWeekday"), nt("day", "d"), nt("weekday", "e"), nt("isoWeekday", "E"), at("day", 11), at("weekday", 11), at("isoWeekday", 11), Nt("d", xt), Nt("e", xt), Nt("E", xt), Nt("dd", function (t, e) {
        return e.weekdaysMinRegex(t);
      }), Nt("ddd", function (t, e) {
        return e.weekdaysShortRegex(t);
      }), Nt("dddd", function (t, e) {
        return e.weekdaysRegex(t);
      }), zt(["dd", "ddd", "dddd"], function (t, e, i, n) {
        var o = i._locale.weekdaysParse(t, n, i._strict);

        null != o ? e.d = o : g(i).invalidWeekday = t;
      }), zt(["d", "e", "E"], function (t, e, i, n) {
        e[n] = ct(t);
      });
      var Ie = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          Ne = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          Re = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          Fe = It,
          Ye = It,
          je = It;

      function He(t, e) {
        var i = s(this._weekdays) ? this._weekdays : this._weekdays[t && !0 !== t && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
        return !0 === t ? Le(i, this._week.dow) : t ? i[t.day()] : i;
      }

      function ze(t) {
        return !0 === t ? Le(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
      }

      function Ge(t) {
        return !0 === t ? Le(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
      }

      function We(t, e, i) {
        var n,
            o,
            r,
            s = t.toLocaleLowerCase();
        if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n) {
          r = m([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(r, "").toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(r, "").toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(r, "").toLocaleLowerCase();
        }
        return i ? "dddd" === e ? -1 !== (o = Wt.call(this._weekdaysParse, s)) ? o : null : "ddd" === e ? -1 !== (o = Wt.call(this._shortWeekdaysParse, s)) ? o : null : -1 !== (o = Wt.call(this._minWeekdaysParse, s)) ? o : null : "dddd" === e ? -1 !== (o = Wt.call(this._weekdaysParse, s)) || -1 !== (o = Wt.call(this._shortWeekdaysParse, s)) || -1 !== (o = Wt.call(this._minWeekdaysParse, s)) ? o : null : "ddd" === e ? -1 !== (o = Wt.call(this._shortWeekdaysParse, s)) || -1 !== (o = Wt.call(this._weekdaysParse, s)) || -1 !== (o = Wt.call(this._minWeekdaysParse, s)) ? o : null : -1 !== (o = Wt.call(this._minWeekdaysParse, s)) || -1 !== (o = Wt.call(this._weekdaysParse, s)) || -1 !== (o = Wt.call(this._shortWeekdaysParse, s)) ? o : null;
      }

      function Be(t, e, i) {
        var n, o, r;
        if (this._weekdaysParseExact) return We.call(this, t, e, i);

        for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
          if (o = m([2e3, 1]).day(n), i && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp("^" + this.weekdays(o, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[n] = new RegExp("^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[n] = new RegExp("^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[n] || (r = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[n] = new RegExp(r.replace(".", ""), "i")), i && "dddd" === e && this._fullWeekdaysParse[n].test(t)) return n;
          if (i && "ddd" === e && this._shortWeekdaysParse[n].test(t)) return n;
          if (i && "dd" === e && this._minWeekdaysParse[n].test(t)) return n;
          if (!i && this._weekdaysParse[n].test(t)) return n;
        }
      }

      function Ve(t) {
        if (!this.isValid()) return null != t ? this : NaN;
        var e = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        return null != t ? (t = Pe(t, this.localeData()), this.add(t - e, "d")) : e;
      }

      function Ue(t) {
        if (!this.isValid()) return null != t ? this : NaN;
        var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return null == t ? e : this.add(t - e, "d");
      }

      function Xe(t) {
        if (!this.isValid()) return null != t ? this : NaN;

        if (null != t) {
          var e = Ae(t, this.localeData());
          return this.day(this.day() % 7 ? e : e - 7);
        }

        return this.day() || 7;
      }

      function qe(t) {
        return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || Ke.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (l(this, "_weekdaysRegex") || (this._weekdaysRegex = Fe), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
      }

      function Ze(t) {
        return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || Ke.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (l(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Ye), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
      }

      function $e(t) {
        return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || Ke.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (l(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = je), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
      }

      function Ke() {
        function t(t, e) {
          return e.length - t.length;
        }

        var e,
            i,
            n,
            o,
            r,
            s = [],
            a = [],
            l = [],
            h = [];

        for (e = 0; e < 7; e++) {
          i = m([2e3, 1]).day(e), n = Yt(this.weekdaysMin(i, "")), o = Yt(this.weekdaysShort(i, "")), r = Yt(this.weekdays(i, "")), s.push(n), a.push(o), l.push(r), h.push(n), h.push(o), h.push(r);
        }

        s.sort(t), a.sort(t), l.sort(t), h.sort(t), this._weekdaysRegex = new RegExp("^(" + h.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + s.join("|") + ")", "i");
      }

      function Je() {
        return this.hours() % 12 || 12;
      }

      function Qe() {
        return this.hours() || 24;
      }

      function ti(t, e) {
        z(t, 0, 0, function () {
          return this.localeData().meridiem(this.hours(), this.minutes(), e);
        });
      }

      function ei(t, e) {
        return e._meridiemParse;
      }

      function ii(t) {
        return "p" === (t + "").toLowerCase().charAt(0);
      }

      z("H", ["HH", 2], 0, "hour"), z("h", ["hh", 2], 0, Je), z("k", ["kk", 2], 0, Qe), z("hmm", 0, 0, function () {
        return "" + Je.apply(this) + R(this.minutes(), 2);
      }), z("hmmss", 0, 0, function () {
        return "" + Je.apply(this) + R(this.minutes(), 2) + R(this.seconds(), 2);
      }), z("Hmm", 0, 0, function () {
        return "" + this.hours() + R(this.minutes(), 2);
      }), z("Hmmss", 0, 0, function () {
        return "" + this.hours() + R(this.minutes(), 2) + R(this.seconds(), 2);
      }), ti("a", !0), ti("A", !1), nt("hour", "h"), at("hour", 13), Nt("a", ei), Nt("A", ei), Nt("H", xt), Nt("h", xt), Nt("k", xt), Nt("HH", xt, bt), Nt("hh", xt, bt), Nt("kk", xt, bt), Nt("hmm", Dt), Nt("hmmss", St), Nt("Hmm", Dt), Nt("Hmmss", St), Ht(["H", "HH"], Xt), Ht(["k", "kk"], function (t, e, i) {
        var n = ct(t);
        e[Xt] = 24 === n ? 0 : n;
      }), Ht(["a", "A"], function (t, e, i) {
        i._isPm = i._locale.isPM(t), i._meridiem = t;
      }), Ht(["h", "hh"], function (t, e, i) {
        e[Xt] = ct(t), g(i).bigHour = !0;
      }), Ht("hmm", function (t, e, i) {
        var n = t.length - 2;
        e[Xt] = ct(t.substr(0, n)), e[qt] = ct(t.substr(n)), g(i).bigHour = !0;
      }), Ht("hmmss", function (t, e, i) {
        var n = t.length - 4,
            o = t.length - 2;
        e[Xt] = ct(t.substr(0, n)), e[qt] = ct(t.substr(n, 2)), e[Zt] = ct(t.substr(o)), g(i).bigHour = !0;
      }), Ht("Hmm", function (t, e, i) {
        var n = t.length - 2;
        e[Xt] = ct(t.substr(0, n)), e[qt] = ct(t.substr(n));
      }), Ht("Hmmss", function (t, e, i) {
        var n = t.length - 4,
            o = t.length - 2;
        e[Xt] = ct(t.substr(0, n)), e[qt] = ct(t.substr(n, 2)), e[Zt] = ct(t.substr(o));
      });
      var ni = /[ap]\.?m?\.?/i,
          oi = dt("Hours", !0);

      function ri(t, e, i) {
        return t > 11 ? i ? "pm" : "PM" : i ? "am" : "AM";
      }

      var si,
          ai = {
        calendar: I,
        longDateFormat: U,
        invalidDate: q,
        ordinal: $,
        dayOfMonthOrdinalParse: K,
        relativeTime: Q,
        months: ee,
        monthsShort: ie,
        week: Ce,
        weekdays: Ie,
        weekdaysMin: Re,
        weekdaysShort: Ne,
        meridiemParse: ni
      },
          li = {},
          hi = {};

      function ui(t, e) {
        var i,
            n = Math.min(t.length, e.length);

        for (i = 0; i < n; i += 1) {
          if (t[i] !== e[i]) return i;
        }

        return n;
      }

      function ci(t) {
        return t ? t.toLowerCase().replace("_", "-") : t;
      }

      function di(t) {
        for (var e, i, n, o, r = 0; r < t.length;) {
          for (e = (o = ci(t[r]).split("-")).length, i = (i = ci(t[r + 1])) ? i.split("-") : null; e > 0;) {
            if (n = pi(o.slice(0, e).join("-"))) return n;
            if (i && i.length >= e && ui(o, i) >= e - 1) break;
            e--;
          }

          r++;
        }

        return si;
      }

      function pi(e) {
        var n = null;
        if (void 0 === li[e] && t && t.exports) try {
          n = si._abbr, i(), fi(n);
        } catch (t) {
          li[e] = null;
        }
        return li[e];
      }

      function fi(t, e) {
        var i;
        return t && ((i = u(e) ? gi(t) : mi(t, e)) ? si = i : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), si._abbr;
      }

      function mi(t, e) {
        if (null !== e) {
          var i,
              n = ai;
          if (e.abbr = t, null != li[t]) O("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), n = li[t]._config;else if (null != e.parentLocale) if (null != li[e.parentLocale]) n = li[e.parentLocale]._config;else {
            if (null == (i = pi(e.parentLocale))) return hi[e.parentLocale] || (hi[e.parentLocale] = []), hi[e.parentLocale].push({
              name: t,
              config: e
            }), null;
            n = i._config;
          }
          return li[t] = new L(A(n, e)), hi[t] && hi[t].forEach(function (t) {
            mi(t.name, t.config);
          }), fi(t), li[t];
        }

        return delete li[t], null;
      }

      function vi(t, e) {
        if (null != e) {
          var i,
              n,
              o = ai;
          null != li[t] && null != li[t].parentLocale ? li[t].set(A(li[t]._config, e)) : (null != (n = pi(t)) && (o = n._config), e = A(o, e), null == n && (e.abbr = t), (i = new L(e)).parentLocale = li[t], li[t] = i), fi(t);
        } else null != li[t] && (null != li[t].parentLocale ? (li[t] = li[t].parentLocale, t === fi() && fi(t)) : null != li[t] && delete li[t]);

        return li[t];
      }

      function gi(t) {
        var e;
        if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return si;

        if (!s(t)) {
          if (e = pi(t)) return e;
          t = [t];
        }

        return di(t);
      }

      function yi() {
        return T(li);
      }

      function bi(t) {
        var e,
            i = t._a;
        return i && -2 === g(t).overflow && (e = i[Vt] < 0 || i[Vt] > 11 ? Vt : i[Ut] < 1 || i[Ut] > te(i[Bt], i[Vt]) ? Ut : i[Xt] < 0 || i[Xt] > 24 || 24 === i[Xt] && (0 !== i[qt] || 0 !== i[Zt] || 0 !== i[$t]) ? Xt : i[qt] < 0 || i[qt] > 59 ? qt : i[Zt] < 0 || i[Zt] > 59 ? Zt : i[$t] < 0 || i[$t] > 999 ? $t : -1, g(t)._overflowDayOfYear && (e < Bt || e > Ut) && (e = Ut), g(t)._overflowWeeks && -1 === e && (e = Kt), g(t)._overflowWeekday && -1 === e && (e = Jt), g(t).overflow = e), t;
      }

      var _i = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
          wi = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
          ki = /Z|[+-]\d\d(?::?\d\d)?/,
          xi = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/], ["YYYYMM", /\d{6}/, !1], ["YYYY", /\d{4}/, !1]],
          Di = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
          Si = /^\/?Date\((-?\d+)/i,
          Ci = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
          Ti = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
      };

      function Mi(t) {
        var e,
            i,
            n,
            o,
            r,
            s,
            a = t._i,
            l = _i.exec(a) || wi.exec(a);

        if (l) {
          for (g(t).iso = !0, e = 0, i = xi.length; e < i; e++) {
            if (xi[e][1].exec(l[1])) {
              o = xi[e][0], n = !1 !== xi[e][2];
              break;
            }
          }

          if (null == o) return void (t._isValid = !1);

          if (l[3]) {
            for (e = 0, i = Di.length; e < i; e++) {
              if (Di[e][1].exec(l[3])) {
                r = (l[2] || " ") + Di[e][0];
                break;
              }
            }

            if (null == r) return void (t._isValid = !1);
          }

          if (!n && null != r) return void (t._isValid = !1);

          if (l[4]) {
            if (!ki.exec(l[4])) return void (t._isValid = !1);
            s = "Z";
          }

          t._f = o + (r || "") + (s || ""), Hi(t);
        } else t._isValid = !1;
      }

      function Oi(t, e, i, n, o, r) {
        var s = [Ei(t), ie.indexOf(e), parseInt(i, 10), parseInt(n, 10), parseInt(o, 10)];
        return r && s.push(parseInt(r, 10)), s;
      }

      function Ei(t) {
        var e = parseInt(t, 10);
        return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
      }

      function Pi(t) {
        return t.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
      }

      function Ai(t, e, i) {
        return !t || Ne.indexOf(t) === new Date(e[0], e[1], e[2]).getDay() || (g(i).weekdayMismatch = !0, i._isValid = !1, !1);
      }

      function Li(t, e, i) {
        if (t) return Ti[t];
        if (e) return 0;
        var n = parseInt(i, 10),
            o = n % 100;
        return (n - o) / 100 * 60 + o;
      }

      function Ii(t) {
        var e,
            i = Ci.exec(Pi(t._i));

        if (i) {
          if (e = Oi(i[4], i[3], i[2], i[5], i[6], i[7]), !Ai(i[1], e, t)) return;
          t._a = e, t._tzm = Li(i[8], i[9], i[10]), t._d = _e.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), g(t).rfc2822 = !0;
        } else t._isValid = !1;
      }

      function Ni(t) {
        var e = Si.exec(t._i);
        null === e ? (Mi(t), !1 === t._isValid && (delete t._isValid, Ii(t), !1 === t._isValid && (delete t._isValid, t._strict ? t._isValid = !1 : o.createFromInputFallback(t)))) : t._d = new Date(+e[1]);
      }

      function Ri(t, e, i) {
        return null != t ? t : null != e ? e : i;
      }

      function Fi(t) {
        var e = new Date(o.now());
        return t._useUTC ? [e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()] : [e.getFullYear(), e.getMonth(), e.getDate()];
      }

      function Yi(t) {
        var e,
            i,
            n,
            o,
            r,
            s = [];

        if (!t._d) {
          for (n = Fi(t), t._w && null == t._a[Ut] && null == t._a[Vt] && ji(t), null != t._dayOfYear && (r = Ri(t._a[Bt], n[Bt]), (t._dayOfYear > ve(r) || 0 === t._dayOfYear) && (g(t)._overflowDayOfYear = !0), i = _e(r, 0, t._dayOfYear), t._a[Vt] = i.getUTCMonth(), t._a[Ut] = i.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) {
            t._a[e] = s[e] = n[e];
          }

          for (; e < 7; e++) {
            t._a[e] = s[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
          }

          24 === t._a[Xt] && 0 === t._a[qt] && 0 === t._a[Zt] && 0 === t._a[$t] && (t._nextDay = !0, t._a[Xt] = 0), t._d = (t._useUTC ? _e : be).apply(null, s), o = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[Xt] = 24), t._w && void 0 !== t._w.d && t._w.d !== o && (g(t).weekdayMismatch = !0);
        }
      }

      function ji(t) {
        var e, i, n, o, r, s, a, l, h;
        null != (e = t._w).GG || null != e.W || null != e.E ? (r = 1, s = 4, i = Ri(e.GG, t._a[Bt], xe(qi(), 1, 4).year), n = Ri(e.W, 1), ((o = Ri(e.E, 1)) < 1 || o > 7) && (l = !0)) : (r = t._locale._week.dow, s = t._locale._week.doy, h = xe(qi(), r, s), i = Ri(e.gg, t._a[Bt], h.year), n = Ri(e.w, h.week), null != e.d ? ((o = e.d) < 0 || o > 6) && (l = !0) : null != e.e ? (o = e.e + r, (e.e < 0 || e.e > 6) && (l = !0)) : o = r), n < 1 || n > De(i, r, s) ? g(t)._overflowWeeks = !0 : null != l ? g(t)._overflowWeekday = !0 : (a = ke(i, n, o, r, s), t._a[Bt] = a.year, t._dayOfYear = a.dayOfYear);
      }

      function Hi(t) {
        if (t._f !== o.ISO_8601) {
          if (t._f !== o.RFC_2822) {
            t._a = [], g(t).empty = !0;
            var e,
                i,
                n,
                r,
                s,
                a,
                l = "" + t._i,
                h = l.length,
                u = 0;

            for (n = V(t._f, t._locale).match(F) || [], e = 0; e < n.length; e++) {
              r = n[e], (i = (l.match(Rt(r, t)) || [])[0]) && ((s = l.substr(0, l.indexOf(i))).length > 0 && g(t).unusedInput.push(s), l = l.slice(l.indexOf(i) + i.length), u += i.length), H[r] ? (i ? g(t).empty = !1 : g(t).unusedTokens.push(r), Gt(r, i, t)) : t._strict && !i && g(t).unusedTokens.push(r);
            }

            g(t).charsLeftOver = h - u, l.length > 0 && g(t).unusedInput.push(l), t._a[Xt] <= 12 && !0 === g(t).bigHour && t._a[Xt] > 0 && (g(t).bigHour = void 0), g(t).parsedDateParts = t._a.slice(0), g(t).meridiem = t._meridiem, t._a[Xt] = zi(t._locale, t._a[Xt], t._meridiem), null !== (a = g(t).era) && (t._a[Bt] = t._locale.erasConvertYear(a, t._a[Bt])), Yi(t), bi(t);
          } else Ii(t);
        } else Mi(t);
      }

      function zi(t, e, i) {
        var n;
        return null == i ? e : null != t.meridiemHour ? t.meridiemHour(e, i) : null != t.isPM ? ((n = t.isPM(i)) && e < 12 && (e += 12), n || 12 !== e || (e = 0), e) : e;
      }

      function Gi(t) {
        var e,
            i,
            n,
            o,
            r,
            s,
            a = !1;
        if (0 === t._f.length) return g(t).invalidFormat = !0, void (t._d = new Date(NaN));

        for (o = 0; o < t._f.length; o++) {
          r = 0, s = !1, e = k({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[o], Hi(e), y(e) && (s = !0), r += g(e).charsLeftOver, r += 10 * g(e).unusedTokens.length, g(e).score = r, a ? r < n && (n = r, i = e) : (null == n || r < n || s) && (n = r, i = e, s && (a = !0));
        }

        f(t, i || e);
      }

      function Wi(t) {
        if (!t._d) {
          var e = rt(t._i),
              i = void 0 === e.day ? e.date : e.day;
          t._a = p([e.year, e.month, i, e.hour, e.minute, e.second, e.millisecond], function (t) {
            return t && parseInt(t, 10);
          }), Yi(t);
        }
      }

      function Bi(t) {
        var e = new x(bi(Vi(t)));
        return e._nextDay && (e.add(1, "d"), e._nextDay = void 0), e;
      }

      function Vi(t) {
        var e = t._i,
            i = t._f;
        return t._locale = t._locale || gi(t._l), null === e || void 0 === i && "" === e ? b({
          nullInput: !0
        }) : ("string" == typeof e && (t._i = e = t._locale.preparse(e)), D(e) ? new x(bi(e)) : (d(e) ? t._d = e : s(i) ? Gi(t) : i ? Hi(t) : Ui(t), y(t) || (t._d = null), t));
      }

      function Ui(t) {
        var e = t._i;
        u(e) ? t._d = new Date(o.now()) : d(e) ? t._d = new Date(e.valueOf()) : "string" == typeof e ? Ni(t) : s(e) ? (t._a = p(e.slice(0), function (t) {
          return parseInt(t, 10);
        }), Yi(t)) : a(e) ? Wi(t) : c(e) ? t._d = new Date(e) : o.createFromInputFallback(t);
      }

      function Xi(t, e, i, n, o) {
        var r = {};
        return !0 !== e && !1 !== e || (n = e, e = void 0), !0 !== i && !1 !== i || (n = i, i = void 0), (a(t) && h(t) || s(t) && 0 === t.length) && (t = void 0), r._isAMomentObject = !0, r._useUTC = r._isUTC = o, r._l = i, r._i = t, r._f = e, r._strict = n, Bi(r);
      }

      function qi(t, e, i, n) {
        return Xi(t, e, i, n, !1);
      }

      o.createFromInputFallback = C("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (t) {
        t._d = new Date(t._i + (t._useUTC ? " UTC" : ""));
      }), o.ISO_8601 = function () {}, o.RFC_2822 = function () {};
      var Zi = C("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
        var t = qi.apply(null, arguments);
        return this.isValid() && t.isValid() ? t < this ? this : t : b();
      }),
          $i = C("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
        var t = qi.apply(null, arguments);
        return this.isValid() && t.isValid() ? t > this ? this : t : b();
      });

      function Ki(t, e) {
        var i, n;
        if (1 === e.length && s(e[0]) && (e = e[0]), !e.length) return qi();

        for (i = e[0], n = 1; n < e.length; ++n) {
          e[n].isValid() && !e[n][t](i) || (i = e[n]);
        }

        return i;
      }

      function Ji() {
        return Ki("isBefore", [].slice.call(arguments, 0));
      }

      function Qi() {
        return Ki("isAfter", [].slice.call(arguments, 0));
      }

      var tn = function tn() {
        return Date.now ? Date.now() : +new Date();
      },
          en = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

      function nn(t) {
        var e,
            i,
            n = !1;

        for (e in t) {
          if (l(t, e) && (-1 === Wt.call(en, e) || null != t[e] && isNaN(t[e]))) return !1;
        }

        for (i = 0; i < en.length; ++i) {
          if (t[en[i]]) {
            if (n) return !1;
            parseFloat(t[en[i]]) !== ct(t[en[i]]) && (n = !0);
          }
        }

        return !0;
      }

      function on() {
        return this._isValid;
      }

      function rn() {
        return Mn(NaN);
      }

      function sn(t) {
        var e = rt(t),
            i = e.year || 0,
            n = e.quarter || 0,
            o = e.month || 0,
            r = e.week || e.isoWeek || 0,
            s = e.day || 0,
            a = e.hour || 0,
            l = e.minute || 0,
            h = e.second || 0,
            u = e.millisecond || 0;
        this._isValid = nn(e), this._milliseconds = +u + 1e3 * h + 6e4 * l + 1e3 * a * 60 * 60, this._days = +s + 7 * r, this._months = +o + 3 * n + 12 * i, this._data = {}, this._locale = gi(), this._bubble();
      }

      function an(t) {
        return t instanceof sn;
      }

      function ln(t) {
        return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t);
      }

      function hn(t, e, i) {
        var n,
            o = Math.min(t.length, e.length),
            r = Math.abs(t.length - e.length),
            s = 0;

        for (n = 0; n < o; n++) {
          (i && t[n] !== e[n] || !i && ct(t[n]) !== ct(e[n])) && s++;
        }

        return s + r;
      }

      function un(t, e) {
        z(t, 0, 0, function () {
          var t = this.utcOffset(),
              i = "+";
          return t < 0 && (t = -t, i = "-"), i + R(~~(t / 60), 2) + e + R(~~t % 60, 2);
        });
      }

      un("Z", ":"), un("ZZ", ""), Nt("Z", At), Nt("ZZ", At), Ht(["Z", "ZZ"], function (t, e, i) {
        i._useUTC = !0, i._tzm = dn(At, t);
      });
      var cn = /([\+\-]|\d\d)/gi;

      function dn(t, e) {
        var i,
            n,
            o = (e || "").match(t);
        return null === o ? null : 0 === (n = 60 * (i = ((o[o.length - 1] || []) + "").match(cn) || ["-", 0, 0])[1] + ct(i[2])) ? 0 : "+" === i[0] ? n : -n;
      }

      function pn(t, e) {
        var i, n;
        return e._isUTC ? (i = e.clone(), n = (D(t) || d(t) ? t.valueOf() : qi(t).valueOf()) - i.valueOf(), i._d.setTime(i._d.valueOf() + n), o.updateOffset(i, !1), i) : qi(t).local();
      }

      function fn(t) {
        return -Math.round(t._d.getTimezoneOffset());
      }

      function mn(t, e, i) {
        var n,
            r = this._offset || 0;
        if (!this.isValid()) return null != t ? this : NaN;

        if (null != t) {
          if ("string" == typeof t) {
            if (null === (t = dn(At, t))) return this;
          } else Math.abs(t) < 16 && !i && (t *= 60);

          return !this._isUTC && e && (n = fn(this)), this._offset = t, this._isUTC = !0, null != n && this.add(n, "m"), r !== t && (!e || this._changeInProgress ? Ln(this, Mn(t - r, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, o.updateOffset(this, !0), this._changeInProgress = null)), this;
        }

        return this._isUTC ? r : fn(this);
      }

      function vn(t, e) {
        return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset();
      }

      function gn(t) {
        return this.utcOffset(0, t);
      }

      function yn(t) {
        return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(fn(this), "m")), this;
      }

      function bn() {
        if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
          var t = dn(Pt, this._i);
          null != t ? this.utcOffset(t) : this.utcOffset(0, !0);
        }
        return this;
      }

      function _n(t) {
        return !!this.isValid() && (t = t ? qi(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0);
      }

      function wn() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
      }

      function kn() {
        if (!u(this._isDSTShifted)) return this._isDSTShifted;
        var t,
            e = {};
        return k(e, this), (e = Vi(e))._a ? (t = e._isUTC ? m(e._a) : qi(e._a), this._isDSTShifted = this.isValid() && hn(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
      }

      function xn() {
        return !!this.isValid() && !this._isUTC;
      }

      function Dn() {
        return !!this.isValid() && this._isUTC;
      }

      function Sn() {
        return !!this.isValid() && this._isUTC && 0 === this._offset;
      }

      o.updateOffset = function () {};

      var Cn = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
          Tn = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

      function Mn(t, e) {
        var i,
            n,
            o,
            r = t,
            s = null;
        return an(t) ? r = {
          ms: t._milliseconds,
          d: t._days,
          M: t._months
        } : c(t) || !isNaN(+t) ? (r = {}, e ? r[e] = +t : r.milliseconds = +t) : (s = Cn.exec(t)) ? (i = "-" === s[1] ? -1 : 1, r = {
          y: 0,
          d: ct(s[Ut]) * i,
          h: ct(s[Xt]) * i,
          m: ct(s[qt]) * i,
          s: ct(s[Zt]) * i,
          ms: ct(ln(1e3 * s[$t])) * i
        }) : (s = Tn.exec(t)) ? (i = "-" === s[1] ? -1 : 1, r = {
          y: On(s[2], i),
          M: On(s[3], i),
          w: On(s[4], i),
          d: On(s[5], i),
          h: On(s[6], i),
          m: On(s[7], i),
          s: On(s[8], i)
        }) : null == r ? r = {} : "object" == typeof r && ("from" in r || "to" in r) && (o = Pn(qi(r.from), qi(r.to)), (r = {}).ms = o.milliseconds, r.M = o.months), n = new sn(r), an(t) && l(t, "_locale") && (n._locale = t._locale), an(t) && l(t, "_isValid") && (n._isValid = t._isValid), n;
      }

      function On(t, e) {
        var i = t && parseFloat(t.replace(",", "."));
        return (isNaN(i) ? 0 : i) * e;
      }

      function En(t, e) {
        var i = {};
        return i.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(i.months, "M").isAfter(e) && --i.months, i.milliseconds = +e - +t.clone().add(i.months, "M"), i;
      }

      function Pn(t, e) {
        var i;
        return t.isValid() && e.isValid() ? (e = pn(e, t), t.isBefore(e) ? i = En(t, e) : ((i = En(e, t)).milliseconds = -i.milliseconds, i.months = -i.months), i) : {
          milliseconds: 0,
          months: 0
        };
      }

      function An(t, e) {
        return function (i, n) {
          var o;
          return null === n || isNaN(+n) || (O(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), o = i, i = n, n = o), Ln(this, Mn(i, n), t), this;
        };
      }

      function Ln(t, e, i, n) {
        var r = e._milliseconds,
            s = ln(e._days),
            a = ln(e._months);
        t.isValid() && (n = null == n || n, a && ue(t, pt(t, "Month") + a * i), s && ft(t, "Date", pt(t, "Date") + s * i), r && t._d.setTime(t._d.valueOf() + r * i), n && o.updateOffset(t, s || a));
      }

      Mn.fn = sn.prototype, Mn.invalid = rn;
      var In = An(1, "add"),
          Nn = An(-1, "subtract");

      function Rn(t) {
        return "string" == typeof t || t instanceof String;
      }

      function Fn(t) {
        return D(t) || d(t) || Rn(t) || c(t) || jn(t) || Yn(t) || null == t;
      }

      function Yn(t) {
        var e,
            i,
            n = a(t) && !h(t),
            o = !1,
            r = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"];

        for (e = 0; e < r.length; e += 1) {
          i = r[e], o = o || l(t, i);
        }

        return n && o;
      }

      function jn(t) {
        var e = s(t),
            i = !1;
        return e && (i = 0 === t.filter(function (e) {
          return !c(e) && Rn(t);
        }).length), e && i;
      }

      function Hn(t) {
        var e,
            i,
            n = a(t) && !h(t),
            o = !1,
            r = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];

        for (e = 0; e < r.length; e += 1) {
          i = r[e], o = o || l(t, i);
        }

        return n && o;
      }

      function zn(t, e) {
        var i = t.diff(e, "days", !0);
        return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse";
      }

      function Gn(t, e) {
        1 === arguments.length && (arguments[0] ? Fn(arguments[0]) ? (t = arguments[0], e = void 0) : Hn(arguments[0]) && (e = arguments[0], t = void 0) : (t = void 0, e = void 0));
        var i = t || qi(),
            n = pn(i, this).startOf("day"),
            r = o.calendarFormat(this, n) || "sameElse",
            s = e && (E(e[r]) ? e[r].call(this, i) : e[r]);
        return this.format(s || this.localeData().calendar(r, this, qi(i)));
      }

      function Wn() {
        return new x(this);
      }

      function Bn(t, e) {
        var i = D(t) ? t : qi(t);
        return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = ot(e) || "millisecond") ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf());
      }

      function Vn(t, e) {
        var i = D(t) ? t : qi(t);
        return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = ot(e) || "millisecond") ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf());
      }

      function Un(t, e, i, n) {
        var o = D(t) ? t : qi(t),
            r = D(e) ? e : qi(e);
        return !!(this.isValid() && o.isValid() && r.isValid()) && ("(" === (n = n || "()")[0] ? this.isAfter(o, i) : !this.isBefore(o, i)) && (")" === n[1] ? this.isBefore(r, i) : !this.isAfter(r, i));
      }

      function Xn(t, e) {
        var i,
            n = D(t) ? t : qi(t);
        return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = ot(e) || "millisecond") ? this.valueOf() === n.valueOf() : (i = n.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()));
      }

      function qn(t, e) {
        return this.isSame(t, e) || this.isAfter(t, e);
      }

      function Zn(t, e) {
        return this.isSame(t, e) || this.isBefore(t, e);
      }

      function $n(t, e, i) {
        var n, o, r;
        if (!this.isValid()) return NaN;
        if (!(n = pn(t, this)).isValid()) return NaN;

        switch (o = 6e4 * (n.utcOffset() - this.utcOffset()), e = ot(e)) {
          case "year":
            r = Kn(this, n) / 12;
            break;

          case "month":
            r = Kn(this, n);
            break;

          case "quarter":
            r = Kn(this, n) / 3;
            break;

          case "second":
            r = (this - n) / 1e3;
            break;

          case "minute":
            r = (this - n) / 6e4;
            break;

          case "hour":
            r = (this - n) / 36e5;
            break;

          case "day":
            r = (this - n - o) / 864e5;
            break;

          case "week":
            r = (this - n - o) / 6048e5;
            break;

          default:
            r = this - n;
        }

        return i ? r : ut(r);
      }

      function Kn(t, e) {
        if (t.date() < e.date()) return -Kn(e, t);
        var i = 12 * (e.year() - t.year()) + (e.month() - t.month()),
            n = t.clone().add(i, "months");
        return -(i + (e - n < 0 ? (e - n) / (n - t.clone().add(i - 1, "months")) : (e - n) / (t.clone().add(i + 1, "months") - n))) || 0;
      }

      function Jn() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
      }

      function Qn(t) {
        if (!this.isValid()) return null;
        var e = !0 !== t,
            i = e ? this.clone().utc() : this;
        return i.year() < 0 || i.year() > 9999 ? B(i, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : E(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", B(i, "Z")) : B(i, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
      }

      function to() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var t,
            e,
            i,
            n,
            o = "moment",
            r = "";
        return this.isLocal() || (o = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", r = "Z"), t = "[" + o + '("]', e = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", n = r + '[")]', this.format(t + e + i + n);
      }

      function eo(t) {
        t || (t = this.isUtc() ? o.defaultFormatUtc : o.defaultFormat);
        var e = B(this, t);
        return this.localeData().postformat(e);
      }

      function io(t, e) {
        return this.isValid() && (D(t) && t.isValid() || qi(t).isValid()) ? Mn({
          to: this,
          from: t
        }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
      }

      function no(t) {
        return this.from(qi(), t);
      }

      function oo(t, e) {
        return this.isValid() && (D(t) && t.isValid() || qi(t).isValid()) ? Mn({
          from: this,
          to: t
        }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
      }

      function ro(t) {
        return this.to(qi(), t);
      }

      function so(t) {
        var e;
        return void 0 === t ? this._locale._abbr : (null != (e = gi(t)) && (this._locale = e), this);
      }

      o.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", o.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
      var ao = C("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (t) {
        return void 0 === t ? this.localeData() : this.locale(t);
      });

      function lo() {
        return this._locale;
      }

      var ho = 1e3,
          uo = 60 * ho,
          co = 60 * uo,
          po = 3506328 * co;

      function fo(t, e) {
        return (t % e + e) % e;
      }

      function mo(t, e, i) {
        return t < 100 && t >= 0 ? new Date(t + 400, e, i) - po : new Date(t, e, i).valueOf();
      }

      function vo(t, e, i) {
        return t < 100 && t >= 0 ? Date.UTC(t + 400, e, i) - po : Date.UTC(t, e, i);
      }

      function go(t) {
        var e, i;
        if (void 0 === (t = ot(t)) || "millisecond" === t || !this.isValid()) return this;

        switch (i = this._isUTC ? vo : mo, t) {
          case "year":
            e = i(this.year(), 0, 1);
            break;

          case "quarter":
            e = i(this.year(), this.month() - this.month() % 3, 1);
            break;

          case "month":
            e = i(this.year(), this.month(), 1);
            break;

          case "week":
            e = i(this.year(), this.month(), this.date() - this.weekday());
            break;

          case "isoWeek":
            e = i(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
            break;

          case "day":
          case "date":
            e = i(this.year(), this.month(), this.date());
            break;

          case "hour":
            e = this._d.valueOf(), e -= fo(e + (this._isUTC ? 0 : this.utcOffset() * uo), co);
            break;

          case "minute":
            e = this._d.valueOf(), e -= fo(e, uo);
            break;

          case "second":
            e = this._d.valueOf(), e -= fo(e, ho);
        }

        return this._d.setTime(e), o.updateOffset(this, !0), this;
      }

      function yo(t) {
        var e, i;
        if (void 0 === (t = ot(t)) || "millisecond" === t || !this.isValid()) return this;

        switch (i = this._isUTC ? vo : mo, t) {
          case "year":
            e = i(this.year() + 1, 0, 1) - 1;
            break;

          case "quarter":
            e = i(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
            break;

          case "month":
            e = i(this.year(), this.month() + 1, 1) - 1;
            break;

          case "week":
            e = i(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
            break;

          case "isoWeek":
            e = i(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
            break;

          case "day":
          case "date":
            e = i(this.year(), this.month(), this.date() + 1) - 1;
            break;

          case "hour":
            e = this._d.valueOf(), e += co - fo(e + (this._isUTC ? 0 : this.utcOffset() * uo), co) - 1;
            break;

          case "minute":
            e = this._d.valueOf(), e += uo - fo(e, uo) - 1;
            break;

          case "second":
            e = this._d.valueOf(), e += ho - fo(e, ho) - 1;
        }

        return this._d.setTime(e), o.updateOffset(this, !0), this;
      }

      function bo() {
        return this._d.valueOf() - 6e4 * (this._offset || 0);
      }

      function _o() {
        return Math.floor(this.valueOf() / 1e3);
      }

      function wo() {
        return new Date(this.valueOf());
      }

      function ko() {
        var t = this;
        return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()];
      }

      function xo() {
        var t = this;
        return {
          years: t.year(),
          months: t.month(),
          date: t.date(),
          hours: t.hours(),
          minutes: t.minutes(),
          seconds: t.seconds(),
          milliseconds: t.milliseconds()
        };
      }

      function Do() {
        return this.isValid() ? this.toISOString() : null;
      }

      function So() {
        return y(this);
      }

      function Co() {
        return f({}, g(this));
      }

      function To() {
        return g(this).overflow;
      }

      function Mo() {
        return {
          input: this._i,
          format: this._f,
          locale: this._locale,
          isUTC: this._isUTC,
          strict: this._strict
        };
      }

      function Oo(t, e) {
        var i,
            n,
            r,
            s = this._eras || gi("en")._eras;

        for (i = 0, n = s.length; i < n; ++i) {
          switch (typeof s[i].since) {
            case "string":
              r = o(s[i].since).startOf("day"), s[i].since = r.valueOf();
          }

          switch (typeof s[i].until) {
            case "undefined":
              s[i].until = 1 / 0;
              break;

            case "string":
              r = o(s[i].until).startOf("day").valueOf(), s[i].until = r.valueOf();
          }
        }

        return s;
      }

      function Eo(t, e, i) {
        var n,
            o,
            r,
            s,
            a,
            l = this.eras();

        for (t = t.toUpperCase(), n = 0, o = l.length; n < o; ++n) {
          if (r = l[n].name.toUpperCase(), s = l[n].abbr.toUpperCase(), a = l[n].narrow.toUpperCase(), i) switch (e) {
            case "N":
            case "NN":
            case "NNN":
              if (s === t) return l[n];
              break;

            case "NNNN":
              if (r === t) return l[n];
              break;

            case "NNNNN":
              if (a === t) return l[n];
          } else if ([r, s, a].indexOf(t) >= 0) return l[n];
        }
      }

      function Po(t, e) {
        var i = t.since <= t.until ? 1 : -1;
        return void 0 === e ? o(t.since).year() : o(t.since).year() + (e - t.offset) * i;
      }

      function Ao() {
        var t,
            e,
            i,
            n = this.localeData().eras();

        for (t = 0, e = n.length; t < e; ++t) {
          if (i = this.clone().startOf("day").valueOf(), n[t].since <= i && i <= n[t].until) return n[t].name;
          if (n[t].until <= i && i <= n[t].since) return n[t].name;
        }

        return "";
      }

      function Lo() {
        var t,
            e,
            i,
            n = this.localeData().eras();

        for (t = 0, e = n.length; t < e; ++t) {
          if (i = this.clone().startOf("day").valueOf(), n[t].since <= i && i <= n[t].until) return n[t].narrow;
          if (n[t].until <= i && i <= n[t].since) return n[t].narrow;
        }

        return "";
      }

      function Io() {
        var t,
            e,
            i,
            n = this.localeData().eras();

        for (t = 0, e = n.length; t < e; ++t) {
          if (i = this.clone().startOf("day").valueOf(), n[t].since <= i && i <= n[t].until) return n[t].abbr;
          if (n[t].until <= i && i <= n[t].since) return n[t].abbr;
        }

        return "";
      }

      function No() {
        var t,
            e,
            i,
            n,
            r = this.localeData().eras();

        for (t = 0, e = r.length; t < e; ++t) {
          if (i = r[t].since <= r[t].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), r[t].since <= n && n <= r[t].until || r[t].until <= n && n <= r[t].since) return (this.year() - o(r[t].since).year()) * i + r[t].offset;
        }

        return this.year();
      }

      function Ro(t) {
        return l(this, "_erasNameRegex") || Wo.call(this), t ? this._erasNameRegex : this._erasRegex;
      }

      function Fo(t) {
        return l(this, "_erasAbbrRegex") || Wo.call(this), t ? this._erasAbbrRegex : this._erasRegex;
      }

      function Yo(t) {
        return l(this, "_erasNarrowRegex") || Wo.call(this), t ? this._erasNarrowRegex : this._erasRegex;
      }

      function jo(t, e) {
        return e.erasAbbrRegex(t);
      }

      function Ho(t, e) {
        return e.erasNameRegex(t);
      }

      function zo(t, e) {
        return e.erasNarrowRegex(t);
      }

      function Go(t, e) {
        return e._eraYearOrdinalRegex || Ot;
      }

      function Wo() {
        var t,
            e,
            i = [],
            n = [],
            o = [],
            r = [],
            s = this.eras();

        for (t = 0, e = s.length; t < e; ++t) {
          n.push(Yt(s[t].name)), i.push(Yt(s[t].abbr)), o.push(Yt(s[t].narrow)), r.push(Yt(s[t].name)), r.push(Yt(s[t].abbr)), r.push(Yt(s[t].narrow));
        }

        this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + o.join("|") + ")", "i");
      }

      function Bo(t, e) {
        z(0, [t, t.length], 0, e);
      }

      function Vo(t) {
        return Ko.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
      }

      function Uo(t) {
        return Ko.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4);
      }

      function Xo() {
        return De(this.year(), 1, 4);
      }

      function qo() {
        return De(this.isoWeekYear(), 1, 4);
      }

      function Zo() {
        var t = this.localeData()._week;

        return De(this.year(), t.dow, t.doy);
      }

      function $o() {
        var t = this.localeData()._week;

        return De(this.weekYear(), t.dow, t.doy);
      }

      function Ko(t, e, i, n, o) {
        var r;
        return null == t ? xe(this, n, o).year : (e > (r = De(t, n, o)) && (e = r), Jo.call(this, t, e, i, n, o));
      }

      function Jo(t, e, i, n, o) {
        var r = ke(t, e, i, n, o),
            s = _e(r.year, 0, r.dayOfYear);

        return this.year(s.getUTCFullYear()), this.month(s.getUTCMonth()), this.date(s.getUTCDate()), this;
      }

      function Qo(t) {
        return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3);
      }

      z("N", 0, 0, "eraAbbr"), z("NN", 0, 0, "eraAbbr"), z("NNN", 0, 0, "eraAbbr"), z("NNNN", 0, 0, "eraName"), z("NNNNN", 0, 0, "eraNarrow"), z("y", ["y", 1], "yo", "eraYear"), z("y", ["yy", 2], 0, "eraYear"), z("y", ["yyy", 3], 0, "eraYear"), z("y", ["yyyy", 4], 0, "eraYear"), Nt("N", jo), Nt("NN", jo), Nt("NNN", jo), Nt("NNNN", Ho), Nt("NNNNN", zo), Ht(["N", "NN", "NNN", "NNNN", "NNNNN"], function (t, e, i, n) {
        var o = i._locale.erasParse(t, n, i._strict);

        o ? g(i).era = o : g(i).invalidEra = t;
      }), Nt("y", Ot), Nt("yy", Ot), Nt("yyy", Ot), Nt("yyyy", Ot), Nt("yo", Go), Ht(["y", "yy", "yyy", "yyyy"], Bt), Ht(["yo"], function (t, e, i, n) {
        var o;
        i._locale._eraYearOrdinalRegex && (o = t.match(i._locale._eraYearOrdinalRegex)), i._locale.eraYearOrdinalParse ? e[Bt] = i._locale.eraYearOrdinalParse(t, o) : e[Bt] = parseInt(t, 10);
      }), z(0, ["gg", 2], 0, function () {
        return this.weekYear() % 100;
      }), z(0, ["GG", 2], 0, function () {
        return this.isoWeekYear() % 100;
      }), Bo("gggg", "weekYear"), Bo("ggggg", "weekYear"), Bo("GGGG", "isoWeekYear"), Bo("GGGGG", "isoWeekYear"), nt("weekYear", "gg"), nt("isoWeekYear", "GG"), at("weekYear", 1), at("isoWeekYear", 1), Nt("G", Et), Nt("g", Et), Nt("GG", xt, bt), Nt("gg", xt, bt), Nt("GGGG", Tt, wt), Nt("gggg", Tt, wt), Nt("GGGGG", Mt, kt), Nt("ggggg", Mt, kt), zt(["gggg", "ggggg", "GGGG", "GGGGG"], function (t, e, i, n) {
        e[n.substr(0, 2)] = ct(t);
      }), zt(["gg", "GG"], function (t, e, i, n) {
        e[n] = o.parseTwoDigitYear(t);
      }), z("Q", 0, "Qo", "quarter"), nt("quarter", "Q"), at("quarter", 7), Nt("Q", yt), Ht("Q", function (t, e) {
        e[Vt] = 3 * (ct(t) - 1);
      }), z("D", ["DD", 2], "Do", "date"), nt("date", "D"), at("date", 9), Nt("D", xt), Nt("DD", xt, bt), Nt("Do", function (t, e) {
        return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient;
      }), Ht(["D", "DD"], Ut), Ht("Do", function (t, e) {
        e[Ut] = ct(t.match(xt)[0]);
      });
      var tr = dt("Date", !0);

      function er(t) {
        var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return null == t ? e : this.add(t - e, "d");
      }

      z("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), nt("dayOfYear", "DDD"), at("dayOfYear", 4), Nt("DDD", Ct), Nt("DDDD", _t), Ht(["DDD", "DDDD"], function (t, e, i) {
        i._dayOfYear = ct(t);
      }), z("m", ["mm", 2], 0, "minute"), nt("minute", "m"), at("minute", 14), Nt("m", xt), Nt("mm", xt, bt), Ht(["m", "mm"], qt);
      var ir = dt("Minutes", !1);
      z("s", ["ss", 2], 0, "second"), nt("second", "s"), at("second", 15), Nt("s", xt), Nt("ss", xt, bt), Ht(["s", "ss"], Zt);
      var nr,
          or,
          rr = dt("Seconds", !1);

      for (z("S", 0, 0, function () {
        return ~~(this.millisecond() / 100);
      }), z(0, ["SS", 2], 0, function () {
        return ~~(this.millisecond() / 10);
      }), z(0, ["SSS", 3], 0, "millisecond"), z(0, ["SSSS", 4], 0, function () {
        return 10 * this.millisecond();
      }), z(0, ["SSSSS", 5], 0, function () {
        return 100 * this.millisecond();
      }), z(0, ["SSSSSS", 6], 0, function () {
        return 1e3 * this.millisecond();
      }), z(0, ["SSSSSSS", 7], 0, function () {
        return 1e4 * this.millisecond();
      }), z(0, ["SSSSSSSS", 8], 0, function () {
        return 1e5 * this.millisecond();
      }), z(0, ["SSSSSSSSS", 9], 0, function () {
        return 1e6 * this.millisecond();
      }), nt("millisecond", "ms"), at("millisecond", 16), Nt("S", Ct, yt), Nt("SS", Ct, bt), Nt("SSS", Ct, _t), nr = "SSSS"; nr.length <= 9; nr += "S") {
        Nt(nr, Ot);
      }

      function sr(t, e) {
        e[$t] = ct(1e3 * ("0." + t));
      }

      for (nr = "S"; nr.length <= 9; nr += "S") {
        Ht(nr, sr);
      }

      function ar() {
        return this._isUTC ? "UTC" : "";
      }

      function lr() {
        return this._isUTC ? "Coordinated Universal Time" : "";
      }

      or = dt("Milliseconds", !1), z("z", 0, 0, "zoneAbbr"), z("zz", 0, 0, "zoneName");
      var hr = x.prototype;

      function ur(t) {
        return qi(1e3 * t);
      }

      function cr() {
        return qi.apply(null, arguments).parseZone();
      }

      function dr(t) {
        return t;
      }

      hr.add = In, hr.calendar = Gn, hr.clone = Wn, hr.diff = $n, hr.endOf = yo, hr.format = eo, hr.from = io, hr.fromNow = no, hr.to = oo, hr.toNow = ro, hr.get = mt, hr.invalidAt = To, hr.isAfter = Bn, hr.isBefore = Vn, hr.isBetween = Un, hr.isSame = Xn, hr.isSameOrAfter = qn, hr.isSameOrBefore = Zn, hr.isValid = So, hr.lang = ao, hr.locale = so, hr.localeData = lo, hr.max = $i, hr.min = Zi, hr.parsingFlags = Co, hr.set = vt, hr.startOf = go, hr.subtract = Nn, hr.toArray = ko, hr.toObject = xo, hr.toDate = wo, hr.toISOString = Qn, hr.inspect = to, "undefined" != typeof Symbol && null != Symbol.for && (hr[Symbol.for("nodejs.util.inspect.custom")] = function () {
        return "Moment<" + this.format() + ">";
      }), hr.toJSON = Do, hr.toString = Jn, hr.unix = _o, hr.valueOf = bo, hr.creationData = Mo, hr.eraName = Ao, hr.eraNarrow = Lo, hr.eraAbbr = Io, hr.eraYear = No, hr.year = ge, hr.isLeapYear = ye, hr.weekYear = Vo, hr.isoWeekYear = Uo, hr.quarter = hr.quarters = Qo, hr.month = ce, hr.daysInMonth = de, hr.week = hr.weeks = Oe, hr.isoWeek = hr.isoWeeks = Ee, hr.weeksInYear = Zo, hr.weeksInWeekYear = $o, hr.isoWeeksInYear = Xo, hr.isoWeeksInISOWeekYear = qo, hr.date = tr, hr.day = hr.days = Ve, hr.weekday = Ue, hr.isoWeekday = Xe, hr.dayOfYear = er, hr.hour = hr.hours = oi, hr.minute = hr.minutes = ir, hr.second = hr.seconds = rr, hr.millisecond = hr.milliseconds = or, hr.utcOffset = mn, hr.utc = gn, hr.local = yn, hr.parseZone = bn, hr.hasAlignedHourOffset = _n, hr.isDST = wn, hr.isLocal = xn, hr.isUtcOffset = Dn, hr.isUtc = Sn, hr.isUTC = Sn, hr.zoneAbbr = ar, hr.zoneName = lr, hr.dates = C("dates accessor is deprecated. Use date instead.", tr), hr.months = C("months accessor is deprecated. Use month instead", ce), hr.years = C("years accessor is deprecated. Use year instead", ge), hr.zone = C("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", vn), hr.isDSTShifted = C("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", kn);
      var pr = L.prototype;

      function fr(t, e, i, n) {
        var o = gi(),
            r = m().set(n, e);
        return o[i](r, t);
      }

      function mr(t, e, i) {
        if (c(t) && (e = t, t = void 0), t = t || "", null != e) return fr(t, e, i, "month");
        var n,
            o = [];

        for (n = 0; n < 12; n++) {
          o[n] = fr(t, n, i, "month");
        }

        return o;
      }

      function vr(t, e, i, n) {
        "boolean" == typeof t ? (c(e) && (i = e, e = void 0), e = e || "") : (i = e = t, t = !1, c(e) && (i = e, e = void 0), e = e || "");
        var o,
            r = gi(),
            s = t ? r._week.dow : 0,
            a = [];
        if (null != i) return fr(e, (i + s) % 7, n, "day");

        for (o = 0; o < 7; o++) {
          a[o] = fr(e, (o + s) % 7, n, "day");
        }

        return a;
      }

      function gr(t, e) {
        return mr(t, e, "months");
      }

      function yr(t, e) {
        return mr(t, e, "monthsShort");
      }

      function br(t, e, i) {
        return vr(t, e, i, "weekdays");
      }

      function _r(t, e, i) {
        return vr(t, e, i, "weekdaysShort");
      }

      function wr(t, e, i) {
        return vr(t, e, i, "weekdaysMin");
      }

      pr.calendar = N, pr.longDateFormat = X, pr.invalidDate = Z, pr.ordinal = J, pr.preparse = dr, pr.postformat = dr, pr.relativeTime = tt, pr.pastFuture = et, pr.set = P, pr.eras = Oo, pr.erasParse = Eo, pr.erasConvertYear = Po, pr.erasAbbrRegex = Fo, pr.erasNameRegex = Ro, pr.erasNarrowRegex = Yo, pr.months = se, pr.monthsShort = ae, pr.monthsParse = he, pr.monthsRegex = fe, pr.monthsShortRegex = pe, pr.week = Se, pr.firstDayOfYear = Me, pr.firstDayOfWeek = Te, pr.weekdays = He, pr.weekdaysMin = Ge, pr.weekdaysShort = ze, pr.weekdaysParse = Be, pr.weekdaysRegex = qe, pr.weekdaysShortRegex = Ze, pr.weekdaysMinRegex = $e, pr.isPM = ii, pr.meridiem = ri, fi("en", {
        eras: [{
          since: "0001-01-01",
          until: 1 / 0,
          offset: 1,
          name: "Anno Domini",
          narrow: "AD",
          abbr: "AD"
        }, {
          since: "0000-12-31",
          until: -1 / 0,
          offset: 1,
          name: "Before Christ",
          narrow: "BC",
          abbr: "BC"
        }],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(t) {
          var e = t % 10;
          return t + (1 === ct(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th");
        }
      }), o.lang = C("moment.lang is deprecated. Use moment.locale instead.", fi), o.langData = C("moment.langData is deprecated. Use moment.localeData instead.", gi);
      var kr = Math.abs;

      function xr() {
        var t = this._data;
        return this._milliseconds = kr(this._milliseconds), this._days = kr(this._days), this._months = kr(this._months), t.milliseconds = kr(t.milliseconds), t.seconds = kr(t.seconds), t.minutes = kr(t.minutes), t.hours = kr(t.hours), t.months = kr(t.months), t.years = kr(t.years), this;
      }

      function Dr(t, e, i, n) {
        var o = Mn(e, i);
        return t._milliseconds += n * o._milliseconds, t._days += n * o._days, t._months += n * o._months, t._bubble();
      }

      function Sr(t, e) {
        return Dr(this, t, e, 1);
      }

      function Cr(t, e) {
        return Dr(this, t, e, -1);
      }

      function Tr(t) {
        return t < 0 ? Math.floor(t) : Math.ceil(t);
      }

      function Mr() {
        var t,
            e,
            i,
            n,
            o,
            r = this._milliseconds,
            s = this._days,
            a = this._months,
            l = this._data;
        return r >= 0 && s >= 0 && a >= 0 || r <= 0 && s <= 0 && a <= 0 || (r += 864e5 * Tr(Er(a) + s), s = 0, a = 0), l.milliseconds = r % 1e3, t = ut(r / 1e3), l.seconds = t % 60, e = ut(t / 60), l.minutes = e % 60, i = ut(e / 60), l.hours = i % 24, s += ut(i / 24), a += o = ut(Or(s)), s -= Tr(Er(o)), n = ut(a / 12), a %= 12, l.days = s, l.months = a, l.years = n, this;
      }

      function Or(t) {
        return 4800 * t / 146097;
      }

      function Er(t) {
        return 146097 * t / 4800;
      }

      function Pr(t) {
        if (!this.isValid()) return NaN;
        var e,
            i,
            n = this._milliseconds;
        if ("month" === (t = ot(t)) || "quarter" === t || "year" === t) switch (e = this._days + n / 864e5, i = this._months + Or(e), t) {
          case "month":
            return i;

          case "quarter":
            return i / 3;

          case "year":
            return i / 12;
        } else switch (e = this._days + Math.round(Er(this._months)), t) {
          case "week":
            return e / 7 + n / 6048e5;

          case "day":
            return e + n / 864e5;

          case "hour":
            return 24 * e + n / 36e5;

          case "minute":
            return 1440 * e + n / 6e4;

          case "second":
            return 86400 * e + n / 1e3;

          case "millisecond":
            return Math.floor(864e5 * e) + n;

          default:
            throw new Error("Unknown unit " + t);
        }
      }

      function Ar() {
        return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * ct(this._months / 12) : NaN;
      }

      function Lr(t) {
        return function () {
          return this.as(t);
        };
      }

      var Ir = Lr("ms"),
          Nr = Lr("s"),
          Rr = Lr("m"),
          Fr = Lr("h"),
          Yr = Lr("d"),
          jr = Lr("w"),
          Hr = Lr("M"),
          zr = Lr("Q"),
          Gr = Lr("y");

      function Wr() {
        return Mn(this);
      }

      function Br(t) {
        return t = ot(t), this.isValid() ? this[t + "s"]() : NaN;
      }

      function Vr(t) {
        return function () {
          return this.isValid() ? this._data[t] : NaN;
        };
      }

      var Ur = Vr("milliseconds"),
          Xr = Vr("seconds"),
          qr = Vr("minutes"),
          Zr = Vr("hours"),
          $r = Vr("days"),
          Kr = Vr("months"),
          Jr = Vr("years");

      function Qr() {
        return ut(this.days() / 7);
      }

      var ts = Math.round,
          es = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
      };

      function is(t, e, i, n, o) {
        return o.relativeTime(e || 1, !!i, t, n);
      }

      function ns(t, e, i, n) {
        var o = Mn(t).abs(),
            r = ts(o.as("s")),
            s = ts(o.as("m")),
            a = ts(o.as("h")),
            l = ts(o.as("d")),
            h = ts(o.as("M")),
            u = ts(o.as("w")),
            c = ts(o.as("y")),
            d = r <= i.ss && ["s", r] || r < i.s && ["ss", r] || s <= 1 && ["m"] || s < i.m && ["mm", s] || a <= 1 && ["h"] || a < i.h && ["hh", a] || l <= 1 && ["d"] || l < i.d && ["dd", l];
        return null != i.w && (d = d || u <= 1 && ["w"] || u < i.w && ["ww", u]), (d = d || h <= 1 && ["M"] || h < i.M && ["MM", h] || c <= 1 && ["y"] || ["yy", c])[2] = e, d[3] = +t > 0, d[4] = n, is.apply(null, d);
      }

      function os(t) {
        return void 0 === t ? ts : "function" == typeof t && (ts = t, !0);
      }

      function rs(t, e) {
        return void 0 !== es[t] && (void 0 === e ? es[t] : (es[t] = e, "s" === t && (es.ss = e - 1), !0));
      }

      function ss(t, e) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var i,
            n,
            o = !1,
            r = es;
        return "object" == typeof t && (e = t, t = !1), "boolean" == typeof t && (o = t), "object" == typeof e && (r = Object.assign({}, es, e), null != e.s && null == e.ss && (r.ss = e.s - 1)), n = ns(this, !o, r, i = this.localeData()), o && (n = i.pastFuture(+this, n)), i.postformat(n);
      }

      var as = Math.abs;

      function ls(t) {
        return (t > 0) - (t < 0) || +t;
      }

      function hs() {
        if (!this.isValid()) return this.localeData().invalidDate();
        var t,
            e,
            i,
            n,
            o,
            r,
            s,
            a,
            l = as(this._milliseconds) / 1e3,
            h = as(this._days),
            u = as(this._months),
            c = this.asSeconds();
        return c ? (t = ut(l / 60), e = ut(t / 60), l %= 60, t %= 60, i = ut(u / 12), u %= 12, n = l ? l.toFixed(3).replace(/\.?0+$/, "") : "", o = c < 0 ? "-" : "", r = ls(this._months) !== ls(c) ? "-" : "", s = ls(this._days) !== ls(c) ? "-" : "", a = ls(this._milliseconds) !== ls(c) ? "-" : "", o + "P" + (i ? r + i + "Y" : "") + (u ? r + u + "M" : "") + (h ? s + h + "D" : "") + (e || t || l ? "T" : "") + (e ? a + e + "H" : "") + (t ? a + t + "M" : "") + (l ? a + n + "S" : "")) : "P0D";
      }

      var us = sn.prototype;
      return us.isValid = on, us.abs = xr, us.add = Sr, us.subtract = Cr, us.as = Pr, us.asMilliseconds = Ir, us.asSeconds = Nr, us.asMinutes = Rr, us.asHours = Fr, us.asDays = Yr, us.asWeeks = jr, us.asMonths = Hr, us.asQuarters = zr, us.asYears = Gr, us.valueOf = Ar, us._bubble = Mr, us.clone = Wr, us.get = Br, us.milliseconds = Ur, us.seconds = Xr, us.minutes = qr, us.hours = Zr, us.days = $r, us.weeks = Qr, us.months = Kr, us.years = Jr, us.humanize = ss, us.toISOString = hs, us.toString = hs, us.toJSON = hs, us.locale = so, us.localeData = lo, us.toIsoString = C("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", hs), us.lang = ao, z("X", 0, 0, "unix"), z("x", 0, 0, "valueOf"), Nt("x", Et), Nt("X", Lt), Ht("X", function (t, e, i) {
        i._d = new Date(1e3 * parseFloat(t));
      }), Ht("x", function (t, e, i) {
        i._d = new Date(ct(t));
      }), //! moment.js
      o.version = "2.29.1", r(qi), o.fn = hr, o.min = Ji, o.max = Qi, o.now = tn, o.utc = m, o.unix = ur, o.months = gr, o.isDate = d, o.locale = fi, o.invalid = b, o.duration = Mn, o.isMoment = D, o.weekdays = br, o.parseZone = cr, o.localeData = gi, o.isDuration = an, o.monthsShort = yr, o.weekdaysMin = wr, o.defineLocale = mi, o.updateLocale = vi, o.locales = yi, o.weekdaysShort = _r, o.normalizeUnits = ot, o.relativeTimeRounding = os, o.relativeTimeThreshold = rs, o.calendarFormat = zn, o.prototype = hr, o.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
      }, o;
    }();
  }),
      s = (n(function (t, e) {
    (function (t) {
      function e(t, e, i, n) {
        var o = {
          m: ["eine Minute", "einer Minute"],
          h: ["eine Stunde", "einer Stunde"],
          d: ["ein Tag", "einem Tag"],
          dd: [t + " Tage", t + " Tagen"],
          w: ["eine Woche", "einer Woche"],
          M: ["ein Monat", "einem Monat"],
          MM: [t + " Monate", t + " Monaten"],
          y: ["ein Jahr", "einem Jahr"],
          yy: [t + " Jahre", t + " Jahren"]
        };
        return e ? o[i][0] : o[i][1];
      }

      t.defineLocale("de", {
        months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY HH:mm",
          LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[heute um] LT [Uhr]",
          sameElse: "L",
          nextDay: "[morgen um] LT [Uhr]",
          nextWeek: "dddd [um] LT [Uhr]",
          lastDay: "[gestern um] LT [Uhr]",
          lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
          future: "in %s",
          past: "vor %s",
          s: "ein paar Sekunden",
          ss: "%d Sekunden",
          m: e,
          mm: "%d Minuten",
          h: e,
          hh: "%d Stunden",
          d: e,
          dd: e,
          w: e,
          ww: "%d Wochen",
          M: e,
          MM: e,
          y: e,
          yy: e
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    })(r);
  }), n(function (t, e) {
    (function (t) {
      var e = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
          i = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
          n = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
          o = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
      t.defineLocale("es", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function monthsShort(t, n) {
          return t ? /-MMM-/.test(n) ? i[t.month()] : e[t.month()] : e;
        },
        monthsRegex: o,
        monthsShortRegex: o,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: n,
        longMonthsParse: n,
        shortMonthsParse: n,
        weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
        weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D [de] MMMM [de] YYYY",
          LLL: "D [de] MMMM [de] YYYY H:mm",
          LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
          sameDay: function sameDay() {
            return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          nextDay: function nextDay() {
            return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          nextWeek: function nextWeek() {
            return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          lastDay: function lastDay() {
            return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          lastWeek: function lastWeek() {
            return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "en %s",
          past: "hace %s",
          s: "unos segundos",
          ss: "%d segundos",
          m: "un minuto",
          mm: "%d minutos",
          h: "una hora",
          hh: "%d horas",
          d: "un día",
          dd: "%d días",
          w: "una semana",
          ww: "%d semanas",
          M: "un mes",
          MM: "%d meses",
          y: "un año",
          yy: "%d años"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        },
        invalidDate: "Fecha inválida"
      });
    })(r);
  }), n(function (t, e) {
    (function (t) {
      var e = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
          i = [/^janv/i, /^févr/i, /^mars/i, /^avr/i, /^mai/i, /^juin/i, /^juil/i, /^août/i, /^sept/i, /^oct/i, /^nov/i, /^déc/i];
      t.defineLocale("fr", {
        months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        monthsRegex: e,
        monthsShortRegex: e,
        monthsStrictRegex: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex: /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsParse: i,
        longMonthsParse: i,
        shortMonthsParse: i,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Aujourd’hui à] LT",
          nextDay: "[Demain à] LT",
          nextWeek: "dddd [à] LT",
          lastDay: "[Hier à] LT",
          lastWeek: "dddd [dernier à] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "dans %s",
          past: "il y a %s",
          s: "quelques secondes",
          ss: "%d secondes",
          m: "une minute",
          mm: "%d minutes",
          h: "une heure",
          hh: "%d heures",
          d: "un jour",
          dd: "%d jours",
          w: "une semaine",
          ww: "%d semaines",
          M: "un mois",
          MM: "%d mois",
          y: "un an",
          yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function ordinal(t, e) {
          switch (e) {
            case "D":
              return t + (1 === t ? "er" : "");

            default:
            case "M":
            case "Q":
            case "DDD":
            case "d":
              return t + (1 === t ? "er" : "e");

            case "w":
            case "W":
              return t + (1 === t ? "re" : "e");
          }
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    })(r);
  }), n(function (t, e) {
    (function (t) {
      t.defineLocale("it", {
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: function sameDay() {
            return "[Oggi a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
          },
          nextDay: function nextDay() {
            return "[Domani a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
          },
          nextWeek: function nextWeek() {
            return "dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
          },
          lastDay: function lastDay() {
            return "[Ieri a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
          },
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
                return "[La scorsa] dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";

              default:
                return "[Lo scorso] dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "tra %s",
          past: "%s fa",
          s: "alcuni secondi",
          ss: "%d secondi",
          m: "un minuto",
          mm: "%d minuti",
          h: "un'ora",
          hh: "%d ore",
          d: "un giorno",
          dd: "%d giorni",
          w: "una settimana",
          ww: "%d settimane",
          M: "un mese",
          MM: "%d mesi",
          y: "un anno",
          yy: "%d anni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    })(r);
  }), n(function (t, e) {
    (function (t) {
      t.defineLocale("ja", {
        eras: [{
          since: "2019-05-01",
          offset: 1,
          name: "令和",
          narrow: "㋿",
          abbr: "R"
        }, {
          since: "1989-01-08",
          until: "2019-04-30",
          offset: 1,
          name: "平成",
          narrow: "㍻",
          abbr: "H"
        }, {
          since: "1926-12-25",
          until: "1989-01-07",
          offset: 1,
          name: "昭和",
          narrow: "㍼",
          abbr: "S"
        }, {
          since: "1912-07-30",
          until: "1926-12-24",
          offset: 1,
          name: "大正",
          narrow: "㍽",
          abbr: "T"
        }, {
          since: "1873-01-01",
          until: "1912-07-29",
          offset: 6,
          name: "明治",
          narrow: "㍾",
          abbr: "M"
        }, {
          since: "0001-01-01",
          until: "1873-12-31",
          offset: 1,
          name: "西暦",
          narrow: "AD",
          abbr: "AD"
        }, {
          since: "0000-12-31",
          until: -1 / 0,
          offset: 1,
          name: "紀元前",
          narrow: "BC",
          abbr: "BC"
        }],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function eraYearOrdinalParse(t, e) {
          return "元" === e[1] ? 1 : parseInt(e[1] || t, 10);
        },
        months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),
        weekdaysShort: "日_月_火_水_木_金_土".split("_"),
        weekdaysMin: "日_月_火_水_木_金_土".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY/MM/DD",
          LL: "YYYY年M月D日",
          LLL: "YYYY年M月D日 HH:mm",
          LLLL: "YYYY年M月D日 dddd HH:mm",
          l: "YYYY/MM/DD",
          ll: "YYYY年M月D日",
          lll: "YYYY年M月D日 HH:mm",
          llll: "YYYY年M月D日(ddd) HH:mm"
        },
        meridiemParse: /午前|午後/i,
        isPM: function isPM(t) {
          return "午後" === t;
        },
        meridiem: function meridiem(t, e, i) {
          return t < 12 ? "午前" : "午後";
        },
        calendar: {
          sameDay: "[今日] LT",
          nextDay: "[明日] LT",
          nextWeek: function nextWeek(t) {
            return t.week() !== this.week() ? "[来週]dddd LT" : "dddd LT";
          },
          lastDay: "[昨日] LT",
          lastWeek: function lastWeek(t) {
            return this.week() !== t.week() ? "[先週]dddd LT" : "dddd LT";
          },
          sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function ordinal(t, e) {
          switch (e) {
            case "y":
              return 1 === t ? "元年" : t + "年";

            case "d":
            case "D":
            case "DDD":
              return t + "日";

            default:
              return t;
          }
        },
        relativeTime: {
          future: "%s後",
          past: "%s前",
          s: "数秒",
          ss: "%d秒",
          m: "1分",
          mm: "%d分",
          h: "1時間",
          hh: "%d時間",
          d: "1日",
          dd: "%d日",
          M: "1ヶ月",
          MM: "%dヶ月",
          y: "1年",
          yy: "%d年"
        }
      });
    })(r);
  }), n(function (t, e) {
    (function (t) {
      var e = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
          i = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
          n = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
          o = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
      t.defineLocale("nl", {
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: function monthsShort(t, n) {
          return t ? /-MMM-/.test(n) ? i[t.month()] : e[t.month()] : e;
        },
        monthsRegex: o,
        monthsShortRegex: o,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: n,
        longMonthsParse: n,
        shortMonthsParse: n,
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD-MM-YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[vandaag om] LT",
          nextDay: "[morgen om] LT",
          nextWeek: "dddd [om] LT",
          lastDay: "[gisteren om] LT",
          lastWeek: "[afgelopen] dddd [om] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "over %s",
          past: "%s geleden",
          s: "een paar seconden",
          ss: "%d seconden",
          m: "één minuut",
          mm: "%d minuten",
          h: "één uur",
          hh: "%d uur",
          d: "één dag",
          dd: "%d dagen",
          w: "één week",
          ww: "%d weken",
          M: "één maand",
          MM: "%d maanden",
          y: "één jaar",
          yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(t) {
          return t + (1 === t || 8 === t || t >= 20 ? "ste" : "de");
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    })(r);
  }), n(function (t, e) {
    (function (t) {
      var e = "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),
          i = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),
          n = [/^sty/i, /^lut/i, /^mar/i, /^kwi/i, /^maj/i, /^cze/i, /^lip/i, /^sie/i, /^wrz/i, /^paź/i, /^lis/i, /^gru/i];

      function o(t) {
        return t % 10 < 5 && t % 10 > 1 && ~~(t / 10) % 10 != 1;
      }

      function r(t, e, i) {
        var n = t + " ";

        switch (i) {
          case "ss":
            return n + (o(t) ? "sekundy" : "sekund");

          case "m":
            return e ? "minuta" : "minutę";

          case "mm":
            return n + (o(t) ? "minuty" : "minut");

          case "h":
            return e ? "godzina" : "godzinę";

          case "hh":
            return n + (o(t) ? "godziny" : "godzin");

          case "ww":
            return n + (o(t) ? "tygodnie" : "tygodni");

          case "MM":
            return n + (o(t) ? "miesiące" : "miesięcy");

          case "yy":
            return n + (o(t) ? "lata" : "lat");
        }
      }

      t.defineLocale("pl", {
        months: function months(t, n) {
          return t ? /D MMMM/.test(n) ? i[t.month()] : e[t.month()] : e;
        },
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),
        monthsParse: n,
        longMonthsParse: n,
        shortMonthsParse: n,
        weekdays: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),
        weekdaysShort: "ndz_pon_wt_śr_czw_pt_sob".split("_"),
        weekdaysMin: "Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Dziś o] LT",
          nextDay: "[Jutro o] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[W niedzielę o] LT";

              case 2:
                return "[We wtorek o] LT";

              case 3:
                return "[W środę o] LT";

              case 6:
                return "[W sobotę o] LT";

              default:
                return "[W] dddd [o] LT";
            }
          },
          lastDay: "[Wczoraj o] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
                return "[W zeszłą niedzielę o] LT";

              case 3:
                return "[W zeszłą środę o] LT";

              case 6:
                return "[W zeszłą sobotę o] LT";

              default:
                return "[W zeszły] dddd [o] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "za %s",
          past: "%s temu",
          s: "kilka sekund",
          ss: r,
          m: r,
          mm: r,
          h: r,
          hh: r,
          d: "1 dzień",
          dd: "%d dni",
          w: "tydzień",
          ww: r,
          M: "miesiąc",
          MM: r,
          y: "rok",
          yy: r
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    })(r);
  }), n(function (t, e) {
    (function (t) {
      function e(t, e, i) {
        var n, o;
        return "m" === i ? e ? "минута" : "минуту" : t + " " + (n = +t, o = {
          ss: e ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
          mm: e ? "минута_минуты_минут" : "минуту_минуты_минут",
          hh: "час_часа_часов",
          dd: "день_дня_дней",
          ww: "неделя_недели_недель",
          MM: "месяц_месяца_месяцев",
          yy: "год_года_лет"
        }[i].split("_"), n % 10 == 1 && n % 100 != 11 ? o[0] : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? o[1] : o[2]);
      }

      var i = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
      t.defineLocale("ru", {
        months: {
          format: "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),
          standalone: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")
        },
        monthsShort: {
          format: "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),
          standalone: "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")
        },
        weekdays: {
          standalone: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),
          format: "воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),
          isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
        },
        weekdaysShort: "вс_пн_вт_ср_чт_пт_сб".split("_"),
        weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
        monthsParse: i,
        longMonthsParse: i,
        shortMonthsParse: i,
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY г.",
          LLL: "D MMMM YYYY г., H:mm",
          LLLL: "dddd, D MMMM YYYY г., H:mm"
        },
        calendar: {
          sameDay: "[Сегодня, в] LT",
          nextDay: "[Завтра, в] LT",
          lastDay: "[Вчера, в] LT",
          nextWeek: function nextWeek(t) {
            if (t.week() === this.week()) return 2 === this.day() ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";

            switch (this.day()) {
              case 0:
                return "[В следующее] dddd, [в] LT";

              case 1:
              case 2:
              case 4:
                return "[В следующий] dddd, [в] LT";

              case 3:
              case 5:
              case 6:
                return "[В следующую] dddd, [в] LT";
            }
          },
          lastWeek: function lastWeek(t) {
            if (t.week() === this.week()) return 2 === this.day() ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";

            switch (this.day()) {
              case 0:
                return "[В прошлое] dddd, [в] LT";

              case 1:
              case 2:
              case 4:
                return "[В прошлый] dddd, [в] LT";

              case 3:
              case 5:
              case 6:
                return "[В прошлую] dddd, [в] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "через %s",
          past: "%s назад",
          s: "несколько секунд",
          ss: e,
          m: e,
          mm: e,
          h: "час",
          hh: e,
          d: "день",
          dd: e,
          w: "неделя",
          ww: e,
          M: "месяц",
          MM: e,
          y: "год",
          yy: e
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function isPM(t) {
          return /^(дня|вечера)$/.test(t);
        },
        meridiem: function meridiem(t, e, i) {
          return t < 4 ? "ночи" : t < 12 ? "утра" : t < 17 ? "дня" : "вечера";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function ordinal(t, e) {
          switch (e) {
            case "M":
            case "d":
            case "DDD":
              return t + "-й";

            case "D":
              return t + "-го";

            case "w":
            case "W":
              return t + "-я";

            default:
              return t;
          }
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    })(r);
  }), n(function (t, e) {
    (function (t) {
      function e(t, e, i) {
        var n, o;
        return "m" === i ? e ? "хвилина" : "хвилину" : "h" === i ? e ? "година" : "годину" : t + " " + (n = +t, o = {
          ss: e ? "секунда_секунди_секунд" : "секунду_секунди_секунд",
          mm: e ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин",
          hh: e ? "година_години_годин" : "годину_години_годин",
          dd: "день_дні_днів",
          MM: "місяць_місяці_місяців",
          yy: "рік_роки_років"
        }[i].split("_"), n % 10 == 1 && n % 100 != 11 ? o[0] : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? o[1] : o[2]);
      }

      function i(t) {
        return function () {
          return t + "о" + (11 === this.hours() ? "б" : "") + "] LT";
        };
      }

      t.defineLocale("uk", {
        months: {
          format: "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),
          standalone: "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")
        },
        monthsShort: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),
        weekdays: function weekdays(t, e) {
          var i = {
            nominative: "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),
            accusative: "неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),
            genitive: "неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")
          };
          return !0 === t ? i.nominative.slice(1, 7).concat(i.nominative.slice(0, 1)) : t ? i[/(\[[ВвУу]\]) ?dddd/.test(e) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(e) ? "genitive" : "nominative"][t.day()] : i.nominative;
        },
        weekdaysShort: "нд_пн_вт_ср_чт_пт_сб".split("_"),
        weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY р.",
          LLL: "D MMMM YYYY р., HH:mm",
          LLLL: "dddd, D MMMM YYYY р., HH:mm"
        },
        calendar: {
          sameDay: i("[Сьогодні "),
          nextDay: i("[Завтра "),
          lastDay: i("[Вчора "),
          nextWeek: i("[У] dddd ["),
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
              case 3:
              case 5:
              case 6:
                return i("[Минулої] dddd [").call(this);

              case 1:
              case 2:
              case 4:
                return i("[Минулого] dddd [").call(this);
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "за %s",
          past: "%s тому",
          s: "декілька секунд",
          ss: e,
          m: e,
          mm: e,
          h: "годину",
          hh: e,
          d: "день",
          dd: e,
          M: "місяць",
          MM: e,
          y: "рік",
          yy: e
        },
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function isPM(t) {
          return /^(дня|вечора)$/.test(t);
        },
        meridiem: function meridiem(t, e, i) {
          return t < 4 ? "ночі" : t < 12 ? "ранку" : t < 17 ? "дня" : "вечора";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function ordinal(t, e) {
          switch (e) {
            case "M":
            case "d":
            case "DDD":
            case "w":
            case "W":
              return t + "-й";

            case "D":
              return t + "-го";

            default:
              return t;
          }
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    })(r);
  }), function (t) {
    return t && t.Math == Math && t;
  }),
      a = s("object" == typeof globalThis && globalThis) || s("object" == typeof window && window) || s("object" == typeof self && self) || s("object" == typeof e && e) || function () {
    return this;
  }() || Function("return this")(),
      l = function l(t) {
    try {
      return !!t();
    } catch (t) {
      return !0;
    }
  },
      h = !l(function () {
    return 7 != Object.defineProperty({}, 1, {
      get: function get() {
        return 7;
      }
    })[1];
  }),
      u = {}.propertyIsEnumerable,
      c = Object.getOwnPropertyDescriptor,
      d = {
    f: c && !u.call({
      1: 2
    }, 1) ? function (t) {
      var e = c(this, t);
      return !!e && e.enumerable;
    } : u
  },
      p = function p(t, e) {
    return {
      enumerable: !(1 & t),
      configurable: !(2 & t),
      writable: !(4 & t),
      value: e
    };
  },
      f = {}.toString,
      m = function m(t) {
    return f.call(t).slice(8, -1);
  },
      v = "".split,
      g = l(function () {
    return !Object("z").propertyIsEnumerable(0);
  }) ? function (t) {
    return "String" == m(t) ? v.call(t, "") : Object(t);
  } : Object,
      y = function y(t) {
    if (null == t) throw TypeError("Can't call method on " + t);
    return t;
  },
      b = function b(t) {
    return g(y(t));
  },
      _ = function _(t) {
    return "object" == typeof t ? null !== t : "function" == typeof t;
  },
      w = function w(t, e) {
    if (!_(t)) return t;
    var i, n;
    if (e && "function" == typeof (i = t.toString) && !_(n = i.call(t))) return n;
    if ("function" == typeof (i = t.valueOf) && !_(n = i.call(t))) return n;
    if (!e && "function" == typeof (i = t.toString) && !_(n = i.call(t))) return n;
    throw TypeError("Can't convert object to primitive value");
  },
      k = {}.hasOwnProperty,
      x = function x(t, e) {
    return k.call(t, e);
  },
      D = a.document,
      S = _(D) && _(D.createElement),
      C = function C(t) {
    return S ? D.createElement(t) : {};
  },
      T = !h && !l(function () {
    return 7 != Object.defineProperty(C("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  }),
      M = Object.getOwnPropertyDescriptor,
      O = {
    f: h ? M : function (t, e) {
      if (t = b(t), e = w(e, !0), T) try {
        return M(t, e);
      } catch (t) {}
      if (x(t, e)) return p(!d.f.call(t, e), t[e]);
    }
  },
      E = /#|\.prototype\./,
      P = function P(t, e) {
    var i = L[A(t)];
    return i == N || i != I && ("function" == typeof e ? l(e) : !!e);
  },
      A = P.normalize = function (t) {
    return String(t).replace(E, ".").toLowerCase();
  },
      L = P.data = {},
      I = P.NATIVE = "N",
      N = P.POLYFILL = "P",
      R = P,
      F = {},
      Y = function Y(t) {
    if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
    return t;
  },
      j = function j(t, e, i) {
    if (Y(t), void 0 === e) return t;

    switch (i) {
      case 0:
        return function () {
          return t.call(e);
        };

      case 1:
        return function (i) {
          return t.call(e, i);
        };

      case 2:
        return function (i, n) {
          return t.call(e, i, n);
        };

      case 3:
        return function (i, n, o) {
          return t.call(e, i, n, o);
        };
    }

    return function () {
      return t.apply(e, arguments);
    };
  },
      H = function H(t) {
    if (!_(t)) throw TypeError(String(t) + " is not an object");
    return t;
  },
      z = Object.defineProperty,
      G = {
    f: h ? z : function (t, e, i) {
      if (H(t), e = w(e, !0), H(i), T) try {
        return z(t, e, i);
      } catch (t) {}
      if ("get" in i || "set" in i) throw TypeError("Accessors not supported");
      return "value" in i && (t[e] = i.value), t;
    }
  },
      W = h ? function (t, e, i) {
    return G.f(t, e, p(1, i));
  } : function (t, e, i) {
    return t[e] = i, t;
  },
      B = O.f,
      V = function V(t) {
    var e = function e(_e2, i, n) {
      if (this instanceof t) {
        switch (arguments.length) {
          case 0:
            return new t();

          case 1:
            return new t(_e2);

          case 2:
            return new t(_e2, i);
        }

        return new t(_e2, i, n);
      }

      return t.apply(this, arguments);
    };

    return e.prototype = t.prototype, e;
  },
      U = function U(t, e) {
    var i,
        n,
        o,
        r,
        s,
        l,
        h,
        u,
        c = t.target,
        d = t.global,
        p = t.stat,
        f = t.proto,
        m = d ? a : p ? a[c] : (a[c] || {}).prototype,
        v = d ? F : F[c] || (F[c] = {}),
        g = v.prototype;

    for (o in e) {
      i = !R(d ? o : c + (p ? "." : "#") + o, t.forced) && m && x(m, o), s = v[o], i && (l = t.noTargetGet ? (u = B(m, o)) && u.value : m[o]), r = i && l ? l : e[o], i && typeof s == typeof r || (h = t.bind && i ? j(r, a) : t.wrap && i ? V(r) : f && "function" == typeof r ? j(Function.call, r) : r, (t.sham || r && r.sham || s && s.sham) && W(h, "sham", !0), v[o] = h, f && (x(F, n = c + "Prototype") || W(F, n, {}), F[n][o] = r, t.real && g && !g[o] && W(g, o, r)));
    }
  };

  U({
    target: "Object",
    stat: !0,
    forced: !h,
    sham: !h
  }, {
    defineProperty: G.f
  });

  var X = n(function (t) {
    var e = F.Object,
        i = t.exports = function (t, i, n) {
      return e.defineProperty(t, i, n);
    };

    e.defineProperty.sham && (i.sham = !0);
  }),
      q = X,
      Z = Math.ceil,
      $ = Math.floor,
      K = function K(t) {
    return isNaN(t = +t) ? 0 : (t > 0 ? $ : Z)(t);
  },
      J = Math.min,
      Q = function Q(t) {
    return t > 0 ? J(K(t), 9007199254740991) : 0;
  },
      tt = Math.max,
      et = Math.min,
      it = function it(t, e) {
    var i = K(t);
    return i < 0 ? tt(i + e, 0) : et(i, e);
  },
      nt = function nt(t) {
    return function (e, i, n) {
      var o,
          r = b(e),
          s = Q(r.length),
          a = it(n, s);

      if (t && i != i) {
        for (; s > a;) {
          if ((o = r[a++]) != o) return !0;
        }
      } else for (; s > a; a++) {
        if ((t || a in r) && r[a] === i) return t || a || 0;
      }

      return !t && -1;
    };
  },
      ot = {
    includes: nt(!0),
    indexOf: nt(!1)
  },
      rt = {},
      st = ot.indexOf,
      at = function at(t, e) {
    var i,
        n = b(t),
        o = 0,
        r = [];

    for (i in n) {
      !x(rt, i) && x(n, i) && r.push(i);
    }

    for (; e.length > o;) {
      x(n, i = e[o++]) && (~st(r, i) || r.push(i));
    }

    return r;
  },
      lt = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
      ht = Object.keys || function (t) {
    return at(t, lt);
  },
      ut = h ? Object.defineProperties : function (t, e) {
    H(t);

    for (var i, n = ht(e), o = n.length, r = 0; o > r;) {
      G.f(t, i = n[r++], e[i]);
    }

    return t;
  };

  U({
    target: "Object",
    stat: !0,
    forced: !h,
    sham: !h
  }, {
    defineProperties: ut
  });

  var ct = n(function (t) {
    var e = F.Object,
        i = t.exports = function (t, i) {
      return e.defineProperties(t, i);
    };

    e.defineProperties.sham && (i.sham = !0);
  }),
      dt = function dt(t) {
    return "function" == typeof t ? t : void 0;
  },
      pt = function pt(t, e) {
    return arguments.length < 2 ? dt(F[t]) || dt(a[t]) : F[t] && F[t][e] || a[t] && a[t][e];
  },
      ft = lt.concat("length", "prototype"),
      mt = {
    f: Object.getOwnPropertyNames || function (t) {
      return at(t, ft);
    }
  },
      vt = {
    f: Object.getOwnPropertySymbols
  },
      gt = pt("Reflect", "ownKeys") || function (t) {
    var e = mt.f(H(t)),
        i = vt.f;
    return i ? e.concat(i(t)) : e;
  },
      yt = function yt(t, e, i) {
    var n = w(e);
    n in t ? G.f(t, n, p(0, i)) : t[n] = i;
  };

  U({
    target: "Object",
    stat: !0,
    sham: !h
  }, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
      for (var e, i, n = b(t), o = O.f, r = gt(n), s = {}, a = 0; r.length > a;) {
        void 0 !== (i = o(n, e = r[a++])) && yt(s, e, i);
      }

      return s;
    }
  });
  var bt = F.Object.getOwnPropertyDescriptors,
      _t = O.f,
      wt = l(function () {
    _t(1);
  });
  U({
    target: "Object",
    stat: !0,
    forced: !h || wt,
    sham: !h
  }, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
      return _t(b(t), e);
    }
  });

  var kt,
      xt = n(function (t) {
    var e = F.Object,
        i = t.exports = function (t, i) {
      return e.getOwnPropertyDescriptor(t, i);
    };

    e.getOwnPropertyDescriptor.sham && (i.sham = !0);
  }),
      Dt = !!Object.getOwnPropertySymbols && !l(function () {
    return !String(Symbol());
  }),
      St = Dt && !Symbol.sham && "symbol" == typeof Symbol.iterator,
      Ct = Array.isArray || function (t) {
    return "Array" == m(t);
  },
      Tt = function Tt(t) {
    return Object(y(t));
  },
      Mt = pt("document", "documentElement"),
      Ot = "__core-js_shared__",
      Et = a[Ot] || function (t, e) {
    try {
      W(a, t, e);
    } catch (i) {
      a[t] = e;
    }

    return e;
  }(Ot, {}),
      Pt = n(function (t) {
    (t.exports = function (t, e) {
      return Et[t] || (Et[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: "3.8.2",
      mode: "pure",
      copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
    });
  }),
      At = 0,
      Lt = Math.random(),
      It = function It(t) {
    return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++At + Lt).toString(36);
  },
      Nt = Pt("keys"),
      Rt = function Rt(t) {
    return Nt[t] || (Nt[t] = It(t));
  },
      Ft = Rt("IE_PROTO"),
      Yt = function Yt() {},
      jt = function jt(t) {
    return "<script>" + t + "</" + "script>";
  },
      _Ht = function Ht() {
    try {
      kt = document.domain && new ActiveXObject("htmlfile");
    } catch (t) {}

    var t, e;
    _Ht = kt ? function (t) {
      t.write(jt("")), t.close();
      var e = t.parentWindow.Object;
      return t = null, e;
    }(kt) : ((e = C("iframe")).style.display = "none", Mt.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(jt("document.F=Object")), t.close(), t.F);

    for (var i = lt.length; i--;) {
      delete _Ht.prototype[lt[i]];
    }

    return _Ht();
  };

  rt[Ft] = !0;

  var zt = Object.create || function (t, e) {
    var i;
    return null !== t ? (Yt.prototype = H(t), i = new Yt(), Yt.prototype = null, i[Ft] = t) : i = _Ht(), void 0 === e ? i : ut(i, e);
  },
      Gt = mt.f,
      Wt = {}.toString,
      Bt = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
      Vt = {
    f: function f(t) {
      return Bt && "[object Window]" == Wt.call(t) ? function (t) {
        try {
          return Gt(t);
        } catch (t) {
          return Bt.slice();
        }
      }(t) : Gt(b(t));
    }
  },
      Ut = function Ut(t, e, i, n) {
    n && n.enumerable ? t[e] = i : W(t, e, i);
  },
      Xt = Pt("wks"),
      qt = a.Symbol,
      Zt = St ? qt : qt && qt.withoutSetter || It,
      $t = function $t(t) {
    return x(Xt, t) || (Dt && x(qt, t) ? Xt[t] = qt[t] : Xt[t] = Zt("Symbol." + t)), Xt[t];
  },
      Kt = {
    f: $t
  },
      Jt = G.f,
      Qt = function Qt(t) {
    var e = F.Symbol || (F.Symbol = {});
    x(e, t) || Jt(e, t, {
      value: Kt.f(t)
    });
  },
      te = {};

  te[$t("toStringTag")] = "z";

  var ee = "[object z]" === String(te),
      ie = $t("toStringTag"),
      ne = "Arguments" == m(function () {
    return arguments;
  }()),
      oe = ee ? m : function (t) {
    var e, i, n;
    return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (i = function (t, e) {
      try {
        return t[e];
      } catch (t) {}
    }(e = Object(t), ie)) ? i : ne ? m(e) : "Object" == (n = m(e)) && "function" == typeof e.callee ? "Arguments" : n;
  },
      re = ee ? {}.toString : function () {
    return "[object " + oe(this) + "]";
  },
      se = G.f,
      ae = $t("toStringTag"),
      le = function le(t, e, i, n) {
    if (t) {
      var o = i ? t : t.prototype;
      x(o, ae) || se(o, ae, {
        configurable: !0,
        value: e
      }), n && !ee && W(o, "toString", re);
    }
  },
      he = Function.toString;

  "function" != typeof Et.inspectSource && (Et.inspectSource = function (t) {
    return he.call(t);
  });
  var ue,
      ce,
      de,
      pe = Et.inspectSource,
      fe = a.WeakMap,
      me = "function" == typeof fe && /native code/.test(pe(fe)),
      ve = a.WeakMap;

  if (me) {
    var ge = Et.state || (Et.state = new ve()),
        ye = ge.get,
        be = ge.has,
        _e = ge.set;
    ue = function ue(t, e) {
      return e.facade = t, _e.call(ge, t, e), e;
    }, ce = function ce(t) {
      return ye.call(ge, t) || {};
    }, de = function de(t) {
      return be.call(ge, t);
    };
  } else {
    var we = Rt("state");
    rt[we] = !0, ue = function ue(t, e) {
      return e.facade = t, W(t, we, e), e;
    }, ce = function ce(t) {
      return x(t, we) ? t[we] : {};
    }, de = function de(t) {
      return x(t, we);
    };
  }

  var ke = {
    set: ue,
    get: ce,
    has: de,
    enforce: function enforce(t) {
      return de(t) ? ce(t) : ue(t, {});
    },
    getterFor: function getterFor(t) {
      return function (e) {
        var i;
        if (!_(e) || (i = ce(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
        return i;
      };
    }
  },
      xe = $t("species"),
      De = function De(t, e) {
    var i;
    return Ct(t) && ("function" != typeof (i = t.constructor) || i !== Array && !Ct(i.prototype) ? _(i) && null === (i = i[xe]) && (i = void 0) : i = void 0), new (void 0 === i ? Array : i)(0 === e ? 0 : e);
  },
      Se = [].push,
      Ce = function Ce(t) {
    var e = 1 == t,
        i = 2 == t,
        n = 3 == t,
        o = 4 == t,
        r = 6 == t,
        s = 7 == t,
        a = 5 == t || r;
    return function (l, h, u, c) {
      for (var d, p, f = Tt(l), m = g(f), v = j(h, u, 3), y = Q(m.length), b = 0, _ = c || De, w = e ? _(l, y) : i || s ? _(l, 0) : void 0; y > b; b++) {
        if ((a || b in m) && (p = v(d = m[b], b, f), t)) if (e) w[b] = p;else if (p) switch (t) {
          case 3:
            return !0;

          case 5:
            return d;

          case 6:
            return b;

          case 2:
            Se.call(w, d);
        } else switch (t) {
          case 4:
            return !1;

          case 7:
            Se.call(w, d);
        }
      }

      return r ? -1 : n || o ? o : w;
    };
  },
      Te = {
    forEach: Ce(0),
    map: Ce(1),
    filter: Ce(2),
    some: Ce(3),
    every: Ce(4),
    find: Ce(5),
    findIndex: Ce(6),
    filterOut: Ce(7)
  },
      Me = Te.forEach,
      Oe = Rt("hidden"),
      Ee = "Symbol",
      Pe = $t("toPrimitive"),
      Ae = ke.set,
      Le = ke.getterFor(Ee),
      Ie = Object.prototype,
      _Ne = a.Symbol,
      Re = pt("JSON", "stringify"),
      Fe = O.f,
      Ye = G.f,
      je = Vt.f,
      He = d.f,
      ze = Pt("symbols"),
      Ge = Pt("op-symbols"),
      We = Pt("string-to-symbol-registry"),
      Be = Pt("symbol-to-string-registry"),
      Ve = Pt("wks"),
      Ue = a.QObject,
      Xe = !Ue || !Ue.prototype || !Ue.prototype.findChild,
      qe = h && l(function () {
    return 7 != zt(Ye({}, "a", {
      get: function get() {
        return Ye(this, "a", {
          value: 7
        }).a;
      }
    })).a;
  }) ? function (t, e, i) {
    var n = Fe(Ie, e);
    n && delete Ie[e], Ye(t, e, i), n && t !== Ie && Ye(Ie, e, n);
  } : Ye,
      Ze = function Ze(t, e) {
    var i = ze[t] = zt(_Ne.prototype);
    return Ae(i, {
      type: Ee,
      tag: t,
      description: e
    }), h || (i.description = e), i;
  },
      $e = St ? function (t) {
    return "symbol" == typeof t;
  } : function (t) {
    return Object(t) instanceof _Ne;
  },
      Ke = function Ke(t, e, i) {
    t === Ie && Ke(Ge, e, i), H(t);
    var n = w(e, !0);
    return H(i), x(ze, n) ? (i.enumerable ? (x(t, Oe) && t[Oe][n] && (t[Oe][n] = !1), i = zt(i, {
      enumerable: p(0, !1)
    })) : (x(t, Oe) || Ye(t, Oe, p(1, {})), t[Oe][n] = !0), qe(t, n, i)) : Ye(t, n, i);
  },
      Je = function Je(t, e) {
    H(t);
    var i = b(e),
        n = ht(i).concat(ii(i));
    return Me(n, function (e) {
      h && !Qe.call(i, e) || Ke(t, e, i[e]);
    }), t;
  },
      Qe = function Qe(t) {
    var e = w(t, !0),
        i = He.call(this, e);
    return !(this === Ie && x(ze, e) && !x(Ge, e)) && (!(i || !x(this, e) || !x(ze, e) || x(this, Oe) && this[Oe][e]) || i);
  },
      ti = function ti(t, e) {
    var i = b(t),
        n = w(e, !0);

    if (i !== Ie || !x(ze, n) || x(Ge, n)) {
      var o = Fe(i, n);
      return !o || !x(ze, n) || x(i, Oe) && i[Oe][n] || (o.enumerable = !0), o;
    }
  },
      ei = function ei(t) {
    var e = je(b(t)),
        i = [];
    return Me(e, function (t) {
      x(ze, t) || x(rt, t) || i.push(t);
    }), i;
  },
      ii = function ii(t) {
    var e = t === Ie,
        i = je(e ? Ge : b(t)),
        n = [];
    return Me(i, function (t) {
      !x(ze, t) || e && !x(Ie, t) || n.push(ze[t]);
    }), n;
  };

  if (Dt || (Ut((_Ne = function Ne() {
    if (this instanceof _Ne) throw TypeError("Symbol is not a constructor");

    var t = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
        e = It(t),
        i = function i(t) {
      this === Ie && i.call(Ge, t), x(this, Oe) && x(this[Oe], e) && (this[Oe][e] = !1), qe(this, e, p(1, t));
    };

    return h && Xe && qe(Ie, e, {
      configurable: !0,
      set: i
    }), Ze(e, t);
  }).prototype, "toString", function () {
    return Le(this).tag;
  }), Ut(_Ne, "withoutSetter", function (t) {
    return Ze(It(t), t);
  }), d.f = Qe, G.f = Ke, O.f = ti, mt.f = Vt.f = ei, vt.f = ii, Kt.f = function (t) {
    return Ze($t(t), t);
  }, h && Ye(_Ne.prototype, "description", {
    configurable: !0,
    get: function get() {
      return Le(this).description;
    }
  })), U({
    global: !0,
    wrap: !0,
    forced: !Dt,
    sham: !Dt
  }, {
    Symbol: _Ne
  }), Me(ht(Ve), function (t) {
    Qt(t);
  }), U({
    target: Ee,
    stat: !0,
    forced: !Dt
  }, {
    for: function _for(t) {
      var e = String(t);
      if (x(We, e)) return We[e];

      var i = _Ne(e);

      return We[e] = i, Be[i] = e, i;
    },
    keyFor: function keyFor(t) {
      if (!$e(t)) throw TypeError(t + " is not a symbol");
      if (x(Be, t)) return Be[t];
    },
    useSetter: function useSetter() {
      Xe = !0;
    },
    useSimple: function useSimple() {
      Xe = !1;
    }
  }), U({
    target: "Object",
    stat: !0,
    forced: !Dt,
    sham: !h
  }, {
    create: function create(t, e) {
      return void 0 === e ? zt(t) : Je(zt(t), e);
    },
    defineProperty: Ke,
    defineProperties: Je,
    getOwnPropertyDescriptor: ti
  }), U({
    target: "Object",
    stat: !0,
    forced: !Dt
  }, {
    getOwnPropertyNames: ei,
    getOwnPropertySymbols: ii
  }), U({
    target: "Object",
    stat: !0,
    forced: l(function () {
      vt.f(1);
    })
  }, {
    getOwnPropertySymbols: function getOwnPropertySymbols(t) {
      return vt.f(Tt(t));
    }
  }), Re) {
    var ni = !Dt || l(function () {
      var t = _Ne();

      return "[null]" != Re([t]) || "{}" != Re({
        a: t
      }) || "{}" != Re(Object(t));
    });
    U({
      target: "JSON",
      stat: !0,
      forced: ni
    }, {
      stringify: function stringify(t, e, i) {
        for (var n, o = [t], r = 1; arguments.length > r;) {
          o.push(arguments[r++]);
        }

        if (n = e, (_(e) || void 0 !== t) && !$e(t)) return Ct(e) || (e = function e(t, _e3) {
          if ("function" == typeof n && (_e3 = n.call(this, t, _e3)), !$e(_e3)) return _e3;
        }), o[1] = e, Re.apply(null, o);
      }
    });
  }

  _Ne.prototype[Pe] || W(_Ne.prototype, Pe, _Ne.prototype.valueOf), le(_Ne, Ee), rt[Oe] = !0;
  var oi,
      ri,
      si,
      ai = F.Object.getOwnPropertySymbols,
      li = {},
      hi = !l(function () {
    function t() {}

    return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
  }),
      ui = Rt("IE_PROTO"),
      ci = Object.prototype,
      di = hi ? Object.getPrototypeOf : function (t) {
    return t = Tt(t), x(t, ui) ? t[ui] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? ci : null;
  },
      pi = ($t("iterator"), !1);
  [].keys && ("next" in (si = [].keys()) ? (ri = di(di(si))) !== Object.prototype && (oi = ri) : pi = !0), null == oi && (oi = {});

  var fi = {
    IteratorPrototype: oi,
    BUGGY_SAFARI_ITERATORS: pi
  },
      mi = fi.IteratorPrototype,
      vi = function vi() {
    return this;
  },
      gi = Object.setPrototypeOf || ("__proto__" in {} ? function () {
    var t,
        e = !1,
        i = {};

    try {
      (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(i, []), e = i instanceof Array;
    } catch (t) {}

    return function (i, n) {
      return H(i), function (t) {
        if (!_(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
      }(n), e ? t.call(i, n) : i.__proto__ = n, i;
    };
  }() : void 0),
      yi = fi.IteratorPrototype,
      bi = fi.BUGGY_SAFARI_ITERATORS,
      _i = $t("iterator"),
      wi = "keys",
      ki = "values",
      xi = "entries",
      Di = function Di() {
    return this;
  },
      Si = function Si(t, e, i, n, o, r, s) {
    !function (t, e, i) {
      var n = e + " Iterator";
      t.prototype = zt(mi, {
        next: p(1, i)
      }), le(t, n, !1, !0), li[n] = vi;
    }(i, e, n);

    var a,
        l,
        h,
        u = function u(t) {
      if (t === o && v) return v;
      if (!bi && t in f) return f[t];

      switch (t) {
        case wi:
        case ki:
        case xi:
          return function () {
            return new i(this, t);
          };
      }

      return function () {
        return new i(this);
      };
    },
        c = e + " Iterator",
        d = !1,
        f = t.prototype,
        m = f[_i] || f["@@iterator"] || o && f[o],
        v = !bi && m || u(o),
        g = "Array" == e && f.entries || m;

    if (g && (a = di(g.call(new t())), yi !== Object.prototype && a.next && (le(a, c, !0, !0), li[c] = Di)), o == ki && m && m.name !== ki && (d = !0, v = function v() {
      return m.call(this);
    }), s && f[_i] !== v && W(f, _i, v), li[e] = v, o) if (l = {
      values: u(ki),
      keys: r ? v : u(wi),
      entries: u(xi)
    }, s) for (h in l) {
      (bi || d || !(h in f)) && Ut(f, h, l[h]);
    } else U({
      target: e,
      proto: !0,
      forced: bi || d
    }, l);
    return l;
  },
      Ci = "Array Iterator",
      Ti = ke.set,
      Mi = ke.getterFor(Ci);

  Si(Array, "Array", function (t, e) {
    Ti(this, {
      type: Ci,
      target: b(t),
      index: 0,
      kind: e
    });
  }, function () {
    var t = Mi(this),
        e = t.target,
        i = t.kind,
        n = t.index++;
    return !e || n >= e.length ? (t.target = void 0, {
      value: void 0,
      done: !0
    }) : "keys" == i ? {
      value: n,
      done: !1
    } : "values" == i ? {
      value: e[n],
      done: !1
    } : {
      value: [n, e[n]],
      done: !1
    };
  }, "values");
  li.Arguments = li.Array;
  var Oi = $t("toStringTag");

  for (var Ei in {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }) {
    var Pi = a[Ei],
        Ai = Pi && Pi.prototype;
    Ai && oe(Ai) !== Oi && W(Ai, Oi, Ei), li[Ei] = li.Array;
  }

  var Li = function Li(t) {
    return function (e, i) {
      var n,
          o,
          r = String(y(e)),
          s = K(i),
          a = r.length;
      return s < 0 || s >= a ? t ? "" : void 0 : (n = r.charCodeAt(s)) < 55296 || n > 56319 || s + 1 === a || (o = r.charCodeAt(s + 1)) < 56320 || o > 57343 ? t ? r.charAt(s) : n : t ? r.slice(s, s + 2) : o - 56320 + (n - 55296 << 10) + 65536;
    };
  },
      Ii = {
    codeAt: Li(!1),
    charAt: Li(!0)
  }.charAt,
      Ni = "String Iterator",
      Ri = ke.set,
      Fi = ke.getterFor(Ni);

  Si(String, "String", function (t) {
    Ri(this, {
      type: Ni,
      string: String(t),
      index: 0
    });
  }, function () {
    var t,
        e = Fi(this),
        i = e.string,
        n = e.index;
    return n >= i.length ? {
      value: void 0,
      done: !0
    } : (t = Ii(i, n), e.index += t.length, {
      value: t,
      done: !1
    });
  });

  var Yi = $t("iterator"),
      ji = function ji(t) {
    if (null != t) return t[Yi] || t["@@iterator"] || li[oe(t)];
  },
      Hi = function Hi(t) {
    var e = ji(t);
    if ("function" != typeof e) throw TypeError(String(t) + " is not iterable");
    return H(e.call(t));
  },
      zi = ji,
      Gi = function Gi(t) {
    var e = t.return;
    if (void 0 !== e) return H(e.call(t)).value;
  },
      Wi = function Wi(t, e, i, n) {
    try {
      return n ? e(H(i)[0], i[1]) : e(i);
    } catch (e) {
      throw Gi(t), e;
    }
  },
      Bi = $t("iterator"),
      Vi = Array.prototype,
      Ui = function Ui(t) {
    return void 0 !== t && (li.Array === t || Vi[Bi] === t);
  },
      Xi = $t("iterator"),
      qi = !1;

  try {
    var Zi = 0,
        $i = {
      next: function next() {
        return {
          done: !!Zi++
        };
      },
      return: function _return() {
        qi = !0;
      }
    };
    $i[Xi] = function () {
      return this;
    }, Array.from($i, function () {
      throw 2;
    });
  } catch (t) {}

  var Ki = !function (t, e) {
    if (!e && !qi) return !1;
    var i = !1;

    try {
      var n = {};
      n[Xi] = function () {
        return {
          next: function next() {
            return {
              done: i = !0
            };
          }
        };
      }, t(n);
    } catch (t) {}

    return i;
  }(function (t) {
    Array.from(t);
  });
  U({
    target: "Array",
    stat: !0,
    forced: Ki
  }, {
    from: function from(t) {
      var e,
          i,
          n,
          o,
          r,
          s,
          a = Tt(t),
          l = "function" == typeof this ? this : Array,
          h = arguments.length,
          u = h > 1 ? arguments[1] : void 0,
          c = void 0 !== u,
          d = ji(a),
          p = 0;
      if (c && (u = j(u, h > 2 ? arguments[2] : void 0, 2)), null == d || l == Array && Ui(d)) for (i = new l(e = Q(a.length)); e > p; p++) {
        s = c ? u(a[p], p) : a[p], yt(i, p, s);
      } else for (r = (o = d.call(a)).next, i = new l(); !(n = r.call(o)).done; p++) {
        s = c ? Wi(o, u, [n.value, p], !0) : n.value, yt(i, p, s);
      }
      return i.length = p, i;
    }
  });
  var Ji = F.Array.from,
      Qi = Ji;
  U({
    target: "Array",
    proto: !0
  }, {
    fill: function fill(t) {
      for (var e = Tt(this), i = Q(e.length), n = arguments.length, o = it(n > 1 ? arguments[1] : void 0, i), r = n > 2 ? arguments[2] : void 0, s = void 0 === r ? i : it(r, i); s > o;) {
        e[o++] = t;
      }

      return e;
    }
  });

  var tn = function tn(t) {
    return F[t + "Prototype"];
  },
      en = tn("Array").fill,
      nn = Array.prototype,
      on = function on(t) {
    var e = t.fill;
    return t === nn || t instanceof Array && e === nn.fill ? en : e;
  },
      rn = pt("navigator", "userAgent") || "",
      sn = [].slice,
      an = /MSIE .\./.test(rn),
      ln = function ln(t) {
    return function (e, i) {
      var n = arguments.length > 2,
          o = n ? sn.call(arguments, 2) : void 0;
      return t(n ? function () {
        ("function" == typeof e ? e : Function(e)).apply(this, o);
      } : e, i);
    };
  };

  U({
    global: !0,
    bind: !0,
    forced: an
  }, {
    setTimeout: ln(a.setTimeout),
    setInterval: ln(a.setInterval)
  });

  var hn = F.setTimeout,
      un = pt("JSON", "stringify"),
      cn = /[\uD800-\uDFFF]/g,
      dn = /^[\uD800-\uDBFF]$/,
      pn = /^[\uDC00-\uDFFF]$/,
      fn = function fn(t, e, i) {
    var n = i.charAt(e - 1),
        o = i.charAt(e + 1);
    return dn.test(t) && !pn.test(o) || pn.test(t) && !dn.test(n) ? "\\u" + t.charCodeAt(0).toString(16) : t;
  },
      mn = l(function () {
    return "\"\\udf06\\ud834\"" !== un("\uDF06\uD834") || "\"\\udead\"" !== un("\uDEAD");
  });

  un && U({
    target: "JSON",
    stat: !0,
    forced: mn
  }, {
    stringify: function stringify(t, e, i) {
      var n = un.apply(null, arguments);
      return "string" == typeof n ? n.replace(cn, fn) : n;
    }
  }), F.JSON || (F.JSON = {
    stringify: JSON.stringify
  });

  var vn = function vn(t, e, i) {
    return F.JSON.stringify.apply(null, arguments);
  };

  var gn = function gn(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  },
      yn = X;

  function bn(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), yn(t, n.key, n);
    }
  }

  var _n = function _n(t, e, i) {
    return e && bn(t.prototype, e), i && bn(t, i), t;
  };

  U({
    target: "Object",
    stat: !0,
    sham: !h
  }, {
    create: zt
  });

  var wn = F.Object,
      kn = function kn(t, e) {
    return wn.create(t, e);
  },
      xn = kn;

  var Dn,
      Sn = function Sn(t, e, i) {
    return e in t ? yn(t, e, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = i, t;
  },
      Cn = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
      Tn = "[" + Cn + "]",
      Mn = RegExp("^" + Tn + Tn + "*"),
      On = RegExp(Tn + Tn + "*$"),
      En = function En(t) {
    return function (e) {
      var i = String(y(e));
      return 1 & t && (i = i.replace(Mn, "")), 2 & t && (i = i.replace(On, "")), i;
    };
  },
      Pn = {
    start: En(1),
    end: En(2),
    trim: En(3)
  },
      An = Pn.trim;

  U({
    target: "String",
    proto: !0,
    forced: (Dn = "trim", l(function () {
      return !!Cn[Dn]() || "​᠎" != "​᠎"[Dn]() || Cn[Dn].name !== Dn;
    }))
  }, {
    trim: function trim() {
      return An(this);
    }
  });

  var Ln = tn("String").trim,
      In = String.prototype,
      Nn = function Nn(t) {
    var e = t.trim;
    return "string" == typeof t || t === In || t instanceof String && e === In.trim ? Ln : e;
  },
      Rn = function Rn(t, e) {
    var i = [][t];
    return !!i && l(function () {
      i.call(null, e || function () {
        throw 1;
      }, 1);
    });
  },
      Fn = Object.defineProperty,
      Yn = {},
      jn = function jn(t) {
    throw t;
  },
      Hn = function Hn(t, e) {
    if (x(Yn, t)) return Yn[t];
    e || (e = {});
    var i = [][t],
        n = !!x(e, "ACCESSORS") && e.ACCESSORS,
        o = x(e, 0) ? e[0] : jn,
        r = x(e, 1) ? e[1] : void 0;
    return Yn[t] = !!i && !l(function () {
      if (n && !h) return !0;
      var t = {
        length: -1
      };
      n ? Fn(t, 1, {
        enumerable: !0,
        get: jn
      }) : t[1] = 1, i.call(t, o, r);
    });
  },
      zn = ot.indexOf,
      Gn = [].indexOf,
      Wn = !!Gn && 1 / [1].indexOf(1, -0) < 0,
      Bn = Rn("indexOf"),
      Vn = Hn("indexOf", {
    ACCESSORS: !0,
    1: 0
  });

  U({
    target: "Array",
    proto: !0,
    forced: Wn || !Bn || !Vn
  }, {
    indexOf: function indexOf(t) {
      return Wn ? Gn.apply(this, arguments) || 0 : zn(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var Un = tn("Array").indexOf,
      Xn = Array.prototype,
      qn = function qn(t) {
    var e = t.indexOf;
    return t === Xn || t instanceof Array && e === Xn.indexOf ? Un : e;
  },
      Zn = Pn.trim,
      $n = a.parseInt,
      Kn = /^[+-]?0[Xx]/,
      Jn = 8 !== $n(Cn + "08") || 22 !== $n(Cn + "0x16") ? function (t, e) {
    var i = Zn(String(t));
    return $n(i, e >>> 0 || (Kn.test(i) ? 16 : 10));
  } : $n;

  U({
    global: !0,
    forced: parseInt != Jn
  }, {
    parseInt: Jn
  });

  var Qn = F.parseInt,
      to = d.f,
      eo = function eo(t) {
    return function (e) {
      for (var i, n = b(e), o = ht(n), r = o.length, s = 0, a = []; r > s;) {
        i = o[s++], h && !to.call(n, i) || a.push(t ? [i, n[i]] : n[i]);
      }

      return a;
    };
  },
      io = {
    entries: eo(!0),
    values: eo(!1)
  }.values;

  U({
    target: "Object",
    stat: !0
  }, {
    values: function values(t) {
      return io(t);
    }
  });
  var no,
      oo,
      ro = F.Object.values,
      so = a.process,
      ao = so && so.versions,
      lo = ao && ao.v8;
  lo ? oo = (no = lo.split("."))[0] + no[1] : rn && (!(no = rn.match(/Edge\/(\d+)/)) || no[1] >= 74) && (no = rn.match(/Chrome\/(\d+)/)) && (oo = no[1]);

  var ho = oo && +oo,
      uo = $t("species"),
      co = function co(t) {
    return ho >= 51 || !l(function () {
      var e = [];
      return (e.constructor = {})[uo] = function () {
        return {
          foo: 1
        };
      }, 1 !== e[t](Boolean).foo;
    });
  },
      po = Te.filter,
      fo = co("filter"),
      mo = Hn("filter");

  U({
    target: "Array",
    proto: !0,
    forced: !fo || !mo
  }, {
    filter: function filter(t) {
      return po(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var vo = tn("Array").filter,
      go = Array.prototype,
      yo = function yo(t) {
    var e = t.filter;
    return t === go || t instanceof Array && e === go.filter ? vo : e;
  },
      bo = l(function () {
    di(1);
  });

  U({
    target: "Object",
    stat: !0,
    forced: bo,
    sham: !hi
  }, {
    getPrototypeOf: function getPrototypeOf(t) {
      return di(Tt(t));
    }
  });
  var _o = F.Object.getPrototypeOf,
      wo = _o,
      ko = ot.includes,
      xo = Hn("indexOf", {
    ACCESSORS: !0,
    1: 0
  });
  U({
    target: "Array",
    proto: !0,
    forced: !xo
  }, {
    includes: function includes(t) {
      return ko(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var Do = tn("Array").includes,
      So = $t("match"),
      Co = function Co(t) {
    if (function (t) {
      var e;
      return _(t) && (void 0 !== (e = t[So]) ? !!e : "RegExp" == m(t));
    }(t)) throw TypeError("The method doesn't accept regular expressions");
    return t;
  },
      To = $t("match");

  U({
    target: "String",
    proto: !0,
    forced: !function (t) {
      var e = /./;

      try {
        "/./"[t](e);
      } catch (i) {
        try {
          return e[To] = !1, "/./"[t](e);
        } catch (t) {}
      }

      return !1;
    }("includes")
  }, {
    includes: function includes(t) {
      return !!~String(y(this)).indexOf(Co(t), arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var Mo = tn("String").includes,
      Oo = Array.prototype,
      Eo = String.prototype,
      Po = function Po(t) {
    var e = t.includes;
    return t === Oo || t instanceof Array && e === Oo.includes ? Do : "string" == typeof t || t === Eo || t instanceof String && e === Eo.includes ? Mo : e;
  },
      Ao = Object.assign,
      Lo = Object.defineProperty,
      Io = !Ao || l(function () {
    if (h && 1 !== Ao({
      b: 1
    }, Ao(Lo({}, "a", {
      enumerable: !0,
      get: function get() {
        Lo(this, "b", {
          value: 3,
          enumerable: !1
        });
      }
    }), {
      b: 2
    })).b) return !0;
    var t = {},
        e = {},
        i = Symbol(),
        n = "abcdefghijklmnopqrst";
    return t[i] = 7, n.split("").forEach(function (t) {
      e[t] = t;
    }), 7 != Ao({}, t)[i] || ht(Ao({}, e)).join("") != n;
  }) ? function (t, e) {
    for (var i = Tt(t), n = arguments.length, o = 1, r = vt.f, s = d.f; n > o;) {
      for (var a, l = g(arguments[o++]), u = r ? ht(l).concat(r(l)) : ht(l), c = u.length, p = 0; c > p;) {
        a = u[p++], h && !s.call(l, a) || (i[a] = l[a]);
      }
    }

    return i;
  } : Ao;

  U({
    target: "Object",
    stat: !0,
    forced: Object.assign !== Io
  }, {
    assign: Io
  });
  var No = F.Object.assign,
      Ro = co("splice"),
      Fo = Hn("splice", {
    ACCESSORS: !0,
    0: 0,
    1: 2
  }),
      Yo = Math.max,
      jo = Math.min,
      Ho = 9007199254740991,
      zo = "Maximum allowed length exceeded";
  U({
    target: "Array",
    proto: !0,
    forced: !Ro || !Fo
  }, {
    splice: function splice(t, e) {
      var i,
          n,
          o,
          r,
          s,
          a,
          l = Tt(this),
          h = Q(l.length),
          u = it(t, h),
          c = arguments.length;
      if (0 === c ? i = n = 0 : 1 === c ? (i = 0, n = h - u) : (i = c - 2, n = jo(Yo(K(e), 0), h - u)), h + i - n > Ho) throw TypeError(zo);

      for (o = De(l, n), r = 0; r < n; r++) {
        (s = u + r) in l && yt(o, r, l[s]);
      }

      if (o.length = n, i < n) {
        for (r = u; r < h - n; r++) {
          a = r + i, (s = r + n) in l ? l[a] = l[s] : delete l[a];
        }

        for (r = h; r > h - n + i; r--) {
          delete l[r - 1];
        }
      } else if (i > n) for (r = h - n; r > u; r--) {
        a = r + i - 1, (s = r + n - 1) in l ? l[a] = l[s] : delete l[a];
      }

      for (r = 0; r < i; r++) {
        l[r + u] = arguments[r + 2];
      }

      return l.length = h - n + i, o;
    }
  });

  var Go = tn("Array").splice,
      Wo = Array.prototype,
      Bo = function Bo(t) {
    var e = t.splice;
    return t === Wo || t instanceof Array && e === Wo.splice ? Go : e;
  },
      Vo = [].reverse,
      Uo = [1, 2];

  U({
    target: "Array",
    proto: !0,
    forced: String(Uo) === String(Uo.reverse())
  }, {
    reverse: function reverse() {
      return Ct(this) && (this.length = this.length), Vo.call(this);
    }
  });

  var Xo = tn("Array").reverse,
      qo = Array.prototype,
      Zo = function Zo(t) {
    var e = t.reverse;
    return t === qo || t instanceof Array && e === qo.reverse ? Xo : e;
  },
      $o = Te.forEach,
      Ko = Rn("forEach"),
      Jo = Hn("forEach"),
      Qo = Ko && Jo ? [].forEach : function (t) {
    return $o(this, t, arguments.length > 1 ? arguments[1] : void 0);
  };

  U({
    target: "Array",
    proto: !0,
    forced: [].forEach != Qo
  }, {
    forEach: Qo
  });

  var tr = tn("Array").forEach,
      er = Array.prototype,
      ir = {
    DOMTokenList: !0,
    NodeList: !0
  },
      nr = function nr(t) {
    var e = t.forEach;
    return t === er || t instanceof Array && e === er.forEach || ir.hasOwnProperty(oe(t)) ? tr : e;
  },
      or = [].slice,
      rr = {},
      sr = function sr(t, e, i) {
    if (!(e in rr)) {
      for (var n = [], o = 0; o < e; o++) {
        n[o] = "a[" + o + "]";
      }

      rr[e] = Function("C,a", "return new C(" + n.join(",") + ")");
    }

    return rr[e](t, i);
  },
      ar = Function.bind || function (t) {
    var e = Y(this),
        i = or.call(arguments, 1),
        n = function n() {
      var o = i.concat(or.call(arguments));
      return this instanceof n ? sr(e, o.length, o) : e.apply(t, o);
    };

    return _(e.prototype) && (n.prototype = e.prototype), n;
  };

  U({
    target: "Function",
    proto: !0
  }, {
    bind: ar
  });

  var lr = tn("Function").bind,
      hr = Function.prototype,
      ur = function ur(t) {
    var e = t.bind;
    return t === hr || t instanceof Function && e === hr.bind ? lr : e;
  };

  U({
    target: "Array",
    stat: !0
  }, {
    isArray: Ct
  });
  var cr = F.Array.isArray,
      dr = cr;

  var pr = function pr(t) {
    if (dr(t)) return t;
  },
      fr = $t("iterator"),
      mr = function mr(t) {
    var e = Object(t);
    return void 0 !== e[fr] || "@@iterator" in e || li.hasOwnProperty(oe(e));
  },
      vr = $t("isConcatSpreadable"),
      gr = 9007199254740991,
      yr = "Maximum allowed index exceeded",
      br = ho >= 51 || !l(function () {
    var t = [];
    return t[vr] = !1, t.concat()[0] !== t;
  }),
      _r = co("concat"),
      wr = function wr(t) {
    if (!_(t)) return !1;
    var e = t[vr];
    return void 0 !== e ? !!e : Ct(t);
  };

  U({
    target: "Array",
    proto: !0,
    forced: !br || !_r
  }, {
    concat: function concat(t) {
      var e,
          i,
          n,
          o,
          r,
          s = Tt(this),
          a = De(s, 0),
          l = 0;

      for (e = -1, n = arguments.length; e < n; e++) {
        if (wr(r = -1 === e ? s : arguments[e])) {
          if (l + (o = Q(r.length)) > gr) throw TypeError(yr);

          for (i = 0; i < o; i++, l++) {
            i in r && yt(a, l, r[i]);
          }
        } else {
          if (l >= gr) throw TypeError(yr);
          yt(a, l++, r);
        }
      }

      return a.length = l, a;
    }
  });
  var kr = Object.freeze({
    __proto__: null
  });
  Qt("asyncIterator");
  var xr = Object.freeze({
    __proto__: null
  });
  Qt("hasInstance"), Qt("isConcatSpreadable"), Qt("iterator"), Qt("match"), Qt("matchAll"), Qt("replace"), Qt("search"), Qt("species"), Qt("split"), Qt("toPrimitive"), Qt("toStringTag"), Qt("unscopables"), le(a.JSON, "JSON", !0);
  var Dr = Object.freeze({
    __proto__: null
  }),
      Sr = Object.freeze({
    __proto__: null
  });
  o(kr), o(xr), o(Dr), o(Sr);
  var Cr = F.Symbol;
  Qt("asyncDispose"), Qt("dispose"), Qt("observable"), Qt("patternMatch"), Qt("replaceAll");
  var Tr = Cr;

  var Mr = function Mr(t, e) {
    if (void 0 !== Tr && mr(Object(t))) {
      var i = [],
          n = !0,
          o = !1,
          r = void 0;

      try {
        for (var s, a = Hi(t); !(n = (s = a.next()).done) && (i.push(s.value), !e || i.length !== e); n = !0) {
          ;
        }
      } catch (t) {
        o = !0, r = t;
      } finally {
        try {
          n || null == a.return || a.return();
        } finally {
          if (o) throw r;
        }
      }

      return i;
    }
  },
      Or = Ji,
      Er = co("slice"),
      Pr = Hn("slice", {
    ACCESSORS: !0,
    0: 0,
    1: 2
  }),
      Ar = $t("species"),
      Lr = [].slice,
      Ir = Math.max;

  U({
    target: "Array",
    proto: !0,
    forced: !Er || !Pr
  }, {
    slice: function slice(t, e) {
      var i,
          n,
          o,
          r = b(this),
          s = Q(r.length),
          a = it(t, s),
          l = it(void 0 === e ? s : e, s);
      if (Ct(r) && ("function" != typeof (i = r.constructor) || i !== Array && !Ct(i.prototype) ? _(i) && null === (i = i[Ar]) && (i = void 0) : i = void 0, i === Array || void 0 === i)) return Lr.call(r, a, l);

      for (n = new (void 0 === i ? Array : i)(Ir(l - a, 0)), o = 0; a < l; a++, o++) {
        a in r && yt(n, o, r[a]);
      }

      return n.length = o, n;
    }
  });

  var Nr = tn("Array").slice,
      Rr = Array.prototype,
      Fr = function Fr(t) {
    var e = t.slice;
    return t === Rr || t instanceof Array && e === Rr.slice ? Nr : e;
  },
      Yr = Fr;

  var jr = function jr(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, n = new Array(e); i < e; i++) {
      n[i] = t[i];
    }

    return n;
  };

  var Hr = function Hr(t, e) {
    var i;

    if (t) {
      if ("string" == typeof t) return jr(t, e);
      var n = Yr(i = Object.prototype.toString.call(t)).call(i, 8, -1);
      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Or(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? jr(t, e) : void 0;
    }
  };

  var zr = function zr() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  };

  var Gr = function Gr(t, e) {
    return pr(t) || Mr(t, e) || Hr(t, e) || zr();
  };

  U({
    target: "Date",
    stat: !0
  }, {
    now: function now() {
      return new Date().getTime();
    }
  });
  var Wr = F.Date.now,
      Br = l(function () {
    ht(1);
  });
  U({
    target: "Object",
    stat: !0,
    forced: Br
  }, {
    keys: function keys(t) {
      return ht(Tt(t));
    }
  });
  var Vr = F.Object.keys,
      Ur = Te.map,
      Xr = co("map"),
      qr = Hn("map");
  U({
    target: "Array",
    proto: !0,
    forced: !Xr || !qr
  }, {
    map: function map(t) {
      return Ur(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var Zr = tn("Array").map,
      $r = Array.prototype,
      Kr = function Kr(t) {
    var e = t.map;
    return t === $r || t instanceof Array && e === $r.map ? Zr : e;
  },
      Jr = cr,
      Qr = Kt.f("iterator"),
      ts = Qr,
      es = n(function (t) {
    function e(i) {
      return t.exports = e = "function" == typeof Tr && "symbol" == typeof ts ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Tr && t.constructor === Tr && t !== Tr.prototype ? "symbol" : typeof t;
      }, e(i);
    }

    t.exports = e;
  });

  U({
    target: "Reflect",
    stat: !0
  }, {
    ownKeys: gt
  });
  var is = F.Reflect.ownKeys,
      ns = Fr;

  var os = function os(t) {
    if (dr(t)) return jr(t);
  };

  var rs = function rs(t) {
    if (void 0 !== Tr && mr(Object(t))) return Or(t);
  };

  var ss = function ss() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  };

  var as = function as(t) {
    return os(t) || rs(t) || Hr(t) || ss();
  },
      ls = tn("Array").concat,
      hs = Array.prototype,
      us = function us(t) {
    var e = t.concat;
    return t === hs || t instanceof Array && e === hs.concat ? ls : e;
  },
      cs = Cr,
      ds = n(function (t) {
    function e(t) {
      if (t) return function (t) {
        for (var i in e.prototype) {
          t[i] = e.prototype[i];
        }

        return t;
      }(t);
    }

    t.exports = e, e.prototype.on = e.prototype.addEventListener = function (t, e) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
    }, e.prototype.once = function (t, e) {
      function i() {
        this.off(t, i), e.apply(this, arguments);
      }

      return i.fn = e, this.on(t, i), this;
    }, e.prototype.off = e.prototype.removeListener = e.prototype.removeAllListeners = e.prototype.removeEventListener = function (t, e) {
      if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
      var i,
          n = this._callbacks["$" + t];
      if (!n) return this;
      if (1 == arguments.length) return delete this._callbacks["$" + t], this;

      for (var o = 0; o < n.length; o++) {
        if ((i = n[o]) === e || i.fn === e) {
          n.splice(o, 1);
          break;
        }
      }

      return 0 === n.length && delete this._callbacks["$" + t], this;
    }, e.prototype.emit = function (t) {
      this._callbacks = this._callbacks || {};

      for (var e = new Array(arguments.length - 1), i = this._callbacks["$" + t], n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }

      if (i) {
        n = 0;

        for (var o = (i = i.slice(0)).length; n < o; ++n) {
          i[n].apply(this, e);
        }
      }

      return this;
    }, e.prototype.listeners = function (t) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
    }, e.prototype.hasListeners = function (t) {
      return !!this.listeners(t).length;
    };
  });
  /*! Hammer.JS - v2.0.17-rc - 2019-12-16
  	 * http://naver.github.io/egjs
  	 *
  	 * Forked By Naver egjs
  	 * Copyright (c) hammerjs
  	 * Licensed under the MIT license */


  function ps() {
    return (ps = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = arguments[e];

        for (var n in i) {
          Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  function fs(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
  }

  function ms(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  var vs,
      gs = "function" != typeof Object.assign ? function (t) {
    if (null == t) throw new TypeError("Cannot convert undefined or null to object");

    for (var e = Object(t), i = 1; i < arguments.length; i++) {
      var n = arguments[i];
      if (null != n) for (var o in n) {
        n.hasOwnProperty(o) && (e[o] = n[o]);
      }
    }

    return e;
  } : Object.assign,
      ys = ["", "webkit", "Moz", "MS", "ms", "o"],
      bs = "undefined" == typeof document ? {
    style: {}
  } : document.createElement("div"),
      _s = Math.round,
      ws = Math.abs,
      ks = Date.now;

  function xs(t, e) {
    for (var i, n, o = e[0].toUpperCase() + e.slice(1), r = 0; r < ys.length;) {
      if ((n = (i = ys[r]) ? i + o : e) in t) return n;
      r++;
    }
  }

  vs = "undefined" == typeof window ? {} : window;
  var Ds = xs(bs.style, "touchAction"),
      Ss = void 0 !== Ds;

  var Cs = "compute",
      Ts = "auto",
      Ms = "manipulation",
      Os = "none",
      Es = "pan-x",
      Ps = "pan-y",
      As = function () {
    if (!Ss) return !1;
    var t = {},
        e = vs.CSS && vs.CSS.supports;
    return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function (i) {
      return t[i] = !e || vs.CSS.supports("touch-action", i);
    }), t;
  }(),
      Ls = ("ontouchstart" in vs),
      Is = void 0 !== xs(vs, "PointerEvent"),
      Ns = Ls && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
      Rs = "touch",
      Fs = "mouse",
      Ys = 16,
      js = 24,
      Hs = ["x", "y"],
      zs = ["clientX", "clientY"];

  function Gs(t, e, i) {
    var n;
    if (t) if (t.forEach) t.forEach(e, i);else if (void 0 !== t.length) for (n = 0; n < t.length;) {
      e.call(i, t[n], n, t), n++;
    } else for (n in t) {
      t.hasOwnProperty(n) && e.call(i, t[n], n, t);
    }
  }

  function Ws(t, e) {
    return "function" == typeof t ? t.apply(e && e[0] || void 0, e) : t;
  }

  function Bs(t, e) {
    return t.indexOf(e) > -1;
  }

  var Vs = function () {
    function t(t, e) {
      this.manager = t, this.set(e);
    }

    var e = t.prototype;
    return e.set = function (t) {
      t === Cs && (t = this.compute()), Ss && this.manager.element.style && As[t] && (this.manager.element.style[Ds] = t), this.actions = t.toLowerCase().trim();
    }, e.update = function () {
      this.set(this.manager.options.touchAction);
    }, e.compute = function () {
      var t = [];
      return Gs(this.manager.recognizers, function (e) {
        Ws(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
      }), function (t) {
        if (Bs(t, Os)) return Os;
        var e = Bs(t, Es),
            i = Bs(t, Ps);
        return e && i ? Os : e || i ? e ? Es : Ps : Bs(t, Ms) ? Ms : Ts;
      }(t.join(" "));
    }, e.preventDefaults = function (t) {
      var e = t.srcEvent,
          i = t.offsetDirection;
      if (this.manager.session.prevented) e.preventDefault();else {
        var n = this.actions,
            o = Bs(n, Os) && !As.none,
            r = Bs(n, Ps) && !As["pan-y"],
            s = Bs(n, Es) && !As["pan-x"];

        if (o) {
          var a = 1 === t.pointers.length,
              l = t.distance < 2,
              h = t.deltaTime < 250;
          if (a && l && h) return;
        }

        if (!s || !r) return o || r && 6 & i || s && i & js ? this.preventSrc(e) : void 0;
      }
    }, e.preventSrc = function (t) {
      this.manager.session.prevented = !0, t.preventDefault();
    }, t;
  }();

  function Us(t, e) {
    for (; t;) {
      if (t === e) return !0;
      t = t.parentNode;
    }

    return !1;
  }

  function Xs(t) {
    var e = t.length;
    if (1 === e) return {
      x: _s(t[0].clientX),
      y: _s(t[0].clientY)
    };

    for (var i = 0, n = 0, o = 0; o < e;) {
      i += t[o].clientX, n += t[o].clientY, o++;
    }

    return {
      x: _s(i / e),
      y: _s(n / e)
    };
  }

  function qs(t) {
    for (var e = [], i = 0; i < t.pointers.length;) {
      e[i] = {
        clientX: _s(t.pointers[i].clientX),
        clientY: _s(t.pointers[i].clientY)
      }, i++;
    }

    return {
      timeStamp: ks(),
      pointers: e,
      center: Xs(e),
      deltaX: t.deltaX,
      deltaY: t.deltaY
    };
  }

  function Zs(t, e, i) {
    i || (i = Hs);
    var n = e[i[0]] - t[i[0]],
        o = e[i[1]] - t[i[1]];
    return Math.sqrt(n * n + o * o);
  }

  function $s(t, e, i) {
    i || (i = Hs);
    var n = e[i[0]] - t[i[0]],
        o = e[i[1]] - t[i[1]];
    return 180 * Math.atan2(o, n) / Math.PI;
  }

  function Ks(t, e) {
    return t === e ? 1 : ws(t) >= ws(e) ? t < 0 ? 2 : 4 : e < 0 ? 8 : Ys;
  }

  function Js(t, e, i) {
    return {
      x: e / t || 0,
      y: i / t || 0
    };
  }

  function Qs(t, e) {
    var i = t.session,
        n = e.pointers,
        o = n.length;
    i.firstInput || (i.firstInput = qs(e)), o > 1 && !i.firstMultiple ? i.firstMultiple = qs(e) : 1 === o && (i.firstMultiple = !1);
    var r = i.firstInput,
        s = i.firstMultiple,
        a = s ? s.center : r.center,
        l = e.center = Xs(n);
    e.timeStamp = ks(), e.deltaTime = e.timeStamp - r.timeStamp, e.angle = $s(a, l), e.distance = Zs(a, l), function (t, e) {
      var i = e.center,
          n = t.offsetDelta || {},
          o = t.prevDelta || {},
          r = t.prevInput || {};
      1 !== e.eventType && 4 !== r.eventType || (o = t.prevDelta = {
        x: r.deltaX || 0,
        y: r.deltaY || 0
      }, n = t.offsetDelta = {
        x: i.x,
        y: i.y
      }), e.deltaX = o.x + (i.x - n.x), e.deltaY = o.y + (i.y - n.y);
    }(i, e), e.offsetDirection = Ks(e.deltaX, e.deltaY);
    var h,
        u,
        c = Js(e.deltaTime, e.deltaX, e.deltaY);
    e.overallVelocityX = c.x, e.overallVelocityY = c.y, e.overallVelocity = ws(c.x) > ws(c.y) ? c.x : c.y, e.scale = s ? (h = s.pointers, Zs((u = n)[0], u[1], zs) / Zs(h[0], h[1], zs)) : 1, e.rotation = s ? function (t, e) {
      return $s(e[1], e[0], zs) + $s(t[1], t[0], zs);
    }(s.pointers, n) : 0, e.maxPointers = i.prevInput ? e.pointers.length > i.prevInput.maxPointers ? e.pointers.length : i.prevInput.maxPointers : e.pointers.length, function (t, e) {
      var i,
          n,
          o,
          r,
          s = t.lastInterval || e,
          a = e.timeStamp - s.timeStamp;

      if (8 !== e.eventType && (a > 25 || void 0 === s.velocity)) {
        var l = e.deltaX - s.deltaX,
            h = e.deltaY - s.deltaY,
            u = Js(a, l, h);
        n = u.x, o = u.y, i = ws(u.x) > ws(u.y) ? u.x : u.y, r = Ks(l, h), t.lastInterval = e;
      } else i = s.velocity, n = s.velocityX, o = s.velocityY, r = s.direction;

      e.velocity = i, e.velocityX = n, e.velocityY = o, e.direction = r;
    }(i, e);
    var d,
        p = t.element,
        f = e.srcEvent;
    Us(d = f.composedPath ? f.composedPath()[0] : f.path ? f.path[0] : f.target, p) && (p = d), e.target = p;
  }

  function ta(t, e, i) {
    var n = i.pointers.length,
        o = i.changedPointers.length,
        r = 1 & e && n - o == 0,
        s = 12 & e && n - o == 0;
    i.isFirst = !!r, i.isFinal = !!s, r && (t.session = {}), i.eventType = e, Qs(t, i), t.emit("hammer.input", i), t.recognize(i), t.session.prevInput = i;
  }

  function ea(t) {
    return t.trim().split(/\s+/g);
  }

  function ia(t, e, i) {
    Gs(ea(e), function (e) {
      t.addEventListener(e, i, !1);
    });
  }

  function na(t, e, i) {
    Gs(ea(e), function (e) {
      t.removeEventListener(e, i, !1);
    });
  }

  function oa(t) {
    var e = t.ownerDocument || t;
    return e.defaultView || e.parentWindow || window;
  }

  var ra = function () {
    function t(t, e) {
      var i = this;
      this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function (e) {
        Ws(t.options.enable, [t]) && i.handler(e);
      }, this.init();
    }

    var e = t.prototype;
    return e.handler = function () {}, e.init = function () {
      this.evEl && ia(this.element, this.evEl, this.domHandler), this.evTarget && ia(this.target, this.evTarget, this.domHandler), this.evWin && ia(oa(this.element), this.evWin, this.domHandler);
    }, e.destroy = function () {
      this.evEl && na(this.element, this.evEl, this.domHandler), this.evTarget && na(this.target, this.evTarget, this.domHandler), this.evWin && na(oa(this.element), this.evWin, this.domHandler);
    }, t;
  }();

  function sa(t, e, i) {
    if (t.indexOf && !i) return t.indexOf(e);

    for (var n = 0; n < t.length;) {
      if (i && t[n][i] == e || !i && t[n] === e) return n;
      n++;
    }

    return -1;
  }

  var aa = {
    pointerdown: 1,
    pointermove: 2,
    pointerup: 4,
    pointercancel: 8,
    pointerout: 8
  },
      la = {
    2: Rs,
    3: "pen",
    4: Fs,
    5: "kinect"
  },
      ha = "pointerdown",
      ua = "pointermove pointerup pointercancel";
  vs.MSPointerEvent && !vs.PointerEvent && (ha = "MSPointerDown", ua = "MSPointerMove MSPointerUp MSPointerCancel");

  var ca = function (t) {
    function e() {
      var i,
          n = e.prototype;
      return n.evEl = ha, n.evWin = ua, (i = t.apply(this, arguments) || this).store = i.manager.session.pointerEvents = [], i;
    }

    return fs(e, t), e.prototype.handler = function (t) {
      var e = this.store,
          i = !1,
          n = t.type.toLowerCase().replace("ms", ""),
          o = aa[n],
          r = la[t.pointerType] || t.pointerType,
          s = r === Rs,
          a = sa(e, t.pointerId, "pointerId");
      1 & o && (0 === t.button || s) ? a < 0 && (e.push(t), a = e.length - 1) : 12 & o && (i = !0), a < 0 || (e[a] = t, this.callback(this.manager, o, {
        pointers: e,
        changedPointers: [t],
        pointerType: r,
        srcEvent: t
      }), i && e.splice(a, 1));
    }, e;
  }(ra);

  function da(t) {
    return Array.prototype.slice.call(t, 0);
  }

  function pa(t, e, i) {
    for (var n = [], o = [], r = 0; r < t.length;) {
      var s = e ? t[r][e] : t[r];
      sa(o, s) < 0 && n.push(t[r]), o[r] = s, r++;
    }

    return i && (n = e ? n.sort(function (t, i) {
      return t[e] > i[e];
    }) : n.sort()), n;
  }

  var fa = {
    touchstart: 1,
    touchmove: 2,
    touchend: 4,
    touchcancel: 8
  },
      ma = "touchstart touchmove touchend touchcancel",
      va = function (t) {
    function e() {
      var i;
      return e.prototype.evTarget = ma, (i = t.apply(this, arguments) || this).targetIds = {}, i;
    }

    return fs(e, t), e.prototype.handler = function (t) {
      var e = fa[t.type],
          i = ga.call(this, t, e);
      i && this.callback(this.manager, e, {
        pointers: i[0],
        changedPointers: i[1],
        pointerType: Rs,
        srcEvent: t
      });
    }, e;
  }(ra);

  function ga(t, e) {
    var i,
        n,
        o = da(t.touches),
        r = this.targetIds;
    if (3 & e && 1 === o.length) return r[o[0].identifier] = !0, [o, o];
    var s = da(t.changedTouches),
        a = [],
        l = this.target;
    if (n = o.filter(function (t) {
      return Us(t.target, l);
    }), 1 === e) for (i = 0; i < n.length;) {
      r[n[i].identifier] = !0, i++;
    }

    for (i = 0; i < s.length;) {
      r[s[i].identifier] && a.push(s[i]), 12 & e && delete r[s[i].identifier], i++;
    }

    return a.length ? [pa(n.concat(a), "identifier", !0), a] : void 0;
  }

  var ya = {
    mousedown: 1,
    mousemove: 2,
    mouseup: 4
  },
      ba = "mousedown",
      _a = "mousemove mouseup",
      wa = function (t) {
    function e() {
      var i,
          n = e.prototype;
      return n.evEl = ba, n.evWin = _a, (i = t.apply(this, arguments) || this).pressed = !1, i;
    }

    return fs(e, t), e.prototype.handler = function (t) {
      var e = ya[t.type];
      1 & e && 0 === t.button && (this.pressed = !0), 2 & e && 1 !== t.which && (e = 4), this.pressed && (4 & e && (this.pressed = !1), this.callback(this.manager, e, {
        pointers: [t],
        changedPointers: [t],
        pointerType: Fs,
        srcEvent: t
      }));
    }, e;
  }(ra);

  function ka(t) {
    var e = t.changedPointers[0];

    if (e.identifier === this.primaryTouch) {
      var i = {
        x: e.clientX,
        y: e.clientY
      },
          n = this.lastTouches;
      this.lastTouches.push(i);
      setTimeout(function () {
        var t = n.indexOf(i);
        t > -1 && n.splice(t, 1);
      }, 2500);
    }
  }

  function xa(t, e) {
    1 & t ? (this.primaryTouch = e.changedPointers[0].identifier, ka.call(this, e)) : 12 & t && ka.call(this, e);
  }

  function Da(t) {
    for (var e = t.srcEvent.clientX, i = t.srcEvent.clientY, n = 0; n < this.lastTouches.length; n++) {
      var o = this.lastTouches[n],
          r = Math.abs(e - o.x),
          s = Math.abs(i - o.y);
      if (r <= 25 && s <= 25) return !0;
    }

    return !1;
  }

  var Sa = function () {
    return function (t) {
      function e(e, i) {
        var n;
        return (n = t.call(this, e, i) || this).handler = function (t, e, i) {
          var o = i.pointerType === Rs,
              r = i.pointerType === Fs;

          if (!(r && i.sourceCapabilities && i.sourceCapabilities.firesTouchEvents)) {
            if (o) xa.call(ms(ms(n)), e, i);else if (r && Da.call(ms(ms(n)), i)) return;
            n.callback(t, e, i);
          }
        }, n.touch = new va(n.manager, n.handler), n.mouse = new wa(n.manager, n.handler), n.primaryTouch = null, n.lastTouches = [], n;
      }

      return fs(e, t), e.prototype.destroy = function () {
        this.touch.destroy(), this.mouse.destroy();
      }, e;
    }(ra);
  }();

  function Ca(t, e, i) {
    return !!Array.isArray(t) && (Gs(t, i[e], i), !0);
  }

  var Ta = 32,
      Ma = 1;

  function Oa(t, e) {
    var i = e.manager;
    return i ? i.get(t) : t;
  }

  function Ea(t) {
    return 16 & t ? "cancel" : 8 & t ? "end" : 4 & t ? "move" : 2 & t ? "start" : "";
  }

  var Pa = function () {
    function t(t) {
      void 0 === t && (t = {}), this.options = ps({
        enable: !0
      }, t), this.id = Ma++, this.manager = null, this.state = 1, this.simultaneous = {}, this.requireFail = [];
    }

    var e = t.prototype;
    return e.set = function (t) {
      return gs(this.options, t), this.manager && this.manager.touchAction.update(), this;
    }, e.recognizeWith = function (t) {
      if (Ca(t, "recognizeWith", this)) return this;
      var e = this.simultaneous;
      return e[(t = Oa(t, this)).id] || (e[t.id] = t, t.recognizeWith(this)), this;
    }, e.dropRecognizeWith = function (t) {
      return Ca(t, "dropRecognizeWith", this) || (t = Oa(t, this), delete this.simultaneous[t.id]), this;
    }, e.requireFailure = function (t) {
      if (Ca(t, "requireFailure", this)) return this;
      var e = this.requireFail;
      return -1 === sa(e, t = Oa(t, this)) && (e.push(t), t.requireFailure(this)), this;
    }, e.dropRequireFailure = function (t) {
      if (Ca(t, "dropRequireFailure", this)) return this;
      t = Oa(t, this);
      var e = sa(this.requireFail, t);
      return e > -1 && this.requireFail.splice(e, 1), this;
    }, e.hasRequireFailures = function () {
      return this.requireFail.length > 0;
    }, e.canRecognizeWith = function (t) {
      return !!this.simultaneous[t.id];
    }, e.emit = function (t) {
      var e = this,
          i = this.state;

      function n(i) {
        e.manager.emit(i, t);
      }

      i < 8 && n(e.options.event + Ea(i)), n(e.options.event), t.additionalEvent && n(t.additionalEvent), i >= 8 && n(e.options.event + Ea(i));
    }, e.tryEmit = function (t) {
      if (this.canEmit()) return this.emit(t);
      this.state = Ta;
    }, e.canEmit = function () {
      for (var t = 0; t < this.requireFail.length;) {
        if (!(33 & this.requireFail[t].state)) return !1;
        t++;
      }

      return !0;
    }, e.recognize = function (t) {
      var e = gs({}, t);
      if (!Ws(this.options.enable, [this, e])) return this.reset(), void (this.state = Ta);
      56 & this.state && (this.state = 1), this.state = this.process(e), 30 & this.state && this.tryEmit(e);
    }, e.process = function (t) {}, e.getTouchAction = function () {}, e.reset = function () {}, t;
  }(),
      Aa = function (t) {
    function e(e) {
      var i;
      return void 0 === e && (e = {}), (i = t.call(this, ps({
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        time: 250,
        threshold: 9,
        posThreshold: 10
      }, e)) || this).pTime = !1, i.pCenter = !1, i._timer = null, i._input = null, i.count = 0, i;
    }

    fs(e, t);
    var i = e.prototype;
    return i.getTouchAction = function () {
      return [Ms];
    }, i.process = function (t) {
      var e = this,
          i = this.options,
          n = t.pointers.length === i.pointers,
          o = t.distance < i.threshold,
          r = t.deltaTime < i.time;
      if (this.reset(), 1 & t.eventType && 0 === this.count) return this.failTimeout();

      if (o && r && n) {
        if (4 !== t.eventType) return this.failTimeout();
        var s = !this.pTime || t.timeStamp - this.pTime < i.interval,
            a = !this.pCenter || Zs(this.pCenter, t.center) < i.posThreshold;
        if (this.pTime = t.timeStamp, this.pCenter = t.center, a && s ? this.count += 1 : this.count = 1, this._input = t, 0 === this.count % i.taps) return this.hasRequireFailures() ? (this._timer = setTimeout(function () {
          e.state = 8, e.tryEmit();
        }, i.interval), 2) : 8;
      }

      return Ta;
    }, i.failTimeout = function () {
      var t = this;
      return this._timer = setTimeout(function () {
        t.state = Ta;
      }, this.options.interval), Ta;
    }, i.reset = function () {
      clearTimeout(this._timer);
    }, i.emit = function () {
      8 === this.state && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
    }, e;
  }(Pa),
      La = function (t) {
    function e(e) {
      return void 0 === e && (e = {}), t.call(this, ps({
        pointers: 1
      }, e)) || this;
    }

    fs(e, t);
    var i = e.prototype;
    return i.attrTest = function (t) {
      var e = this.options.pointers;
      return 0 === e || t.pointers.length === e;
    }, i.process = function (t) {
      var e = this.state,
          i = t.eventType,
          n = 6 & e,
          o = this.attrTest(t);
      return n && (8 & i || !o) ? 16 | e : n || o ? 4 & i ? 8 | e : 2 & e ? 4 | e : 2 : Ta;
    }, e;
  }(Pa);

  function Ia(t) {
    return t === Ys ? "down" : 8 === t ? "up" : 2 === t ? "left" : 4 === t ? "right" : "";
  }

  var Na = function (t) {
    function e(e) {
      var i;
      return void 0 === e && (e = {}), (i = t.call(this, ps({
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: 30
      }, e)) || this).pX = null, i.pY = null, i;
    }

    fs(e, t);
    var i = e.prototype;
    return i.getTouchAction = function () {
      var t = this.options.direction,
          e = [];
      return 6 & t && e.push(Ps), t & js && e.push(Es), e;
    }, i.directionTest = function (t) {
      var e = this.options,
          i = !0,
          n = t.distance,
          o = t.direction,
          r = t.deltaX,
          s = t.deltaY;
      return o & e.direction || (6 & e.direction ? (o = 0 === r ? 1 : r < 0 ? 2 : 4, i = r !== this.pX, n = Math.abs(t.deltaX)) : (o = 0 === s ? 1 : s < 0 ? 8 : Ys, i = s !== this.pY, n = Math.abs(t.deltaY))), t.direction = o, i && n > e.threshold && o & e.direction;
    }, i.attrTest = function (t) {
      return La.prototype.attrTest.call(this, t) && (2 & this.state || !(2 & this.state) && this.directionTest(t));
    }, i.emit = function (e) {
      this.pX = e.deltaX, this.pY = e.deltaY;
      var i = Ia(e.direction);
      i && (e.additionalEvent = this.options.event + i), t.prototype.emit.call(this, e);
    }, e;
  }(La),
      Ra = function (t) {
    function e(e) {
      return void 0 === e && (e = {}), t.call(this, ps({
        event: "swipe",
        threshold: 10,
        velocity: .3,
        direction: 30,
        pointers: 1
      }, e)) || this;
    }

    fs(e, t);
    var i = e.prototype;
    return i.getTouchAction = function () {
      return Na.prototype.getTouchAction.call(this);
    }, i.attrTest = function (e) {
      var i,
          n = this.options.direction;
      return 30 & n ? i = e.overallVelocity : 6 & n ? i = e.overallVelocityX : n & js && (i = e.overallVelocityY), t.prototype.attrTest.call(this, e) && n & e.offsetDirection && e.distance > this.options.threshold && e.maxPointers === this.options.pointers && ws(i) > this.options.velocity && 4 & e.eventType;
    }, i.emit = function (t) {
      var e = Ia(t.offsetDirection);
      e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t);
    }, e;
  }(La),
      Fa = function (t) {
    function e(e) {
      return void 0 === e && (e = {}), t.call(this, ps({
        event: "pinch",
        threshold: 0,
        pointers: 2
      }, e)) || this;
    }

    fs(e, t);
    var i = e.prototype;
    return i.getTouchAction = function () {
      return [Os];
    }, i.attrTest = function (e) {
      return t.prototype.attrTest.call(this, e) && (Math.abs(e.scale - 1) > this.options.threshold || 2 & this.state);
    }, i.emit = function (e) {
      if (1 !== e.scale) {
        var i = e.scale < 1 ? "in" : "out";
        e.additionalEvent = this.options.event + i;
      }

      t.prototype.emit.call(this, e);
    }, e;
  }(La),
      Ya = function (t) {
    function e(e) {
      return void 0 === e && (e = {}), t.call(this, ps({
        event: "rotate",
        threshold: 0,
        pointers: 2
      }, e)) || this;
    }

    fs(e, t);
    var i = e.prototype;
    return i.getTouchAction = function () {
      return [Os];
    }, i.attrTest = function (e) {
      return t.prototype.attrTest.call(this, e) && (Math.abs(e.rotation) > this.options.threshold || 2 & this.state);
    }, e;
  }(La),
      ja = function (t) {
    function e(e) {
      var i;
      return void 0 === e && (e = {}), (i = t.call(this, ps({
        event: "press",
        pointers: 1,
        time: 251,
        threshold: 9
      }, e)) || this)._timer = null, i._input = null, i;
    }

    fs(e, t);
    var i = e.prototype;
    return i.getTouchAction = function () {
      return [Ts];
    }, i.process = function (t) {
      var e = this,
          i = this.options,
          n = t.pointers.length === i.pointers,
          o = t.distance < i.threshold,
          r = t.deltaTime > i.time;
      if (this._input = t, !o || !n || 12 & t.eventType && !r) this.reset();else if (1 & t.eventType) this.reset(), this._timer = setTimeout(function () {
        e.state = 8, e.tryEmit();
      }, i.time);else if (4 & t.eventType) return 8;
      return Ta;
    }, i.reset = function () {
      clearTimeout(this._timer);
    }, i.emit = function (t) {
      8 === this.state && (t && 4 & t.eventType ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = ks(), this.manager.emit(this.options.event, this._input)));
    }, e;
  }(Pa),
      Ha = {
    domEvents: !1,
    touchAction: Cs,
    enable: !0,
    inputTarget: null,
    inputClass: null,
    cssProps: {
      userSelect: "none",
      touchSelect: "none",
      touchCallout: "none",
      contentZooming: "none",
      userDrag: "none",
      tapHighlightColor: "rgba(0,0,0,0)"
    }
  },
      za = [[Ya, {
    enable: !1
  }], [Fa, {
    enable: !1
  }, ["rotate"]], [Ra, {
    direction: 6
  }], [Na, {
    direction: 6
  }, ["swipe"]], [Aa], [Aa, {
    event: "doubletap",
    taps: 2
  }, ["tap"]], [ja]];

  function Ga(t, e) {
    var i,
        n = t.element;
    n.style && (Gs(t.options.cssProps, function (o, r) {
      i = xs(n.style, r), e ? (t.oldCssProps[i] = n.style[i], n.style[i] = o) : n.style[i] = t.oldCssProps[i] || "";
    }), e || (t.oldCssProps = {}));
  }

  var Wa = function () {
    function t(t, e) {
      var i,
          n = this;
      this.options = gs({}, Ha, e || {}), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = t, this.input = new ((i = this).options.inputClass || (Is ? ca : Ns ? va : Ls ? Sa : wa))(i, ta), this.touchAction = new Vs(this, this.options.touchAction), Ga(this, !0), Gs(this.options.recognizers, function (t) {
        var e = n.add(new t[0](t[1]));
        t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
      }, this);
    }

    var e = t.prototype;
    return e.set = function (t) {
      return gs(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this;
    }, e.stop = function (t) {
      this.session.stopped = t ? 2 : 1;
    }, e.recognize = function (t) {
      var e = this.session;

      if (!e.stopped) {
        var i;
        this.touchAction.preventDefaults(t);
        var n = this.recognizers,
            o = e.curRecognizer;
        (!o || o && 8 & o.state) && (e.curRecognizer = null, o = null);

        for (var r = 0; r < n.length;) {
          i = n[r], 2 === e.stopped || o && i !== o && !i.canRecognizeWith(o) ? i.reset() : i.recognize(t), !o && 14 & i.state && (e.curRecognizer = i, o = i), r++;
        }
      }
    }, e.get = function (t) {
      if (t instanceof Pa) return t;

      for (var e = this.recognizers, i = 0; i < e.length; i++) {
        if (e[i].options.event === t) return e[i];
      }

      return null;
    }, e.add = function (t) {
      if (Ca(t, "add", this)) return this;
      var e = this.get(t.options.event);
      return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t;
    }, e.remove = function (t) {
      if (Ca(t, "remove", this)) return this;
      var e = this.get(t);

      if (t) {
        var i = this.recognizers,
            n = sa(i, e);
        -1 !== n && (i.splice(n, 1), this.touchAction.update());
      }

      return this;
    }, e.on = function (t, e) {
      if (void 0 === t || void 0 === e) return this;
      var i = this.handlers;
      return Gs(ea(t), function (t) {
        i[t] = i[t] || [], i[t].push(e);
      }), this;
    }, e.off = function (t, e) {
      if (void 0 === t) return this;
      var i = this.handlers;
      return Gs(ea(t), function (t) {
        e ? i[t] && i[t].splice(sa(i[t], e), 1) : delete i[t];
      }), this;
    }, e.emit = function (t, e) {
      this.options.domEvents && function (t, e) {
        var i = document.createEvent("Event");
        i.initEvent(t, !0, !0), i.gesture = e, e.target.dispatchEvent(i);
      }(t, e);
      var i = this.handlers[t] && this.handlers[t].slice();

      if (i && i.length) {
        e.type = t, e.preventDefault = function () {
          e.srcEvent.preventDefault();
        };

        for (var n = 0; n < i.length;) {
          i[n](e), n++;
        }
      }
    }, e.destroy = function () {
      this.element && Ga(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
    }, t;
  }(),
      Ba = {
    touchstart: 1,
    touchmove: 2,
    touchend: 4,
    touchcancel: 8
  },
      Va = "touchstart",
      Ua = "touchstart touchmove touchend touchcancel",
      Xa = function (t) {
    function e() {
      var i,
          n = e.prototype;
      return n.evTarget = Va, n.evWin = Ua, (i = t.apply(this, arguments) || this).started = !1, i;
    }

    return fs(e, t), e.prototype.handler = function (t) {
      var e = Ba[t.type];

      if (1 === e && (this.started = !0), this.started) {
        var i = qa.call(this, t, e);
        12 & e && i[0].length - i[1].length == 0 && (this.started = !1), this.callback(this.manager, e, {
          pointers: i[0],
          changedPointers: i[1],
          pointerType: Rs,
          srcEvent: t
        });
      }
    }, e;
  }(ra);

  function qa(t, e) {
    var i = da(t.touches),
        n = da(t.changedTouches);
    return 12 & e && (i = pa(i.concat(n), "identifier", !0)), [i, n];
  }

  function Za(t, e, i) {
    var n = "DEPRECATED METHOD: " + e + "\n" + i + " AT \n";
    return function () {
      var e = new Error("get-stack-trace"),
          i = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
          o = window.console && (window.console.warn || window.console.log);
      return o && o.call(window.console, n, i), t.apply(this, arguments);
    };
  }

  var $a = Za(function (t, e, i) {
    for (var n = Object.keys(e), o = 0; o < n.length;) {
      (!i || i && void 0 === t[n[o]]) && (t[n[o]] = e[n[o]]), o++;
    }

    return t;
  }, "extend", "Use `assign`."),
      Ka = Za(function (t, e) {
    return $a(t, e, !0);
  }, "merge", "Use `assign`.");

  function Ja(t, e, i) {
    var n,
        o = e.prototype;
    (n = t.prototype = Object.create(o)).constructor = t, n._super = o, i && gs(n, i);
  }

  function Qa(t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }

  var tl = function () {
    var t = function t(_t2, e) {
      return void 0 === e && (e = {}), new Wa(_t2, ps({
        recognizers: za.concat()
      }, e));
    };

    return t.VERSION = "2.0.17-rc", t.DIRECTION_ALL = 30, t.DIRECTION_DOWN = Ys, t.DIRECTION_LEFT = 2, t.DIRECTION_RIGHT = 4, t.DIRECTION_UP = 8, t.DIRECTION_HORIZONTAL = 6, t.DIRECTION_VERTICAL = js, t.DIRECTION_NONE = 1, t.DIRECTION_DOWN = Ys, t.INPUT_START = 1, t.INPUT_MOVE = 2, t.INPUT_END = 4, t.INPUT_CANCEL = 8, t.STATE_POSSIBLE = 1, t.STATE_BEGAN = 2, t.STATE_CHANGED = 4, t.STATE_ENDED = 8, t.STATE_RECOGNIZED = 8, t.STATE_CANCELLED = 16, t.STATE_FAILED = Ta, t.Manager = Wa, t.Input = ra, t.TouchAction = Vs, t.TouchInput = va, t.MouseInput = wa, t.PointerEventInput = ca, t.TouchMouseInput = Sa, t.SingleTouchInput = Xa, t.Recognizer = Pa, t.AttrRecognizer = La, t.Tap = Aa, t.Pan = Na, t.Swipe = Ra, t.Pinch = Fa, t.Rotate = Ya, t.Press = ja, t.on = ia, t.off = na, t.each = Gs, t.merge = Ka, t.extend = $a, t.bindFn = Qa, t.assign = gs, t.inherit = Ja, t.bindFn = Qa, t.prefixed = xs, t.toArray = da, t.inArray = sa, t.uniqueArray = pa, t.splitStr = ea, t.boolOrFn = Ws, t.hasParent = Us, t.addEventListeners = ia, t.removeEventListeners = na, t.defaults = gs({}, Ha, {
      preset: za
    }), t;
  }();

  function el(t, e) {
    var i = Vr(t);

    if (ai) {
      var n = ai(t);
      e && (n = yo(n).call(n, function (e) {
        return xt(t, e).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function il(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i,
          n = null != arguments[e] ? arguments[e] : {};
      if (e % 2) nr(i = el(Object(n), !0)).call(i, function (e) {
        Sn(t, e, n[e]);
      });else if (bt) ct(t, bt(n));else {
        var o;
        nr(o = el(Object(n))).call(o, function (e) {
          q(t, e, xt(n, e));
        });
      }
    }

    return t;
  }

  function nl(t, e) {
    var i;

    if (void 0 === cs || null == zi(t)) {
      if (Jr(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return ol(t, e);
        var n = ns(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Qi(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ol(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);

        var _n2 = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n2 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n2++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var r,
        s = !0,
        a = !1;
    return {
      s: function s() {
        i = Hi(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i.return || i.return();
        } finally {
          if (a) throw r;
        }
      }
    };
  }

  function ol(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, n = new Array(e); i < e; i++) {
      n[i] = t[i];
    }

    return n;
  }

  var rl = cs("DELETE");

  function sl(t) {
    for (var e, i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) {
      n[o - 1] = arguments[o];
    }

    return al.apply(void 0, us(e = [{}, t]).call(e, n));
  }

  function al() {
    var t = ll.apply(void 0, arguments);
    return ul(t), t;
  }

  function ll() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) {
      e[i] = arguments[i];
    }

    if (e.length < 2) return e[0];
    var n;
    if (e.length > 2) return ll.apply(void 0, us(n = [al(e[0], e[1])]).call(n, as(ns(e).call(e, 2))));
    var o,
        r = e[0],
        s = e[1],
        a = nl(is(s));

    try {
      for (a.s(); !(o = a.n()).done;) {
        var l = o.value;
        Object.prototype.propertyIsEnumerable.call(s, l) && (s[l] === rl ? delete r[l] : null === r[l] || null === s[l] || "object" !== es(r[l]) || "object" !== es(s[l]) || Jr(r[l]) || Jr(s[l]) ? r[l] = hl(s[l]) : r[l] = ll(r[l], s[l]));
      }
    } catch (t) {
      a.e(t);
    } finally {
      a.f();
    }

    return r;
  }

  function hl(t) {
    return Jr(t) ? Kr(t).call(t, function (t) {
      return hl(t);
    }) : "object" === es(t) && null !== t ? ll({}, t) : t;
  }

  function ul(t) {
    for (var e = 0, i = Vr(t); e < i.length; e++) {
      var n = i[e];
      t[n] === rl ? delete t[n] : "object" === es(t[n]) && null !== t[n] && ul(t[n]);
    }
  }

  function cl(t) {
    var e = function () {
      for (var t = dl(), e = t(" "), i = t(" "), n = t(" "), o = 0; o < arguments.length; o++) {
        (e -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (e += 1), (i -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (i += 1), (n -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (n += 1);
      }

      return [e, i, n];
    }(t),
        i = Gr(e, 3),
        n = i[0],
        o = i[1],
        r = i[2],
        s = 1,
        a = function a() {
      var t = 2091639 * n + 2.3283064365386963e-10 * s;
      return n = o, o = r, r = t - (s = 0 | t);
    };

    return a.uint32 = function () {
      return 4294967296 * a();
    }, a.fract53 = function () {
      return a() + 11102230246251565e-32 * (2097152 * a() | 0);
    }, a.algorithm = "Alea", a.seed = t, a.version = "0.9", a;
  }

  function dl() {
    var t = 4022871197;
    return function (e) {
      for (var i = e.toString(), n = 0; n < i.length; n++) {
        var o = .02519603282416938 * (t += i.charCodeAt(n));
        o -= t = o >>> 0, t = (o *= t) >>> 0, t += 4294967296 * (o -= t);
      }

      return 2.3283064365386963e-10 * (t >>> 0);
    };
  }

  var pl = "undefined" != typeof window ? window.Hammer || tl : function () {
    return {
      on: t = function t() {},
      off: t,
      destroy: t,
      emit: t,
      get: function get() {
        return {
          set: t
        };
      }
    };
    var t;
  };

  function fl(t) {
    var e,
        i = this;
    this._cleanupQueue = [], this.active = !1, this._dom = {
      container: t,
      overlay: document.createElement("div")
    }, this._dom.overlay.classList.add("vis-overlay"), this._dom.container.appendChild(this._dom.overlay), this._cleanupQueue.push(function () {
      i._dom.overlay.parentNode.removeChild(i._dom.overlay);
    });
    var n = pl(this._dom.overlay);
    n.on("tap", ur(e = this._onTapOverlay).call(e, this)), this._cleanupQueue.push(function () {
      n.destroy();
    });
    var o = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];
    nr(o).call(o, function (t) {
      n.on(t, function (t) {
        t.srcEvent.stopPropagation();
      });
    }), document && document.body && (this._onClick = function (e) {
      (function (t, e) {
        for (; t;) {
          if (t === e) return !0;
          t = t.parentNode;
        }

        return !1;
      })(e.target, t) || i.deactivate();
    }, document.body.addEventListener("click", this._onClick), this._cleanupQueue.push(function () {
      document.body.removeEventListener("click", i._onClick);
    })), this._escListener = function (t) {
      ("key" in t ? "Escape" === t.key : 27 === t.keyCode) && i.deactivate();
    };
  }

  ds(fl.prototype), fl.current = null, fl.prototype.destroy = function () {
    var t, e;
    this.deactivate();
    var i,
        n = nl(Zo(t = Bo(e = this._cleanupQueue).call(e, 0)).call(t));

    try {
      for (n.s(); !(i = n.n()).done;) {
        (0, i.value)();
      }
    } catch (t) {
      n.e(t);
    } finally {
      n.f();
    }
  }, fl.prototype.activate = function () {
    fl.current && fl.current.deactivate(), fl.current = this, this.active = !0, this._dom.overlay.style.display = "none", this._dom.container.classList.add("vis-active"), this.emit("change"), this.emit("activate"), document.body.addEventListener("keydown", this._escListener);
  }, fl.prototype.deactivate = function () {
    this.active = !1, this._dom.overlay.style.display = "block", this._dom.container.classList.remove("vis-active"), document.body.removeEventListener("keydown", this._escListener), this.emit("change"), this.emit("deactivate");
  }, fl.prototype._onTapOverlay = function (t) {
    this.activate(), t.srcEvent.stopPropagation();
  };
  var ml = /^\/?Date\((-?\d+)/i,
      vl = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
      gl = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      yl = /^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i,
      bl = /^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;

  function _l(t) {
    return t instanceof Number || "number" == typeof t;
  }

  function wl(t) {
    return t instanceof String || "string" == typeof t;
  }

  function kl(t) {
    return "object" === es(t) && null !== t;
  }

  function xl(t, e, i, n) {
    var o = !1;
    !0 === n && (o = null === e[i] && void 0 !== t[i]), o ? delete t[i] : t[i] = e[i];
  }

  var Dl = No;

  function Sl(t, e) {
    var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];

    for (var o in e) {
      if (Object.prototype.hasOwnProperty.call(e, o) || !0 === i) if ("object" === es(e[o]) && null !== e[o] && wo(e[o]) === Object.prototype) void 0 === t[o] ? t[o] = Sl({}, e[o], i) : "object" === es(t[o]) && null !== t[o] && wo(t[o]) === Object.prototype ? Sl(t[o], e[o], i) : xl(t, e, o, n);else if (Jr(e[o])) {
        var r;
        t[o] = ns(r = e[o]).call(r);
      } else xl(t, e, o, n);
    }

    return t;
  }

  function Cl(t) {
    var e = es(t);
    return "object" === e ? null === t ? "null" : t instanceof Boolean ? "Boolean" : t instanceof Number ? "Number" : t instanceof String ? "String" : Jr(t) ? "Array" : t instanceof Date ? "Date" : "Object" : "number" === e ? "Number" : "boolean" === e ? "Boolean" : "string" === e ? "String" : void 0 === e ? "undefined" : e;
  }

  function Tl(t, e) {
    var i;
    return us(i = []).call(i, as(t), [e]);
  }

  function Ml(t) {
    return ns(t).call(t);
  }

  var Ol = ro;
  var El = {
    asBoolean: function asBoolean(t, e) {
      return "function" == typeof t && (t = t()), null != t ? 0 != t : e || null;
    },
    asNumber: function asNumber(t, e) {
      return "function" == typeof t && (t = t()), null != t ? Number(t) || e || null : e || null;
    },
    asString: function asString(t, e) {
      return "function" == typeof t && (t = t()), null != t ? String(t) : e || null;
    },
    asSize: function asSize(t, e) {
      return "function" == typeof t && (t = t()), wl(t) ? t : _l(t) ? t + "px" : e || null;
    },
    asElement: function asElement(t, e) {
      return "function" == typeof t && (t = t()), t || e || null;
    }
  };

  function Pl(t) {
    var e;

    switch (t.length) {
      case 3:
      case 4:
        return (e = gl.exec(t)) ? {
          r: Qn(e[1] + e[1], 16),
          g: Qn(e[2] + e[2], 16),
          b: Qn(e[3] + e[3], 16)
        } : null;

      case 6:
      case 7:
        return (e = vl.exec(t)) ? {
          r: Qn(e[1], 16),
          g: Qn(e[2], 16),
          b: Qn(e[3], 16)
        } : null;

      default:
        return null;
    }
  }

  function Al(t, e, i) {
    var n;
    return "#" + ns(n = ((1 << 24) + (t << 16) + (e << 8) + i).toString(16)).call(n, 1);
  }

  function Ll(t, e, i) {
    t /= 255, e /= 255, i /= 255;
    var n = Math.min(t, Math.min(e, i)),
        o = Math.max(t, Math.max(e, i));
    return n === o ? {
      h: 0,
      s: 0,
      v: n
    } : {
      h: 60 * ((t === n ? 3 : i === n ? 1 : 5) - (t === n ? e - i : i === n ? t - e : i - t) / (o - n)) / 360,
      s: (o - n) / o,
      v: o
    };
  }

  var Il = function Il(t) {
    var e,
        i = {};
    return nr(e = t.split(";")).call(e, function (t) {
      if ("" != Nn(t).call(t)) {
        var e,
            n,
            o = t.split(":"),
            r = Nn(e = o[0]).call(e),
            s = Nn(n = o[1]).call(n);
        i[r] = s;
      }
    }), i;
  },
      Nl = function Nl(t) {
    var e;
    return Kr(e = Vr(t)).call(e, function (e) {
      return e + ": " + t[e];
    }).join("; ");
  };

  function Rl(t, e, i) {
    var n,
        o,
        r,
        s = Math.floor(6 * t),
        a = 6 * t - s,
        l = i * (1 - e),
        h = i * (1 - a * e),
        u = i * (1 - (1 - a) * e);

    switch (s % 6) {
      case 0:
        n = i, o = u, r = l;
        break;

      case 1:
        n = h, o = i, r = l;
        break;

      case 2:
        n = l, o = i, r = u;
        break;

      case 3:
        n = l, o = h, r = i;
        break;

      case 4:
        n = u, o = l, r = i;
        break;

      case 5:
        n = i, o = l, r = h;
    }

    return {
      r: Math.floor(255 * n),
      g: Math.floor(255 * o),
      b: Math.floor(255 * r)
    };
  }

  function Fl(t, e, i) {
    var n = Rl(t, e, i);
    return Al(n.r, n.g, n.b);
  }

  function Yl(t) {
    var e = Pl(t);
    if (!e) throw new TypeError("'".concat(t, "' is not a valid color."));
    return Ll(e.r, e.g, e.b);
  }

  function jl(t) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
  }

  function Hl(t) {
    return yl.test(t);
  }

  function zl(t) {
    return bl.test(t);
  }

  function Gl(t) {
    if (null === t || "object" !== es(t)) return null;
    if (t instanceof Element) return t;
    var e = xn(t);

    for (var i in t) {
      Object.prototype.hasOwnProperty.call(t, i) && "object" == es(t[i]) && (e[i] = Gl(t[i]));
    }

    return e;
  }

  var Wl = {
    black: "#000000",
    navy: "#000080",
    darkblue: "#00008B",
    mediumblue: "#0000CD",
    blue: "#0000FF",
    darkgreen: "#006400",
    green: "#008000",
    teal: "#008080",
    darkcyan: "#008B8B",
    deepskyblue: "#00BFFF",
    darkturquoise: "#00CED1",
    mediumspringgreen: "#00FA9A",
    lime: "#00FF00",
    springgreen: "#00FF7F",
    aqua: "#00FFFF",
    cyan: "#00FFFF",
    midnightblue: "#191970",
    dodgerblue: "#1E90FF",
    lightseagreen: "#20B2AA",
    forestgreen: "#228B22",
    seagreen: "#2E8B57",
    darkslategray: "#2F4F4F",
    limegreen: "#32CD32",
    mediumseagreen: "#3CB371",
    turquoise: "#40E0D0",
    royalblue: "#4169E1",
    steelblue: "#4682B4",
    darkslateblue: "#483D8B",
    mediumturquoise: "#48D1CC",
    indigo: "#4B0082",
    darkolivegreen: "#556B2F",
    cadetblue: "#5F9EA0",
    cornflowerblue: "#6495ED",
    mediumaquamarine: "#66CDAA",
    dimgray: "#696969",
    slateblue: "#6A5ACD",
    olivedrab: "#6B8E23",
    slategray: "#708090",
    lightslategray: "#778899",
    mediumslateblue: "#7B68EE",
    lawngreen: "#7CFC00",
    chartreuse: "#7FFF00",
    aquamarine: "#7FFFD4",
    maroon: "#800000",
    purple: "#800080",
    olive: "#808000",
    gray: "#808080",
    skyblue: "#87CEEB",
    lightskyblue: "#87CEFA",
    blueviolet: "#8A2BE2",
    darkred: "#8B0000",
    darkmagenta: "#8B008B",
    saddlebrown: "#8B4513",
    darkseagreen: "#8FBC8F",
    lightgreen: "#90EE90",
    mediumpurple: "#9370D8",
    darkviolet: "#9400D3",
    palegreen: "#98FB98",
    darkorchid: "#9932CC",
    yellowgreen: "#9ACD32",
    sienna: "#A0522D",
    brown: "#A52A2A",
    darkgray: "#A9A9A9",
    lightblue: "#ADD8E6",
    greenyellow: "#ADFF2F",
    paleturquoise: "#AFEEEE",
    lightsteelblue: "#B0C4DE",
    powderblue: "#B0E0E6",
    firebrick: "#B22222",
    darkgoldenrod: "#B8860B",
    mediumorchid: "#BA55D3",
    rosybrown: "#BC8F8F",
    darkkhaki: "#BDB76B",
    silver: "#C0C0C0",
    mediumvioletred: "#C71585",
    indianred: "#CD5C5C",
    peru: "#CD853F",
    chocolate: "#D2691E",
    tan: "#D2B48C",
    lightgrey: "#D3D3D3",
    palevioletred: "#D87093",
    thistle: "#D8BFD8",
    orchid: "#DA70D6",
    goldenrod: "#DAA520",
    crimson: "#DC143C",
    gainsboro: "#DCDCDC",
    plum: "#DDA0DD",
    burlywood: "#DEB887",
    lightcyan: "#E0FFFF",
    lavender: "#E6E6FA",
    darksalmon: "#E9967A",
    violet: "#EE82EE",
    palegoldenrod: "#EEE8AA",
    lightcoral: "#F08080",
    khaki: "#F0E68C",
    aliceblue: "#F0F8FF",
    honeydew: "#F0FFF0",
    azure: "#F0FFFF",
    sandybrown: "#F4A460",
    wheat: "#F5DEB3",
    beige: "#F5F5DC",
    whitesmoke: "#F5F5F5",
    mintcream: "#F5FFFA",
    ghostwhite: "#F8F8FF",
    salmon: "#FA8072",
    antiquewhite: "#FAEBD7",
    linen: "#FAF0E6",
    lightgoldenrodyellow: "#FAFAD2",
    oldlace: "#FDF5E6",
    red: "#FF0000",
    fuchsia: "#FF00FF",
    magenta: "#FF00FF",
    deeppink: "#FF1493",
    orangered: "#FF4500",
    tomato: "#FF6347",
    hotpink: "#FF69B4",
    coral: "#FF7F50",
    darkorange: "#FF8C00",
    lightsalmon: "#FFA07A",
    orange: "#FFA500",
    lightpink: "#FFB6C1",
    pink: "#FFC0CB",
    gold: "#FFD700",
    peachpuff: "#FFDAB9",
    navajowhite: "#FFDEAD",
    moccasin: "#FFE4B5",
    bisque: "#FFE4C4",
    mistyrose: "#FFE4E1",
    blanchedalmond: "#FFEBCD",
    papayawhip: "#FFEFD5",
    lavenderblush: "#FFF0F5",
    seashell: "#FFF5EE",
    cornsilk: "#FFF8DC",
    lemonchiffon: "#FFFACD",
    floralwhite: "#FFFAF0",
    snow: "#FFFAFA",
    yellow: "#FFFF00",
    lightyellow: "#FFFFE0",
    ivory: "#FFFFF0",
    white: "#FFFFFF"
  },
      Bl = function () {
    function t() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
      gn(this, t), this.pixelRatio = e, this.generated = !1, this.centerCoordinates = {
        x: 144.5,
        y: 144.5
      }, this.r = 289 * .49, this.color = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      }, this.hueCircle = void 0, this.initialColor = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      }, this.previousColor = void 0, this.applied = !1, this.updateCallback = function () {}, this.closeCallback = function () {}, this._create();
    }

    return _n(t, [{
      key: "insertTo",
      value: function value(t) {
        void 0 !== this.hammer && (this.hammer.destroy(), this.hammer = void 0), this.container = t, this.container.appendChild(this.frame), this._bindHammer(), this._setSize();
      }
    }, {
      key: "setUpdateCallback",
      value: function value(t) {
        if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker update callback is not a function.");
        this.updateCallback = t;
      }
    }, {
      key: "setCloseCallback",
      value: function value(t) {
        if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
        this.closeCallback = t;
      }
    }, {
      key: "_isColorString",
      value: function value(t) {
        if ("string" == typeof t) return Wl[t];
      }
    }, {
      key: "setColor",
      value: function value(t) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

        if ("none" !== t) {
          var i,
              n = this._isColorString(t);

          if (void 0 !== n && (t = n), !0 === wl(t)) {
            if (!0 === Hl(t)) {
              var o = t.substr(4).substr(0, t.length - 5).split(",");
              i = {
                r: o[0],
                g: o[1],
                b: o[2],
                a: 1
              };
            } else if (!0 === zl(t)) {
              var r = t.substr(5).substr(0, t.length - 6).split(",");
              i = {
                r: r[0],
                g: r[1],
                b: r[2],
                a: r[3]
              };
            } else if (!0 === jl(t)) {
              var s = Pl(t);
              i = {
                r: s.r,
                g: s.g,
                b: s.b,
                a: 1
              };
            }
          } else if (t instanceof Object && void 0 !== t.r && void 0 !== t.g && void 0 !== t.b) {
            var a = void 0 !== t.a ? t.a : "1.0";
            i = {
              r: t.r,
              g: t.g,
              b: t.b,
              a: a
            };
          }

          if (void 0 === i) throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + vn(t));

          this._setColor(i, e);
        }
      }
    }, {
      key: "show",
      value: function value() {
        void 0 !== this.closeCallback && (this.closeCallback(), this.closeCallback = void 0), this.applied = !1, this.frame.style.display = "block", this._generateHueCircle();
      }
    }, {
      key: "_hide",
      value: function value() {
        var t = this,
            e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        !0 === e && (this.previousColor = No({}, this.color)), !0 === this.applied && this.updateCallback(this.initialColor), this.frame.style.display = "none", hn(function () {
          void 0 !== t.closeCallback && (t.closeCallback(), t.closeCallback = void 0);
        }, 0);
      }
    }, {
      key: "_save",
      value: function value() {
        this.updateCallback(this.color), this.applied = !1, this._hide();
      }
    }, {
      key: "_apply",
      value: function value() {
        this.applied = !0, this.updateCallback(this.color), this._updatePicker(this.color);
      }
    }, {
      key: "_loadLast",
      value: function value() {
        void 0 !== this.previousColor ? this.setColor(this.previousColor, !1) : alert("There is no last color to load...");
      }
    }, {
      key: "_setColor",
      value: function value(t) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        !0 === e && (this.initialColor = No({}, t)), this.color = t;
        var i = Ll(t.r, t.g, t.b),
            n = 2 * Math.PI,
            o = this.r * i.s,
            r = this.centerCoordinates.x + o * Math.sin(n * i.h),
            s = this.centerCoordinates.y + o * Math.cos(n * i.h);
        this.colorPickerSelector.style.left = r - .5 * this.colorPickerSelector.clientWidth + "px", this.colorPickerSelector.style.top = s - .5 * this.colorPickerSelector.clientHeight + "px", this._updatePicker(t);
      }
    }, {
      key: "_setOpacity",
      value: function value(t) {
        this.color.a = t / 100, this._updatePicker(this.color);
      }
    }, {
      key: "_setBrightness",
      value: function value(t) {
        var e = Ll(this.color.r, this.color.g, this.color.b);
        e.v = t / 100;
        var i = Rl(e.h, e.s, e.v);
        i.a = this.color.a, this.color = i, this._updatePicker();
      }
    }, {
      key: "_updatePicker",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.color,
            e = Ll(t.r, t.g, t.b),
            i = this.colorPickerCanvas.getContext("2d");
        void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (i.webkitBackingStorePixelRatio || i.mozBackingStorePixelRatio || i.msBackingStorePixelRatio || i.oBackingStorePixelRatio || i.backingStorePixelRatio || 1)), i.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        var n = this.colorPickerCanvas.clientWidth,
            o = this.colorPickerCanvas.clientHeight;
        i.clearRect(0, 0, n, o), i.putImageData(this.hueCircle, 0, 0), i.fillStyle = "rgba(0,0,0," + (1 - e.v) + ")", i.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), on(i).call(i), this.brightnessRange.value = 100 * e.v, this.opacityRange.value = 100 * t.a, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
      }
    }, {
      key: "_setSize",
      value: function value() {
        this.colorPickerCanvas.style.width = "100%", this.colorPickerCanvas.style.height = "100%", this.colorPickerCanvas.width = 289 * this.pixelRatio, this.colorPickerCanvas.height = 289 * this.pixelRatio;
      }
    }, {
      key: "_create",
      value: function value() {
        var t, e, i, n;

        if (this.frame = document.createElement("div"), this.frame.className = "vis-color-picker", this.colorPickerDiv = document.createElement("div"), this.colorPickerSelector = document.createElement("div"), this.colorPickerSelector.className = "vis-selector", this.colorPickerDiv.appendChild(this.colorPickerSelector), this.colorPickerCanvas = document.createElement("canvas"), this.colorPickerDiv.appendChild(this.colorPickerCanvas), this.colorPickerCanvas.getContext) {
          var o = this.colorPickerCanvas.getContext("2d");
          this.pixelRatio = (window.devicePixelRatio || 1) / (o.webkitBackingStorePixelRatio || o.mozBackingStorePixelRatio || o.msBackingStorePixelRatio || o.oBackingStorePixelRatio || o.backingStorePixelRatio || 1), this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        } else {
          var r = document.createElement("DIV");
          r.style.color = "red", r.style.fontWeight = "bold", r.style.padding = "10px", r.innerText = "Error: your browser does not support HTML canvas", this.colorPickerCanvas.appendChild(r);
        }

        this.colorPickerDiv.className = "vis-color", this.opacityDiv = document.createElement("div"), this.opacityDiv.className = "vis-opacity", this.brightnessDiv = document.createElement("div"), this.brightnessDiv.className = "vis-brightness", this.arrowDiv = document.createElement("div"), this.arrowDiv.className = "vis-arrow", this.opacityRange = document.createElement("input");

        try {
          this.opacityRange.type = "range", this.opacityRange.min = "0", this.opacityRange.max = "100";
        } catch (t) {}

        this.opacityRange.value = "100", this.opacityRange.className = "vis-range", this.brightnessRange = document.createElement("input");

        try {
          this.brightnessRange.type = "range", this.brightnessRange.min = "0", this.brightnessRange.max = "100";
        } catch (t) {}

        this.brightnessRange.value = "100", this.brightnessRange.className = "vis-range", this.opacityDiv.appendChild(this.opacityRange), this.brightnessDiv.appendChild(this.brightnessRange);
        var s = this;
        this.opacityRange.onchange = function () {
          s._setOpacity(this.value);
        }, this.opacityRange.oninput = function () {
          s._setOpacity(this.value);
        }, this.brightnessRange.onchange = function () {
          s._setBrightness(this.value);
        }, this.brightnessRange.oninput = function () {
          s._setBrightness(this.value);
        }, this.brightnessLabel = document.createElement("div"), this.brightnessLabel.className = "vis-label vis-brightness", this.brightnessLabel.innerText = "brightness:", this.opacityLabel = document.createElement("div"), this.opacityLabel.className = "vis-label vis-opacity", this.opacityLabel.innerText = "opacity:", this.newColorDiv = document.createElement("div"), this.newColorDiv.className = "vis-new-color", this.newColorDiv.innerText = "new", this.initialColorDiv = document.createElement("div"), this.initialColorDiv.className = "vis-initial-color", this.initialColorDiv.innerText = "initial", this.cancelButton = document.createElement("div"), this.cancelButton.className = "vis-button vis-cancel", this.cancelButton.innerText = "cancel", this.cancelButton.onclick = ur(t = this._hide).call(t, this, !1), this.applyButton = document.createElement("div"), this.applyButton.className = "vis-button vis-apply", this.applyButton.innerText = "apply", this.applyButton.onclick = ur(e = this._apply).call(e, this), this.saveButton = document.createElement("div"), this.saveButton.className = "vis-button vis-save", this.saveButton.innerText = "save", this.saveButton.onclick = ur(i = this._save).call(i, this), this.loadButton = document.createElement("div"), this.loadButton.className = "vis-button vis-load", this.loadButton.innerText = "load last", this.loadButton.onclick = ur(n = this._loadLast).call(n, this), this.frame.appendChild(this.colorPickerDiv), this.frame.appendChild(this.arrowDiv), this.frame.appendChild(this.brightnessLabel), this.frame.appendChild(this.brightnessDiv), this.frame.appendChild(this.opacityLabel), this.frame.appendChild(this.opacityDiv), this.frame.appendChild(this.newColorDiv), this.frame.appendChild(this.initialColorDiv), this.frame.appendChild(this.cancelButton), this.frame.appendChild(this.applyButton), this.frame.appendChild(this.saveButton), this.frame.appendChild(this.loadButton);
      }
    }, {
      key: "_bindHammer",
      value: function value() {
        var t = this;
        this.drag = {}, this.pinch = {}, this.hammer = new pl(this.colorPickerCanvas), this.hammer.get("pinch").set({
          enable: !0
        }), this.hammer.on("hammer.input", function (e) {
          e.isFirst && t._moveSelector(e);
        }), this.hammer.on("tap", function (e) {
          t._moveSelector(e);
        }), this.hammer.on("panstart", function (e) {
          t._moveSelector(e);
        }), this.hammer.on("panmove", function (e) {
          t._moveSelector(e);
        }), this.hammer.on("panend", function (e) {
          t._moveSelector(e);
        });
      }
    }, {
      key: "_generateHueCircle",
      value: function value() {
        if (!1 === this.generated) {
          var t = this.colorPickerCanvas.getContext("2d");
          void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1)), t.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
          var e,
              i,
              n,
              o,
              r = this.colorPickerCanvas.clientWidth,
              s = this.colorPickerCanvas.clientHeight;
          t.clearRect(0, 0, r, s), this.centerCoordinates = {
            x: .5 * r,
            y: .5 * s
          }, this.r = .49 * r;
          var a,
              l = 2 * Math.PI / 360,
              h = 1 / this.r;

          for (n = 0; n < 360; n++) {
            for (o = 0; o < this.r; o++) {
              e = this.centerCoordinates.x + o * Math.sin(l * n), i = this.centerCoordinates.y + o * Math.cos(l * n), a = Rl(.002777777777777778 * n, o * h, 1), t.fillStyle = "rgb(" + a.r + "," + a.g + "," + a.b + ")", t.fillRect(e - .5, i - .5, 2, 2);
            }
          }

          t.strokeStyle = "rgba(0,0,0,1)", t.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), t.stroke(), this.hueCircle = t.getImageData(0, 0, r, s);
        }

        this.generated = !0;
      }
    }, {
      key: "_moveSelector",
      value: function value(t) {
        var e = this.colorPickerDiv.getBoundingClientRect(),
            i = t.center.x - e.left,
            n = t.center.y - e.top,
            o = .5 * this.colorPickerDiv.clientHeight,
            r = .5 * this.colorPickerDiv.clientWidth,
            s = i - r,
            a = n - o,
            l = Math.atan2(s, a),
            h = .98 * Math.min(Math.sqrt(s * s + a * a), r),
            u = Math.cos(l) * h + o,
            c = Math.sin(l) * h + r;
        this.colorPickerSelector.style.top = u - .5 * this.colorPickerSelector.clientHeight + "px", this.colorPickerSelector.style.left = c - .5 * this.colorPickerSelector.clientWidth + "px";
        var d = l / (2 * Math.PI);
        d = d < 0 ? d + 1 : d;
        var p = h / this.r,
            f = Ll(this.color.r, this.color.g, this.color.b);
        f.h = d, f.s = p;
        var m = Rl(f.h, f.s, f.v);
        m.a = this.color.a, this.color = m, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
      }
    }]), t;
  }();

  function Vl() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) {
      e[i] = arguments[i];
    }

    if (e.length < 1) throw new TypeError("Invalid arguments.");
    if (1 === e.length) return document.createTextNode(e[0]);
    var n = document.createElement(e[0]);
    return n.appendChild(Vl.apply(void 0, as(ns(e).call(e, 1)))), n;
  }

  var Ul,
      Xl = function () {
    function t(e, i, n) {
      var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
          r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : function () {
        return !1;
      };
      gn(this, t), this.parent = e, this.changedOptions = [], this.container = i, this.allowCreation = !1, this.hideOption = r, this.options = {}, this.initialized = !1, this.popupCounter = 0, this.defaultOptions = {
        enabled: !1,
        filter: !0,
        container: void 0,
        showButton: !0
      }, No(this.options, this.defaultOptions), this.configureOptions = n, this.moduleOptions = {}, this.domElements = [], this.popupDiv = {}, this.popupLimit = 5, this.popupHistory = {}, this.colorPicker = new Bl(o), this.wrapper = void 0;
    }

    return _n(t, [{
      key: "setOptions",
      value: function value(t) {
        if (void 0 !== t) {
          this.popupHistory = {}, this._removePopup();
          var e = !0;
          if ("string" == typeof t) this.options.filter = t;else if (Jr(t)) this.options.filter = t.join();else if ("object" === es(t)) {
            if (null == t) throw new TypeError("options cannot be null");
            void 0 !== t.container && (this.options.container = t.container), void 0 !== yo(t) && (this.options.filter = yo(t)), void 0 !== t.showButton && (this.options.showButton = t.showButton), void 0 !== t.enabled && (e = t.enabled);
          } else "boolean" == typeof t ? (this.options.filter = !0, e = t) : "function" == typeof t && (this.options.filter = t, e = !0);
          !1 === yo(this.options) && (e = !1), this.options.enabled = e;
        }

        this._clean();
      }
    }, {
      key: "setModuleOptions",
      value: function value(t) {
        this.moduleOptions = t, !0 === this.options.enabled && (this._clean(), void 0 !== this.options.container && (this.container = this.options.container), this._create());
      }
    }, {
      key: "_create",
      value: function value() {
        this._clean(), this.changedOptions = [];
        var t = yo(this.options),
            e = 0,
            i = !1;

        for (var n in this.configureOptions) {
          Object.prototype.hasOwnProperty.call(this.configureOptions, n) && (this.allowCreation = !1, i = !1, "function" == typeof t ? i = (i = t(n, [])) || this._handleObject(this.configureOptions[n], [n], !0) : !0 !== t && -1 === qn(t).call(t, n) || (i = !0), !1 !== i && (this.allowCreation = !0, e > 0 && this._makeItem([]), this._makeHeader(n), this._handleObject(this.configureOptions[n], [n])), e++);
        }

        this._makeButton(), this._push();
      }
    }, {
      key: "_push",
      value: function value() {
        this.wrapper = document.createElement("div"), this.wrapper.className = "vis-configuration-wrapper", this.container.appendChild(this.wrapper);

        for (var t = 0; t < this.domElements.length; t++) {
          this.wrapper.appendChild(this.domElements[t]);
        }

        this._showPopupIfNeeded();
      }
    }, {
      key: "_clean",
      value: function value() {
        for (var t = 0; t < this.domElements.length; t++) {
          this.wrapper.removeChild(this.domElements[t]);
        }

        void 0 !== this.wrapper && (this.container.removeChild(this.wrapper), this.wrapper = void 0), this.domElements = [], this._removePopup();
      }
    }, {
      key: "_getValue",
      value: function value(t) {
        for (var e = this.moduleOptions, i = 0; i < t.length; i++) {
          if (void 0 === e[t[i]]) {
            e = void 0;
            break;
          }

          e = e[t[i]];
        }

        return e;
      }
    }, {
      key: "_makeItem",
      value: function value(t) {
        if (!0 === this.allowCreation) {
          var e = document.createElement("div");
          e.className = "vis-configuration vis-config-item vis-config-s" + t.length;

          for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) {
            n[o - 1] = arguments[o];
          }

          return nr(n).call(n, function (t) {
            e.appendChild(t);
          }), this.domElements.push(e), this.domElements.length;
        }

        return 0;
      }
    }, {
      key: "_makeHeader",
      value: function value(t) {
        var e = document.createElement("div");
        e.className = "vis-configuration vis-config-header", e.innerText = t, this._makeItem([], e);
      }
    }, {
      key: "_makeLabel",
      value: function value(t, e) {
        var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = document.createElement("div");

        if (n.className = "vis-configuration vis-config-label vis-config-s" + e.length, !0 === i) {
          for (; n.firstChild;) {
            n.removeChild(n.firstChild);
          }

          n.appendChild(Vl("i", "b", t));
        } else n.innerText = t + ":";

        return n;
      }
    }, {
      key: "_makeDropdown",
      value: function value(t, e, i) {
        var n = document.createElement("select");
        n.className = "vis-configuration vis-config-select";
        var o = 0;
        void 0 !== e && -1 !== qn(t).call(t, e) && (o = qn(t).call(t, e));

        for (var r = 0; r < t.length; r++) {
          var s = document.createElement("option");
          s.value = t[r], r === o && (s.selected = "selected"), s.innerText = t[r], n.appendChild(s);
        }

        var a = this;

        n.onchange = function () {
          a._update(this.value, i);
        };

        var l = this._makeLabel(i[i.length - 1], i);

        this._makeItem(i, l, n);
      }
    }, {
      key: "_makeRange",
      value: function value(t, e, i) {
        var n = t[0],
            o = t[1],
            r = t[2],
            s = t[3],
            a = document.createElement("input");
        a.className = "vis-configuration vis-config-range";

        try {
          a.type = "range", a.min = o, a.max = r;
        } catch (t) {}

        a.step = s;
        var l = "",
            h = 0;

        if (void 0 !== e) {
          var u = 1.2;
          e < 0 && e * u < o ? (a.min = Math.ceil(e * u), h = a.min, l = "range increased") : e / u < o && (a.min = Math.ceil(e / u), h = a.min, l = "range increased"), e * u > r && 1 !== r && (a.max = Math.ceil(e * u), h = a.max, l = "range increased"), a.value = e;
        } else a.value = n;

        var c = document.createElement("input");
        c.className = "vis-configuration vis-config-rangeinput", c.value = a.value;
        var d = this;
        a.onchange = function () {
          c.value = this.value, d._update(Number(this.value), i);
        }, a.oninput = function () {
          c.value = this.value;
        };

        var p = this._makeLabel(i[i.length - 1], i),
            f = this._makeItem(i, p, a, c);

        "" !== l && this.popupHistory[f] !== h && (this.popupHistory[f] = h, this._setupPopup(l, f));
      }
    }, {
      key: "_makeButton",
      value: function value() {
        var t = this;

        if (!0 === this.options.showButton) {
          var e = document.createElement("div");
          e.className = "vis-configuration vis-config-button", e.innerText = "generate options", e.onclick = function () {
            t._printOptions();
          }, e.onmouseover = function () {
            e.className = "vis-configuration vis-config-button hover";
          }, e.onmouseout = function () {
            e.className = "vis-configuration vis-config-button";
          }, this.optionsContainer = document.createElement("div"), this.optionsContainer.className = "vis-configuration vis-config-option-container", this.domElements.push(this.optionsContainer), this.domElements.push(e);
        }
      }
    }, {
      key: "_setupPopup",
      value: function value(t, e) {
        var i = this;

        if (!0 === this.initialized && !0 === this.allowCreation && this.popupCounter < this.popupLimit) {
          var n = document.createElement("div");
          n.id = "vis-configuration-popup", n.className = "vis-configuration-popup", n.innerText = t, n.onclick = function () {
            i._removePopup();
          }, this.popupCounter += 1, this.popupDiv = {
            html: n,
            index: e
          };
        }
      }
    }, {
      key: "_removePopup",
      value: function value() {
        void 0 !== this.popupDiv.html && (this.popupDiv.html.parentNode.removeChild(this.popupDiv.html), clearTimeout(this.popupDiv.hideTimeout), clearTimeout(this.popupDiv.deleteTimeout), this.popupDiv = {});
      }
    }, {
      key: "_showPopupIfNeeded",
      value: function value() {
        var t = this;

        if (void 0 !== this.popupDiv.html) {
          var e = this.domElements[this.popupDiv.index].getBoundingClientRect();
          this.popupDiv.html.style.left = e.left + "px", this.popupDiv.html.style.top = e.top - 30 + "px", document.body.appendChild(this.popupDiv.html), this.popupDiv.hideTimeout = hn(function () {
            t.popupDiv.html.style.opacity = 0;
          }, 1500), this.popupDiv.deleteTimeout = hn(function () {
            t._removePopup();
          }, 1800);
        }
      }
    }, {
      key: "_makeCheckbox",
      value: function value(t, e, i) {
        var n = document.createElement("input");
        n.type = "checkbox", n.className = "vis-configuration vis-config-checkbox", n.checked = t, void 0 !== e && (n.checked = e, e !== t && ("object" === es(t) ? e !== t.enabled && this.changedOptions.push({
          path: i,
          value: e
        }) : this.changedOptions.push({
          path: i,
          value: e
        })));
        var o = this;

        n.onchange = function () {
          o._update(this.checked, i);
        };

        var r = this._makeLabel(i[i.length - 1], i);

        this._makeItem(i, r, n);
      }
    }, {
      key: "_makeTextInput",
      value: function value(t, e, i) {
        var n = document.createElement("input");
        n.type = "text", n.className = "vis-configuration vis-config-text", n.value = e, e !== t && this.changedOptions.push({
          path: i,
          value: e
        });
        var o = this;

        n.onchange = function () {
          o._update(this.value, i);
        };

        var r = this._makeLabel(i[i.length - 1], i);

        this._makeItem(i, r, n);
      }
    }, {
      key: "_makeColorField",
      value: function value(t, e, i) {
        var n = this,
            o = t[1],
            r = document.createElement("div");
        "none" !== (e = void 0 === e ? o : e) ? (r.className = "vis-configuration vis-config-colorBlock", r.style.backgroundColor = e) : r.className = "vis-configuration vis-config-colorBlock none", e = void 0 === e ? o : e, r.onclick = function () {
          n._showColorPicker(e, r, i);
        };

        var s = this._makeLabel(i[i.length - 1], i);

        this._makeItem(i, s, r);
      }
    }, {
      key: "_showColorPicker",
      value: function value(t, e, i) {
        var n = this;
        e.onclick = function () {}, this.colorPicker.insertTo(e), this.colorPicker.show(), this.colorPicker.setColor(t), this.colorPicker.setUpdateCallback(function (t) {
          var o = "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
          e.style.backgroundColor = o, n._update(o, i);
        }), this.colorPicker.setCloseCallback(function () {
          e.onclick = function () {
            n._showColorPicker(t, e, i);
          };
        });
      }
    }, {
      key: "_handleObject",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = !1,
            o = yo(this.options),
            r = !1;

        for (var s in t) {
          if (Object.prototype.hasOwnProperty.call(t, s)) {
            n = !0;
            var a = t[s],
                l = Tl(e, s);

            if ("function" == typeof o && !1 === (n = o(s, e)) && !Jr(a) && "string" != typeof a && "boolean" != typeof a && a instanceof Object && (this.allowCreation = !1, n = this._handleObject(a, l, !0), this.allowCreation = !1 === i), !1 !== n) {
              r = !0;

              var h = this._getValue(l);

              if (Jr(a)) this._handleArray(a, h, l);else if ("string" == typeof a) this._makeTextInput(a, h, l);else if ("boolean" == typeof a) this._makeCheckbox(a, h, l);else if (a instanceof Object) {
                if (!this.hideOption(e, s, this.moduleOptions)) if (void 0 !== a.enabled) {
                  var u = Tl(l, "enabled"),
                      c = this._getValue(u);

                  if (!0 === c) {
                    var d = this._makeLabel(s, l, !0);

                    this._makeItem(l, d), r = this._handleObject(a, l) || r;
                  } else this._makeCheckbox(a, c, l);
                } else {
                  var p = this._makeLabel(s, l, !0);

                  this._makeItem(l, p), r = this._handleObject(a, l) || r;
                }
              } else console.error("dont know how to handle", a, s, l);
            }
          }
        }

        return r;
      }
    }, {
      key: "_handleArray",
      value: function value(t, e, i) {
        "string" == typeof t[0] && "color" === t[0] ? (this._makeColorField(t, e, i), t[1] !== e && this.changedOptions.push({
          path: i,
          value: e
        })) : "string" == typeof t[0] ? (this._makeDropdown(t, e, i), t[0] !== e && this.changedOptions.push({
          path: i,
          value: e
        })) : "number" == typeof t[0] && (this._makeRange(t, e, i), t[0] !== e && this.changedOptions.push({
          path: i,
          value: Number(e)
        }));
      }
    }, {
      key: "_update",
      value: function value(t, e) {
        var i = this._constructOptions(t, e);

        this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit && this.parent.body.emitter.emit("configChange", i), this.initialized = !0, this.parent.setOptions(i);
      }
    }, {
      key: "_constructOptions",
      value: function value(t, e) {
        var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = i;
        t = "false" !== (t = "true" === t || t) && t;

        for (var o = 0; o < e.length; o++) {
          "global" !== e[o] && (void 0 === n[e[o]] && (n[e[o]] = {}), o !== e.length - 1 ? n = n[e[o]] : n[e[o]] = t);
        }

        return i;
      }
    }, {
      key: "_printOptions",
      value: function value() {
        for (var t = this.getOptions(); this.optionsContainer.firstChild;) {
          this.optionsContainer.removeChild(this.optionsContainer.firstChild);
        }

        this.optionsContainer.appendChild(Vl("pre", "const options = " + vn(t, null, 2)));
      }
    }, {
      key: "getOptions",
      value: function value() {
        for (var t = {}, e = 0; e < this.changedOptions.length; e++) {
          this._constructOptions(this.changedOptions[e].value, this.changedOptions[e].path, t);
        }

        return t;
      }
    }]), t;
  }(),
      ql = !1,
      Zl = "background: #FFeeee; color: #dd0000",
      $l = fl,
      Kl = Bl,
      Jl = Xl,
      Ql = pl,
      th = function () {
    function t(e, i) {
      gn(this, t), this.container = e, this.overflowMethod = i || "cap", this.x = 0, this.y = 0, this.padding = 5, this.hidden = !1, this.frame = document.createElement("div"), this.frame.className = "vis-tooltip", this.container.appendChild(this.frame);
    }

    return _n(t, [{
      key: "setPosition",
      value: function value(t, e) {
        this.x = Qn(t), this.y = Qn(e);
      }
    }, {
      key: "setText",
      value: function value(t) {
        if (t instanceof Element) {
          for (; this.frame.firstChild;) {
            this.frame.removeChild(this.frame.firstChild);
          }

          this.frame.appendChild(t);
        } else this.frame.innerText = t;
      }
    }, {
      key: "show",
      value: function value(t) {
        if (void 0 === t && (t = !0), !0 === t) {
          var e = this.frame.clientHeight,
              i = this.frame.clientWidth,
              n = this.frame.parentNode.clientHeight,
              o = this.frame.parentNode.clientWidth,
              r = 0,
              s = 0;

          if ("flip" == this.overflowMethod) {
            var a = !1,
                l = !0;
            this.y - e < this.padding && (l = !1), this.x + i > o - this.padding && (a = !0), r = a ? this.x - i : this.x, s = l ? this.y - e : this.y;
          } else (s = this.y - e) + e + this.padding > n && (s = n - e - this.padding), s < this.padding && (s = this.padding), (r = this.x) + i + this.padding > o && (r = o - i - this.padding), r < this.padding && (r = this.padding);

          this.frame.style.left = r + "px", this.frame.style.top = s + "px", this.frame.style.visibility = "visible", this.hidden = !1;
        } else this.hide();
      }
    }, {
      key: "hide",
      value: function value() {
        this.hidden = !0, this.frame.style.left = "0", this.frame.style.top = "0", this.frame.style.visibility = "hidden";
      }
    }, {
      key: "destroy",
      value: function value() {
        this.frame.parentNode.removeChild(this.frame);
      }
    }]), t;
  }(),
      eh = function () {
    function t() {
      gn(this, t);
    }

    return _n(t, null, [{
      key: "validate",
      value: function value(e, i, n) {
        ql = !1, Ul = i;
        var o = i;
        return void 0 !== n && (o = i[n]), t.parse(e, o, []), ql;
      }
    }, {
      key: "parse",
      value: function value(e, i, n) {
        for (var o in e) {
          Object.prototype.hasOwnProperty.call(e, o) && t.check(o, e, i, n);
        }
      }
    }, {
      key: "check",
      value: function value(e, i, n, o) {
        if (void 0 !== n[e] || void 0 !== n.__any__) {
          var r = e,
              s = !0;
          void 0 === n[e] && void 0 !== n.__any__ && (r = "__any__", s = "object" === t.getType(i[e]));
          var a = n[r];
          s && void 0 !== a.__type__ && (a = a.__type__), t.checkFields(e, i, n, r, a, o);
        } else t.getSuggestion(e, n, o);
      }
    }, {
      key: "checkFields",
      value: function value(e, i, n, o, r, s) {
        var a = function a(i) {
          console.error("%c" + i + t.printLocation(s, e), Zl);
        },
            l = t.getType(i[e]),
            h = r[l];

        void 0 !== h ? "array" === t.getType(h) && -1 === qn(h).call(h, i[e]) ? (a('Invalid option detected in "' + e + '". Allowed values are:' + t.print(h) + ' not "' + i[e] + '". '), ql = !0) : "object" === l && "__any__" !== o && (s = Tl(s, e), t.parse(i[e], n[o], s)) : void 0 === r.any && (a('Invalid type received for "' + e + '". Expected: ' + t.print(Vr(r)) + ". Received [" + l + '] "' + i[e] + '"'), ql = !0);
      }
    }, {
      key: "getType",
      value: function value(t) {
        var e = es(t);
        return "object" === e ? null === t ? "null" : t instanceof Boolean ? "boolean" : t instanceof Number ? "number" : t instanceof String ? "string" : Jr(t) ? "array" : t instanceof Date ? "date" : void 0 !== t.nodeType ? "dom" : !0 === t._isAMomentObject ? "moment" : "object" : "number" === e ? "number" : "boolean" === e ? "boolean" : "string" === e ? "string" : void 0 === e ? "undefined" : e;
      }
    }, {
      key: "getSuggestion",
      value: function value(e, i, n) {
        var o,
            r = t.findInOptions(e, i, n, !1),
            s = t.findInOptions(e, Ul, [], !0);
        o = void 0 !== r.indexMatch ? " in " + t.printLocation(r.path, e, "") + 'Perhaps it was incomplete? Did you mean: "' + r.indexMatch + '"?\n\n' : s.distance <= 4 && r.distance > s.distance ? " in " + t.printLocation(r.path, e, "") + "Perhaps it was misplaced? Matching option found at: " + t.printLocation(s.path, s.closestMatch, "") : r.distance <= 8 ? '. Did you mean "' + r.closestMatch + '"?' + t.printLocation(r.path, e) : ". Did you mean one of these: " + t.print(Vr(i)) + t.printLocation(n, e), console.error('%cUnknown option detected: "' + e + '"' + o, Zl), ql = !0;
      }
    }, {
      key: "findInOptions",
      value: function value(e, i, n) {
        var o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            r = 1e9,
            s = "",
            a = [],
            l = e.toLowerCase(),
            h = void 0;

        for (var u in i) {
          var c = void 0;

          if (void 0 !== i[u].__type__ && !0 === o) {
            var d = t.findInOptions(e, i[u], Tl(n, u));
            r > d.distance && (s = d.closestMatch, a = d.path, r = d.distance, h = d.indexMatch);
          } else {
            var p;
            -1 !== qn(p = u.toLowerCase()).call(p, l) && (h = u), r > (c = t.levenshteinDistance(e, u)) && (s = u, a = Ml(n), r = c);
          }
        }

        return {
          closestMatch: s,
          path: a,
          distance: r,
          indexMatch: h
        };
      }
    }, {
      key: "printLocation",
      value: function value(t, e) {
        for (var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Problem value found at: \n", n = "\n\n" + i + "options = {\n", o = 0; o < t.length; o++) {
          for (var r = 0; r < o + 1; r++) {
            n += "  ";
          }

          n += t[o] + ": {\n";
        }

        for (var s = 0; s < t.length + 1; s++) {
          n += "  ";
        }

        n += e + "\n";

        for (var a = 0; a < t.length + 1; a++) {
          for (var l = 0; l < t.length - a; l++) {
            n += "  ";
          }

          n += "}\n";
        }

        return n + "\n\n";
      }
    }, {
      key: "print",
      value: function value(t) {
        return vn(t).replace(/(")|(\[)|(\])|(,"__type__")/g, "").replace(/(,)/g, ", ");
      }
    }, {
      key: "levenshteinDistance",
      value: function value(t, e) {
        if (0 === t.length) return e.length;
        if (0 === e.length) return t.length;
        var i,
            n,
            o = [];

        for (i = 0; i <= e.length; i++) {
          o[i] = [i];
        }

        for (n = 0; n <= t.length; n++) {
          o[0][n] = n;
        }

        for (i = 1; i <= e.length; i++) {
          for (n = 1; n <= t.length; n++) {
            e.charAt(i - 1) == t.charAt(n - 1) ? o[i][n] = o[i - 1][n - 1] : o[i][n] = Math.min(o[i - 1][n - 1] + 1, Math.min(o[i][n - 1] + 1, o[i - 1][n] + 1));
          }
        }

        return o[e.length][t.length];
      }
    }]), t;
  }(),
      ih = Object.freeze({
    __proto__: null,
    Activator: $l,
    Alea: function Alea() {
      for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) {
        e[i] = arguments[i];
      }

      return cl(e.length ? e : [Wr()]);
    },
    ColorPicker: Kl,
    Configurator: Jl,
    DELETE: rl,
    HSVToHex: Fl,
    HSVToRGB: Rl,
    Hammer: Ql,
    Popup: th,
    RGBToHSV: Ll,
    RGBToHex: Al,
    VALIDATOR_PRINT_STYLE: "background: #FFeeee; color: #dd0000",
    Validator: eh,
    addClassName: function addClassName(t, e) {
      var i = t.className.split(" "),
          n = e.split(" ");
      i = us(i).call(i, yo(n).call(n, function (t) {
        return !Po(i).call(i, t);
      })), t.className = i.join(" ");
    },
    addCssText: function addCssText(t, e) {
      var i = Il(t.style.cssText),
          n = Il(e),
          o = il(il({}, i), n);
      t.style.cssText = Nl(o);
    },
    addEventListener: function addEventListener(t, e, i, n) {
      var o;
      t.addEventListener ? (void 0 === n && (n = !1), "mousewheel" === e && Po(o = navigator.userAgent).call(o, "Firefox") && (e = "DOMMouseScroll"), t.addEventListener(e, i, n)) : t.attachEvent("on" + e, i);
    },
    binarySearchCustom: function binarySearchCustom(t, e, i, n) {
      for (var o = 0, r = 0, s = t.length - 1; r <= s && o < 1e4;) {
        var a = Math.floor((r + s) / 2),
            l = t[a],
            h = e(void 0 === n ? l[i] : l[i][n]);
        if (0 == h) return a;
        -1 == h ? r = a + 1 : s = a - 1, o++;
      }

      return -1;
    },
    binarySearchValue: function binarySearchValue(t, e, i, n, o) {
      var r,
          s,
          a,
          l,
          h = 0,
          u = 0,
          c = t.length - 1;

      for (o = null != o ? o : function (t, e) {
        return t == e ? 0 : t < e ? -1 : 1;
      }; u <= c && h < 1e4;) {
        if (l = Math.floor(.5 * (c + u)), r = t[Math.max(0, l - 1)][i], s = t[l][i], a = t[Math.min(t.length - 1, l + 1)][i], 0 == o(s, e)) return l;
        if (o(r, e) < 0 && o(s, e) > 0) return "before" == n ? Math.max(0, l - 1) : l;
        if (o(s, e) < 0 && o(a, e) > 0) return "before" == n ? l : Math.min(t.length - 1, l + 1);
        o(s, e) < 0 ? u = l + 1 : c = l - 1, h++;
      }

      return -1;
    },
    bridgeObject: Gl,
    copyAndExtendArray: Tl,
    copyArray: Ml,
    deepExtend: Sl,
    deepObjectAssign: al,
    easingFunctions: {
      linear: function linear(t) {
        return t;
      },
      easeInQuad: function easeInQuad(t) {
        return t * t;
      },
      easeOutQuad: function easeOutQuad(t) {
        return t * (2 - t);
      },
      easeInOutQuad: function easeInOutQuad(t) {
        return t < .5 ? 2 * t * t : (4 - 2 * t) * t - 1;
      },
      easeInCubic: function easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic: function easeOutCubic(t) {
        return --t * t * t + 1;
      },
      easeInOutCubic: function easeInOutCubic(t) {
        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      },
      easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart: function easeOutQuart(t) {
        return 1 - --t * t * t * t;
      },
      easeInOutQuart: function easeInOutQuart(t) {
        return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
      },
      easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint: function easeOutQuint(t) {
        return 1 + --t * t * t * t * t;
      },
      easeInOutQuint: function easeInOutQuint(t) {
        return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
      }
    },
    equalArray: function equalArray(t, e) {
      if (t.length !== e.length) return !1;

      for (var i = 0, n = t.length; i < n; i++) {
        if (t[i] != e[i]) return !1;
      }

      return !0;
    },
    extend: Dl,
    fillIfDefined: function t(e, i) {
      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];

      for (var o in e) {
        if (void 0 !== i[o]) if (null === i[o] || "object" !== es(i[o])) xl(e, i, o, n);else {
          var r = e[o],
              s = i[o];
          kl(r) && kl(s) && t(r, s, n);
        }
      }
    },
    forEach: function forEach(t, e) {
      if (Jr(t)) for (var i = t.length, n = 0; n < i; n++) {
        e(t[n], n, t);
      } else for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && e(t[o], o, t);
      }
    },
    getAbsoluteLeft: function getAbsoluteLeft(t) {
      return t.getBoundingClientRect().left;
    },
    getAbsoluteRight: function getAbsoluteRight(t) {
      return t.getBoundingClientRect().right;
    },
    getAbsoluteTop: function getAbsoluteTop(t) {
      return t.getBoundingClientRect().top;
    },
    getScrollBarWidth: function getScrollBarWidth() {
      var t = document.createElement("p");
      t.style.width = "100%", t.style.height = "200px";
      var e = document.createElement("div");
      e.style.position = "absolute", e.style.top = "0px", e.style.left = "0px", e.style.visibility = "hidden", e.style.width = "200px", e.style.height = "150px", e.style.overflow = "hidden", e.appendChild(t), document.body.appendChild(e);
      var i = t.offsetWidth;
      e.style.overflow = "scroll";
      var n = t.offsetWidth;
      return i == n && (n = e.clientWidth), document.body.removeChild(e), i - n;
    },
    getTarget: function getTarget() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.event,
          e = null;
      return t && (t.target ? e = t.target : t.srcElement && (e = t.srcElement)), e instanceof Element && (null == e.nodeType || 3 != e.nodeType || (e = e.parentNode) instanceof Element) ? e : null;
    },
    getType: Cl,
    hasParent: function hasParent(t, e) {
      for (var i = t; i;) {
        if (i === e) return !0;
        if (!i.parentNode) return !1;
        i = i.parentNode;
      }

      return !1;
    },
    hexToHSV: Yl,
    hexToRGB: Pl,
    insertSort: function insertSort(t, e) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i],
            o = void 0;

        for (o = i; o > 0 && e(n, t[o - 1]) < 0; o--) {
          t[o] = t[o - 1];
        }

        t[o] = n;
      }

      return t;
    },
    isDate: function isDate(t) {
      if (t instanceof Date) return !0;

      if (wl(t)) {
        if (ml.exec(t)) return !0;
        if (!isNaN(Date.parse(t))) return !0;
      }

      return !1;
    },
    isNumber: _l,
    isObject: kl,
    isString: wl,
    isValidHex: jl,
    isValidRGB: Hl,
    isValidRGBA: zl,
    mergeOptions: function mergeOptions(t, e, i) {
      var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
          o = function o(t) {
        return null != t;
      },
          r = function r(t) {
        return null !== t && "object" === es(t);
      },
          s = function s(t) {
        for (var e in t) {
          if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
        }

        return !0;
      };

      if (!r(t)) throw new Error("Parameter mergeTarget must be an object");
      if (!r(e)) throw new Error("Parameter options must be an object");
      if (!o(i)) throw new Error("Parameter option must have a value");
      if (!r(n)) throw new Error("Parameter globalOptions must be an object");

      var a = function a(t, e, i) {
        r(t[i]) || (t[i] = {});
        var n = e[i],
            o = t[i];

        for (var s in n) {
          Object.prototype.hasOwnProperty.call(n, s) && (o[s] = n[s]);
        }
      },
          l = e[i],
          h = r(n) && !s(n),
          u = h ? n[i] : void 0,
          c = u ? u.enabled : void 0;

      if (void 0 !== l) {
        if ("boolean" == typeof l) return r(t[i]) || (t[i] = {}), void (t[i].enabled = l);

        if (null === l && !r(t[i])) {
          if (!o(u)) return;
          t[i] = xn(u);
        }

        if (r(l)) {
          var d = !0;
          void 0 !== l.enabled ? d = l.enabled : void 0 !== c && (d = u.enabled), a(t, e, i), t[i].enabled = d;
        }
      }
    },
    option: El,
    overrideOpacity: function overrideOpacity(t, e) {
      if (Po(t).call(t, "rgba")) return t;

      if (Po(t).call(t, "rgb")) {
        var i = t.substr(qn(t).call(t, "(") + 1).replace(")", "").split(",");
        return "rgba(" + i[0] + "," + i[1] + "," + i[2] + "," + e + ")";
      }

      var n = Pl(t);
      return null == n ? t : "rgba(" + n.r + "," + n.g + "," + n.b + "," + e + ")";
    },
    parseColor: function parseColor(t, e) {
      if (wl(t)) {
        var i = t;

        if (Hl(i)) {
          var n,
              o = Kr(n = i.substr(4).substr(0, i.length - 5).split(",")).call(n, function (t) {
            return Qn(t);
          });
          i = Al(o[0], o[1], o[2]);
        }

        if (!0 === jl(i)) {
          var r = Yl(i),
              s = {
            h: r.h,
            s: .8 * r.s,
            v: Math.min(1, 1.02 * r.v)
          },
              a = {
            h: r.h,
            s: Math.min(1, 1.25 * r.s),
            v: .8 * r.v
          },
              l = Fl(a.h, a.s, a.v),
              h = Fl(s.h, s.s, s.v);
          return {
            background: i,
            border: l,
            highlight: {
              background: h,
              border: l
            },
            hover: {
              background: h,
              border: l
            }
          };
        }

        return {
          background: i,
          border: i,
          highlight: {
            background: i,
            border: i
          },
          hover: {
            background: i,
            border: i
          }
        };
      }

      return e ? {
        background: t.background || e.background,
        border: t.border || e.border,
        highlight: wl(t.highlight) ? {
          border: t.highlight,
          background: t.highlight
        } : {
          background: t.highlight && t.highlight.background || e.highlight.background,
          border: t.highlight && t.highlight.border || e.highlight.border
        },
        hover: wl(t.hover) ? {
          border: t.hover,
          background: t.hover
        } : {
          border: t.hover && t.hover.border || e.hover.border,
          background: t.hover && t.hover.background || e.hover.background
        }
      } : {
        background: t.background || void 0,
        border: t.border || void 0,
        highlight: wl(t.highlight) ? {
          border: t.highlight,
          background: t.highlight
        } : {
          background: t.highlight && t.highlight.background || void 0,
          border: t.highlight && t.highlight.border || void 0
        },
        hover: wl(t.hover) ? {
          border: t.hover,
          background: t.hover
        } : {
          border: t.hover && t.hover.border || void 0,
          background: t.hover && t.hover.background || void 0
        }
      };
    },
    preventDefault: function preventDefault(t) {
      t || (t = window.event), t && (t.preventDefault ? t.preventDefault() : t.returnValue = !1);
    },
    pureDeepObjectAssign: sl,
    recursiveDOMDelete: function t(e) {
      if (e) for (; !0 === e.hasChildNodes();) {
        var i = e.firstChild;
        i && (t(i), e.removeChild(i));
      }
    },
    removeClassName: function removeClassName(t, e) {
      var i = t.className.split(" "),
          n = e.split(" ");
      i = yo(i).call(i, function (t) {
        return !Po(n).call(n, t);
      }), t.className = i.join(" ");
    },
    removeCssText: function removeCssText(t, e) {
      var i = Il(t.style.cssText),
          n = Il(e);

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && delete i[o];
      }

      t.style.cssText = Nl(i);
    },
    removeEventListener: function removeEventListener(t, e, i, n) {
      var o;
      t.removeEventListener ? (void 0 === n && (n = !1), "mousewheel" === e && Po(o = navigator.userAgent).call(o, "Firefox") && (e = "DOMMouseScroll"), t.removeEventListener(e, i, n)) : t.detachEvent("on" + e, i);
    },
    selectiveBridgeObject: function selectiveBridgeObject(t, e) {
      if (null !== e && "object" === es(e)) {
        for (var i = xn(e), n = 0; n < t.length; n++) {
          Object.prototype.hasOwnProperty.call(e, t[n]) && "object" == es(e[t[n]]) && (i[t[n]] = Gl(e[t[n]]));
        }

        return i;
      }

      return null;
    },
    selectiveDeepExtend: function selectiveDeepExtend(t, e, i) {
      var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
      if (Jr(i)) throw new TypeError("Arrays are not supported by deepExtend");

      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        if (Object.prototype.hasOwnProperty.call(i, r)) if (i[r] && i[r].constructor === Object) void 0 === e[r] && (e[r] = {}), e[r].constructor === Object ? Sl(e[r], i[r], !1, n) : xl(e, i, r, n);else {
          if (Jr(i[r])) throw new TypeError("Arrays are not supported by deepExtend");
          xl(e, i, r, n);
        }
      }

      return e;
    },
    selectiveExtend: function selectiveExtend(t, e) {
      if (!Jr(t)) throw new Error("Array with property names expected as first argument");

      for (var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), o = 2; o < i; o++) {
        n[o - 2] = arguments[o];
      }

      for (var r = 0, s = n; r < s.length; r++) {
        for (var a = s[r], l = 0; l < t.length; l++) {
          var h = t[l];
          a && Object.prototype.hasOwnProperty.call(a, h) && (e[h] = a[h]);
        }
      }

      return e;
    },
    selectiveNotDeepExtend: function selectiveNotDeepExtend(t, e, i) {
      var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
      if (Jr(i)) throw new TypeError("Arrays are not supported by deepExtend");

      for (var o in i) {
        if (Object.prototype.hasOwnProperty.call(i, o) && !Po(t).call(t, o)) if (i[o] && i[o].constructor === Object) void 0 === e[o] && (e[o] = {}), e[o].constructor === Object ? Sl(e[o], i[o]) : xl(e, i, o, n);else if (Jr(i[o])) {
          e[o] = [];

          for (var r = 0; r < i[o].length; r++) {
            e[o].push(i[o][r]);
          }
        } else xl(e, i, o, n);
      }

      return e;
    },
    throttle: function throttle(t) {
      var e = !1;
      return function () {
        e || (e = !0, requestAnimationFrame(function () {
          e = !1, t();
        }));
      };
    },
    toArray: Ol,
    topMost: function topMost(t, e) {
      var i;
      Jr(e) || (e = [e]);
      var n,
          o = nl(t);

      try {
        for (o.s(); !(n = o.n()).done;) {
          var r = n.value;

          if (r) {
            i = r[e[0]];

            for (var s = 1; s < e.length; s++) {
              i && (i = i[e[s]]);
            }

            if (void 0 !== i) break;
          }
        }
      } catch (t) {
        o.e(t);
      } finally {
        o.f();
      }

      return i;
    },
    updateProperty: function updateProperty(t, e, i) {
      return t[e] !== i && (t[e] = i, !0);
    }
  });

  function nh(t) {
    for (var e in t) {
      t.hasOwnProperty(e) && (t[e].redundant = t[e].used, t[e].used = []);
    }
  }

  function oh(t) {
    for (var e in t) {
      if (t.hasOwnProperty(e) && t[e].redundant) {
        for (var i = 0; i < t[e].redundant.length; i++) {
          t[e].redundant[i].parentNode.removeChild(t[e].redundant[i]);
        }

        t[e].redundant = [];
      }
    }
  }

  function rh(t) {
    nh(t), oh(t), nh(t);
  }

  function sh(t, e, i) {
    var n;
    return e.hasOwnProperty(t) ? e[t].redundant.length > 0 ? (n = e[t].redundant[0], e[t].redundant.shift()) : (n = document.createElementNS("http://www.w3.org/2000/svg", t), i.appendChild(n)) : (n = document.createElementNS("http://www.w3.org/2000/svg", t), e[t] = {
      used: [],
      redundant: []
    }, i.appendChild(n)), e[t].used.push(n), n;
  }

  function ah(t, e, i, n) {
    var o;
    return e.hasOwnProperty(t) ? e[t].redundant.length > 0 ? (o = e[t].redundant[0], e[t].redundant.shift()) : (o = document.createElement(t), void 0 !== n ? i.insertBefore(o, n) : i.appendChild(o)) : (o = document.createElement(t), e[t] = {
      used: [],
      redundant: []
    }, void 0 !== n ? i.insertBefore(o, n) : i.appendChild(o)), e[t].used.push(o), o;
  }

  function lh(t, e, i, n, o, r) {
    var s;

    if ("circle" == i.style ? ((s = sh("circle", n, o)).setAttributeNS(null, "cx", t), s.setAttributeNS(null, "cy", e), s.setAttributeNS(null, "r", .5 * i.size)) : ((s = sh("rect", n, o)).setAttributeNS(null, "x", t - .5 * i.size), s.setAttributeNS(null, "y", e - .5 * i.size), s.setAttributeNS(null, "width", i.size), s.setAttributeNS(null, "height", i.size)), void 0 !== i.styles && s.setAttributeNS(null, "style", i.styles), s.setAttributeNS(null, "class", i.className + " vis-point"), r) {
      var a = sh("text", n, o);
      r.xOffset && (t += r.xOffset), r.yOffset && (e += r.yOffset), r.content && (a.textContent = r.content), r.className && a.setAttributeNS(null, "class", r.className + " vis-label"), a.setAttributeNS(null, "x", t), a.setAttributeNS(null, "y", e);
    }

    return s;
  }

  function hh(t, e, i, n, o, r, s, a) {
    if (0 != n) {
      n < 0 && (e -= n *= -1);
      var l = sh("rect", r, s);
      l.setAttributeNS(null, "x", t - .5 * i), l.setAttributeNS(null, "y", e), l.setAttributeNS(null, "width", i), l.setAttributeNS(null, "height", n), l.setAttributeNS(null, "class", o), a && l.setAttributeNS(null, "style", a);
    }
  }

  function uh() {
    try {
      return navigator ? navigator.languages && navigator.languages.length ? navigator.languages : navigator.userLanguage || navigator.language || navigator.browserLanguage || "en" : "en";
    } catch (t) {
      return "en";
    }
  }

  var ch = Object.freeze({
    __proto__: null,
    prepareElements: nh,
    cleanupElements: oh,
    resetElements: rh,
    getSVGElement: sh,
    getDOMElement: ah,
    drawPoint: lh,
    drawBar: hh,
    getNavigatorLanguage: uh
  }),
      dh = pt("Reflect", "construct"),
      ph = l(function () {
    function t() {}

    return !(dh(function () {}, [], t) instanceof t);
  }),
      fh = !l(function () {
    dh(function () {});
  }),
      mh = ph || fh;
  U({
    target: "Reflect",
    stat: !0,
    forced: mh,
    sham: mh
  }, {
    construct: function construct(t, e) {
      Y(t), H(e);
      var i = arguments.length < 3 ? t : Y(arguments[2]);
      if (fh && !ph) return dh(t, e, i);

      if (t == i) {
        switch (e.length) {
          case 0:
            return new t();

          case 1:
            return new t(e[0]);

          case 2:
            return new t(e[0], e[1]);

          case 3:
            return new t(e[0], e[1], e[2]);

          case 4:
            return new t(e[0], e[1], e[2], e[3]);
        }

        var n = [null];
        return n.push.apply(n, e), new (ar.apply(t, n))();
      }

      var o = i.prototype,
          r = zt(_(o) ? o : Object.prototype),
          s = Function.apply.call(t, r, e);
      return _(s) ? s : r;
    }
  });
  var vh = F.Reflect.construct;

  var gh = function gh(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  },
      yh = tn("Array").entries,
      bh = Array.prototype,
      _h = {
    DOMTokenList: !0,
    NodeList: !0
  },
      wh = function wh(t) {
    var e = t.entries;
    return t === bh || t instanceof Array && e === bh.entries || _h.hasOwnProperty(oe(t)) ? yh : e;
  },
      kh = tn("Array").values,
      xh = Array.prototype,
      Dh = {
    DOMTokenList: !0,
    NodeList: !0
  },
      Sh = function Sh(t) {
    var e = t.values;
    return t === xh || t instanceof Array && e === xh.values || Dh.hasOwnProperty(oe(t)) ? kh : e;
  },
      Ch = tn("Array").keys,
      Th = Array.prototype,
      Mh = {
    DOMTokenList: !0,
    NodeList: !0
  },
      Oh = function Oh(t) {
    var e = t.keys;
    return t === Th || t instanceof Array && e === Th.keys || Mh.hasOwnProperty(oe(t)) ? Ch : e;
  },
      Eh = Te.some,
      Ph = Rn("some"),
      Ah = Hn("some");

  U({
    target: "Array",
    proto: !0,
    forced: !Ph || !Ah
  }, {
    some: function some(t) {
      return Eh(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var Lh = tn("Array").some,
      Ih = Array.prototype,
      Nh = function Nh(t) {
    var e = t.some;
    return t === Ih || t instanceof Array && e === Ih.some ? Lh : e;
  },
      Rh = kn;

  U({
    target: "Object",
    stat: !0
  }, {
    setPrototypeOf: gi
  });
  var Fh = F.Object.setPrototypeOf,
      Yh = n(function (t) {
    function e(i, n) {
      return t.exports = e = Fh || function (t, e) {
        return t.__proto__ = e, t;
      }, e(i, n);
    }

    t.exports = e;
  });

  var jh = function jh(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Rh(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && Yh(t, e);
  };

  var Hh = function Hh(t, e) {
    return !e || "object" !== es(e) && "function" != typeof e ? gh(t) : e;
  },
      zh = _o,
      Gh = n(function (t) {
    function e(i) {
      return t.exports = e = Fh ? zh : function (t) {
        return t.__proto__ || zh(t);
      }, e(i);
    }

    t.exports = e;
  }),
      Wh = [],
      Bh = Wh.sort,
      Vh = l(function () {
    Wh.sort(void 0);
  }),
      Uh = l(function () {
    Wh.sort(null);
  }),
      Xh = Rn("sort");

  U({
    target: "Array",
    proto: !0,
    forced: Vh || !Uh || !Xh
  }, {
    sort: function sort(t) {
      return void 0 === t ? Bh.call(Tt(this)) : Bh.call(Tt(this), Y(t));
    }
  });

  var qh = tn("Array").sort,
      Zh = Array.prototype,
      $h = function $h(t) {
    var e = t.sort;
    return t === Zh || t instanceof Array && e === Zh.sort ? qh : e;
  },
      Kh = !l(function () {
    return Object.isExtensible(Object.preventExtensions({}));
  }),
      Jh = n(function (t) {
    var e = G.f,
        i = It("meta"),
        n = 0,
        o = Object.isExtensible || function () {
      return !0;
    },
        r = function r(t) {
      e(t, i, {
        value: {
          objectID: "O" + ++n,
          weakData: {}
        }
      });
    },
        s = t.exports = {
      REQUIRED: !1,
      fastKey: function fastKey(t, e) {
        if (!_(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;

        if (!x(t, i)) {
          if (!o(t)) return "F";
          if (!e) return "E";
          r(t);
        }

        return t[i].objectID;
      },
      getWeakData: function getWeakData(t, e) {
        if (!x(t, i)) {
          if (!o(t)) return !0;
          if (!e) return !1;
          r(t);
        }

        return t[i].weakData;
      },
      onFreeze: function onFreeze(t) {
        return Kh && s.REQUIRED && o(t) && !x(t, i) && r(t), t;
      }
    };

    rt[i] = !0;
  }),
      Qh = (Jh.REQUIRED, Jh.fastKey, Jh.getWeakData, Jh.onFreeze, function (t, e) {
    this.stopped = t, this.result = e;
  }),
      tu = function tu(t, e, i) {
    var n,
        o,
        r,
        s,
        a,
        l,
        h,
        u = i && i.that,
        c = !(!i || !i.AS_ENTRIES),
        d = !(!i || !i.IS_ITERATOR),
        p = !(!i || !i.INTERRUPTED),
        f = j(e, u, 1 + c + p),
        m = function m(t) {
      return n && Gi(n), new Qh(!0, t);
    },
        v = function v(t) {
      return c ? (H(t), p ? f(t[0], t[1], m) : f(t[0], t[1])) : p ? f(t, m) : f(t);
    };

    if (d) n = t;else {
      if ("function" != typeof (o = ji(t))) throw TypeError("Target is not iterable");

      if (Ui(o)) {
        for (r = 0, s = Q(t.length); s > r; r++) {
          if ((a = v(t[r])) && a instanceof Qh) return a;
        }

        return new Qh(!1);
      }

      n = o.call(t);
    }

    for (l = n.next; !(h = l.call(n)).done;) {
      try {
        a = v(h.value);
      } catch (t) {
        throw Gi(n), t;
      }

      if ("object" == typeof a && a && a instanceof Qh) return a;
    }

    return new Qh(!1);
  },
      eu = function eu(t, e, i) {
    if (!(t instanceof e)) throw TypeError("Incorrect " + (i ? i + " " : "") + "invocation");
    return t;
  },
      iu = G.f,
      nu = Te.forEach,
      ou = ke.set,
      ru = ke.getterFor,
      su = function su(t, e, i) {
    var n,
        o = -1 !== t.indexOf("Map"),
        r = -1 !== t.indexOf("Weak"),
        s = o ? "set" : "add",
        u = a[t],
        c = u && u.prototype,
        d = {};

    if (h && "function" == typeof u && (r || c.forEach && !l(function () {
      new u().entries().next();
    }))) {
      n = e(function (e, i) {
        ou(eu(e, n, t), {
          type: t,
          collection: new u()
        }), null != i && tu(i, e[s], {
          that: e,
          AS_ENTRIES: o
        });
      });
      var p = ru(t);
      nu(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function (t) {
        var e = "add" == t || "set" == t;
        !(t in c) || r && "clear" == t || W(n.prototype, t, function (i, n) {
          var o = p(this).collection;
          if (!e && r && !_(i)) return "get" == t && void 0;
          var s = o[t](0 === i ? 0 : i, n);
          return e ? this : s;
        });
      }), r || iu(n.prototype, "size", {
        configurable: !0,
        get: function get() {
          return p(this).collection.size;
        }
      });
    } else n = i.getConstructor(e, t, o, s), Jh.REQUIRED = !0;

    return le(n, t, !1, !0), d[t] = n, U({
      global: !0,
      forced: !0
    }, d), r || i.setStrong(n, t, o), n;
  },
      au = function au(t, e, i) {
    for (var n in e) {
      i && i.unsafe && t[n] ? t[n] = e[n] : Ut(t, n, e[n], i);
    }

    return t;
  },
      lu = $t("species"),
      hu = G.f,
      uu = Jh.fastKey,
      cu = ke.set,
      du = ke.getterFor,
      pu = {
    getConstructor: function getConstructor(t, e, i, n) {
      var o = t(function (t, r) {
        eu(t, o, e), cu(t, {
          type: e,
          index: zt(null),
          first: void 0,
          last: void 0,
          size: 0
        }), h || (t.size = 0), null != r && tu(r, t[n], {
          that: t,
          AS_ENTRIES: i
        });
      }),
          r = du(e),
          s = function s(t, e, i) {
        var n,
            o,
            s = r(t),
            l = a(t, e);
        return l ? l.value = i : (s.last = l = {
          index: o = uu(e, !0),
          key: e,
          value: i,
          previous: n = s.last,
          next: void 0,
          removed: !1
        }, s.first || (s.first = l), n && (n.next = l), h ? s.size++ : t.size++, "F" !== o && (s.index[o] = l)), t;
      },
          a = function a(t, e) {
        var i,
            n = r(t),
            o = uu(e);
        if ("F" !== o) return n.index[o];

        for (i = n.first; i; i = i.next) {
          if (i.key == e) return i;
        }
      };

      return au(o.prototype, {
        clear: function clear() {
          for (var t = r(this), e = t.index, i = t.first; i;) {
            i.removed = !0, i.previous && (i.previous = i.previous.next = void 0), delete e[i.index], i = i.next;
          }

          t.first = t.last = void 0, h ? t.size = 0 : this.size = 0;
        },
        delete: function _delete(t) {
          var e = this,
              i = r(e),
              n = a(e, t);

          if (n) {
            var o = n.next,
                s = n.previous;
            delete i.index[n.index], n.removed = !0, s && (s.next = o), o && (o.previous = s), i.first == n && (i.first = o), i.last == n && (i.last = s), h ? i.size-- : e.size--;
          }

          return !!n;
        },
        forEach: function forEach(t) {
          for (var e, i = r(this), n = j(t, arguments.length > 1 ? arguments[1] : void 0, 3); e = e ? e.next : i.first;) {
            for (n(e.value, e.key, this); e && e.removed;) {
              e = e.previous;
            }
          }
        },
        has: function has(t) {
          return !!a(this, t);
        }
      }), au(o.prototype, i ? {
        get: function get(t) {
          var e = a(this, t);
          return e && e.value;
        },
        set: function set(t, e) {
          return s(this, 0 === t ? 0 : t, e);
        }
      } : {
        add: function add(t) {
          return s(this, t = 0 === t ? 0 : t, t);
        }
      }), h && hu(o.prototype, "size", {
        get: function get() {
          return r(this).size;
        }
      }), o;
    },
    setStrong: function setStrong(t, e, i) {
      var n = e + " Iterator",
          o = du(e),
          r = du(n);
      Si(t, e, function (t, e) {
        cu(this, {
          type: n,
          target: t,
          state: o(t),
          kind: e,
          last: void 0
        });
      }, function () {
        for (var t = r(this), e = t.kind, i = t.last; i && i.removed;) {
          i = i.previous;
        }

        return t.target && (t.last = i = i ? i.next : t.state.first) ? "keys" == e ? {
          value: i.key,
          done: !1
        } : "values" == e ? {
          value: i.value,
          done: !1
        } : {
          value: [i.key, i.value],
          done: !1
        } : (t.target = void 0, {
          value: void 0,
          done: !0
        });
      }, i ? "entries" : "values", !i, !0), function (t) {
        var e = pt(t),
            i = G.f;
        h && e && !e[lu] && i(e, lu, {
          configurable: !0,
          get: function get() {
            return this;
          }
        });
      }(e);
    }
  },
      fu = (su("Set", function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0);
    };
  }, pu), F.Set),
      mu = (su("Map", function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0);
    };
  }, pu), F.Map),
      vu = n(function (t) {
    var e = function (t) {
      var e,
          i = Object.prototype,
          n = i.hasOwnProperty,
          o = "function" == typeof Symbol ? Symbol : {},
          r = o.iterator || "@@iterator",
          s = o.asyncIterator || "@@asyncIterator",
          a = o.toStringTag || "@@toStringTag";

      function l(t, e, i) {
        return Object.defineProperty(t, e, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }

      try {
        l({}, "");
      } catch (t) {
        l = function l(t, e, i) {
          return t[e] = i;
        };
      }

      function h(t, e, i, n) {
        var o = e && e.prototype instanceof v ? e : v,
            r = Object.create(o.prototype),
            s = new M(n || []);
        return r._invoke = function (t, e, i) {
          var n = c;
          return function (o, r) {
            if (n === p) throw new Error("Generator is already running");

            if (n === f) {
              if ("throw" === o) throw r;
              return E();
            }

            for (i.method = o, i.arg = r;;) {
              var s = i.delegate;

              if (s) {
                var a = S(s, i);

                if (a) {
                  if (a === m) continue;
                  return a;
                }
              }

              if ("next" === i.method) i.sent = i._sent = i.arg;else if ("throw" === i.method) {
                if (n === c) throw n = f, i.arg;
                i.dispatchException(i.arg);
              } else "return" === i.method && i.abrupt("return", i.arg);
              n = p;
              var l = u(t, e, i);

              if ("normal" === l.type) {
                if (n = i.done ? f : d, l.arg === m) continue;
                return {
                  value: l.arg,
                  done: i.done
                };
              }

              "throw" === l.type && (n = f, i.method = "throw", i.arg = l.arg);
            }
          };
        }(t, i, s), r;
      }

      function u(t, e, i) {
        try {
          return {
            type: "normal",
            arg: t.call(e, i)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = h;
      var c = "suspendedStart",
          d = "suspendedYield",
          p = "executing",
          f = "completed",
          m = {};

      function v() {}

      function g() {}

      function y() {}

      var b = {};

      b[r] = function () {
        return this;
      };

      var _ = Object.getPrototypeOf,
          w = _ && _(_(O([])));

      w && w !== i && n.call(w, r) && (b = w);
      var k = y.prototype = v.prototype = Object.create(b);

      function x(t) {
        ["next", "throw", "return"].forEach(function (e) {
          l(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }

      function D(t, e) {
        var i;

        this._invoke = function (o, r) {
          function s() {
            return new e(function (i, s) {
              !function i(o, r, s, a) {
                var l = u(t[o], t, r);

                if ("throw" !== l.type) {
                  var h = l.arg,
                      c = h.value;
                  return c && "object" == typeof c && n.call(c, "__await") ? e.resolve(c.__await).then(function (t) {
                    i("next", t, s, a);
                  }, function (t) {
                    i("throw", t, s, a);
                  }) : e.resolve(c).then(function (t) {
                    h.value = t, s(h);
                  }, function (t) {
                    return i("throw", t, s, a);
                  });
                }

                a(l.arg);
              }(o, r, i, s);
            });
          }

          return i = i ? i.then(s, s) : s();
        };
      }

      function S(t, i) {
        var n = t.iterator[i.method];

        if (n === e) {
          if (i.delegate = null, "throw" === i.method) {
            if (t.iterator.return && (i.method = "return", i.arg = e, S(t, i), "throw" === i.method)) return m;
            i.method = "throw", i.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return m;
        }

        var o = u(n, t.iterator, i.arg);
        if ("throw" === o.type) return i.method = "throw", i.arg = o.arg, i.delegate = null, m;
        var r = o.arg;
        return r ? r.done ? (i[t.resultName] = r.value, i.next = t.nextLoc, "return" !== i.method && (i.method = "next", i.arg = e), i.delegate = null, m) : r : (i.method = "throw", i.arg = new TypeError("iterator result is not an object"), i.delegate = null, m);
      }

      function C(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function T(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function M(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(C, this), this.reset(!0);
      }

      function O(t) {
        if (t) {
          var i = t[r];
          if (i) return i.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                s = function i() {
              for (; ++o < t.length;) {
                if (n.call(t, o)) return i.value = t[o], i.done = !1, i;
              }

              return i.value = e, i.done = !0, i;
            };

            return s.next = s;
          }
        }

        return {
          next: E
        };
      }

      function E() {
        return {
          value: e,
          done: !0
        };
      }

      return g.prototype = k.constructor = y, y.constructor = g, g.displayName = l(y, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === g || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, l(t, a, "GeneratorFunction")), t.prototype = Object.create(k), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, x(D.prototype), D.prototype[s] = function () {
        return this;
      }, t.AsyncIterator = D, t.async = function (e, i, n, o, r) {
        void 0 === r && (r = Promise);
        var s = new D(h(e, i, n, o), r);
        return t.isGeneratorFunction(i) ? s : s.next().then(function (t) {
          return t.done ? t.value : s.next();
        });
      }, x(k), l(k, a, "Generator"), k[r] = function () {
        return this;
      }, k.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var e = [];

        for (var i in t) {
          e.push(i);
        }

        return e.reverse(), function i() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return i.value = n, i.done = !1, i;
          }

          return i.done = !0, i;
        };
      }, t.values = O, M.prototype = {
        constructor: M,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(T), !t) for (var i in this) {
            "t" === i.charAt(0) && n.call(this, i) && !isNaN(+i.slice(1)) && (this[i] = e);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var i = this;

          function o(n, o) {
            return a.type = "throw", a.arg = t, i.next = n, o && (i.method = "next", i.arg = e), !!o;
          }

          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var s = this.tryEntries[r],
                a = s.completion;
            if ("root" === s.tryLoc) return o("end");

            if (s.tryLoc <= this.prev) {
              var l = n.call(s, "catchLoc"),
                  h = n.call(s, "finallyLoc");

              if (l && h) {
                if (this.prev < s.catchLoc) return o(s.catchLoc, !0);
                if (this.prev < s.finallyLoc) return o(s.finallyLoc);
              } else if (l) {
                if (this.prev < s.catchLoc) return o(s.catchLoc, !0);
              } else {
                if (!h) throw new Error("try statement without catch or finally");
                if (this.prev < s.finallyLoc) return o(s.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var o = this.tryEntries[i];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var r = o;
              break;
            }
          }

          r && ("break" === t || "continue" === t) && r.tryLoc <= e && e <= r.finallyLoc && (r = null);
          var s = r ? r.completion : {};
          return s.type = t, s.arg = e, r ? (this.method = "next", this.next = r.finallyLoc, m) : this.complete(s);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), m;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var i = this.tryEntries[e];
            if (i.finallyLoc === t) return this.complete(i.completion, i.afterLoc), T(i), m;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var i = this.tryEntries[e];

            if (i.tryLoc === t) {
              var n = i.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                T(i);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, i, n) {
          return this.delegate = {
            iterator: O(t),
            resultName: i,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = e;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(e);
    }
  }),
      gu = Qr,
      yu = function yu(t, e, i, n, o, r, s, a) {
    for (var l, h = o, u = 0, c = !!s && j(s, a, 3); u < n;) {
      if (u in i) {
        if (l = c ? c(i[u], u, e) : i[u], r > 0 && Ct(l)) h = yu(t, e, l, Q(l.length), h, r - 1) - 1;else {
          if (h >= 9007199254740991) throw TypeError("Exceed the acceptable array length");
          t[h] = l;
        }
        h++;
      }

      u++;
    }

    return h;
  },
      bu = yu;

  U({
    target: "Array",
    proto: !0
  }, {
    flatMap: function flatMap(t) {
      var e,
          i = Tt(this),
          n = Q(i.length);
      return Y(t), (e = De(i, 0)).length = bu(e, i, i, n, 0, 1, t, arguments.length > 1 ? arguments[1] : void 0), e;
    }
  });

  var _u = tn("Array").flatMap,
      wu = Array.prototype,
      ku = function ku(t) {
    var e = t.flatMap;
    return t === wu || t instanceof Array && e === wu.flatMap ? _u : e;
  },
      xu = function xu(t) {
    return function (e, i, n, o) {
      Y(i);
      var r = Tt(e),
          s = g(r),
          a = Q(r.length),
          l = t ? a - 1 : 0,
          h = t ? -1 : 1;
      if (n < 2) for (;;) {
        if (l in s) {
          o = s[l], l += h;
          break;
        }

        if (l += h, t ? l < 0 : a <= l) throw TypeError("Reduce of empty array with no initial value");
      }

      for (; t ? l >= 0 : a > l; l += h) {
        l in s && (o = i(o, s[l], l, r));
      }

      return o;
    };
  },
      Du = {
    left: xu(!1),
    right: xu(!0)
  },
      Su = "process" == m(a.process),
      Cu = Du.left,
      Tu = Rn("reduce"),
      Mu = Hn("reduce", {
    1: 0
  });

  U({
    target: "Array",
    proto: !0,
    forced: !Tu || !Mu || !Su && ho > 79 && ho < 83
  }, {
    reduce: function reduce(t) {
      return Cu(this, t, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var Ou = tn("Array").reduce,
      Eu = Array.prototype,
      Pu = function Pu(t) {
    var e = t.reduce;
    return t === Eu || t instanceof Array && e === Eu.reduce ? Ou : e;
  },
      Au = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto),
      Lu = new Uint8Array(16);

  function Iu() {
    if (!Au) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return Au(Lu);
  }

  for (var Nu = [], Ru = 0; Ru < 256; ++Ru) {
    Nu[Ru] = (Ru + 256).toString(16).substr(1);
  }

  function Fu(t, e, i) {
    var n = e && i || 0;
    "string" == typeof t && (e = "binary" === t ? new Array(16) : null, t = null);
    var o = (t = t || {}).random || (t.rng || Iu)();
    if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, e) for (var r = 0; r < 16; ++r) {
      e[n + r] = o[r];
    }
    return e || function (t, e) {
      var i = e || 0,
          n = Nu;
      return [n[t[i++]], n[t[i++]], n[t[i++]], n[t[i++]], "-", n[t[i++]], n[t[i++]], "-", n[t[i++]], n[t[i++]], "-", n[t[i++]], n[t[i++]], "-", n[t[i++]], n[t[i++]], n[t[i++]], n[t[i++]], n[t[i++]], n[t[i++]]].join("");
    }(o);
  }

  function Yu(t, e) {
    var i = Vr(t);

    if (ai) {
      var n = ai(t);
      e && (n = yo(n).call(n, function (e) {
        return xt(t, e).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function ju(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i,
          n = null != arguments[e] ? arguments[e] : {};
      if (e % 2) nr(i = Yu(Object(n), !0)).call(i, function (e) {
        Sn(t, e, n[e]);
      });else if (bt) ct(t, bt(n));else {
        var o;
        nr(o = Yu(Object(n))).call(o, function (e) {
          q(t, e, xt(n, e));
        });
      }
    }

    return t;
  }

  function Hu(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  function zu(t, e) {
    var i;

    if (void 0 === cs || null == zi(t)) {
      if (Jr(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return Gu(t, e);
        var n = ns(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Qi(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Gu(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);

        var _n3 = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n3 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n3++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var r,
        s = !0,
        a = !1;
    return {
      s: function s() {
        i = Hi(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i.return || i.return();
        } finally {
          if (a) throw r;
        }
      }
    };
  }

  function Gu(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, n = new Array(e); i < e; i++) {
      n[i] = t[i];
    }

    return n;
  }

  function Wu(t) {
    return new Vu(t);
  }

  var Bu = function () {
    function t(e, i, n) {
      var o, r, s;
      gn(this, t), this._source = e, this._transformers = i, this._target = n, this._listeners = {
        add: ur(o = this._add).call(o, this),
        remove: ur(r = this._remove).call(r, this),
        update: ur(s = this._update).call(s, this)
      };
    }

    return _n(t, [{
      key: "all",
      value: function value() {
        return this._target.update(this._transformItems(this._source.get())), this;
      }
    }, {
      key: "start",
      value: function value() {
        return this._source.on("add", this._listeners.add), this._source.on("remove", this._listeners.remove), this._source.on("update", this._listeners.update), this;
      }
    }, {
      key: "stop",
      value: function value() {
        return this._source.off("add", this._listeners.add), this._source.off("remove", this._listeners.remove), this._source.off("update", this._listeners.update), this;
      }
    }, {
      key: "_transformItems",
      value: function value(t) {
        var e;
        return Pu(e = this._transformers).call(e, function (t, e) {
          return e(t);
        }, t);
      }
    }, {
      key: "_add",
      value: function value(t, e) {
        null != e && this._target.add(this._transformItems(this._source.get(e.items)));
      }
    }, {
      key: "_update",
      value: function value(t, e) {
        null != e && this._target.update(this._transformItems(this._source.get(e.items)));
      }
    }, {
      key: "_remove",
      value: function value(t, e) {
        null != e && this._target.remove(this._transformItems(e.oldData));
      }
    }]), t;
  }(),
      Vu = function () {
    function t(e) {
      gn(this, t), this._source = e, this._transformers = [];
    }

    return _n(t, [{
      key: "filter",
      value: function value(t) {
        return this._transformers.push(function (e) {
          return yo(e).call(e, t);
        }), this;
      }
    }, {
      key: "map",
      value: function value(t) {
        return this._transformers.push(function (e) {
          return Kr(e).call(e, t);
        }), this;
      }
    }, {
      key: "flatMap",
      value: function value(t) {
        return this._transformers.push(function (e) {
          return ku(e).call(e, t);
        }), this;
      }
    }, {
      key: "to",
      value: function value(t) {
        return new Bu(this._source, this._transformers, t);
      }
    }]), t;
  }();

  function Uu(t) {
    return "string" == typeof t || "number" == typeof t;
  }

  var Xu = function () {
    function t(e) {
      gn(this, t), this._queue = [], this._timeout = null, this._extended = null, this.delay = null, this.max = 1 / 0, this.setOptions(e);
    }

    return _n(t, [{
      key: "setOptions",
      value: function value(t) {
        t && void 0 !== t.delay && (this.delay = t.delay), t && void 0 !== t.max && (this.max = t.max), this._flushIfNeeded();
      }
    }, {
      key: "destroy",
      value: function value() {
        if (this.flush(), this._extended) {
          for (var t = this._extended.object, e = this._extended.methods, i = 0; i < e.length; i++) {
            var n = e[i];
            n.original ? t[n.name] = n.original : delete t[n.name];
          }

          this._extended = null;
        }
      }
    }, {
      key: "replace",
      value: function value(t, e) {
        var i = this,
            n = t[e];
        if (!n) throw new Error("Method " + e + " undefined");

        t[e] = function () {
          for (var t = arguments.length, e = new Array(t), o = 0; o < t; o++) {
            e[o] = arguments[o];
          }

          i.queue({
            args: e,
            fn: n,
            context: this
          });
        };
      }
    }, {
      key: "queue",
      value: function value(t) {
        "function" == typeof t ? this._queue.push({
          fn: t
        }) : this._queue.push(t), this._flushIfNeeded();
      }
    }, {
      key: "_flushIfNeeded",
      value: function value() {
        var t = this;
        this._queue.length > this.max && this.flush(), null != this._timeout && (clearTimeout(this._timeout), this._timeout = null), this.queue.length > 0 && "number" == typeof this.delay && (this._timeout = hn(function () {
          t.flush();
        }, this.delay));
      }
    }, {
      key: "flush",
      value: function value() {
        var t, e;
        nr(t = Bo(e = this._queue).call(e, 0)).call(t, function (t) {
          t.fn.apply(t.context || t.fn, t.args || []);
        });
      }
    }], [{
      key: "extend",
      value: function value(e, i) {
        var n = new t(i);
        if (void 0 !== e.flush) throw new Error("Target object already has a property flush");

        e.flush = function () {
          n.flush();
        };

        var o = [{
          name: "flush",
          original: void 0
        }];
        if (i && i.replace) for (var r = 0; r < i.replace.length; r++) {
          var s = i.replace[r];
          o.push({
            name: s,
            original: e[s]
          }), n.replace(e, s);
        }
        return n._extended = {
          object: e,
          methods: o
        }, n;
      }
    }]), t;
  }(),
      qu = function () {
    function t() {
      gn(this, t), this._subscribers = {
        "*": [],
        add: [],
        remove: [],
        update: []
      }, this.subscribe = t.prototype.on, this.unsubscribe = t.prototype.off;
    }

    return _n(t, [{
      key: "_trigger",
      value: function value(t, e, i) {
        var n, o;
        if ("*" === t) throw new Error("Cannot trigger event *");
        nr(n = us(o = []).call(o, as(this._subscribers[t]), as(this._subscribers["*"]))).call(n, function (n) {
          n(t, e, null != i ? i : null);
        });
      }
    }, {
      key: "on",
      value: function value(t, e) {
        "function" == typeof e && this._subscribers[t].push(e);
      }
    }, {
      key: "off",
      value: function value(t, e) {
        var i;
        this._subscribers[t] = yo(i = this._subscribers[t]).call(i, function (t) {
          return t !== e;
        });
      }
    }]), t;
  }(),
      Zu = function () {
    function t(e) {
      gn(this, t), this._pairs = e;
    }

    return _n(t, [{
      key: gu,
      value: vu.mark(function t() {
        var e, i, n, o, r;
        return vu.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e = zu(this._pairs), t.prev = 1, e.s();

              case 3:
                if ((i = e.n()).done) {
                  t.next = 9;
                  break;
                }

                return n = Gr(i.value, 2), o = n[0], r = n[1], t.next = 7, [o, r];

              case 7:
                t.next = 3;
                break;

              case 9:
                t.next = 14;
                break;

              case 11:
                t.prev = 11, t.t0 = t.catch(1), e.e(t.t0);

              case 14:
                return t.prev = 14, e.f(), t.finish(14);

              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "entries",
      value: vu.mark(function t() {
        var e, i, n, o, r;
        return vu.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e = zu(this._pairs), t.prev = 1, e.s();

              case 3:
                if ((i = e.n()).done) {
                  t.next = 9;
                  break;
                }

                return n = Gr(i.value, 2), o = n[0], r = n[1], t.next = 7, [o, r];

              case 7:
                t.next = 3;
                break;

              case 9:
                t.next = 14;
                break;

              case 11:
                t.prev = 11, t.t0 = t.catch(1), e.e(t.t0);

              case 14:
                return t.prev = 14, e.f(), t.finish(14);

              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "keys",
      value: vu.mark(function t() {
        var e, i, n, o;
        return vu.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e = zu(this._pairs), t.prev = 1, e.s();

              case 3:
                if ((i = e.n()).done) {
                  t.next = 9;
                  break;
                }

                return n = Gr(i.value, 1), o = n[0], t.next = 7, o;

              case 7:
                t.next = 3;
                break;

              case 9:
                t.next = 14;
                break;

              case 11:
                t.prev = 11, t.t0 = t.catch(1), e.e(t.t0);

              case 14:
                return t.prev = 14, e.f(), t.finish(14);

              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "values",
      value: vu.mark(function t() {
        var e, i, n, o;
        return vu.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e = zu(this._pairs), t.prev = 1, e.s();

              case 3:
                if ((i = e.n()).done) {
                  t.next = 9;
                  break;
                }

                return n = Gr(i.value, 2), o = n[1], t.next = 7, o;

              case 7:
                t.next = 3;
                break;

              case 9:
                t.next = 14;
                break;

              case 11:
                t.prev = 11, t.t0 = t.catch(1), e.e(t.t0);

              case 14:
                return t.prev = 14, e.f(), t.finish(14);

              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "toIdArray",
      value: function value() {
        var t;
        return Kr(t = as(this._pairs)).call(t, function (t) {
          return t[0];
        });
      }
    }, {
      key: "toItemArray",
      value: function value() {
        var t;
        return Kr(t = as(this._pairs)).call(t, function (t) {
          return t[1];
        });
      }
    }, {
      key: "toEntryArray",
      value: function value() {
        return as(this._pairs);
      }
    }, {
      key: "toObjectMap",
      value: function value() {
        var t,
            e = xn(null),
            i = zu(this._pairs);

        try {
          for (i.s(); !(t = i.n()).done;) {
            var n = Gr(t.value, 2),
                o = n[0],
                r = n[1];
            e[o] = r;
          }
        } catch (t) {
          i.e(t);
        } finally {
          i.f();
        }

        return e;
      }
    }, {
      key: "toMap",
      value: function value() {
        return new mu(this._pairs);
      }
    }, {
      key: "toIdSet",
      value: function value() {
        return new fu(this.toIdArray());
      }
    }, {
      key: "toItemSet",
      value: function value() {
        return new fu(this.toItemArray());
      }
    }, {
      key: "cache",
      value: function value() {
        return new t(as(this._pairs));
      }
    }, {
      key: "distinct",
      value: function value(t) {
        var e,
            i = new fu(),
            n = zu(this._pairs);

        try {
          for (n.s(); !(e = n.n()).done;) {
            var o = Gr(e.value, 2),
                r = o[0],
                s = o[1];
            i.add(t(s, r));
          }
        } catch (t) {
          n.e(t);
        } finally {
          n.f();
        }

        return i;
      }
    }, {
      key: "filter",
      value: function value(e) {
        var i = this._pairs;
        return new t(Sn({}, gu, vu.mark(function t() {
          var n, o, r, s, a;
          return vu.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  n = zu(i), t.prev = 1, n.s();

                case 3:
                  if ((o = n.n()).done) {
                    t.next = 10;
                    break;
                  }

                  if (r = Gr(o.value, 2), s = r[0], a = r[1], !e(a, s)) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 8, [s, a];

                case 8:
                  t.next = 3;
                  break;

                case 10:
                  t.next = 15;
                  break;

                case 12:
                  t.prev = 12, t.t0 = t.catch(1), n.e(t.t0);

                case 15:
                  return t.prev = 15, n.f(), t.finish(15);

                case 18:
                case "end":
                  return t.stop();
              }
            }
          }, t, null, [[1, 12, 15, 18]]);
        })));
      }
    }, {
      key: "forEach",
      value: function value(t) {
        var e,
            i = zu(this._pairs);

        try {
          for (i.s(); !(e = i.n()).done;) {
            var n = Gr(e.value, 2),
                o = n[0];
            t(n[1], o);
          }
        } catch (t) {
          i.e(t);
        } finally {
          i.f();
        }
      }
    }, {
      key: "map",
      value: function value(e) {
        var i = this._pairs;
        return new t(Sn({}, gu, vu.mark(function t() {
          var n, o, r, s, a;
          return vu.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  n = zu(i), t.prev = 1, n.s();

                case 3:
                  if ((o = n.n()).done) {
                    t.next = 9;
                    break;
                  }

                  return r = Gr(o.value, 2), s = r[0], a = r[1], t.next = 7, [s, e(a, s)];

                case 7:
                  t.next = 3;
                  break;

                case 9:
                  t.next = 14;
                  break;

                case 11:
                  t.prev = 11, t.t0 = t.catch(1), n.e(t.t0);

                case 14:
                  return t.prev = 14, n.f(), t.finish(14);

                case 17:
                case "end":
                  return t.stop();
              }
            }
          }, t, null, [[1, 11, 14, 17]]);
        })));
      }
    }, {
      key: "max",
      value: function value(t) {
        var e = Hi(this._pairs),
            i = e.next();
        if (i.done) return null;

        for (var n = i.value[1], o = t(i.value[1], i.value[0]); !(i = e.next()).done;) {
          var r = Gr(i.value, 2),
              s = r[0],
              a = r[1],
              l = t(a, s);
          l > o && (o = l, n = a);
        }

        return n;
      }
    }, {
      key: "min",
      value: function value(t) {
        var e = Hi(this._pairs),
            i = e.next();
        if (i.done) return null;

        for (var n = i.value[1], o = t(i.value[1], i.value[0]); !(i = e.next()).done;) {
          var r = Gr(i.value, 2),
              s = r[0],
              a = r[1],
              l = t(a, s);
          l < o && (o = l, n = a);
        }

        return n;
      }
    }, {
      key: "reduce",
      value: function value(t, e) {
        var i,
            n = zu(this._pairs);

        try {
          for (n.s(); !(i = n.n()).done;) {
            var o = Gr(i.value, 2),
                r = o[0];
            e = t(e, o[1], r);
          }
        } catch (t) {
          n.e(t);
        } finally {
          n.f();
        }

        return e;
      }
    }, {
      key: "sort",
      value: function value(e) {
        var i = this;
        return new t(Sn({}, gu, function () {
          var t;
          return Hi($h(t = as(i._pairs)).call(t, function (t, i) {
            var n = Gr(t, 2),
                o = n[0],
                r = n[1],
                s = Gr(i, 2),
                a = s[0],
                l = s[1];
            return e(r, l, o, a);
          }));
        }));
      }
    }]), t;
  }();

  var $u = function (t) {
    jh(i, t);
    var e = Hu(i);

    function i(t, n) {
      var o;
      return gn(this, i), (o = e.call(this))._queue = null, t && !Jr(t) && (n = t, t = []), o._options = n || {}, o._data = new mu(), o.length = 0, o._idProp = o._options.fieldId || "id", t && t.length && o.add(t), o.setOptions(n), o;
    }

    return _n(i, [{
      key: "setOptions",
      value: function value(t) {
        t && void 0 !== t.queue && (!1 === t.queue ? this._queue && (this._queue.destroy(), this._queue = null) : (this._queue || (this._queue = Xu.extend(this, {
          replace: ["add", "update", "remove"]
        })), t.queue && "object" === es(t.queue) && this._queue.setOptions(t.queue)));
      }
    }, {
      key: "add",
      value: function value(t, e) {
        var i,
            n = this,
            o = [];

        if (Jr(t)) {
          var r = Kr(t).call(t, function (t) {
            return t[n._idProp];
          });
          if (Nh(r).call(r, function (t) {
            return n._data.has(t);
          })) throw new Error("A duplicate id was found in the parameter array.");

          for (var s = 0, a = t.length; s < a; s++) {
            i = this._addItem(t[s]), o.push(i);
          }
        } else {
          if (!t || "object" !== es(t)) throw new Error("Unknown dataType");
          i = this._addItem(t), o.push(i);
        }

        return o.length && this._trigger("add", {
          items: o
        }, e), o;
      }
    }, {
      key: "update",
      value: function value(t, e) {
        var i = this,
            n = [],
            o = [],
            r = [],
            s = [],
            a = this._idProp,
            l = function l(t) {
          var e = t[a];

          if (null != e && i._data.has(e)) {
            var l = t,
                h = No({}, i._data.get(e)),
                u = i._updateItem(l);

            o.push(u), s.push(l), r.push(h);
          } else {
            var c = i._addItem(t);

            n.push(c);
          }
        };

        if (Jr(t)) for (var h = 0, u = t.length; h < u; h++) {
          t[h] && "object" === es(t[h]) ? l(t[h]) : console.warn("Ignoring input item, which is not an object at index " + h);
        } else {
          if (!t || "object" !== es(t)) throw new Error("Unknown dataType");
          l(t);
        }

        if (n.length && this._trigger("add", {
          items: n
        }, e), o.length) {
          var c = {
            items: o,
            oldData: r,
            data: s
          };

          this._trigger("update", c, e);
        }

        return us(n).call(n, o);
      }
    }, {
      key: "updateOnly",
      value: function value(t, e) {
        var i,
            n = this;
        Jr(t) || (t = [t]);
        var o = Kr(i = Kr(t).call(t, function (t) {
          var e = n._data.get(t[n._idProp]);

          if (null == e) throw new Error("Updating non-existent items is not allowed.");
          return {
            oldData: e,
            update: t
          };
        })).call(i, function (t) {
          var e = t.oldData,
              i = t.update,
              o = e[n._idProp],
              r = sl(e, i);
          return n._data.set(o, r), {
            id: o,
            oldData: e,
            updatedData: r
          };
        });

        if (o.length) {
          var r = {
            items: Kr(o).call(o, function (t) {
              return t.id;
            }),
            oldData: Kr(o).call(o, function (t) {
              return t.oldData;
            }),
            data: Kr(o).call(o, function (t) {
              return t.updatedData;
            })
          };
          return this._trigger("update", r, e), r.items;
        }

        return [];
      }
    }, {
      key: "get",
      value: function value(t, e) {
        var i = void 0,
            n = void 0,
            o = void 0;
        Uu(t) ? (i = t, o = e) : Jr(t) ? (n = t, o = e) : o = t;
        var r,
            s = o && "Object" === o.returnType ? "Object" : "Array",
            a = o && yo(o),
            l = [],
            h = void 0,
            u = void 0,
            c = void 0;
        if (null != i) (h = this._data.get(i)) && a && !a(h) && (h = void 0);else if (null != n) for (var d = 0, p = n.length; d < p; d++) {
          null == (h = this._data.get(n[d])) || a && !a(h) || l.push(h);
        } else for (var f, m = 0, v = (u = as(Oh(f = this._data).call(f))).length; m < v; m++) {
          c = u[m], null == (h = this._data.get(c)) || a && !a(h) || l.push(h);
        }

        if (o && o.order && null == i && this._sort(l, o.order), o && o.fields) {
          var g = o.fields;
          if (null != i && null != h) h = this._filterFields(h, g);else for (var y = 0, b = l.length; y < b; y++) {
            l[y] = this._filterFields(l[y], g);
          }
        }

        if ("Object" == s) {
          for (var _ = {}, w = 0, k = l.length; w < k; w++) {
            var x = l[w];
            _[x[this._idProp]] = x;
          }

          return _;
        }

        return null != i ? null !== (r = h) && void 0 !== r ? r : null : l;
      }
    }, {
      key: "getIds",
      value: function value(t) {
        var e = this._data,
            i = t && yo(t),
            n = t && t.order,
            o = as(Oh(e).call(e)),
            r = [];
        if (i) {
          if (n) {
            for (var s = [], a = 0, l = o.length; a < l; a++) {
              var h = o[a],
                  u = this._data.get(h);

              null != u && i(u) && s.push(u);
            }

            this._sort(s, n);

            for (var c = 0, d = s.length; c < d; c++) {
              r.push(s[c][this._idProp]);
            }
          } else for (var p = 0, f = o.length; p < f; p++) {
            var m = o[p],
                v = this._data.get(m);

            null != v && i(v) && r.push(v[this._idProp]);
          }
        } else if (n) {
          for (var g = [], y = 0, b = o.length; y < b; y++) {
            var _ = o[y];
            g.push(e.get(_));
          }

          this._sort(g, n);

          for (var w = 0, k = g.length; w < k; w++) {
            r.push(g[w][this._idProp]);
          }
        } else for (var x = 0, D = o.length; x < D; x++) {
          var S = o[x],
              C = e.get(S);
          null != C && r.push(C[this._idProp]);
        }
        return r;
      }
    }, {
      key: "getDataSet",
      value: function value() {
        return this;
      }
    }, {
      key: "forEach",
      value: function value(t, e) {
        var i = e && yo(e),
            n = this._data,
            o = as(Oh(n).call(n));
        if (e && e.order) for (var r = this.get(e), s = 0, a = r.length; s < a; s++) {
          var l = r[s];
          t(l, l[this._idProp]);
        } else for (var h = 0, u = o.length; h < u; h++) {
          var c = o[h],
              d = this._data.get(c);

          null == d || i && !i(d) || t(d, c);
        }
      }
    }, {
      key: "map",
      value: function value(t, e) {
        for (var i = e && yo(e), n = [], o = this._data, r = as(Oh(o).call(o)), s = 0, a = r.length; s < a; s++) {
          var l = r[s],
              h = this._data.get(l);

          null == h || i && !i(h) || n.push(t(h, l));
        }

        return e && e.order && this._sort(n, e.order), n;
      }
    }, {
      key: "_filterFields",
      value: function value(t, e) {
        var i;
        return t ? Pu(i = Jr(e) ? e : Vr(e)).call(i, function (e, i) {
          return e[i] = t[i], e;
        }, {}) : t;
      }
    }, {
      key: "_sort",
      value: function value(t, e) {
        if ("string" == typeof e) {
          var i = e;
          $h(t).call(t, function (t, e) {
            var n = t[i],
                o = e[i];
            return n > o ? 1 : n < o ? -1 : 0;
          });
        } else {
          if ("function" != typeof e) throw new TypeError("Order must be a function or a string");
          $h(t).call(t, e);
        }
      }
    }, {
      key: "remove",
      value: function value(t, e) {
        for (var i = [], n = [], o = Jr(t) ? t : [t], r = 0, s = o.length; r < s; r++) {
          var a = this._remove(o[r]);

          if (a) {
            var l = a[this._idProp];
            null != l && (i.push(l), n.push(a));
          }
        }

        return i.length && this._trigger("remove", {
          items: i,
          oldData: n
        }, e), i;
      }
    }, {
      key: "_remove",
      value: function value(t) {
        var e;

        if (Uu(t) ? e = t : t && "object" === es(t) && (e = t[this._idProp]), null != e && this._data.has(e)) {
          var i = this._data.get(e) || null;
          return this._data.delete(e), --this.length, i;
        }

        return null;
      }
    }, {
      key: "clear",
      value: function value(t) {
        for (var e, i = as(Oh(e = this._data).call(e)), n = [], o = 0, r = i.length; o < r; o++) {
          n.push(this._data.get(i[o]));
        }

        return this._data.clear(), this.length = 0, this._trigger("remove", {
          items: i,
          oldData: n
        }, t), i;
      }
    }, {
      key: "max",
      value: function value(t) {
        var e,
            i,
            n = null,
            o = null,
            r = zu(Sh(e = this._data).call(e));

        try {
          for (r.s(); !(i = r.n()).done;) {
            var s = i.value,
                a = s[t];
            "number" == typeof a && (null == o || a > o) && (n = s, o = a);
          }
        } catch (t) {
          r.e(t);
        } finally {
          r.f();
        }

        return n || null;
      }
    }, {
      key: "min",
      value: function value(t) {
        var e,
            i,
            n = null,
            o = null,
            r = zu(Sh(e = this._data).call(e));

        try {
          for (r.s(); !(i = r.n()).done;) {
            var s = i.value,
                a = s[t];
            "number" == typeof a && (null == o || a < o) && (n = s, o = a);
          }
        } catch (t) {
          r.e(t);
        } finally {
          r.f();
        }

        return n || null;
      }
    }, {
      key: "distinct",
      value: function value(t) {
        for (var e = this._data, i = as(Oh(e).call(e)), n = [], o = 0, r = 0, s = i.length; r < s; r++) {
          for (var a = i[r], l = e.get(a)[t], h = !1, u = 0; u < o; u++) {
            if (n[u] == l) {
              h = !0;
              break;
            }
          }

          h || void 0 === l || (n[o] = l, o++);
        }

        return n;
      }
    }, {
      key: "_addItem",
      value: function value(t) {
        var e = function (t, e) {
          return null == t[e] && (t[e] = Fu()), t;
        }(t, this._idProp),
            i = e[this._idProp];

        if (this._data.has(i)) throw new Error("Cannot add item: item with id " + i + " already exists");
        return this._data.set(i, e), ++this.length, i;
      }
    }, {
      key: "_updateItem",
      value: function value(t) {
        var e = t[this._idProp];
        if (null == e) throw new Error("Cannot update item: item has no id (item: " + vn(t) + ")");

        var i = this._data.get(e);

        if (!i) throw new Error("Cannot update item: no item with id " + e + " found");
        return this._data.set(e, ju(ju({}, i), t)), e;
      }
    }, {
      key: "stream",
      value: function value(t) {
        if (t) {
          var e = this._data;
          return new Zu(Sn({}, gu, vu.mark(function i() {
            var n, o, r, s;
            return vu.wrap(function (i) {
              for (;;) {
                switch (i.prev = i.next) {
                  case 0:
                    n = zu(t), i.prev = 1, n.s();

                  case 3:
                    if ((o = n.n()).done) {
                      i.next = 11;
                      break;
                    }

                    if (r = o.value, null == (s = e.get(r))) {
                      i.next = 9;
                      break;
                    }

                    return i.next = 9, [r, s];

                  case 9:
                    i.next = 3;
                    break;

                  case 11:
                    i.next = 16;
                    break;

                  case 13:
                    i.prev = 13, i.t0 = i.catch(1), n.e(i.t0);

                  case 16:
                    return i.prev = 16, n.f(), i.finish(16);

                  case 19:
                  case "end":
                    return i.stop();
                }
              }
            }, i, null, [[1, 13, 16, 19]]);
          })));
        }

        var i;
        return new Zu(Sn({}, gu, ur(i = wh(this._data)).call(i, this._data)));
      }
    }, {
      key: "idProp",
      get: function get() {
        return this._idProp;
      }
    }]), i;
  }(qu),
      Ku = function (t) {
    jh(i, t);
    var e = Hu(i);

    function i(t, n) {
      var o, r;
      return gn(this, i), (r = e.call(this)).length = 0, r._ids = new fu(), r._options = n || {}, r._listener = ur(o = r._onEvent).call(o, gh(r)), r.setData(t), r;
    }

    return _n(i, [{
      key: "setData",
      value: function value(t) {
        if (this._data) {
          this._data.off && this._data.off("*", this._listener);

          var e = this._data.getIds({
            filter: yo(this._options)
          }),
              i = this._data.get(e);

          this._ids.clear(), this.length = 0, this._trigger("remove", {
            items: e,
            oldData: i
          });
        }

        if (null != t) {
          this._data = t;

          for (var n = this._data.getIds({
            filter: yo(this._options)
          }), o = 0, r = n.length; o < r; o++) {
            var s = n[o];

            this._ids.add(s);
          }

          this.length = n.length, this._trigger("add", {
            items: n
          });
        } else this._data = new $u();

        this._data.on && this._data.on("*", this._listener);
      }
    }, {
      key: "refresh",
      value: function value() {
        for (var t = this._data.getIds({
          filter: yo(this._options)
        }), e = as(this._ids), i = {}, n = [], o = [], r = [], s = 0, a = t.length; s < a; s++) {
          var l = t[s];
          i[l] = !0, this._ids.has(l) || (n.push(l), this._ids.add(l));
        }

        for (var h = 0, u = e.length; h < u; h++) {
          var c = e[h],
              d = this._data.get(c);

          null == d ? console.error("If you see this, report it please.") : i[c] || (o.push(c), r.push(d), this._ids.delete(c));
        }

        this.length += n.length - o.length, n.length && this._trigger("add", {
          items: n
        }), o.length && this._trigger("remove", {
          items: o,
          oldData: r
        });
      }
    }, {
      key: "get",
      value: function value(t, e) {
        if (null == this._data) return null;
        var i,
            n = null;
        Uu(t) || Jr(t) ? (n = t, i = e) : i = t;
        var o = No({}, this._options, i),
            r = yo(this._options),
            s = i && yo(i);
        return r && s && (o.filter = function (t) {
          return r(t) && s(t);
        }), null == n ? this._data.get(o) : this._data.get(n, o);
      }
    }, {
      key: "getIds",
      value: function value(t) {
        if (this._data.length) {
          var e,
              i = yo(this._options),
              n = null != t ? yo(t) : null;
          return e = n ? i ? function (t) {
            return i(t) && n(t);
          } : n : i, this._data.getIds({
            filter: e,
            order: t && t.order
          });
        }

        return [];
      }
    }, {
      key: "forEach",
      value: function value(t, e) {
        if (this._data) {
          var i,
              n,
              o = yo(this._options),
              r = e && yo(e);
          n = r ? o ? function (t) {
            return o(t) && r(t);
          } : r : o, nr(i = this._data).call(i, t, {
            filter: n,
            order: e && e.order
          });
        }
      }
    }, {
      key: "map",
      value: function value(t, e) {
        if (this._data) {
          var i,
              n,
              o = yo(this._options),
              r = e && yo(e);
          return n = r ? o ? function (t) {
            return o(t) && r(t);
          } : r : o, Kr(i = this._data).call(i, t, {
            filter: n,
            order: e && e.order
          });
        }

        return [];
      }
    }, {
      key: "getDataSet",
      value: function value() {
        return this._data.getDataSet();
      }
    }, {
      key: "stream",
      value: function value(t) {
        var e;
        return this._data.stream(t || Sn({}, gu, ur(e = Oh(this._ids)).call(e, this._ids)));
      }
    }, {
      key: "dispose",
      value: function value() {
        var t;
        null !== (t = this._data) && void 0 !== t && t.off && this._data.off("*", this._listener);
        var e,
            n = "This data view has already been disposed of.",
            o = {
          get: function get() {
            throw new Error(n);
          },
          set: function set() {
            throw new Error(n);
          },
          configurable: !1
        },
            r = zu(is(i.prototype));

        try {
          for (r.s(); !(e = r.n()).done;) {
            var s = e.value;
            q(this, s, o);
          }
        } catch (t) {
          r.e(t);
        } finally {
          r.f();
        }
      }
    }, {
      key: "_onEvent",
      value: function value(t, e, i) {
        if (e && e.items && this._data) {
          var n = e.items,
              o = [],
              r = [],
              s = [],
              a = [],
              l = [],
              h = [];

          switch (t) {
            case "add":
              for (var u = 0, c = n.length; u < c; u++) {
                var d = n[u];
                this.get(d) && (this._ids.add(d), o.push(d));
              }

              break;

            case "update":
              for (var p = 0, f = n.length; p < f; p++) {
                var m = n[p];
                this.get(m) ? this._ids.has(m) ? (r.push(m), l.push(e.data[p]), a.push(e.oldData[p])) : (this._ids.add(m), o.push(m)) : this._ids.has(m) && (this._ids.delete(m), s.push(m), h.push(e.oldData[p]));
              }

              break;

            case "remove":
              for (var v = 0, g = n.length; v < g; v++) {
                var y = n[v];
                this._ids.has(y) && (this._ids.delete(y), s.push(y), h.push(e.oldData[v]));
              }

          }

          this.length += o.length - s.length, o.length && this._trigger("add", {
            items: o
          }, i), r.length && this._trigger("update", {
            items: r,
            oldData: a,
            data: l
          }, i), s.length && this._trigger("remove", {
            items: s,
            oldData: h
          }, i);
        }
      }
    }, {
      key: "idProp",
      get: function get() {
        return this.getDataSet().idProp;
      }
    }]), i;
  }(qu);

  function Ju(t, e) {
    return "object" === es(e) && null !== e && t === e.idProp && "function" == typeof nr(e) && "function" == typeof e.get && "function" == typeof e.getDataSet && "function" == typeof e.getIds && "number" == typeof e.length && "function" == typeof Kr(e) && "function" == typeof e.off && "function" == typeof e.on && "function" == typeof e.stream && function (t, e) {
      return "object" === es(e) && null !== e && t === e.idProp && "function" == typeof e.add && "function" == typeof e.clear && "function" == typeof e.distinct && "function" == typeof nr(e) && "function" == typeof e.get && "function" == typeof e.getDataSet && "function" == typeof e.getIds && "number" == typeof e.length && "function" == typeof Kr(e) && "function" == typeof e.max && "function" == typeof e.min && "function" == typeof e.off && "function" == typeof e.on && "function" == typeof e.remove && "function" == typeof e.setOptions && "function" == typeof e.stream && "function" == typeof e.update && "function" == typeof e.updateOnly;
    }(t, e.getDataSet());
  }

  var Qu = "undefined" != typeof window && window.moment || r;

  function tc() {
    var t = {
      "align-content": !1,
      "align-items": !1,
      "align-self": !1,
      "alignment-adjust": !1,
      "alignment-baseline": !1,
      all: !1,
      "anchor-point": !1,
      animation: !1,
      "animation-delay": !1,
      "animation-direction": !1,
      "animation-duration": !1,
      "animation-fill-mode": !1,
      "animation-iteration-count": !1,
      "animation-name": !1,
      "animation-play-state": !1,
      "animation-timing-function": !1,
      azimuth: !1,
      "backface-visibility": !1,
      background: !0,
      "background-attachment": !0,
      "background-clip": !0,
      "background-color": !0,
      "background-image": !0,
      "background-origin": !0,
      "background-position": !0,
      "background-repeat": !0,
      "background-size": !0,
      "baseline-shift": !1,
      binding: !1,
      bleed: !1,
      "bookmark-label": !1,
      "bookmark-level": !1,
      "bookmark-state": !1,
      border: !0,
      "border-bottom": !0,
      "border-bottom-color": !0,
      "border-bottom-left-radius": !0,
      "border-bottom-right-radius": !0,
      "border-bottom-style": !0,
      "border-bottom-width": !0,
      "border-collapse": !0,
      "border-color": !0,
      "border-image": !0,
      "border-image-outset": !0,
      "border-image-repeat": !0,
      "border-image-slice": !0,
      "border-image-source": !0,
      "border-image-width": !0,
      "border-left": !0,
      "border-left-color": !0,
      "border-left-style": !0,
      "border-left-width": !0,
      "border-radius": !0,
      "border-right": !0,
      "border-right-color": !0,
      "border-right-style": !0,
      "border-right-width": !0,
      "border-spacing": !0,
      "border-style": !0,
      "border-top": !0,
      "border-top-color": !0,
      "border-top-left-radius": !0,
      "border-top-right-radius": !0,
      "border-top-style": !0,
      "border-top-width": !0,
      "border-width": !0,
      bottom: !1,
      "box-decoration-break": !0,
      "box-shadow": !0,
      "box-sizing": !0,
      "box-snap": !0,
      "box-suppress": !0,
      "break-after": !0,
      "break-before": !0,
      "break-inside": !0,
      "caption-side": !1,
      chains: !1,
      clear: !0,
      clip: !1,
      "clip-path": !1,
      "clip-rule": !1,
      color: !0,
      "color-interpolation-filters": !0,
      "column-count": !1,
      "column-fill": !1,
      "column-gap": !1,
      "column-rule": !1,
      "column-rule-color": !1,
      "column-rule-style": !1,
      "column-rule-width": !1,
      "column-span": !1,
      "column-width": !1,
      columns: !1,
      contain: !1,
      content: !1,
      "counter-increment": !1,
      "counter-reset": !1,
      "counter-set": !1,
      crop: !1,
      cue: !1,
      "cue-after": !1,
      "cue-before": !1,
      cursor: !1,
      direction: !1,
      display: !0,
      "display-inside": !0,
      "display-list": !0,
      "display-outside": !0,
      "dominant-baseline": !1,
      elevation: !1,
      "empty-cells": !1,
      filter: !1,
      flex: !1,
      "flex-basis": !1,
      "flex-direction": !1,
      "flex-flow": !1,
      "flex-grow": !1,
      "flex-shrink": !1,
      "flex-wrap": !1,
      float: !1,
      "float-offset": !1,
      "flood-color": !1,
      "flood-opacity": !1,
      "flow-from": !1,
      "flow-into": !1,
      font: !0,
      "font-family": !0,
      "font-feature-settings": !0,
      "font-kerning": !0,
      "font-language-override": !0,
      "font-size": !0,
      "font-size-adjust": !0,
      "font-stretch": !0,
      "font-style": !0,
      "font-synthesis": !0,
      "font-variant": !0,
      "font-variant-alternates": !0,
      "font-variant-caps": !0,
      "font-variant-east-asian": !0,
      "font-variant-ligatures": !0,
      "font-variant-numeric": !0,
      "font-variant-position": !0,
      "font-weight": !0,
      grid: !1,
      "grid-area": !1,
      "grid-auto-columns": !1,
      "grid-auto-flow": !1,
      "grid-auto-rows": !1,
      "grid-column": !1,
      "grid-column-end": !1,
      "grid-column-start": !1,
      "grid-row": !1,
      "grid-row-end": !1,
      "grid-row-start": !1,
      "grid-template": !1,
      "grid-template-areas": !1,
      "grid-template-columns": !1,
      "grid-template-rows": !1,
      "hanging-punctuation": !1,
      height: !0,
      hyphens: !1,
      icon: !1,
      "image-orientation": !1,
      "image-resolution": !1,
      "ime-mode": !1,
      "initial-letters": !1,
      "inline-box-align": !1,
      "justify-content": !1,
      "justify-items": !1,
      "justify-self": !1,
      left: !1,
      "letter-spacing": !0,
      "lighting-color": !0,
      "line-box-contain": !1,
      "line-break": !1,
      "line-grid": !1,
      "line-height": !1,
      "line-snap": !1,
      "line-stacking": !1,
      "line-stacking-ruby": !1,
      "line-stacking-shift": !1,
      "line-stacking-strategy": !1,
      "list-style": !0,
      "list-style-image": !0,
      "list-style-position": !0,
      "list-style-type": !0,
      margin: !0,
      "margin-bottom": !0,
      "margin-left": !0,
      "margin-right": !0,
      "margin-top": !0,
      "marker-offset": !1,
      "marker-side": !1,
      marks: !1,
      mask: !1,
      "mask-box": !1,
      "mask-box-outset": !1,
      "mask-box-repeat": !1,
      "mask-box-slice": !1,
      "mask-box-source": !1,
      "mask-box-width": !1,
      "mask-clip": !1,
      "mask-image": !1,
      "mask-origin": !1,
      "mask-position": !1,
      "mask-repeat": !1,
      "mask-size": !1,
      "mask-source-type": !1,
      "mask-type": !1,
      "max-height": !0,
      "max-lines": !1,
      "max-width": !0,
      "min-height": !0,
      "min-width": !0,
      "move-to": !1,
      "nav-down": !1,
      "nav-index": !1,
      "nav-left": !1,
      "nav-right": !1,
      "nav-up": !1,
      "object-fit": !1,
      "object-position": !1,
      opacity: !1,
      order: !1,
      orphans: !1,
      outline: !1,
      "outline-color": !1,
      "outline-offset": !1,
      "outline-style": !1,
      "outline-width": !1,
      overflow: !1,
      "overflow-wrap": !1,
      "overflow-x": !1,
      "overflow-y": !1,
      padding: !0,
      "padding-bottom": !0,
      "padding-left": !0,
      "padding-right": !0,
      "padding-top": !0,
      page: !1,
      "page-break-after": !1,
      "page-break-before": !1,
      "page-break-inside": !1,
      "page-policy": !1,
      pause: !1,
      "pause-after": !1,
      "pause-before": !1,
      perspective: !1,
      "perspective-origin": !1,
      pitch: !1,
      "pitch-range": !1,
      "play-during": !1,
      position: !1,
      "presentation-level": !1,
      quotes: !1,
      "region-fragment": !1,
      resize: !1,
      rest: !1,
      "rest-after": !1,
      "rest-before": !1,
      richness: !1,
      right: !1,
      rotation: !1,
      "rotation-point": !1,
      "ruby-align": !1,
      "ruby-merge": !1,
      "ruby-position": !1,
      "shape-image-threshold": !1,
      "shape-outside": !1,
      "shape-margin": !1,
      size: !1,
      speak: !1,
      "speak-as": !1,
      "speak-header": !1,
      "speak-numeral": !1,
      "speak-punctuation": !1,
      "speech-rate": !1,
      stress: !1,
      "string-set": !1,
      "tab-size": !1,
      "table-layout": !1,
      "text-align": !0,
      "text-align-last": !0,
      "text-combine-upright": !0,
      "text-decoration": !0,
      "text-decoration-color": !0,
      "text-decoration-line": !0,
      "text-decoration-skip": !0,
      "text-decoration-style": !0,
      "text-emphasis": !0,
      "text-emphasis-color": !0,
      "text-emphasis-position": !0,
      "text-emphasis-style": !0,
      "text-height": !0,
      "text-indent": !0,
      "text-justify": !0,
      "text-orientation": !0,
      "text-overflow": !0,
      "text-shadow": !0,
      "text-space-collapse": !0,
      "text-transform": !0,
      "text-underline-position": !0,
      "text-wrap": !0,
      top: !1,
      transform: !1,
      "transform-origin": !1,
      "transform-style": !1,
      transition: !1,
      "transition-delay": !1,
      "transition-duration": !1,
      "transition-property": !1,
      "transition-timing-function": !1,
      "unicode-bidi": !1,
      "vertical-align": !1,
      visibility: !1,
      "voice-balance": !1,
      "voice-duration": !1,
      "voice-family": !1,
      "voice-pitch": !1,
      "voice-range": !1,
      "voice-rate": !1,
      "voice-stress": !1,
      "voice-volume": !1,
      volume: !1,
      "white-space": !1,
      widows: !1,
      width: !0,
      "will-change": !1,
      "word-break": !0,
      "word-spacing": !0,
      "word-wrap": !0,
      "wrap-flow": !1,
      "wrap-through": !1,
      "writing-mode": !1,
      "z-index": !1
    };
    return t;
  }

  var ec = /javascript\s*\:/gim;

  var ic = {
    whiteList: tc(),
    getDefaultWhiteList: tc,
    onAttr: function onAttr(t, e, i) {},
    onIgnoreAttr: function onIgnoreAttr(t, e, i) {},
    safeAttrValue: function safeAttrValue(t, e) {
      return ec.test(e) ? "" : e;
    }
  },
      nc = function nc(t) {
    return String.prototype.trim ? t.trim() : t.replace(/(^\s*)|(\s*$)/g, "");
  },
      oc = function oc(t) {
    return String.prototype.trimRight ? t.trimRight() : t.replace(/(\s*$)/g, "");
  };

  var rc = function rc(t, e) {
    ";" !== (t = oc(t))[t.length - 1] && (t += ";");
    var i = t.length,
        n = !1,
        o = 0,
        r = 0,
        s = "";

    function a() {
      if (!n) {
        var i = nc(t.slice(o, r)),
            a = i.indexOf(":");

        if (-1 !== a) {
          var l = nc(i.slice(0, a)),
              h = nc(i.slice(a + 1));

          if (l) {
            var u = e(o, s.length, l, h, i);
            u && (s += u + "; ");
          }
        }
      }

      o = r + 1;
    }

    for (; r < i; r++) {
      var l = t[r];

      if ("/" === l && "*" === t[r + 1]) {
        var h = t.indexOf("*/", r + 2);
        if (-1 === h) break;
        o = (r = h + 1) + 1, n = !1;
      } else "(" === l ? n = !0 : ")" === l ? n = !1 : ";" === l ? n || a() : "\n" === l && a();
    }

    return nc(s);
  };

  function sc(t) {
    return null == t;
  }

  function ac(t) {
    (t = function (t) {
      var e = {};

      for (var i in t) {
        e[i] = t[i];
      }

      return e;
    }(t || {})).whiteList = t.whiteList || ic.whiteList, t.onAttr = t.onAttr || ic.onAttr, t.onIgnoreAttr = t.onIgnoreAttr || ic.onIgnoreAttr, t.safeAttrValue = t.safeAttrValue || ic.safeAttrValue, this.options = t;
  }

  ac.prototype.process = function (t) {
    if (!(t = (t = t || "").toString())) return "";
    var e = this.options,
        i = e.whiteList,
        n = e.onAttr,
        o = e.onIgnoreAttr,
        r = e.safeAttrValue;
    return rc(t, function (t, e, s, a, l) {
      var h = i[s],
          u = !1;

      if (!0 === h ? u = h : "function" == typeof h ? u = h(a) : h instanceof RegExp && (u = h.test(a)), !0 !== u && (u = !1), a = r(s, a)) {
        var c,
            d = {
          position: e,
          sourcePosition: t,
          source: l,
          isWhite: u
        };
        return u ? sc(c = n(s, a, d)) ? s + ":" + a : c : sc(c = o(s, a, d)) ? void 0 : c;
      }
    });
  };

  var lc = ac,
      hc = n(function (t, e) {
    for (var i in (e = t.exports = function (t, e) {
      return new lc(e).process(t);
    }).FilterCSS = lc, ic) {
      e[i] = ic[i];
    }

    "undefined" != typeof window && (window.filterCSS = t.exports);
  }),
      uc = (hc.FilterCSS, function (t, e) {
    var i, n;
    if (Array.prototype.indexOf) return t.indexOf(e);

    for (i = 0, n = t.length; i < n; i++) {
      if (t[i] === e) return i;
    }

    return -1;
  }),
      cc = function cc(t, e, i) {
    var n, o;
    if (Array.prototype.forEach) return t.forEach(e, i);

    for (n = 0, o = t.length; n < o; n++) {
      e.call(i, t[n], n, t);
    }
  },
      dc = function dc(t) {
    return String.prototype.trim ? t.trim() : t.replace(/(^\s*)|(\s*$)/g, "");
  },
      pc = function pc(t) {
    var e = /\s|\n|\t/.exec(t);
    return e ? e.index : -1;
  },
      fc = hc.FilterCSS,
      mc = hc.getDefaultWhiteList;

  function vc() {
    return {
      a: ["target", "href", "title"],
      abbr: ["title"],
      address: [],
      area: ["shape", "coords", "href", "alt"],
      article: [],
      aside: [],
      audio: ["autoplay", "controls", "loop", "preload", "src"],
      b: [],
      bdi: ["dir"],
      bdo: ["dir"],
      big: [],
      blockquote: ["cite"],
      br: [],
      caption: [],
      center: [],
      cite: [],
      code: [],
      col: ["align", "valign", "span", "width"],
      colgroup: ["align", "valign", "span", "width"],
      dd: [],
      del: ["datetime"],
      details: ["open"],
      div: [],
      dl: [],
      dt: [],
      em: [],
      font: ["color", "size", "face"],
      footer: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      header: [],
      hr: [],
      i: [],
      img: ["src", "alt", "title", "width", "height"],
      ins: ["datetime"],
      li: [],
      mark: [],
      nav: [],
      ol: [],
      p: [],
      pre: [],
      s: [],
      section: [],
      small: [],
      span: [],
      sub: [],
      sup: [],
      strong: [],
      table: ["width", "border", "align", "valign"],
      tbody: ["align", "valign"],
      td: ["width", "rowspan", "colspan", "align", "valign"],
      tfoot: ["align", "valign"],
      th: ["width", "rowspan", "colspan", "align", "valign"],
      thead: ["align", "valign"],
      tr: ["rowspan", "align", "valign"],
      tt: [],
      u: [],
      ul: [],
      video: ["autoplay", "controls", "loop", "preload", "src", "height", "width"]
    };
  }

  var gc = new fc();

  function yc(t) {
    return t.replace(bc, "&lt;").replace(_c, "&gt;");
  }

  var bc = /</g,
      _c = />/g,
      wc = /"/g,
      kc = /&quot;/g,
      xc = /&#([a-zA-Z0-9]*);?/gim,
      Dc = /&colon;?/gim,
      Sc = /&newline;?/gim,
      Cc = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a)\:/gi,
      Tc = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi,
      Mc = /u\s*r\s*l\s*\(.*/gi;

  function Oc(t) {
    return t.replace(wc, "&quot;");
  }

  function Ec(t) {
    return t.replace(kc, '"');
  }

  function Pc(t) {
    return t.replace(xc, function (t, e) {
      return "x" === e[0] || "X" === e[0] ? String.fromCharCode(parseInt(e.substr(1), 16)) : String.fromCharCode(parseInt(e, 10));
    });
  }

  function Ac(t) {
    return t.replace(Dc, ":").replace(Sc, " ");
  }

  function Lc(t) {
    for (var e = "", i = 0, n = t.length; i < n; i++) {
      e += t.charCodeAt(i) < 32 ? " " : t.charAt(i);
    }

    return dc(e);
  }

  function Ic(t) {
    return t = Lc(t = Ac(t = Pc(t = Ec(t))));
  }

  function Nc(t) {
    return t = yc(t = Oc(t));
  }

  var Rc = /<!--[\s\S]*?-->/g;
  var Fc = {
    whiteList: {
      a: ["target", "href", "title"],
      abbr: ["title"],
      address: [],
      area: ["shape", "coords", "href", "alt"],
      article: [],
      aside: [],
      audio: ["autoplay", "controls", "loop", "preload", "src"],
      b: [],
      bdi: ["dir"],
      bdo: ["dir"],
      big: [],
      blockquote: ["cite"],
      br: [],
      caption: [],
      center: [],
      cite: [],
      code: [],
      col: ["align", "valign", "span", "width"],
      colgroup: ["align", "valign", "span", "width"],
      dd: [],
      del: ["datetime"],
      details: ["open"],
      div: [],
      dl: [],
      dt: [],
      em: [],
      font: ["color", "size", "face"],
      footer: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      header: [],
      hr: [],
      i: [],
      img: ["src", "alt", "title", "width", "height"],
      ins: ["datetime"],
      li: [],
      mark: [],
      nav: [],
      ol: [],
      p: [],
      pre: [],
      s: [],
      section: [],
      small: [],
      span: [],
      sub: [],
      sup: [],
      strong: [],
      table: ["width", "border", "align", "valign"],
      tbody: ["align", "valign"],
      td: ["width", "rowspan", "colspan", "align", "valign"],
      tfoot: ["align", "valign"],
      th: ["width", "rowspan", "colspan", "align", "valign"],
      thead: ["align", "valign"],
      tr: ["rowspan", "align", "valign"],
      tt: [],
      u: [],
      ul: [],
      video: ["autoplay", "controls", "loop", "preload", "src", "height", "width"]
    },
    getDefaultWhiteList: vc,
    onTag: function onTag(t, e, i) {},
    onIgnoreTag: function onIgnoreTag(t, e, i) {},
    onTagAttr: function onTagAttr(t, e, i) {},
    onIgnoreTagAttr: function onIgnoreTagAttr(t, e, i) {},
    safeAttrValue: function safeAttrValue(t, e, i, n) {
      if (i = Ic(i), "href" === e || "src" === e) {
        if ("#" === (i = dc(i))) return "#";
        if ("http://" !== i.substr(0, 7) && "https://" !== i.substr(0, 8) && "mailto:" !== i.substr(0, 7) && "tel:" !== i.substr(0, 4) && "data:image/" !== i.substr(0, 11) && "ftp://" !== i.substr(0, 6) && "./" !== i.substr(0, 2) && "../" !== i.substr(0, 3) && "#" !== i[0] && "/" !== i[0]) return "";
      } else if ("background" === e) {
        if (Cc.lastIndex = 0, Cc.test(i)) return "";
      } else if ("style" === e) {
        if (Tc.lastIndex = 0, Tc.test(i)) return "";
        if (Mc.lastIndex = 0, Mc.test(i) && (Cc.lastIndex = 0, Cc.test(i))) return "";
        !1 !== n && (i = (n = n || gc).process(i));
      }

      return i = Nc(i);
    },
    escapeHtml: yc,
    escapeQuote: Oc,
    unescapeQuote: Ec,
    escapeHtmlEntities: Pc,
    escapeDangerHtml5Entities: Ac,
    clearNonPrintableCharacter: Lc,
    friendlyAttrValue: Ic,
    escapeAttrValue: Nc,
    onIgnoreTagStripAll: function onIgnoreTagStripAll() {
      return "";
    },
    StripTagBody: function StripTagBody(t, e) {
      "function" != typeof e && (e = function e() {});
      var i = !Array.isArray(t),
          n = [],
          o = !1;
      return {
        onIgnoreTag: function onIgnoreTag(r, s, a) {
          if (function (e) {
            return !!i || -1 !== uc(t, e);
          }(r)) {
            if (a.isClosing) {
              var l = "[/removed]",
                  h = a.position + l.length;
              return n.push([!1 !== o ? o : a.position, h]), o = !1, l;
            }

            return o || (o = a.position), "[removed]";
          }

          return e(r, s, a);
        },
        remove: function remove(t) {
          var e = "",
              i = 0;
          return cc(n, function (n) {
            e += t.slice(i, n[0]), i = n[1];
          }), e += t.slice(i);
        }
      };
    },
    stripCommentTag: function stripCommentTag(t) {
      return t.replace(Rc, "");
    },
    stripBlankChar: function stripBlankChar(t) {
      var e = t.split("");
      return (e = e.filter(function (t) {
        var e = t.charCodeAt(0);
        return 127 !== e && (!(e <= 31) || 10 === e || 13 === e);
      })).join("");
    },
    cssFilter: gc,
    getDefaultCSSWhiteList: mc
  };

  function Yc(t) {
    var e = pc(t);
    if (-1 === e) var i = t.slice(1, -1);else i = t.slice(1, e + 1);
    return "/" === (i = dc(i).toLowerCase()).slice(0, 1) && (i = i.slice(1)), "/" === i.slice(-1) && (i = i.slice(0, -1)), i;
  }

  function jc(t) {
    return "</" === t.slice(0, 2);
  }

  var Hc = /[^a-zA-Z0-9_:\.\-]/gim;

  function zc(t, e) {
    for (; e < t.length; e++) {
      var i = t[e];
      if (" " !== i) return "=" === i ? e : -1;
    }
  }

  function Gc(t, e) {
    for (; e > 0; e--) {
      var i = t[e];
      if (" " !== i) return "=" === i ? e : -1;
    }
  }

  function Wc(t) {
    return function (t) {
      return '"' === t[0] && '"' === t[t.length - 1] || "'" === t[0] && "'" === t[t.length - 1];
    }(t) ? t.substr(1, t.length - 2) : t;
  }

  var Bc = {
    parseTag: function parseTag(t, e, i) {
      var n = "",
          o = 0,
          r = !1,
          s = !1,
          a = 0,
          l = t.length,
          h = "",
          u = "";

      t: for (a = 0; a < l; a++) {
        var c = t.charAt(a);

        if (!1 === r) {
          if ("<" === c) {
            r = a;
            continue;
          }
        } else if (!1 === s) {
          if ("<" === c) {
            n += i(t.slice(o, a)), r = a, o = a;
            continue;
          }

          if (">" === c) {
            n += i(t.slice(o, r)), h = Yc(u = t.slice(r, a + 1)), n += e(r, n.length, h, u, jc(u)), o = a + 1, r = !1;
            continue;
          }

          if ('"' === c || "'" === c) for (var d = 1, p = t.charAt(a - d); " " === p || "=" === p;) {
            if ("=" === p) {
              s = c;
              continue t;
            }

            p = t.charAt(a - ++d);
          }
        } else if (c === s) {
          s = !1;
          continue;
        }
      }

      return o < t.length && (n += i(t.substr(o))), n;
    },
    parseAttr: function parseAttr(t, e) {
      var i = 0,
          n = [],
          o = !1,
          r = t.length;

      function s(t, i) {
        if (!((t = (t = dc(t)).replace(Hc, "").toLowerCase()).length < 1)) {
          var o = e(t, i || "");
          o && n.push(o);
        }
      }

      for (var a = 0; a < r; a++) {
        var l,
            h = t.charAt(a);
        if (!1 !== o || "=" !== h) {
          if (!1 === o || a !== i || '"' !== h && "'" !== h || "=" !== t.charAt(a - 1)) {
            if (/\s|\n|\t/.test(h)) {
              if (t = t.replace(/\s|\n|\t/g, " "), !1 === o) {
                if (-1 === (l = zc(t, a))) {
                  s(dc(t.slice(i, a))), o = !1, i = a + 1;
                  continue;
                }

                a = l - 1;
                continue;
              }

              if (-1 === (l = Gc(t, a - 1))) {
                s(o, Wc(dc(t.slice(i, a)))), o = !1, i = a + 1;
                continue;
              }
            } else ;
          } else {
            if (-1 === (l = t.indexOf(h, a + 1))) break;
            s(o, dc(t.slice(i + 1, l))), o = !1, i = (a = l) + 1;
          }
        } else o = t.slice(i, a), i = a + 1;
      }

      return i < t.length && (!1 === o ? s(t.slice(i)) : s(o, Wc(dc(t.slice(i))))), dc(n.join(" "));
    }
  },
      Vc = hc.FilterCSS,
      Uc = Bc.parseTag,
      Xc = Bc.parseAttr;

  function qc(t) {
    return null == t;
  }

  function Zc(t) {
    (t = function (t) {
      var e = {};

      for (var i in t) {
        e[i] = t[i];
      }

      return e;
    }(t || {})).stripIgnoreTag && (t.onIgnoreTag && console.error('Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'), t.onIgnoreTag = Fc.onIgnoreTagStripAll), t.whiteList = t.whiteList || Fc.whiteList, t.onTag = t.onTag || Fc.onTag, t.onTagAttr = t.onTagAttr || Fc.onTagAttr, t.onIgnoreTag = t.onIgnoreTag || Fc.onIgnoreTag, t.onIgnoreTagAttr = t.onIgnoreTagAttr || Fc.onIgnoreTagAttr, t.safeAttrValue = t.safeAttrValue || Fc.safeAttrValue, t.escapeHtml = t.escapeHtml || Fc.escapeHtml, this.options = t, !1 === t.css ? this.cssFilter = !1 : (t.css = t.css || {}, this.cssFilter = new Vc(t.css));
  }

  Zc.prototype.process = function (t) {
    if (!(t = (t = t || "").toString())) return "";
    var e = this.options,
        i = e.whiteList,
        n = e.onTag,
        o = e.onIgnoreTag,
        r = e.onTagAttr,
        s = e.onIgnoreTagAttr,
        a = e.safeAttrValue,
        l = e.escapeHtml,
        h = this.cssFilter;
    e.stripBlankChar && (t = Fc.stripBlankChar(t)), e.allowCommentTag || (t = Fc.stripCommentTag(t));
    var u = !1;

    if (e.stripIgnoreTagBody) {
      u = Fc.StripTagBody(e.stripIgnoreTagBody, o);
      o = u.onIgnoreTag;
    }

    var c = Uc(t, function (t, e, u, c, d) {
      var p,
          f = {
        sourcePosition: t,
        position: e,
        isClosing: d,
        isWhite: i.hasOwnProperty(u)
      };
      if (!qc(p = n(u, c, f))) return p;

      if (f.isWhite) {
        if (f.isClosing) return "</" + u + ">";

        var m = function (t) {
          var e = pc(t);
          if (-1 === e) return {
            html: "",
            closing: "/" === t[t.length - 2]
          };
          var i = "/" === (t = dc(t.slice(e + 1, -1)))[t.length - 1];
          return i && (t = dc(t.slice(0, -1))), {
            html: t,
            closing: i
          };
        }(c),
            v = i[u],
            g = Xc(m.html, function (t, e) {
          var i,
              n = -1 !== uc(v, t);
          return qc(i = r(u, t, e, n)) ? n ? (e = a(u, t, e, h)) ? t + '="' + e + '"' : t : qc(i = s(u, t, e, n)) ? void 0 : i : i;
        });

        c = "<" + u;
        return g && (c += " " + g), m.closing && (c += " /"), c += ">";
      }

      return qc(p = o(u, c, f)) ? l(c) : p;
    }, l);
    return u && (c = u.remove(c)), c;
  };

  var $c = Zc,
      Kc = n(function (t, e) {
    function i(t, e) {
      return new $c(e).process(t);
    }

    for (var n in (e = t.exports = i).filterXSS = i, e.FilterXSS = $c, Fc) {
      e[n] = Fc[n];
    }

    for (var n in Bc) {
      e[n] = Bc[n];
    }

    "undefined" != typeof window && (window.filterXSS = t.exports), "undefined" != typeof self && "undefined" != typeof DedicatedWorkerGlobalScope && self instanceof DedicatedWorkerGlobalScope && (self.filterXSS = t.exports);
  });
  Kc.filterXSS, Kc.FilterXSS;

  function Jc(t, e) {
    var i = Vr(t);

    if (ai) {
      var n = ai(t);
      e && (n = yo(n).call(n, function (e) {
        return xt(t, e).enumerable;
      })), i.push.apply(i, n);
    }

    return i;
  }

  function Qc(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i,
          n = null != arguments[e] ? arguments[e] : {};
      if (e % 2) nr(i = Jc(Object(n), !0)).call(i, function (e) {
        Sn(t, e, n[e]);
      });else if (bt) ct(t, bt(n));else {
        var o;
        nr(o = Jc(Object(n))).call(o, function (e) {
          q(t, e, xt(n, e));
        });
      }
    }

    return t;
  }

  var td = /^\/?Date\((-?\d+)/i,
      ed = /^\d+$/;

  function id(t, e) {
    var i;

    if (void 0 !== t) {
      if (null === t) return null;
      if (!e) return t;
      if ("string" != typeof e && !(e instanceof String)) throw new Error("Type must be a string");

      switch (e) {
        case "boolean":
        case "Boolean":
          return Boolean(t);

        case "number":
        case "Number":
          return wl(t) && !isNaN(Date.parse(t)) ? r(t).valueOf() : Number(t.valueOf());

        case "string":
        case "String":
          return String(t);

        case "Date":
          try {
            return id(t, "Moment").toDate();
          } catch (i) {
            throw i instanceof TypeError ? new TypeError("Cannot convert object of type " + Cl(t) + " to type " + e) : i;
          }

        case "Moment":
          if (_l(t)) return r(t);
          if (t instanceof Date) return r(t.valueOf());
          if (r.isMoment(t)) return r(t);
          if (wl(t)) return (i = td.exec(t)) ? r(Number(i[1])) : (i = ed.exec(t), r(i ? Number(t) : t));
          throw new TypeError("Cannot convert object of type " + Cl(t) + " to type " + e);

        case "ISODate":
          if (_l(t)) return new Date(t);
          if (t instanceof Date) return t.toISOString();
          if (r.isMoment(t)) return t.toDate().toISOString();
          if (wl(t)) return (i = td.exec(t)) ? new Date(Number(i[1])).toISOString() : r(t).format();
          throw new Error("Cannot convert object of type " + Cl(t) + " to type ISODate");

        case "ASPDate":
          if (_l(t)) return "/Date(" + t + ")/";
          if (t instanceof Date || r.isMoment(t)) return "/Date(" + t.valueOf() + ")/";
          if (wl(t)) return "/Date(" + ((i = td.exec(t)) ? new Date(Number(i[1])).valueOf() : new Date(t).valueOf()) + ")/";
          throw new Error("Cannot convert object of type " + Cl(t) + " to type ASPDate");

        default:
          throw new Error("Unknown type ".concat(e));
      }
    }
  }

  function nd(t) {
    var e,
        i,
        n,
        o,
        r,
        s,
        a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
      start: "Date",
      end: "Date"
    },
        l = t._idProp,
        h = new $u({
      fieldId: l
    }),
        u = Kr(e = Wu(t)).call(e, function (t) {
      var e;
      return Pu(e = Vr(t)).call(e, function (e, i) {
        return e[i] = id(t[i], a[i]), e;
      }, {});
    }).to(h);
    return u.all().start(), {
      add: function add() {
        var e;
        return (e = t.getDataSet()).add.apply(e, arguments);
      },
      remove: function remove() {
        var e;
        return (e = t.getDataSet()).remove.apply(e, arguments);
      },
      update: function update() {
        var e;
        return (e = t.getDataSet()).update.apply(e, arguments);
      },
      updateOnly: function updateOnly() {
        var e;
        return (e = t.getDataSet()).updateOnly.apply(e, arguments);
      },
      clear: function clear() {
        var e;
        return (e = t.getDataSet()).clear.apply(e, arguments);
      },
      forEach: ur(i = nr(h)).call(i, h),
      get: ur(n = h.get).call(n, h),
      getIds: ur(o = h.getIds).call(o, h),
      off: ur(r = h.off).call(r, h),
      on: ur(s = h.on).call(s, h),

      get length() {
        return h.length;
      },

      idProp: l,
      type: a,
      rawDS: t,
      coercedDS: h,
      dispose: function dispose() {
        return u.stop();
      }
    };
  }

  var od = Qc(Qc({}, ih), {}, {
    convert: id,
    xss: Kc
  }),
      rd = Pn.trim,
      sd = a.parseFloat,
      ad = 1 / sd(Cn + "-0") != -1 / 0 ? function (t) {
    var e = rd(String(t)),
        i = sd(e);
    return 0 === i && "-" == e.charAt(0) ? -0 : i;
  } : sd;
  U({
    global: !0,
    forced: parseFloat != ad
  }, {
    parseFloat: ad
  });

  var ld = F.parseFloat,
      hd = function () {
    function t(e, i) {
      gn(this, t), this.options = null, this.props = null;
    }

    return _n(t, [{
      key: "setOptions",
      value: function value(t) {
        t && od.extend(this.options, t);
      }
    }, {
      key: "redraw",
      value: function value() {
        return !1;
      }
    }, {
      key: "destroy",
      value: function value() {}
    }, {
      key: "_isResized",
      value: function value() {
        var t = this.props._previousWidth !== this.props.width || this.props._previousHeight !== this.props.height;
        return this.props._previousWidth = this.props.width, this.props._previousHeight = this.props.height, t;
      }
    }]), t;
  }();

  U({
    target: "String",
    proto: !0
  }, {
    repeat: "".repeat || function (t) {
      var e = String(y(this)),
          i = "",
          n = K(t);
      if (n < 0 || n == 1 / 0) throw RangeError("Wrong number of repetitions");

      for (; n > 0; (n >>>= 1) && (e += e)) {
        1 & n && (i += e);
      }

      return i;
    }
  });

  var ud = tn("String").repeat,
      cd = String.prototype,
      dd = function dd(t) {
    var e = t.repeat;
    return "string" == typeof t || t === cd || t instanceof String && e === cd.repeat ? ud : e;
  };

  function pd(t, e, i) {
    if (i && !Jr(i)) return pd(t, e, [i]);

    if (e.hiddenDates = [], i && 1 == Jr(i)) {
      for (var n, o = 0; o < i.length; o++) {
        if (void 0 === dd(i[o])) {
          var r = {};
          r.start = t(i[o].start).toDate().valueOf(), r.end = t(i[o].end).toDate().valueOf(), e.hiddenDates.push(r);
        }
      }

      $h(n = e.hiddenDates).call(n, function (t, e) {
        return t.start - e.start;
      });
    }
  }

  function fd(t, e, i) {
    if (i && !Jr(i)) return fd(t, e, [i]);

    if (i && void 0 !== e.domProps.centerContainer.width) {
      pd(t, e, i);

      for (var n = t(e.range.start), o = t(e.range.end), r = (e.range.end - e.range.start) / e.domProps.centerContainer.width, s = 0; s < i.length; s++) {
        if (void 0 !== dd(i[s])) {
          var a = t(i[s].start),
              l = t(i[s].end);
          if ("Invalid Date" == a._d) throw new Error("Supplied start date is not valid: ".concat(i[s].start));
          if ("Invalid Date" == l._d) throw new Error("Supplied end date is not valid: ".concat(i[s].end));

          if (l - a >= 4 * r) {
            var h = 0,
                u = o.clone();

            switch (dd(i[s])) {
              case "daily":
                a.day() != l.day() && (h = 1), a.dayOfYear(n.dayOfYear()), a.year(n.year()), a.subtract(7, "days"), l.dayOfYear(n.dayOfYear()), l.year(n.year()), l.subtract(7 - h, "days"), u.add(1, "weeks");
                break;

              case "weekly":
                var c = l.diff(a, "days"),
                    d = a.day();
                a.date(n.date()), a.month(n.month()), a.year(n.year()), l = a.clone(), a.day(d), l.day(d), l.add(c, "days"), a.subtract(1, "weeks"), l.subtract(1, "weeks"), u.add(1, "weeks");
                break;

              case "monthly":
                a.month() != l.month() && (h = 1), a.month(n.month()), a.year(n.year()), a.subtract(1, "months"), l.month(n.month()), l.year(n.year()), l.subtract(1, "months"), l.add(h, "months"), u.add(1, "months");
                break;

              case "yearly":
                a.year() != l.year() && (h = 1), a.year(n.year()), a.subtract(1, "years"), l.year(n.year()), l.subtract(1, "years"), l.add(h, "years"), u.add(1, "years");
                break;

              default:
                return void console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", dd(i[s]));
            }

            for (; a < u;) {
              switch (e.hiddenDates.push({
                start: a.valueOf(),
                end: l.valueOf()
              }), dd(i[s])) {
                case "daily":
                  a.add(1, "days"), l.add(1, "days");
                  break;

                case "weekly":
                  a.add(1, "weeks"), l.add(1, "weeks");
                  break;

                case "monthly":
                  a.add(1, "months"), l.add(1, "months");
                  break;

                case "yearly":
                  a.add(1, "y"), l.add(1, "y");
                  break;

                default:
                  return void console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", dd(i[s]));
              }
            }

            e.hiddenDates.push({
              start: a.valueOf(),
              end: l.valueOf()
            });
          }
        }
      }

      md(e);
      var p = Sd(e.range.start, e.hiddenDates),
          f = Sd(e.range.end, e.hiddenDates),
          m = e.range.start,
          v = e.range.end;
      1 == p.hidden && (m = 1 == e.range.startToFront ? p.startDate - 1 : p.endDate + 1), 1 == f.hidden && (v = 1 == e.range.endToFront ? f.startDate - 1 : f.endDate + 1), 1 != p.hidden && 1 != f.hidden || e.range._applyRange(m, v);
    }
  }

  function md(t) {
    for (var e, i = t.hiddenDates, n = [], o = 0; o < i.length; o++) {
      for (var r = 0; r < i.length; r++) {
        o != r && 1 != i[r].remove && 1 != i[o].remove && (i[r].start >= i[o].start && i[r].end <= i[o].end ? i[r].remove = !0 : i[r].start >= i[o].start && i[r].start <= i[o].end ? (i[o].end = i[r].end, i[r].remove = !0) : i[r].end >= i[o].start && i[r].end <= i[o].end && (i[o].start = i[r].start, i[r].remove = !0));
      }
    }

    for (o = 0; o < i.length; o++) {
      !0 !== i[o].remove && n.push(i[o]);
    }

    t.hiddenDates = n, $h(e = t.hiddenDates).call(e, function (t, e) {
      return t.start - e.start;
    });
  }

  function vd(t, e, i) {
    for (var n = !1, o = e.current.valueOf(), r = 0; r < e.hiddenDates.length; r++) {
      var s = e.hiddenDates[r].start,
          a = e.hiddenDates[r].end;

      if (o >= s && o < a) {
        n = !0;
        break;
      }
    }

    if (1 == n && o < e._end.valueOf() && o != i) {
      var l = t(i),
          h = t(a);
      l.year() != h.year() ? e.switchedYear = !0 : l.month() != h.month() ? e.switchedMonth = !0 : l.dayOfYear() != h.dayOfYear() && (e.switchedDay = !0), e.current = h;
    }
  }

  function gd(t, e, i) {
    var n;
    if (0 == t.body.hiddenDates.length) return n = t.range.conversion(i), (e.valueOf() - n.offset) * n.scale;
    var o = Sd(e, t.body.hiddenDates);
    1 == o.hidden && (e = o.startDate);
    var r = bd(t.body.hiddenDates, t.range.start, t.range.end);

    if (e < t.range.start) {
      n = t.range.conversion(i, r);

      var s = _d(t.body.hiddenDates, e, n.offset);

      return e = t.options.moment(e).toDate().valueOf(), e += s, -(n.offset - e.valueOf()) * n.scale;
    }

    if (e > t.range.end) {
      var a = {
        start: t.range.start,
        end: e
      };
      return e = wd(t.options.moment, t.body.hiddenDates, a, e), n = t.range.conversion(i, r), (e.valueOf() - n.offset) * n.scale;
    }

    return e = wd(t.options.moment, t.body.hiddenDates, t.range, e), n = t.range.conversion(i, r), (e.valueOf() - n.offset) * n.scale;
  }

  function yd(t, e, i) {
    if (0 == t.body.hiddenDates.length) {
      var n = t.range.conversion(i);
      return new Date(e / n.scale + n.offset);
    }

    var o = bd(t.body.hiddenDates, t.range.start, t.range.end),
        r = (t.range.end - t.range.start - o) * e / i,
        s = xd(t.body.hiddenDates, t.range, r);
    return new Date(s + r + t.range.start);
  }

  function bd(t, e, i) {
    for (var n = 0, o = 0; o < t.length; o++) {
      var r = t[o].start,
          s = t[o].end;
      r >= e && s < i && (n += s - r);
    }

    return n;
  }

  function _d(t, e, i) {
    for (var n = 0, o = 0; o < t.length; o++) {
      var r = t[o].start,
          s = t[o].end;
      r >= e && s <= i && (n += s - r);
    }

    return n;
  }

  function wd(t, e, i, n) {
    return n = t(n).toDate().valueOf(), n -= kd(t, e, i, n);
  }

  function kd(t, e, i, n) {
    var o = 0;
    n = t(n).toDate().valueOf();

    for (var r = 0; r < e.length; r++) {
      var s = e[r].start,
          a = e[r].end;
      s >= i.start && a < i.end && n >= a && (o += a - s);
    }

    return o;
  }

  function xd(t, e, i) {
    for (var n = 0, o = 0, r = e.start, s = 0; s < t.length; s++) {
      var a = t[s].start,
          l = t[s].end;

      if (a >= e.start && l < e.end) {
        if (o += a - r, r = l, o >= i) break;
        n += l - a;
      }
    }

    return n;
  }

  function Dd(t, e, i, n) {
    var o = Sd(e, t);
    return 1 == o.hidden ? i < 0 ? 1 == n ? o.startDate - (o.endDate - e) - 1 : o.startDate - 1 : 1 == n ? o.endDate + (e - o.startDate) + 1 : o.endDate + 1 : e;
  }

  function Sd(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i].start,
          o = e[i].end;
      if (t >= n && t < o) return {
        hidden: !0,
        startDate: n,
        endDate: o
      };
    }

    return {
      hidden: !1,
      startDate: n,
      endDate: o
    };
  }

  var Cd = Object.freeze({
    __proto__: null,
    convertHiddenOptions: pd,
    updateHiddenDates: fd,
    removeDuplicates: md,
    printDates: function printDates(t) {
      for (var e = 0; e < t.length; e++) {
        console.log(e, new Date(t[e].start), new Date(t[e].end), t[e].start, t[e].end, t[e].remove);
      }
    },
    stepOverHiddenDates: vd,
    toScreen: gd,
    toTime: yd,
    getHiddenDurationBetween: bd,
    getHiddenDurationBeforeStart: _d,
    correctTimeForHidden: wd,
    getHiddenDurationBefore: kd,
    getAccumulatedHiddenDuration: xd,
    snapAwayFromHidden: Dd,
    getIsHidden: Sd
  });

  function Td(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var Md = function (t) {
    jh(i, t);
    var e = Td(i);

    function i(t, n) {
      var o, r, s, a, l, h, u, c;
      gn(this, i), c = e.call(this);
      var d = Qu().hours(0).minutes(0).seconds(0).milliseconds(0),
          p = d.clone().add(-3, "days").valueOf(),
          f = d.clone().add(3, "days").valueOf();
      return c.millisecondsPerPixelCache = void 0, void 0 === n ? (c.start = p, c.end = f) : (c.start = n.start || p, c.end = n.end || f), c.rolling = !1, c.body = t, c.deltaDifference = 0, c.scaleOffset = 0, c.startToFront = !1, c.endToFront = !0, c.defaultOptions = {
        rtl: !1,
        start: null,
        end: null,
        moment: Qu,
        direction: "horizontal",
        moveable: !0,
        zoomable: !0,
        min: null,
        max: null,
        zoomMin: 10,
        zoomMax: 31536e10,
        rollingMode: {
          follow: !1,
          offset: .5
        }
      }, c.options = od.extend({}, c.defaultOptions), c.props = {
        touch: {}
      }, c.animationTimer = null, c.body.emitter.on("panstart", ur(o = c._onDragStart).call(o, gh(c))), c.body.emitter.on("panmove", ur(r = c._onDrag).call(r, gh(c))), c.body.emitter.on("panend", ur(s = c._onDragEnd).call(s, gh(c))), c.body.emitter.on("mousewheel", ur(a = c._onMouseWheel).call(a, gh(c))), c.body.emitter.on("touch", ur(l = c._onTouch).call(l, gh(c))), c.body.emitter.on("pinch", ur(h = c._onPinch).call(h, gh(c))), c.body.dom.rollingModeBtn.addEventListener("click", ur(u = c.startRolling).call(u, gh(c))), c.setOptions(n), c;
    }

    return _n(i, [{
      key: "setOptions",
      value: function value(t) {
        if (t) {
          od.selectiveExtend(["animation", "direction", "min", "max", "zoomMin", "zoomMax", "moveable", "zoomable", "moment", "activate", "hiddenDates", "zoomKey", "zoomFriction", "rtl", "showCurrentTime", "rollingMode", "horizontalScroll"], this.options, t), t.rollingMode && t.rollingMode.follow && this.startRolling(), ("start" in t || "end" in t) && this.setRange(t.start, t.end);
        }
      }
    }, {
      key: "startRolling",
      value: function value() {
        var t = this;
        !function e() {
          t.stopRolling(), t.rolling = !0;
          var i = t.end - t.start,
              n = od.convert(new Date(), "Date").valueOf(),
              o = t.options.rollingMode && t.options.rollingMode.offset || .5,
              r = n - i * o,
              s = n + i * (1 - o);
          t.setRange(r, s, {
            animation: !1
          }), (i = 1 / t.conversion(t.body.domProps.center.width).scale / 10) < 30 && (i = 30), i > 1e3 && (i = 1e3), t.body.dom.rollingModeBtn.style.visibility = "hidden", t.currentTimeTimer = hn(e, i);
        }();
      }
    }, {
      key: "stopRolling",
      value: function value() {
        void 0 !== this.currentTimeTimer && (clearTimeout(this.currentTimeTimer), this.rolling = !1, this.body.dom.rollingModeBtn.style.visibility = "visible");
      }
    }, {
      key: "setRange",
      value: function value(t, e, i, n, o) {
        i || (i = {}), !0 !== i.byUser && (i.byUser = !1);
        var r = this,
            s = null != t ? od.convert(t, "Date").valueOf() : null,
            a = null != e ? od.convert(e, "Date").valueOf() : null;

        if (this._cancelAnimation(), this.millisecondsPerPixelCache = void 0, i.animation) {
          var l,
              h = this.start,
              u = this.end,
              c = "object" === es(i.animation) && "duration" in i.animation ? i.animation.duration : 500,
              d = "object" === es(i.animation) && "easingFunction" in i.animation ? i.animation.easingFunction : "easeInOutQuad",
              p = od.easingFunctions[d];
          if (!p) throw new Error(us(l = "Unknown easing function ".concat(vn(d), ". Choose from: ")).call(l, Vr(od.easingFunctions).join(", ")));
          var f = Wr(),
              m = !1;
          return function t() {
            if (!r.props.touch.dragging) {
              var e = Wr() - f,
                  l = p(e / c),
                  d = e > c,
                  g = d || null === s ? s : h + (s - h) * l,
                  y = d || null === a ? a : u + (a - u) * l;
              v = r._applyRange(g, y), fd(r.options.moment, r.body, r.options.hiddenDates), m = m || v;
              var b = {
                start: new Date(r.start),
                end: new Date(r.end),
                byUser: i.byUser,
                event: i.event
              };

              if (o && o(l, v, d), v && r.body.emitter.emit("rangechange", b), d) {
                if (m && (r.body.emitter.emit("rangechanged", b), n)) return n();
              } else r.animationTimer = hn(t, 20);
            }
          }();
        }

        var v = this._applyRange(s, a);

        if (fd(this.options.moment, this.body, this.options.hiddenDates), v) {
          var g = {
            start: new Date(this.start),
            end: new Date(this.end),
            byUser: i.byUser,
            event: i.event
          };
          if (this.body.emitter.emit("rangechange", g), clearTimeout(r.timeoutID), r.timeoutID = hn(function () {
            r.body.emitter.emit("rangechanged", g);
          }, 200), n) return n();
        }
      }
    }, {
      key: "getMillisecondsPerPixel",
      value: function value() {
        return void 0 === this.millisecondsPerPixelCache && (this.millisecondsPerPixelCache = (this.end - this.start) / this.body.dom.center.clientWidth), this.millisecondsPerPixelCache;
      }
    }, {
      key: "_cancelAnimation",
      value: function value() {
        this.animationTimer && (clearTimeout(this.animationTimer), this.animationTimer = null);
      }
    }, {
      key: "_applyRange",
      value: function value(t, e) {
        var i,
            n = null != t ? od.convert(t, "Date").valueOf() : this.start,
            o = null != e ? od.convert(e, "Date").valueOf() : this.end,
            r = null != this.options.max ? od.convert(this.options.max, "Date").valueOf() : null,
            s = null != this.options.min ? od.convert(this.options.min, "Date").valueOf() : null;
        if (isNaN(n) || null === n) throw new Error('Invalid start "'.concat(t, '"'));
        if (isNaN(o) || null === o) throw new Error('Invalid end "'.concat(e, '"'));

        if (o < n && (o = n), null !== s && n < s && (n += i = s - n, o += i, null != r && o > r && (o = r)), null !== r && o > r && (n -= i = o - r, o -= i, null != s && n < s && (n = s)), null !== this.options.zoomMin) {
          var a = ld(this.options.zoomMin);

          if (a < 0 && (a = 0), o - n < a) {
            this.end - this.start === a && n >= this.start - .5 && o <= this.end ? (n = this.start, o = this.end) : (n -= (i = a - (o - n)) / 2, o += i / 2);
          }
        }

        if (null !== this.options.zoomMax) {
          var l = ld(this.options.zoomMax);
          l < 0 && (l = 0), o - n > l && (this.end - this.start === l && n < this.start && o > this.end ? (n = this.start, o = this.end) : (n += (i = o - n - l) / 2, o -= i / 2));
        }

        var h = this.start != n || this.end != o;
        return n >= this.start && n <= this.end || o >= this.start && o <= this.end || this.start >= n && this.start <= o || this.end >= n && this.end <= o || this.body.emitter.emit("checkRangedItems"), this.start = n, this.end = o, h;
      }
    }, {
      key: "getRange",
      value: function value() {
        return {
          start: this.start,
          end: this.end
        };
      }
    }, {
      key: "conversion",
      value: function value(t, e) {
        return i.conversion(this.start, this.end, t, e);
      }
    }, {
      key: "_onDragStart",
      value: function value(t) {
        this.deltaDifference = 0, this.previousDelta = 0, this.options.moveable && this._isInsideRange(t) && this.props.touch.allowDragging && (this.stopRolling(), this.props.touch.start = this.start, this.props.touch.end = this.end, this.props.touch.dragging = !0, this.body.dom.root && (this.body.dom.root.style.cursor = "move"));
      }
    }, {
      key: "_onDrag",
      value: function value(t) {
        if (t && this.props.touch.dragging && this.options.moveable && this.props.touch.allowDragging) {
          var e = this.options.direction;
          Od(e);
          var i = "horizontal" == e ? t.deltaX : t.deltaY;
          i -= this.deltaDifference;
          var n = this.props.touch.end - this.props.touch.start;
          n -= bd(this.body.hiddenDates, this.start, this.end);
          var o,
              r = "horizontal" == e ? this.body.domProps.center.width : this.body.domProps.center.height;
          o = this.options.rtl ? i / r * n : -i / r * n;
          var s = this.props.touch.start + o,
              a = this.props.touch.end + o,
              l = Dd(this.body.hiddenDates, s, this.previousDelta - i, !0),
              h = Dd(this.body.hiddenDates, a, this.previousDelta - i, !0);
          if (l != s || h != a) return this.deltaDifference += i, this.props.touch.start = l, this.props.touch.end = h, void this._onDrag(t);
          this.previousDelta = i, this._applyRange(s, a);
          var u = new Date(this.start),
              c = new Date(this.end);
          this.body.emitter.emit("rangechange", {
            start: u,
            end: c,
            byUser: !0,
            event: t
          }), this.body.emitter.emit("panmove");
        }
      }
    }, {
      key: "_onDragEnd",
      value: function value(t) {
        this.props.touch.dragging && this.options.moveable && this.props.touch.allowDragging && (this.props.touch.dragging = !1, this.body.dom.root && (this.body.dom.root.style.cursor = "auto"), this.body.emitter.emit("rangechanged", {
          start: new Date(this.start),
          end: new Date(this.end),
          byUser: !0,
          event: t
        }));
      }
    }, {
      key: "_onMouseWheel",
      value: function value(t) {
        var e = 0;

        if (t.wheelDelta ? e = t.wheelDelta / 120 : t.detail ? e = -t.detail / 3 : t.deltaY && (e = -t.deltaY / 3), !(this.options.zoomKey && !t[this.options.zoomKey] && this.options.zoomable || !this.options.zoomable && this.options.moveable) && this.options.zoomable && this.options.moveable && this._isInsideRange(t) && e) {
          var i,
              n,
              o = this.options.zoomFriction || 5;

          if (i = e < 0 ? 1 - e / o : 1 / (1 + e / o), this.rolling) {
            var r = this.options.rollingMode && this.options.rollingMode.offset || .5;
            n = this.start + (this.end - this.start) * r;
          } else {
            var s = this.getPointer({
              x: t.clientX,
              y: t.clientY
            }, this.body.dom.center);
            n = this._pointerToDate(s);
          }

          this.zoom(i, n, e, t), t.preventDefault();
        }
      }
    }, {
      key: "_onTouch",
      value: function value(t) {
        this.props.touch.start = this.start, this.props.touch.end = this.end, this.props.touch.allowDragging = !0, this.props.touch.center = null, this.props.touch.centerDate = null, this.scaleOffset = 0, this.deltaDifference = 0, od.preventDefault(t);
      }
    }, {
      key: "_onPinch",
      value: function value(t) {
        if (this.options.zoomable && this.options.moveable) {
          od.preventDefault(t), this.props.touch.allowDragging = !1, this.props.touch.center || (this.props.touch.center = this.getPointer(t.center, this.body.dom.center), this.props.touch.centerDate = this._pointerToDate(this.props.touch.center)), this.stopRolling();
          var e = 1 / (t.scale + this.scaleOffset),
              i = this.props.touch.centerDate,
              n = bd(this.body.hiddenDates, this.start, this.end),
              o = kd(this.options.moment, this.body.hiddenDates, this, i),
              r = n - o,
              s = i - o + (this.props.touch.start - (i - o)) * e,
              a = i + r + (this.props.touch.end - (i + r)) * e;
          this.startToFront = 1 - e <= 0, this.endToFront = e - 1 <= 0;
          var l = Dd(this.body.hiddenDates, s, 1 - e, !0),
              h = Dd(this.body.hiddenDates, a, e - 1, !0);
          l == s && h == a || (this.props.touch.start = l, this.props.touch.end = h, this.scaleOffset = 1 - t.scale, s = l, a = h);
          var u = {
            animation: !1,
            byUser: !0,
            event: t
          };
          this.setRange(s, a, u), this.startToFront = !1, this.endToFront = !0;
        }
      }
    }, {
      key: "_isInsideRange",
      value: function value(t) {
        var e = t.center ? t.center.x : t.clientX,
            i = this.body.dom.centerContainer.getBoundingClientRect(),
            n = this.options.rtl ? e - i.left : i.right - e,
            o = this.body.util.toTime(n);
        return o >= this.start && o <= this.end;
      }
    }, {
      key: "_pointerToDate",
      value: function value(t) {
        var e,
            i = this.options.direction;
        if (Od(i), "horizontal" == i) return this.body.util.toTime(t.x).valueOf();
        var n = this.body.domProps.center.height;
        return e = this.conversion(n), t.y / e.scale + e.offset;
      }
    }, {
      key: "getPointer",
      value: function value(t, e) {
        var i = e.getBoundingClientRect();
        return this.options.rtl ? {
          x: i.right - t.x,
          y: t.y - i.top
        } : {
          x: t.x - i.left,
          y: t.y - i.top
        };
      }
    }, {
      key: "zoom",
      value: function value(t, e, i, n) {
        null == e && (e = (this.start + this.end) / 2);
        var o = bd(this.body.hiddenDates, this.start, this.end),
            r = kd(this.options.moment, this.body.hiddenDates, this, e),
            s = o - r,
            a = e - r + (this.start - (e - r)) * t,
            l = e + s + (this.end - (e + s)) * t;
        this.startToFront = !(i > 0), this.endToFront = !(-i > 0);
        var h = Dd(this.body.hiddenDates, a, i, !0),
            u = Dd(this.body.hiddenDates, l, -i, !0);
        h == a && u == l || (a = h, l = u);
        var c = {
          animation: !1,
          byUser: !0,
          event: n
        };
        this.setRange(a, l, c), this.startToFront = !1, this.endToFront = !0;
      }
    }, {
      key: "move",
      value: function value(t) {
        var e = this.end - this.start,
            i = this.start + e * t,
            n = this.end + e * t;
        this.start = i, this.end = n;
      }
    }, {
      key: "moveTo",
      value: function value(t) {
        var e = (this.start + this.end) / 2 - t,
            i = this.start - e,
            n = this.end - e;
        this.setRange(i, n, {
          animation: !1,
          byUser: !0,
          event: null
        });
      }
    }], [{
      key: "conversion",
      value: function value(t, e, i, n) {
        return void 0 === n && (n = 0), 0 != i && e - t != 0 ? {
          offset: t,
          scale: i / (e - t - n)
        } : {
          offset: 0,
          scale: 1
        };
      }
    }]), i;
  }(hd);

  function Od(t) {
    if ("horizontal" != t && "vertical" != t) throw new TypeError('Unknown direction "'.concat(t, '". Choose "horizontal" or "vertical".'));
  }

  var Ed,
      Pd = F.setInterval,
      Ad = null;
  "undefined" != typeof window ? Ed = function t(e, i) {
    var n = i || {
      preventDefault: !1
    };

    if (e.Manager) {
      var o = e,
          r = function r(e, i) {
        var r = Object.create(n);
        return i && o.assign(r, i), t(new o(e, r), r);
      };

      return o.assign(r, o), r.Manager = function (e, i) {
        var r = Object.create(n);
        return i && o.assign(r, i), t(new o.Manager(e, r), r);
      }, r;
    }

    var s = Object.create(e),
        a = e.element;

    function l(t) {
      return t.match(/[^ ]+/g);
    }

    function h(t) {
      if ("hammer.input" !== t.type) {
        if (t.srcEvent._handled || (t.srcEvent._handled = {}), t.srcEvent._handled[t.type]) return;
        t.srcEvent._handled[t.type] = !0;
      }

      var e = !1;

      t.stopPropagation = function () {
        e = !0;
      };

      var i = t.srcEvent.stopPropagation.bind(t.srcEvent);
      "function" == typeof i && (t.srcEvent.stopPropagation = function () {
        i(), t.stopPropagation();
      }), t.firstTarget = Ad;

      for (var n = Ad; n && !e;) {
        var o = n.hammer;
        if (o) for (var r, s = 0; s < o.length; s++) {
          if (r = o[s]._handlers[t.type]) for (var a = 0; a < r.length && !e; a++) {
            r[a](t);
          }
        }
        n = n.parentNode;
      }
    }

    return a.hammer || (a.hammer = []), a.hammer.push(s), e.on("hammer.input", function (t) {
      !0 !== n.preventDefault && n.preventDefault !== t.pointerType || t.preventDefault(), t.isFirst && (Ad = t.target);
    }), s._handlers = {}, s.on = function (t, i) {
      return l(t).forEach(function (t) {
        var n = s._handlers[t];
        n || (s._handlers[t] = n = [], e.on(t, h)), n.push(i);
      }), s;
    }, s.off = function (t, i) {
      return l(t).forEach(function (t) {
        var n = s._handlers[t];
        n && ((n = i ? n.filter(function (t) {
          return t !== i;
        }) : []).length > 0 ? s._handlers[t] = n : (e.off(t, h), delete s._handlers[t]));
      }), s;
    }, s.emit = function (t, i) {
      Ad = i.target, e.emit(t, i);
    }, s.destroy = function () {
      var t = e.element.hammer,
          i = t.indexOf(s);
      -1 !== i && t.splice(i, 1), t.length || delete e.element.hammer, s._handlers = {}, e.destroy();
    }, s;
  }(window.Hammer || tl, {
    preventDefault: "mouse"
  }) : Ed = function Ed() {
    return {
      on: t = function t() {},
      off: t,
      destroy: t,
      emit: t,
      get: function get(e) {
        return {
          set: t
        };
      }
    };
    var t;
  };
  var Ld = Ed;

  function Id(t, e) {
    e.inputHandler = function (t) {
      t.isFirst && e(t);
    }, t.on("hammer.input", e.inputHandler);
  }

  var Nd = function () {
    function t(e, i, n, o, r) {
      gn(this, t), this.moment = r && r.moment || Qu, this.options = r || {}, this.current = this.moment(), this._start = this.moment(), this._end = this.moment(), this.autoScale = !0, this.scale = "day", this.step = 1, this.setRange(e, i, n), this.switchedDay = !1, this.switchedMonth = !1, this.switchedYear = !1, Jr(o) ? this.hiddenDates = o : this.hiddenDates = null != o ? [o] : [], this.format = t.FORMAT;
    }

    return _n(t, [{
      key: "setMoment",
      value: function value(t) {
        this.moment = t, this.current = this.moment(this.current.valueOf()), this._start = this.moment(this._start.valueOf()), this._end = this.moment(this._end.valueOf());
      }
    }, {
      key: "setFormat",
      value: function value(e) {
        var i = od.deepExtend({}, t.FORMAT);
        this.format = od.deepExtend(i, e);
      }
    }, {
      key: "setRange",
      value: function value(t, e, i) {
        if (!(t instanceof Date && e instanceof Date)) throw "No legal start or end date in method setRange";
        this._start = null != t ? this.moment(t.valueOf()) : Wr(), this._end = null != e ? this.moment(e.valueOf()) : Wr(), this.autoScale && this.setMinimumStep(i);
      }
    }, {
      key: "start",
      value: function value() {
        this.current = this._start.clone(), this.roundToMinor();
      }
    }, {
      key: "roundToMinor",
      value: function value() {
        switch ("week" == this.scale && this.current.weekday(0), this.scale) {
          case "year":
            this.current.year(this.step * Math.floor(this.current.year() / this.step)), this.current.month(0);

          case "month":
            this.current.date(1);

          case "week":
          case "day":
          case "weekday":
            this.current.hours(0);

          case "hour":
            this.current.minutes(0);

          case "minute":
            this.current.seconds(0);

          case "second":
            this.current.milliseconds(0);
        }

        if (1 != this.step) {
          var t = this.current.clone();

          switch (this.scale) {
            case "millisecond":
              this.current.subtract(this.current.milliseconds() % this.step, "milliseconds");
              break;

            case "second":
              this.current.subtract(this.current.seconds() % this.step, "seconds");
              break;

            case "minute":
              this.current.subtract(this.current.minutes() % this.step, "minutes");
              break;

            case "hour":
              this.current.subtract(this.current.hours() % this.step, "hours");
              break;

            case "weekday":
            case "day":
              this.current.subtract((this.current.date() - 1) % this.step, "day");
              break;

            case "week":
              this.current.subtract(this.current.week() % this.step, "week");
              break;

            case "month":
              this.current.subtract(this.current.month() % this.step, "month");
              break;

            case "year":
              this.current.subtract(this.current.year() % this.step, "year");
          }

          t.isSame(this.current) || (this.current = this.moment(Dd(this.hiddenDates, this.current.valueOf(), -1, !0)));
        }
      }
    }, {
      key: "hasNext",
      value: function value() {
        return this.current.valueOf() <= this._end.valueOf();
      }
    }, {
      key: "next",
      value: function value() {
        var t = this.current.valueOf();

        switch (this.scale) {
          case "millisecond":
            this.current.add(this.step, "millisecond");
            break;

          case "second":
            this.current.add(this.step, "second");
            break;

          case "minute":
            this.current.add(this.step, "minute");
            break;

          case "hour":
            this.current.add(this.step, "hour"), this.current.month() < 6 ? this.current.subtract(this.current.hours() % this.step, "hour") : this.current.hours() % this.step != 0 && this.current.add(this.step - this.current.hours() % this.step, "hour");
            break;

          case "weekday":
          case "day":
            this.current.add(this.step, "day");
            break;

          case "week":
            if (0 !== this.current.weekday()) this.current.weekday(0), this.current.add(this.step, "week");else if (!1 === this.options.showMajorLabels) this.current.add(this.step, "week");else {
              var e = this.current.clone();
              e.add(1, "week"), e.isSame(this.current, "month") ? this.current.add(this.step, "week") : (this.current.add(this.step, "week"), this.current.date(1));
            }
            break;

          case "month":
            this.current.add(this.step, "month");
            break;

          case "year":
            this.current.add(this.step, "year");
        }

        if (1 != this.step) switch (this.scale) {
          case "millisecond":
            this.current.milliseconds() > 0 && this.current.milliseconds() < this.step && this.current.milliseconds(0);
            break;

          case "second":
            this.current.seconds() > 0 && this.current.seconds() < this.step && this.current.seconds(0);
            break;

          case "minute":
            this.current.minutes() > 0 && this.current.minutes() < this.step && this.current.minutes(0);
            break;

          case "hour":
            this.current.hours() > 0 && this.current.hours() < this.step && this.current.hours(0);
            break;

          case "weekday":
          case "day":
            this.current.date() < this.step + 1 && this.current.date(1);
            break;

          case "week":
            this.current.week() < this.step && this.current.week(1);
            break;

          case "month":
            this.current.month() < this.step && this.current.month(0);
        }
        this.current.valueOf() == t && (this.current = this._end.clone()), this.switchedDay = !1, this.switchedMonth = !1, this.switchedYear = !1, vd(this.moment, this, t);
      }
    }, {
      key: "getCurrent",
      value: function value() {
        return this.current.clone();
      }
    }, {
      key: "setScale",
      value: function value(t) {
        t && "string" == typeof t.scale && (this.scale = t.scale, this.step = t.step > 0 ? t.step : 1, this.autoScale = !1);
      }
    }, {
      key: "setAutoScale",
      value: function value(t) {
        this.autoScale = t;
      }
    }, {
      key: "setMinimumStep",
      value: function value(t) {
        if (null != t) {
          var e = 31104e6,
              i = 2592e6,
              n = 864e5,
              o = 36e5,
              r = 6e4,
              s = 1e3;
          1e3 * e > t && (this.scale = "year", this.step = 1e3), 500 * e > t && (this.scale = "year", this.step = 500), 100 * e > t && (this.scale = "year", this.step = 100), 50 * e > t && (this.scale = "year", this.step = 50), 10 * e > t && (this.scale = "year", this.step = 10), 5 * e > t && (this.scale = "year", this.step = 5), e > t && (this.scale = "year", this.step = 1), 7776e6 > t && (this.scale = "month", this.step = 3), i > t && (this.scale = "month", this.step = 1), 6048e5 > t && this.options.showWeekScale && (this.scale = "week", this.step = 1), 1728e5 > t && (this.scale = "day", this.step = 2), n > t && (this.scale = "day", this.step = 1), 432e5 > t && (this.scale = "weekday", this.step = 1), 144e5 > t && (this.scale = "hour", this.step = 4), o > t && (this.scale = "hour", this.step = 1), 9e5 > t && (this.scale = "minute", this.step = 15), 6e5 > t && (this.scale = "minute", this.step = 10), 3e5 > t && (this.scale = "minute", this.step = 5), r > t && (this.scale = "minute", this.step = 1), 15e3 > t && (this.scale = "second", this.step = 15), 1e4 > t && (this.scale = "second", this.step = 10), 5e3 > t && (this.scale = "second", this.step = 5), s > t && (this.scale = "second", this.step = 1), 200 > t && (this.scale = "millisecond", this.step = 200), 100 > t && (this.scale = "millisecond", this.step = 100), 50 > t && (this.scale = "millisecond", this.step = 50), 10 > t && (this.scale = "millisecond", this.step = 10), 5 > t && (this.scale = "millisecond", this.step = 5), 1 > t && (this.scale = "millisecond", this.step = 1);
        }
      }
    }, {
      key: "isMajor",
      value: function value() {
        if (1 == this.switchedYear) switch (this.scale) {
          case "year":
          case "month":
          case "week":
          case "weekday":
          case "day":
          case "hour":
          case "minute":
          case "second":
          case "millisecond":
            return !0;

          default:
            return !1;
        } else if (1 == this.switchedMonth) switch (this.scale) {
          case "week":
          case "weekday":
          case "day":
          case "hour":
          case "minute":
          case "second":
          case "millisecond":
            return !0;

          default:
            return !1;
        } else if (1 == this.switchedDay) switch (this.scale) {
          case "millisecond":
          case "second":
          case "minute":
          case "hour":
            return !0;

          default:
            return !1;
        }
        var t = this.moment(this.current);

        switch (this.scale) {
          case "millisecond":
            return 0 == t.milliseconds();

          case "second":
            return 0 == t.seconds();

          case "minute":
            return 0 == t.hours() && 0 == t.minutes();

          case "hour":
            return 0 == t.hours();

          case "weekday":
          case "day":
          case "week":
            return 1 == t.date();

          case "month":
            return 0 == t.month();

          case "year":
          default:
            return !1;
        }
      }
    }, {
      key: "getLabelMinor",
      value: function value(t) {
        if (null == t && (t = this.current), t instanceof Date && (t = this.moment(t)), "function" == typeof this.format.minorLabels) return this.format.minorLabels(t, this.scale, this.step);
        var e = this.format.minorLabels[this.scale];

        switch (this.scale) {
          case "week":
            if (1 === t.date() && 0 !== t.weekday()) return "";

          default:
            return e && e.length > 0 ? this.moment(t).format(e) : "";
        }
      }
    }, {
      key: "getLabelMajor",
      value: function value(t) {
        if (null == t && (t = this.current), t instanceof Date && (t = this.moment(t)), "function" == typeof this.format.majorLabels) return this.format.majorLabels(t, this.scale, this.step);
        var e = this.format.majorLabels[this.scale];
        return e && e.length > 0 ? this.moment(t).format(e) : "";
      }
    }, {
      key: "getClassName",
      value: function value() {
        var t,
            e = this.moment,
            i = this.moment(this.current),
            n = i.locale ? i.locale("en") : i.lang("en"),
            o = this.step,
            r = [];

        function s(t) {
          return t / o % 2 == 0 ? " vis-even" : " vis-odd";
        }

        function a(t) {
          return t.isSame(Wr(), "day") ? " vis-today" : t.isSame(e().add(1, "day"), "day") ? " vis-tomorrow" : t.isSame(e().add(-1, "day"), "day") ? " vis-yesterday" : "";
        }

        function l(t) {
          return t.isSame(Wr(), "week") ? " vis-current-week" : "";
        }

        function h(t) {
          return t.isSame(Wr(), "month") ? " vis-current-month" : "";
        }

        switch (this.scale) {
          case "millisecond":
            r.push(a(n)), r.push(s(n.milliseconds()));
            break;

          case "second":
            r.push(a(n)), r.push(s(n.seconds()));
            break;

          case "minute":
            r.push(a(n)), r.push(s(n.minutes()));
            break;

          case "hour":
            r.push(us(t = "vis-h".concat(n.hours())).call(t, 4 == this.step ? "-h" + (n.hours() + 4) : "")), r.push(a(n)), r.push(s(n.hours()));
            break;

          case "weekday":
            r.push("vis-".concat(n.format("dddd").toLowerCase())), r.push(a(n)), r.push(l(n)), r.push(s(n.date()));
            break;

          case "day":
            r.push("vis-day".concat(n.date())), r.push("vis-".concat(n.format("MMMM").toLowerCase())), r.push(a(n)), r.push(h(n)), r.push(this.step <= 2 ? a(n) : ""), r.push(this.step <= 2 ? "vis-".concat(n.format("dddd").toLowerCase()) : ""), r.push(s(n.date() - 1));
            break;

          case "week":
            r.push("vis-week".concat(n.format("w"))), r.push(l(n)), r.push(s(n.week()));
            break;

          case "month":
            r.push("vis-".concat(n.format("MMMM").toLowerCase())), r.push(h(n)), r.push(s(n.month()));
            break;

          case "year":
            r.push("vis-year".concat(n.year())), r.push(function (t) {
              return t.isSame(Wr(), "year") ? " vis-current-year" : "";
            }(n)), r.push(s(n.year()));
        }

        return yo(r).call(r, String).join(" ");
      }
    }], [{
      key: "snap",
      value: function value(t, e, i) {
        var n = Qu(t);

        if ("year" == e) {
          var o = n.year() + Math.round(n.month() / 12);
          n.year(Math.round(o / i) * i), n.month(0), n.date(0), n.hours(0), n.minutes(0), n.seconds(0), n.milliseconds(0);
        } else if ("month" == e) n.date() > 15 ? (n.date(1), n.add(1, "month")) : n.date(1), n.hours(0), n.minutes(0), n.seconds(0), n.milliseconds(0);else if ("week" == e) n.weekday() > 2 ? (n.weekday(0), n.add(1, "week")) : n.weekday(0), n.hours(0), n.minutes(0), n.seconds(0), n.milliseconds(0);else if ("day" == e) {
          switch (i) {
            case 5:
            case 2:
              n.hours(24 * Math.round(n.hours() / 24));
              break;

            default:
              n.hours(12 * Math.round(n.hours() / 12));
          }

          n.minutes(0), n.seconds(0), n.milliseconds(0);
        } else if ("weekday" == e) {
          switch (i) {
            case 5:
            case 2:
              n.hours(12 * Math.round(n.hours() / 12));
              break;

            default:
              n.hours(6 * Math.round(n.hours() / 6));
          }

          n.minutes(0), n.seconds(0), n.milliseconds(0);
        } else if ("hour" == e) {
          switch (i) {
            case 4:
              n.minutes(60 * Math.round(n.minutes() / 60));
              break;

            default:
              n.minutes(30 * Math.round(n.minutes() / 30));
          }

          n.seconds(0), n.milliseconds(0);
        } else if ("minute" == e) {
          switch (i) {
            case 15:
            case 10:
              n.minutes(5 * Math.round(n.minutes() / 5)), n.seconds(0);
              break;

            case 5:
              n.seconds(60 * Math.round(n.seconds() / 60));
              break;

            default:
              n.seconds(30 * Math.round(n.seconds() / 30));
          }

          n.milliseconds(0);
        } else if ("second" == e) switch (i) {
          case 15:
          case 10:
            n.seconds(5 * Math.round(n.seconds() / 5)), n.milliseconds(0);
            break;

          case 5:
            n.milliseconds(1e3 * Math.round(n.milliseconds() / 1e3));
            break;

          default:
            n.milliseconds(500 * Math.round(n.milliseconds() / 500));
        } else if ("millisecond" == e) {
          var r = i > 5 ? i / 2 : 1;
          n.milliseconds(Math.round(n.milliseconds() / r) * r);
        }

        return n;
      }
    }]), t;
  }();

  function Rd(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  Nd.FORMAT = {
    minorLabels: {
      millisecond: "SSS",
      second: "s",
      minute: "HH:mm",
      hour: "HH:mm",
      weekday: "ddd D",
      day: "D",
      week: "w",
      month: "MMM",
      year: "YYYY"
    },
    majorLabels: {
      millisecond: "HH:mm:ss",
      second: "D MMMM HH:mm",
      minute: "ddd D MMMM",
      hour: "ddd D MMMM",
      weekday: "MMMM YYYY",
      day: "MMMM YYYY",
      week: "MMMM YYYY",
      month: "YYYY",
      year: ""
    }
  };

  var Fd = function (t) {
    jh(i, t);
    var e = Rd(i);

    function i(t, n) {
      var o;
      return gn(this, i), (o = e.call(this)).dom = {
        foreground: null,
        lines: [],
        majorTexts: [],
        minorTexts: [],
        redundant: {
          lines: [],
          majorTexts: [],
          minorTexts: []
        }
      }, o.props = {
        range: {
          start: 0,
          end: 0,
          minimumStep: 0
        },
        lineTop: 0
      }, o.defaultOptions = {
        orientation: {
          axis: "bottom"
        },
        showMinorLabels: !0,
        showMajorLabels: !0,
        showWeekScale: !1,
        maxMinorChars: 7,
        format: od.extend({}, Nd.FORMAT),
        moment: Qu,
        timeAxis: null
      }, o.options = od.extend({}, o.defaultOptions), o.body = t, o._create(), o.setOptions(n), o;
    }

    return _n(i, [{
      key: "setOptions",
      value: function value(t) {
        t && (od.selectiveExtend(["showMinorLabels", "showMajorLabels", "showWeekScale", "maxMinorChars", "hiddenDates", "timeAxis", "moment", "rtl"], this.options, t), od.selectiveDeepExtend(["format"], this.options, t), "orientation" in t && ("string" == typeof t.orientation ? this.options.orientation.axis = t.orientation : "object" === es(t.orientation) && "axis" in t.orientation && (this.options.orientation.axis = t.orientation.axis)), "locale" in t && ("function" == typeof Qu.locale ? Qu.locale(t.locale) : Qu.lang(t.locale)));
      }
    }, {
      key: "_create",
      value: function value() {
        this.dom.foreground = document.createElement("div"), this.dom.background = document.createElement("div"), this.dom.foreground.className = "vis-time-axis vis-foreground", this.dom.background.className = "vis-time-axis vis-background";
      }
    }, {
      key: "destroy",
      value: function value() {
        this.dom.foreground.parentNode && this.dom.foreground.parentNode.removeChild(this.dom.foreground), this.dom.background.parentNode && this.dom.background.parentNode.removeChild(this.dom.background), this.body = null;
      }
    }, {
      key: "redraw",
      value: function value() {
        var t = this.props,
            e = this.dom.foreground,
            i = this.dom.background,
            n = "top" == this.options.orientation.axis ? this.body.dom.top : this.body.dom.bottom,
            o = e.parentNode !== n;

        this._calculateCharSize();

        var r = this.options.showMinorLabels && "none" !== this.options.orientation.axis,
            s = this.options.showMajorLabels && "none" !== this.options.orientation.axis;
        t.minorLabelHeight = r ? t.minorCharHeight : 0, t.majorLabelHeight = s ? t.majorCharHeight : 0, t.height = t.minorLabelHeight + t.majorLabelHeight, t.width = e.offsetWidth, t.minorLineHeight = this.body.domProps.root.height - t.majorLabelHeight - ("top" == this.options.orientation.axis ? this.body.domProps.bottom.height : this.body.domProps.top.height), t.minorLineWidth = 1, t.majorLineHeight = t.minorLineHeight + t.majorLabelHeight, t.majorLineWidth = 1;
        var a = e.nextSibling,
            l = i.nextSibling;
        return e.parentNode && e.parentNode.removeChild(e), i.parentNode && i.parentNode.removeChild(i), e.style.height = "".concat(this.props.height, "px"), this._repaintLabels(), a ? n.insertBefore(e, a) : n.appendChild(e), l ? this.body.dom.backgroundVertical.insertBefore(i, l) : this.body.dom.backgroundVertical.appendChild(i), this._isResized() || o;
      }
    }, {
      key: "_repaintLabels",
      value: function value() {
        var t = this.options.orientation.axis,
            e = od.convert(this.body.range.start, "Number"),
            i = od.convert(this.body.range.end, "Number"),
            n = this.body.util.toTime((this.props.minorCharWidth || 10) * this.options.maxMinorChars).valueOf(),
            o = n - kd(this.options.moment, this.body.hiddenDates, this.body.range, n);
        o -= this.body.util.toTime(0).valueOf();
        var r = new Nd(new Date(e), new Date(i), o, this.body.hiddenDates, this.options);
        r.setMoment(this.options.moment), this.options.format && r.setFormat(this.options.format), this.options.timeAxis && r.setScale(this.options.timeAxis), this.step = r;
        var s,
            a,
            l,
            h,
            u,
            c,
            d = this.dom;
        d.redundant.lines = d.lines, d.redundant.majorTexts = d.majorTexts, d.redundant.minorTexts = d.minorTexts, d.lines = [], d.majorTexts = [], d.minorTexts = [];
        var p,
            f,
            m,
            v = 0,
            g = void 0,
            y = 0,
            b = 1e3;

        for (r.start(), a = r.getCurrent(), h = this.body.util.toScreen(a); r.hasNext() && y < b;) {
          switch (y++, u = r.isMajor(), m = r.getClassName(), s = a, l = h, r.next(), a = r.getCurrent(), p = v, v = (h = this.body.util.toScreen(a)) - l, r.scale) {
            case "week":
              c = !0;
              break;

            default:
              c = v >= .4 * p;
          }

          if (this.options.showMinorLabels && c) {
            var _ = this._repaintMinorText(l, r.getLabelMinor(s), t, m);

            _.style.width = "".concat(v, "px");
          }

          u && this.options.showMajorLabels ? (l > 0 && (null == g && (g = l), _ = this._repaintMajorText(l, r.getLabelMajor(s), t, m)), f = this._repaintMajorLine(l, v, t, m)) : c ? f = this._repaintMinorLine(l, v, t, m) : f && (f.style.width = "".concat(Qn(f.style.width) + v, "px"));
        }

        if (y !== b || Yd || (console.warn("Something is wrong with the Timeline scale. Limited drawing of grid lines to ".concat(b, " lines.")), Yd = !0), this.options.showMajorLabels) {
          var w = this.body.util.toTime(0),
              k = r.getLabelMajor(w),
              x = k.length * (this.props.majorCharWidth || 10) + 10;
          (null == g || x < g) && this._repaintMajorText(0, k, t, m);
        }

        nr(od).call(od, this.dom.redundant, function (t) {
          for (; t.length;) {
            var e = t.pop();
            e && e.parentNode && e.parentNode.removeChild(e);
          }
        });
      }
    }, {
      key: "_repaintMinorText",
      value: function value(t, e, i, n) {
        var o = this.dom.redundant.minorTexts.shift();

        if (!o) {
          var r = document.createTextNode("");
          (o = document.createElement("div")).appendChild(r), this.dom.foreground.appendChild(o);
        }

        this.dom.minorTexts.push(o), o.innerHTML = od.xss(e);
        var s = "top" == i ? this.props.majorLabelHeight : 0;
        return this._setXY(o, t, s), o.className = "vis-text vis-minor ".concat(n), o;
      }
    }, {
      key: "_repaintMajorText",
      value: function value(t, e, i, n) {
        var o = this.dom.redundant.majorTexts.shift();

        if (!o) {
          var r = document.createElement("div");
          (o = document.createElement("div")).appendChild(r), this.dom.foreground.appendChild(o);
        }

        o.childNodes[0].innerHTML = od.xss(e), o.className = "vis-text vis-major ".concat(n);
        var s = "top" == i ? 0 : this.props.minorLabelHeight;
        return this._setXY(o, t, s), this.dom.majorTexts.push(o), o;
      }
    }, {
      key: "_setXY",
      value: function value(t, e, i) {
        var n,
            o = this.options.rtl ? -1 * e : e;
        t.style.transform = us(n = "translate(".concat(o, "px, ")).call(n, i, "px)");
      }
    }, {
      key: "_repaintMinorLine",
      value: function value(t, e, i, n) {
        var o,
            r = this.dom.redundant.lines.shift();
        r || (r = document.createElement("div"), this.dom.background.appendChild(r)), this.dom.lines.push(r);
        var s = this.props;
        r.style.width = "".concat(e, "px"), r.style.height = "".concat(s.minorLineHeight, "px");
        var a = "top" == i ? s.majorLabelHeight : this.body.domProps.top.height,
            l = t - s.minorLineWidth / 2;
        return this._setXY(r, l, a), r.className = us(o = "vis-grid ".concat(this.options.rtl ? "vis-vertical-rtl" : "vis-vertical", " vis-minor ")).call(o, n), r;
      }
    }, {
      key: "_repaintMajorLine",
      value: function value(t, e, i, n) {
        var o,
            r = this.dom.redundant.lines.shift();
        r || (r = document.createElement("div"), this.dom.background.appendChild(r)), this.dom.lines.push(r);
        var s = this.props;
        r.style.width = "".concat(e, "px"), r.style.height = "".concat(s.majorLineHeight, "px");
        var a = "top" == i ? 0 : this.body.domProps.top.height,
            l = t - s.majorLineWidth / 2;
        return this._setXY(r, l, a), r.className = us(o = "vis-grid ".concat(this.options.rtl ? "vis-vertical-rtl" : "vis-vertical", " vis-major ")).call(o, n), r;
      }
    }, {
      key: "_calculateCharSize",
      value: function value() {
        this.dom.measureCharMinor || (this.dom.measureCharMinor = document.createElement("DIV"), this.dom.measureCharMinor.className = "vis-text vis-minor vis-measure", this.dom.measureCharMinor.style.position = "absolute", this.dom.measureCharMinor.appendChild(document.createTextNode("0")), this.dom.foreground.appendChild(this.dom.measureCharMinor)), this.props.minorCharHeight = this.dom.measureCharMinor.clientHeight, this.props.minorCharWidth = this.dom.measureCharMinor.clientWidth, this.dom.measureCharMajor || (this.dom.measureCharMajor = document.createElement("DIV"), this.dom.measureCharMajor.className = "vis-text vis-major vis-measure", this.dom.measureCharMajor.style.position = "absolute", this.dom.measureCharMajor.appendChild(document.createTextNode("0")), this.dom.foreground.appendChild(this.dom.measureCharMajor)), this.props.majorCharHeight = this.dom.measureCharMajor.clientHeight, this.props.majorCharWidth = this.dom.measureCharMajor.clientWidth;
      }
    }]), i;
  }(hd),
      Yd = !1;

  function jd(t) {
    var e,
        i = t && t.preventDefault || !1,
        n = t && t.container || window,
        o = {},
        r = {
      keydown: {},
      keyup: {}
    },
        s = {};

    for (e = 97; e <= 122; e++) {
      s[String.fromCharCode(e)] = {
        code: e - 97 + 65,
        shift: !1
      };
    }

    for (e = 65; e <= 90; e++) {
      s[String.fromCharCode(e)] = {
        code: e,
        shift: !0
      };
    }

    for (e = 0; e <= 9; e++) {
      s["" + e] = {
        code: 48 + e,
        shift: !1
      };
    }

    for (e = 1; e <= 12; e++) {
      s["F" + e] = {
        code: 111 + e,
        shift: !1
      };
    }

    for (e = 0; e <= 9; e++) {
      s["num" + e] = {
        code: 96 + e,
        shift: !1
      };
    }

    s["num*"] = {
      code: 106,
      shift: !1
    }, s["num+"] = {
      code: 107,
      shift: !1
    }, s["num-"] = {
      code: 109,
      shift: !1
    }, s["num/"] = {
      code: 111,
      shift: !1
    }, s["num."] = {
      code: 110,
      shift: !1
    }, s.left = {
      code: 37,
      shift: !1
    }, s.up = {
      code: 38,
      shift: !1
    }, s.right = {
      code: 39,
      shift: !1
    }, s.down = {
      code: 40,
      shift: !1
    }, s.space = {
      code: 32,
      shift: !1
    }, s.enter = {
      code: 13,
      shift: !1
    }, s.shift = {
      code: 16,
      shift: void 0
    }, s.esc = {
      code: 27,
      shift: !1
    }, s.backspace = {
      code: 8,
      shift: !1
    }, s.tab = {
      code: 9,
      shift: !1
    }, s.ctrl = {
      code: 17,
      shift: !1
    }, s.alt = {
      code: 18,
      shift: !1
    }, s.delete = {
      code: 46,
      shift: !1
    }, s.pageup = {
      code: 33,
      shift: !1
    }, s.pagedown = {
      code: 34,
      shift: !1
    }, s["="] = {
      code: 187,
      shift: !1
    }, s["-"] = {
      code: 189,
      shift: !1
    }, s["]"] = {
      code: 221,
      shift: !1
    }, s["["] = {
      code: 219,
      shift: !1
    };

    var a = function a(t) {
      h(t, "keydown");
    },
        l = function l(t) {
      h(t, "keyup");
    },
        h = function h(t, e) {
      if (void 0 !== r[e][t.keyCode]) {
        for (var n = r[e][t.keyCode], o = 0; o < n.length; o++) {
          (void 0 === n[o].shift || 1 == n[o].shift && 1 == t.shiftKey || 0 == n[o].shift && 0 == t.shiftKey) && n[o].fn(t);
        }

        1 == i && t.preventDefault();
      }
    };

    return o.bind = function (t, e, i) {
      if (void 0 === i && (i = "keydown"), void 0 === s[t]) throw new Error("unsupported key: " + t);
      void 0 === r[i][s[t].code] && (r[i][s[t].code] = []), r[i][s[t].code].push({
        fn: e,
        shift: s[t].shift
      });
    }, o.bindAll = function (t, e) {
      for (var i in void 0 === e && (e = "keydown"), s) {
        s.hasOwnProperty(i) && o.bind(i, t, e);
      }
    }, o.getKey = function (t) {
      for (var e in s) {
        if (s.hasOwnProperty(e)) {
          if (1 == t.shiftKey && 1 == s[e].shift && t.keyCode == s[e].code) return e;
          if (0 == t.shiftKey && 0 == s[e].shift && t.keyCode == s[e].code) return e;
          if (t.keyCode == s[e].code && "shift" == e) return e;
        }
      }

      return "unknown key, currently not supported";
    }, o.unbind = function (t, e, i) {
      if (void 0 === i && (i = "keydown"), void 0 === s[t]) throw new Error("unsupported key: " + t);

      if (void 0 !== e) {
        var n = [],
            o = r[i][s[t].code];
        if (void 0 !== o) for (var a = 0; a < o.length; a++) {
          o[a].fn == e && o[a].shift == s[t].shift || n.push(r[i][s[t].code][a]);
        }
        r[i][s[t].code] = n;
      } else r[i][s[t].code] = [];
    }, o.reset = function () {
      r = {
        keydown: {},
        keyup: {}
      };
    }, o.destroy = function () {
      r = {
        keydown: {},
        keyup: {}
      }, n.removeEventListener("keydown", a, !0), n.removeEventListener("keyup", l, !0);
    }, n.addEventListener("keydown", a, !0), n.addEventListener("keyup", l, !0), o;
  }

  function Hd(t) {
    var e, i;
    this.active = !1, this.dom = {
      container: t
    }, this.dom.overlay = document.createElement("div"), this.dom.overlay.className = "vis-overlay", this.dom.container.appendChild(this.dom.overlay), this.hammer = Ld(this.dom.overlay), this.hammer.on("tap", ur(e = this._onTapOverlay).call(e, this));
    var n = this,
        o = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];
    nr(o).call(o, function (t) {
      n.hammer.on(t, function (t) {
        t.stopPropagation();
      });
    }), document && document.body && (this.onClick = function (e) {
      (function (t, e) {
        for (; t;) {
          if (t === e) return !0;
          t = t.parentNode;
        }

        return !1;
      })(e.target, t) || n.deactivate();
    }, document.body.addEventListener("click", this.onClick)), void 0 !== this.keycharm && this.keycharm.destroy(), this.keycharm = jd(), this.escListener = ur(i = this.deactivate).call(i, this);
  }

  ds(Hd.prototype), Hd.current = null, Hd.prototype.destroy = function () {
    this.deactivate(), this.dom.overlay.parentNode.removeChild(this.dom.overlay), this.onClick && document.body.removeEventListener("click", this.onClick), void 0 !== this.keycharm && this.keycharm.destroy(), this.keycharm = null, this.hammer.destroy(), this.hammer = null;
  }, Hd.prototype.activate = function () {
    var t;
    Hd.current && Hd.current.deactivate(), Hd.current = this, this.active = !0, this.dom.overlay.style.display = "none", od.addClassName(this.dom.container, "vis-active"), this.emit("change"), this.emit("activate"), ur(t = this.keycharm).call(t, "esc", this.escListener);
  }, Hd.prototype.deactivate = function () {
    Hd.current === this && (Hd.current = null), this.active = !1, this.dom.overlay.style.display = "", od.removeClassName(this.dom.container, "vis-active"), this.keycharm.unbind("esc", this.escListener), this.emit("change"), this.emit("deactivate");
  }, Hd.prototype._onTapOverlay = function (t) {
    this.activate(), t.stopPropagation();
  };
  var zd = {
    current: "current",
    time: "time",
    deleteSelected: "Delete selected"
  },
      Gd = {
    current: "attuale",
    time: "tempo",
    deleteSelected: "Cancella la selezione"
  },
      Wd = {
    current: "huidige",
    time: "tijd",
    deleteSelected: "Selectie verwijderen"
  },
      Bd = {
    current: "Aktuelle",
    time: "Zeit",
    deleteSelected: "Lösche Auswahl"
  },
      Vd = {
    current: "actuel",
    time: "heure",
    deleteSelected: "Effacer la selection"
  },
      Ud = {
    current: "corriente",
    time: "hora",
    deleteSelected: "Eliminar selección"
  },
      Xd = {
    current: "поточний",
    time: "час",
    deleteSelected: "Видалити обране"
  },
      qd = {
    current: "текущее",
    time: "время",
    deleteSelected: "Удалить выбранное"
  },
      Zd = {
    current: "aktualny",
    time: "czas",
    deleteSelected: "Usuń wybrane"
  },
      $d = {
    current: "atual",
    time: "data",
    deleteSelected: "Apagar selecionado"
  },
      Kd = {
    current: "現在",
    time: "時刻",
    deleteSelected: "選択されたものを削除"
  },
      Jd = {
    en: zd,
    en_EN: zd,
    en_US: zd,
    it: Gd,
    it_IT: Gd,
    it_CH: Gd,
    nl: Wd,
    nl_NL: Wd,
    nl_BE: Wd,
    de: Bd,
    de_DE: Bd,
    fr: Vd,
    fr_FR: Vd,
    fr_CA: Vd,
    fr_BE: Vd,
    es: Ud,
    es_ES: Ud,
    uk: Xd,
    uk_UA: Xd,
    ru: qd,
    ru_RU: qd,
    pl: Zd,
    pl_PL: Zd,
    pt: $d,
    pt_BR: $d,
    pt_PT: $d,
    ja: Kd,
    ja_JP: Kd
  };

  function Qd(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var tp = function (t) {
    jh(i, t);
    var e = Qd(i);

    function i(t, n) {
      var o, r;
      gn(this, i), (r = e.call(this)).body = t, r.defaultOptions = {
        moment: Qu,
        locales: Jd,
        locale: "en",
        id: void 0,
        title: void 0
      }, r.options = od.extend({}, r.defaultOptions), r.setOptions(n), r.options.locales = od.extend({}, Jd, r.options.locales);
      var s = r.defaultOptions.locales[r.defaultOptions.locale];
      return nr(o = Vr(r.options.locales)).call(o, function (t) {
        r.options.locales[t] = od.extend({}, s, r.options.locales[t]);
      }), n && null != n.time ? r.customTime = n.time : r.customTime = new Date(), r.eventParams = {}, r._create(), r;
    }

    return _n(i, [{
      key: "setOptions",
      value: function value(t) {
        t && od.selectiveExtend(["moment", "locale", "locales", "id", "title", "rtl", "snap"], this.options, t);
      }
    }, {
      key: "_create",
      value: function value() {
        var t,
            e,
            i,
            n = document.createElement("div");
        n["custom-time"] = this, n.className = "vis-custom-time ".concat(this.options.id || ""), n.style.position = "absolute", n.style.top = "0px", n.style.height = "100%", this.bar = n;
        var o = document.createElement("div");

        function r(t) {
          this.body.range._onMouseWheel(t);
        }

        o.style.position = "relative", o.style.top = "0px", this.options.rtl ? o.style.right = "-10px" : o.style.left = "-10px", o.style.height = "100%", o.style.width = "20px", o.addEventListener ? (o.addEventListener("mousewheel", ur(r).call(r, this), !1), o.addEventListener("DOMMouseScroll", ur(r).call(r, this), !1)) : o.attachEvent("onmousewheel", ur(r).call(r, this)), n.appendChild(o), this.hammer = new Ld(o), this.hammer.on("panstart", ur(t = this._onDragStart).call(t, this)), this.hammer.on("panmove", ur(e = this._onDrag).call(e, this)), this.hammer.on("panend", ur(i = this._onDragEnd).call(i, this)), this.hammer.get("pan").set({
          threshold: 5,
          direction: Ld.DIRECTION_ALL
        });
      }
    }, {
      key: "destroy",
      value: function value() {
        this.hide(), this.hammer.destroy(), this.hammer = null, this.body = null;
      }
    }, {
      key: "redraw",
      value: function value() {
        var t = this.body.dom.backgroundVertical;
        this.bar.parentNode != t && (this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), t.appendChild(this.bar));
        var e = this.body.util.toScreen(this.customTime),
            i = this.options.locales[this.options.locale];
        i || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), i = this.options.locales.en);
        var n,
            o = this.options.title;
        void 0 === o ? o = (o = us(n = "".concat(i.time, ": ")).call(n, this.options.moment(this.customTime).format("dddd, MMMM Do YYYY, H:mm:ss"))).charAt(0).toUpperCase() + o.substring(1) : "function" == typeof o && (o = o.call(this, this.customTime));
        return this.options.rtl ? this.bar.style.right = "".concat(e, "px") : this.bar.style.left = "".concat(e, "px"), this.bar.title = o, !1;
      }
    }, {
      key: "hide",
      value: function value() {
        this.bar.parentNode && this.bar.parentNode.removeChild(this.bar);
      }
    }, {
      key: "setCustomTime",
      value: function value(t) {
        this.customTime = od.convert(t, "Date"), this.redraw();
      }
    }, {
      key: "getCustomTime",
      value: function value() {
        return new Date(this.customTime.valueOf());
      }
    }, {
      key: "setCustomMarker",
      value: function value(t, e) {
        var i,
            n,
            o = document.createElement("div");
        (o.className = "vis-custom-time-marker", o.innerHTML = od.xss(t), o.style.position = "absolute", e) && (o.setAttribute("contenteditable", "true"), o.addEventListener("pointerdown", function () {
          o.focus();
        }), o.addEventListener("input", ur(i = this._onMarkerChange).call(i, this)), o.title = t, o.addEventListener("blur", ur(n = function n(t) {
          this.title != t.target.innerHTML && (this._onMarkerChanged(t), this.title = t.target.innerHTML);
        }).call(n, this)));
        this.bar.appendChild(o);
      }
    }, {
      key: "setCustomTitle",
      value: function value(t) {
        this.options.title = t;
      }
    }, {
      key: "_onDragStart",
      value: function value(t) {
        this.eventParams.dragging = !0, this.eventParams.customTime = this.customTime, t.stopPropagation();
      }
    }, {
      key: "_onDrag",
      value: function value(t) {
        if (this.eventParams.dragging) {
          var e = this.options.rtl ? -1 * t.deltaX : t.deltaX,
              i = this.body.util.toScreen(this.eventParams.customTime) + e,
              n = this.body.util.toTime(i),
              o = this.body.util.getScale(),
              r = this.body.util.getStep(),
              s = this.options.snap,
              a = s ? s(n, o, r) : n;
          this.setCustomTime(a), this.body.emitter.emit("timechange", {
            id: this.options.id,
            time: new Date(this.customTime.valueOf()),
            event: t
          }), t.stopPropagation();
        }
      }
    }, {
      key: "_onDragEnd",
      value: function value(t) {
        this.eventParams.dragging && (this.body.emitter.emit("timechanged", {
          id: this.options.id,
          time: new Date(this.customTime.valueOf()),
          event: t
        }), t.stopPropagation());
      }
    }, {
      key: "_onMarkerChange",
      value: function value(t) {
        this.body.emitter.emit("markerchange", {
          id: this.options.id,
          title: t.target.innerHTML,
          event: t
        }), t.stopPropagation();
      }
    }, {
      key: "_onMarkerChanged",
      value: function value(t) {
        this.body.emitter.emit("markerchanged", {
          id: this.options.id,
          title: t.target.innerHTML,
          event: t
        }), t.stopPropagation();
      }
    }], [{
      key: "customTimeFromTarget",
      value: function value(t) {
        for (var e = t.target; e;) {
          if (e.hasOwnProperty("custom-time")) return e["custom-time"];
          e = e.parentNode;
        }

        return null;
      }
    }]), i;
  }(hd),
      ep = function () {
    function t() {
      gn(this, t);
    }

    return _n(t, [{
      key: "_create",
      value: function value(t) {
        var e,
            i,
            n,
            o = this;
        this.dom = {}, this.dom.container = t, this.dom.container.style.position = "relative", this.dom.root = document.createElement("div"), this.dom.background = document.createElement("div"), this.dom.backgroundVertical = document.createElement("div"), this.dom.backgroundHorizontal = document.createElement("div"), this.dom.centerContainer = document.createElement("div"), this.dom.leftContainer = document.createElement("div"), this.dom.rightContainer = document.createElement("div"), this.dom.center = document.createElement("div"), this.dom.left = document.createElement("div"), this.dom.right = document.createElement("div"), this.dom.top = document.createElement("div"), this.dom.bottom = document.createElement("div"), this.dom.shadowTop = document.createElement("div"), this.dom.shadowBottom = document.createElement("div"), this.dom.shadowTopLeft = document.createElement("div"), this.dom.shadowBottomLeft = document.createElement("div"), this.dom.shadowTopRight = document.createElement("div"), this.dom.shadowBottomRight = document.createElement("div"), this.dom.rollingModeBtn = document.createElement("div"), this.dom.loadingScreen = document.createElement("div"), this.dom.root.className = "vis-timeline", this.dom.background.className = "vis-panel vis-background", this.dom.backgroundVertical.className = "vis-panel vis-background vis-vertical", this.dom.backgroundHorizontal.className = "vis-panel vis-background vis-horizontal", this.dom.centerContainer.className = "vis-panel vis-center", this.dom.leftContainer.className = "vis-panel vis-left", this.dom.rightContainer.className = "vis-panel vis-right", this.dom.top.className = "vis-panel vis-top", this.dom.bottom.className = "vis-panel vis-bottom", this.dom.left.className = "vis-content", this.dom.center.className = "vis-content", this.dom.right.className = "vis-content", this.dom.shadowTop.className = "vis-shadow vis-top", this.dom.shadowBottom.className = "vis-shadow vis-bottom", this.dom.shadowTopLeft.className = "vis-shadow vis-top", this.dom.shadowBottomLeft.className = "vis-shadow vis-bottom", this.dom.shadowTopRight.className = "vis-shadow vis-top", this.dom.shadowBottomRight.className = "vis-shadow vis-bottom", this.dom.rollingModeBtn.className = "vis-rolling-mode-btn", this.dom.loadingScreen.className = "vis-loading-screen", this.dom.root.appendChild(this.dom.background), this.dom.root.appendChild(this.dom.backgroundVertical), this.dom.root.appendChild(this.dom.backgroundHorizontal), this.dom.root.appendChild(this.dom.centerContainer), this.dom.root.appendChild(this.dom.leftContainer), this.dom.root.appendChild(this.dom.rightContainer), this.dom.root.appendChild(this.dom.top), this.dom.root.appendChild(this.dom.bottom), this.dom.root.appendChild(this.dom.rollingModeBtn), this.dom.centerContainer.appendChild(this.dom.center), this.dom.leftContainer.appendChild(this.dom.left), this.dom.rightContainer.appendChild(this.dom.right), this.dom.centerContainer.appendChild(this.dom.shadowTop), this.dom.centerContainer.appendChild(this.dom.shadowBottom), this.dom.leftContainer.appendChild(this.dom.shadowTopLeft), this.dom.leftContainer.appendChild(this.dom.shadowBottomLeft), this.dom.rightContainer.appendChild(this.dom.shadowTopRight), this.dom.rightContainer.appendChild(this.dom.shadowBottomRight), this.props = {
          root: {},
          background: {},
          centerContainer: {},
          leftContainer: {},
          rightContainer: {},
          center: {},
          left: {},
          right: {},
          top: {},
          bottom: {},
          border: {},
          scrollTop: 0,
          scrollTopMin: 0
        }, this.on("rangechange", function () {
          !0 === o.initialDrawDone && o._redraw();
        }), this.on("rangechanged", function () {
          o.initialRangeChangeDone || (o.initialRangeChangeDone = !0);
        }), this.on("touch", ur(e = this._onTouch).call(e, this)), this.on("panmove", ur(i = this._onDrag).call(i, this));
        var r = this;
        this._origRedraw = ur(n = this._redraw).call(n, this), this._redraw = od.throttle(this._origRedraw), this.on("_change", function (t) {
          r.itemSet && r.itemSet.initialItemSetDrawn && t && 1 == t.queue ? r._redraw() : r._origRedraw();
        }), this.hammer = new Ld(this.dom.root);
        var s = this.hammer.get("pinch").set({
          enable: !0
        });
        s && function (t) {
          t.getTouchAction = function () {
            return ["pan-y"];
          };
        }(s), this.hammer.get("pan").set({
          threshold: 5,
          direction: Ld.DIRECTION_ALL
        }), this.timelineListeners = {};
        var a,
            l,
            h = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];

        function u(t) {
          this.isActive() && this.emit("mousewheel", t);
          var e = 0,
              i = 0;

          if ("detail" in t && (i = -1 * t.detail), "wheelDelta" in t && (i = t.wheelDelta), "wheelDeltaY" in t && (i = t.wheelDeltaY), "wheelDeltaX" in t && (e = -1 * t.wheelDeltaX), "axis" in t && t.axis === t.HORIZONTAL_AXIS && (e = -1 * i, i = 0), "deltaY" in t && (i = -1 * t.deltaY), "deltaX" in t && (e = t.deltaX), t.deltaMode && (1 === t.deltaMode ? (e *= 40, i *= 40) : (e *= 40, i *= 800)), this.options.preferZoom) {
            if (!this.options.zoomKey || t[this.options.zoomKey]) return;
          } else if (this.options.zoomKey && t[this.options.zoomKey]) return;

          if (this.options.verticalScroll || this.options.horizontalScroll) if (this.options.verticalScroll && Math.abs(i) >= Math.abs(e)) {
            var n = this.props.scrollTop,
                o = n + i;
            if (this.isActive()) this._setScrollTop(o) !== n && (this._redraw(), this.emit("scroll", t), t.preventDefault());
          } else if (this.options.horizontalScroll) {
            var r = (Math.abs(e) >= Math.abs(i) ? e : i) / 120 * (this.range.end - this.range.start) / 20,
                s = this.range.start + r,
                a = this.range.end + r,
                l = {
              animation: !1,
              byUser: !0,
              event: t
            };
            this.range.setRange(s, a, l), t.preventDefault();
          }
        }

        nr(h).call(h, function (t) {
          var e = function e(_e4) {
            r.isActive() && r.emit(t, _e4);
          };

          r.hammer.on(t, e), r.timelineListeners[t] = e;
        }), Id(this.hammer, function (t) {
          r.emit("touch", t);
        }), a = this.hammer, (l = function l(t) {
          r.emit("release", t);
        }).inputHandler = function (t) {
          t.isFinal && l(t);
        }, a.on("hammer.input", l.inputHandler);
        var c = "onwheel" in document.createElement("div") ? "wheel" : void 0 !== document.onmousewheel ? "mousewheel" : this.dom.centerContainer.addEventListener ? "DOMMouseScroll" : "onmousewheel";

        function d(t) {
          if (r.options.verticalScroll && (t.preventDefault(), r.isActive())) {
            var e = -t.target.scrollTop;
            r._setScrollTop(e), r._redraw(), r.emit("scrollSide", t);
          }
        }

        this.dom.top.addEventListener, this.dom.bottom.addEventListener, this.dom.centerContainer.addEventListener(c, ur(u).call(u, this), !1), this.dom.top.addEventListener(c, ur(u).call(u, this), !1), this.dom.bottom.addEventListener(c, ur(u).call(u, this), !1), this.dom.left.parentNode.addEventListener("scroll", ur(d).call(d, this)), this.dom.right.parentNode.addEventListener("scroll", ur(d).call(d, this));
        var p = !1;

        function f(t) {
          var e;
          if (t.preventDefault && (r.emit("dragover", r.getEventProperties(t)), t.preventDefault()), qn(e = t.target.className).call(e, "timeline") > -1 && !p) return t.dataTransfer.dropEffect = "move", p = !0, !1;
        }

        function m(t) {
          t.preventDefault && t.preventDefault(), t.stopPropagation && t.stopPropagation();

          try {
            var e = JSON.parse(t.dataTransfer.getData("text"));
            if (!e || !e.content) return;
          } catch (t) {
            return !1;
          }

          return p = !1, t.center = {
            x: t.clientX,
            y: t.clientY
          }, "item" !== e.target ? r.itemSet._onAddItem(t) : r.itemSet._onDropObjectOnItem(t), r.emit("drop", r.getEventProperties(t)), !1;
        }

        if (this.dom.center.addEventListener("dragover", ur(f).call(f, this), !1), this.dom.center.addEventListener("drop", ur(m).call(m, this), !1), this.customTimes = [], this.touch = {}, this.redrawCount = 0, this.initialDrawDone = !1, this.initialRangeChangeDone = !1, !t) throw new Error("No container provided");
        t.appendChild(this.dom.root), t.appendChild(this.dom.loadingScreen);
      }
    }, {
      key: "setOptions",
      value: function value(t) {
        var e;

        if (t) {
          if (od.selectiveExtend(["width", "height", "minHeight", "maxHeight", "autoResize", "start", "end", "clickToUse", "dataAttributes", "hiddenDates", "locale", "locales", "moment", "preferZoom", "rtl", "zoomKey", "horizontalScroll", "verticalScroll", "longSelectPressTime", "snap"], this.options, t), this.dom.rollingModeBtn.style.visibility = "hidden", this.options.rtl && (this.dom.container.style.direction = "rtl", this.dom.backgroundVertical.className = "vis-panel vis-background vis-vertical-rtl"), this.options.verticalScroll && (this.options.rtl ? this.dom.rightContainer.className = "vis-panel vis-right vis-vertical-scroll" : this.dom.leftContainer.className = "vis-panel vis-left vis-vertical-scroll"), "object" !== es(this.options.orientation) && (this.options.orientation = {
            item: void 0,
            axis: void 0
          }), "orientation" in t && ("string" == typeof t.orientation ? this.options.orientation = {
            item: t.orientation,
            axis: t.orientation
          } : "object" === es(t.orientation) && ("item" in t.orientation && (this.options.orientation.item = t.orientation.item), "axis" in t.orientation && (this.options.orientation.axis = t.orientation.axis))), "both" === this.options.orientation.axis) {
            if (!this.timeAxis2) {
              var i = this.timeAxis2 = new Fd(this.body);
              i.setOptions = function (t) {
                var e = t ? od.extend({}, t) : {};
                e.orientation = "top", Fd.prototype.setOptions.call(i, e);
              }, this.components.push(i);
            }
          } else if (this.timeAxis2) {
            var n,
                o,
                r = qn(n = this.components).call(n, this.timeAxis2);
            if (-1 !== r) Bo(o = this.components).call(o, r, 1);
            this.timeAxis2.destroy(), this.timeAxis2 = null;
          }

          "function" == typeof t.drawPoints && (t.drawPoints = {
            onRender: t.drawPoints
          }), "hiddenDates" in this.options && pd(this.options.moment, this.body, this.options.hiddenDates), "clickToUse" in t && (t.clickToUse ? this.activator || (this.activator = new Hd(this.dom.root)) : this.activator && (this.activator.destroy(), delete this.activator)), this._initAutoResize();
        }

        if (nr(e = this.components).call(e, function (e) {
          return e.setOptions(t);
        }), "configure" in t) {
          var s;
          this.configurator || (this.configurator = this._createConfigurator()), this.configurator.setOptions(t.configure);
          var a = od.deepExtend({}, this.options);
          nr(s = this.components).call(s, function (t) {
            od.deepExtend(a, t.options);
          }), this.configurator.setModuleOptions({
            global: a
          });
        }

        this._redraw();
      }
    }, {
      key: "isActive",
      value: function value() {
        return !this.activator || this.activator.active;
      }
    }, {
      key: "destroy",
      value: function value() {
        var t;

        for (var e in this.setItems(null), this.setGroups(null), this.off(), this._stopAutoResize(), this.dom.root.parentNode && this.dom.root.parentNode.removeChild(this.dom.root), this.dom = null, this.activator && (this.activator.destroy(), delete this.activator), this.timelineListeners) {
          this.timelineListeners.hasOwnProperty(e) && delete this.timelineListeners[e];
        }

        this.timelineListeners = null, this.hammer && this.hammer.destroy(), this.hammer = null, nr(t = this.components).call(t, function (t) {
          return t.destroy();
        }), this.body = null;
      }
    }, {
      key: "setCustomTime",
      value: function value(t, e) {
        var i,
            n = yo(i = this.customTimes).call(i, function (t) {
          return e === t.options.id;
        });
        if (0 === n.length) throw new Error("No custom time bar found with id ".concat(vn(e)));
        n.length > 0 && n[0].setCustomTime(t);
      }
    }, {
      key: "getCustomTime",
      value: function value(t) {
        var e,
            i = yo(e = this.customTimes).call(e, function (e) {
          return e.options.id === t;
        });
        if (0 === i.length) throw new Error("No custom time bar found with id ".concat(vn(t)));
        return i[0].getCustomTime();
      }
    }, {
      key: "setCustomTimeMarker",
      value: function value(t, e, i) {
        var n,
            o = yo(n = this.customTimes).call(n, function (t) {
          return t.options.id === e;
        });
        if (0 === o.length) throw new Error("No custom time bar found with id ".concat(vn(e)));
        o.length > 0 && o[0].setCustomMarker(t, i);
      }
    }, {
      key: "setCustomTimeTitle",
      value: function value(t, e) {
        var i,
            n = yo(i = this.customTimes).call(i, function (t) {
          return t.options.id === e;
        });
        if (0 === n.length) throw new Error("No custom time bar found with id ".concat(vn(e)));
        if (n.length > 0) return n[0].setCustomTitle(t);
      }
    }, {
      key: "getEventProperties",
      value: function value(t) {
        return {
          event: t
        };
      }
    }, {
      key: "addCustomTime",
      value: function value(t, e) {
        var i,
            n = void 0 !== t ? od.convert(t, "Date") : new Date();
        if (Nh(i = this.customTimes).call(i, function (t) {
          return t.options.id === e;
        })) throw new Error("A custom time with id ".concat(vn(e), " already exists"));
        var o = new tp(this.body, od.extend({}, this.options, {
          time: n,
          id: e,
          snap: this.itemSet ? this.itemSet.options.snap : this.options.snap
        }));
        return this.customTimes.push(o), this.components.push(o), this._redraw(), e;
      }
    }, {
      key: "removeCustomTime",
      value: function value(t) {
        var e,
            i = this,
            n = yo(e = this.customTimes).call(e, function (e) {
          return e.options.id === t;
        });
        if (0 === n.length) throw new Error("No custom time bar found with id ".concat(vn(t)));
        nr(n).call(n, function (t) {
          var e, n, o, r;
          Bo(e = i.customTimes).call(e, qn(n = i.customTimes).call(n, t), 1), Bo(o = i.components).call(o, qn(r = i.components).call(r, t), 1), t.destroy();
        });
      }
    }, {
      key: "getVisibleItems",
      value: function value() {
        return this.itemSet && this.itemSet.getVisibleItems() || [];
      }
    }, {
      key: "getVisibleGroups",
      value: function value() {
        return this.itemSet && this.itemSet.getVisibleGroups() || [];
      }
    }, {
      key: "fit",
      value: function value(t, e) {
        var i = this.getDataRange();

        if (null !== i.min || null !== i.max) {
          var n = i.max - i.min,
              o = new Date(i.min.valueOf() - .01 * n),
              r = new Date(i.max.valueOf() + .01 * n),
              s = !t || void 0 === t.animation || t.animation;
          this.range.setRange(o, r, {
            animation: s
          }, e);
        }
      }
    }, {
      key: "getDataRange",
      value: function value() {
        throw new Error("Cannot invoke abstract method getDataRange");
      }
    }, {
      key: "setWindow",
      value: function value(t, e, i, n) {
        var o, r;
        "function" == typeof arguments[2] && (n = arguments[2], i = {}), 1 == arguments.length ? (o = void 0 === (r = arguments[0]).animation || r.animation, this.range.setRange(r.start, r.end, {
          animation: o
        })) : 2 == arguments.length && "function" == typeof arguments[1] ? (n = arguments[1], o = void 0 === (r = arguments[0]).animation || r.animation, this.range.setRange(r.start, r.end, {
          animation: o
        }, n)) : (o = !i || void 0 === i.animation || i.animation, this.range.setRange(t, e, {
          animation: o
        }, n));
      }
    }, {
      key: "moveTo",
      value: function value(t, e, i) {
        "function" == typeof arguments[1] && (i = arguments[1], e = {});
        var n = this.range.end - this.range.start,
            o = od.convert(t, "Date").valueOf(),
            r = o - n / 2,
            s = o + n / 2,
            a = !e || void 0 === e.animation || e.animation;
        this.range.setRange(r, s, {
          animation: a
        }, i);
      }
    }, {
      key: "getWindow",
      value: function value() {
        var t = this.range.getRange();
        return {
          start: new Date(t.start),
          end: new Date(t.end)
        };
      }
    }, {
      key: "zoomIn",
      value: function value(t, e, i) {
        if (!(!t || t < 0 || t > 1)) {
          "function" == typeof arguments[1] && (i = arguments[1], e = {});
          var n = this.getWindow(),
              o = n.start.valueOf(),
              r = n.end.valueOf(),
              s = r - o,
              a = s / (1 + t),
              l = (s - a) / 2,
              h = o + l,
              u = r - l;
          this.setWindow(h, u, e, i);
        }
      }
    }, {
      key: "zoomOut",
      value: function value(t, e, i) {
        if (!(!t || t < 0 || t > 1)) {
          "function" == typeof arguments[1] && (i = arguments[1], e = {});
          var n = this.getWindow(),
              o = n.start.valueOf(),
              r = n.end.valueOf(),
              s = r - o,
              a = o - s * t / 2,
              l = r + s * t / 2;
          this.setWindow(a, l, e, i);
        }
      }
    }, {
      key: "redraw",
      value: function value() {
        this._redraw();
      }
    }, {
      key: "_redraw",
      value: function value() {
        var t;
        this.redrawCount++;
        var e = this.dom;

        if (e && e.container && 0 != e.root.offsetWidth) {
          var i = !1,
              n = this.options,
              o = this.props;
          fd(this.options.moment, this.body, this.options.hiddenDates), "top" == n.orientation ? (od.addClassName(e.root, "vis-top"), od.removeClassName(e.root, "vis-bottom")) : (od.removeClassName(e.root, "vis-top"), od.addClassName(e.root, "vis-bottom")), n.rtl ? (od.addClassName(e.root, "vis-rtl"), od.removeClassName(e.root, "vis-ltr")) : (od.addClassName(e.root, "vis-ltr"), od.removeClassName(e.root, "vis-rtl")), e.root.style.maxHeight = od.option.asSize(n.maxHeight, ""), e.root.style.minHeight = od.option.asSize(n.minHeight, ""), e.root.style.width = od.option.asSize(n.width, "");
          var r = e.root.offsetWidth;
          o.border.left = 1, o.border.right = 1, o.border.top = 1, o.border.bottom = 1, o.center.height = e.center.offsetHeight, o.left.height = e.left.offsetHeight, o.right.height = e.right.offsetHeight, o.top.height = e.top.clientHeight || -o.border.top, o.bottom.height = Math.round(e.bottom.getBoundingClientRect().height) || e.bottom.clientHeight || -o.border.bottom;
          var s = Math.max(o.left.height, o.center.height, o.right.height),
              a = o.top.height + s + o.bottom.height + o.border.top + o.border.bottom;
          e.root.style.height = od.option.asSize(n.height, "".concat(a, "px")), o.root.height = e.root.offsetHeight, o.background.height = o.root.height;
          var l = o.root.height - o.top.height - o.bottom.height;
          o.centerContainer.height = l, o.leftContainer.height = l, o.rightContainer.height = o.leftContainer.height, o.root.width = r, o.background.width = o.root.width, this.initialDrawDone || (o.scrollbarWidth = od.getScrollBarWidth());
          var h = e.leftContainer.clientWidth,
              u = e.rightContainer.clientWidth;
          n.verticalScroll ? n.rtl ? (o.left.width = h || -o.border.left, o.right.width = u + o.scrollbarWidth || -o.border.right) : (o.left.width = h + o.scrollbarWidth || -o.border.left, o.right.width = u || -o.border.right) : (o.left.width = h || -o.border.left, o.right.width = u || -o.border.right), this._setDOM();

          var c = this._updateScrollTop();

          "top" != n.orientation.item && (c += Math.max(o.centerContainer.height - o.center.height - o.border.top - o.border.bottom, 0)), e.center.style.transform = "translateY(".concat(c, "px)");
          var d = 0 == o.scrollTop ? "hidden" : "",
              p = o.scrollTop == o.scrollTopMin ? "hidden" : "";
          e.shadowTop.style.visibility = d, e.shadowBottom.style.visibility = p, e.shadowTopLeft.style.visibility = d, e.shadowBottomLeft.style.visibility = p, e.shadowTopRight.style.visibility = d, e.shadowBottomRight.style.visibility = p, n.verticalScroll && (e.rightContainer.className = "vis-panel vis-right vis-vertical-scroll", e.leftContainer.className = "vis-panel vis-left vis-vertical-scroll", e.shadowTopRight.style.visibility = "hidden", e.shadowBottomRight.style.visibility = "hidden", e.shadowTopLeft.style.visibility = "hidden", e.shadowBottomLeft.style.visibility = "hidden", e.left.style.top = "0px", e.right.style.top = "0px"), (!n.verticalScroll || o.center.height < o.centerContainer.height) && (e.left.style.top = "".concat(c, "px"), e.right.style.top = "".concat(c, "px"), e.rightContainer.className = e.rightContainer.className.replace(new RegExp("(?:^|\\s)vis-vertical-scroll(?:\\s|$)"), " "), e.leftContainer.className = e.leftContainer.className.replace(new RegExp("(?:^|\\s)vis-vertical-scroll(?:\\s|$)"), " "), o.left.width = h || -o.border.left, o.right.width = u || -o.border.right, this._setDOM());
          var f = o.center.height > o.centerContainer.height;
          this.hammer.get("pan").set({
            direction: f ? Ld.DIRECTION_ALL : Ld.DIRECTION_HORIZONTAL
          }), this.hammer.get("press").set({
            time: this.options.longSelectPressTime
          }), nr(t = this.components).call(t, function (t) {
            i = t.redraw() || i;
          });

          if (i) {
            if (this.redrawCount < 5) return void this.body.emitter.emit("_change");
            console.log("WARNING: infinite loop in redraw?");
          } else this.redrawCount = 0;

          this.body.emitter.emit("changed");
        }
      }
    }, {
      key: "_setDOM",
      value: function value() {
        var t = this.props,
            e = this.dom;
        t.leftContainer.width = t.left.width, t.rightContainer.width = t.right.width;
        var i = t.root.width - t.left.width - t.right.width;
        t.center.width = i, t.centerContainer.width = i, t.top.width = i, t.bottom.width = i, e.background.style.height = "".concat(t.background.height, "px"), e.backgroundVertical.style.height = "".concat(t.background.height, "px"), e.backgroundHorizontal.style.height = "".concat(t.centerContainer.height, "px"), e.centerContainer.style.height = "".concat(t.centerContainer.height, "px"), e.leftContainer.style.height = "".concat(t.leftContainer.height, "px"), e.rightContainer.style.height = "".concat(t.rightContainer.height, "px"), e.background.style.width = "".concat(t.background.width, "px"), e.backgroundVertical.style.width = "".concat(t.centerContainer.width, "px"), e.backgroundHorizontal.style.width = "".concat(t.background.width, "px"), e.centerContainer.style.width = "".concat(t.center.width, "px"), e.top.style.width = "".concat(t.top.width, "px"), e.bottom.style.width = "".concat(t.bottom.width, "px"), e.background.style.left = "0", e.background.style.top = "0", e.backgroundVertical.style.left = "".concat(t.left.width + t.border.left, "px"), e.backgroundVertical.style.top = "0", e.backgroundHorizontal.style.left = "0", e.backgroundHorizontal.style.top = "".concat(t.top.height, "px"), e.centerContainer.style.left = "".concat(t.left.width, "px"), e.centerContainer.style.top = "".concat(t.top.height, "px"), e.leftContainer.style.left = "0", e.leftContainer.style.top = "".concat(t.top.height, "px"), e.rightContainer.style.left = "".concat(t.left.width + t.center.width, "px"), e.rightContainer.style.top = "".concat(t.top.height, "px"), e.top.style.left = "".concat(t.left.width, "px"), e.top.style.top = "0", e.bottom.style.left = "".concat(t.left.width, "px"), e.bottom.style.top = "".concat(t.top.height + t.centerContainer.height, "px"), e.center.style.left = "0", e.left.style.left = "0", e.right.style.left = "0";
      }
    }, {
      key: "setCurrentTime",
      value: function value(t) {
        if (!this.currentTime) throw new Error("Option showCurrentTime must be true");
        this.currentTime.setCurrentTime(t);
      }
    }, {
      key: "getCurrentTime",
      value: function value() {
        if (!this.currentTime) throw new Error("Option showCurrentTime must be true");
        return this.currentTime.getCurrentTime();
      }
    }, {
      key: "_toTime",
      value: function value(t) {
        return yd(this, t, this.props.center.width);
      }
    }, {
      key: "_toGlobalTime",
      value: function value(t) {
        return yd(this, t, this.props.root.width);
      }
    }, {
      key: "_toScreen",
      value: function value(t) {
        return gd(this, t, this.props.center.width);
      }
    }, {
      key: "_toGlobalScreen",
      value: function value(t) {
        return gd(this, t, this.props.root.width);
      }
    }, {
      key: "_initAutoResize",
      value: function value() {
        1 == this.options.autoResize ? this._startAutoResize() : this._stopAutoResize();
      }
    }, {
      key: "_startAutoResize",
      value: function value() {
        var t = this;
        this._stopAutoResize(), this._onResize = function () {
          if (1 == t.options.autoResize) {
            if (t.dom.root) {
              var e = t.dom.root.offsetHeight,
                  i = t.dom.root.offsetWidth;
              i == t.props.lastWidth && e == t.props.lastHeight || (t.props.lastWidth = i, t.props.lastHeight = e, t.props.scrollbarWidth = od.getScrollBarWidth(), t.body.emitter.emit("_change"));
            }
          } else t._stopAutoResize();
        }, od.addEventListener(window, "resize", this._onResize), t.dom.root && (t.props.lastWidth = t.dom.root.offsetWidth, t.props.lastHeight = t.dom.root.offsetHeight), this.watchTimer = Pd(this._onResize, 1e3);
      }
    }, {
      key: "_stopAutoResize",
      value: function value() {
        this.watchTimer && (clearInterval(this.watchTimer), this.watchTimer = void 0), this._onResize && (od.removeEventListener(window, "resize", this._onResize), this._onResize = null);
      }
    }, {
      key: "_onTouch",
      value: function value(t) {
        this.touch.allowDragging = !0, this.touch.initialScrollTop = this.props.scrollTop;
      }
    }, {
      key: "_onPinch",
      value: function value(t) {
        this.touch.allowDragging = !1;
      }
    }, {
      key: "_onDrag",
      value: function value(t) {
        if (t && this.touch.allowDragging) {
          var e = t.deltaY,
              i = this._getScrollTop(),
              n = this._setScrollTop(this.touch.initialScrollTop + e);

          this.options.verticalScroll && (this.dom.left.parentNode.scrollTop = -this.props.scrollTop, this.dom.right.parentNode.scrollTop = -this.props.scrollTop), n != i && this.emit("verticalDrag");
        }
      }
    }, {
      key: "_setScrollTop",
      value: function value(t) {
        return this.props.scrollTop = t, this._updateScrollTop(), this.props.scrollTop;
      }
    }, {
      key: "_updateScrollTop",
      value: function value() {
        var t = Math.min(this.props.centerContainer.height - this.props.border.top - this.props.border.bottom - this.props.center.height, 0);
        return t != this.props.scrollTopMin && ("top" != this.options.orientation.item && (this.props.scrollTop += t - this.props.scrollTopMin), this.props.scrollTopMin = t), this.props.scrollTop > 0 && (this.props.scrollTop = 0), this.props.scrollTop < t && (this.props.scrollTop = t), this.options.verticalScroll && (this.dom.left.parentNode.scrollTop = -this.props.scrollTop, this.dom.right.parentNode.scrollTop = -this.props.scrollTop), this.props.scrollTop;
      }
    }, {
      key: "_getScrollTop",
      value: function value() {
        return this.props.scrollTop;
      }
    }, {
      key: "_createConfigurator",
      value: function value() {
        throw new Error("Cannot invoke abstract method _createConfigurator");
      }
    }]), t;
  }();

  function ip(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  ds(ep.prototype);

  var np = function (t) {
    jh(i, t);
    var e = ip(i);

    function i(t, n) {
      var o, r;
      gn(this, i), (r = e.call(this)).body = t, r.defaultOptions = {
        rtl: !1,
        showCurrentTime: !0,
        alignCurrentTime: void 0,
        moment: Qu,
        locales: Jd,
        locale: "en"
      }, r.options = od.extend({}, r.defaultOptions), r.setOptions(n), r.options.locales = od.extend({}, Jd, r.options.locales);
      var s = r.defaultOptions.locales[r.defaultOptions.locale];
      return nr(o = Vr(r.options.locales)).call(o, function (t) {
        r.options.locales[t] = od.extend({}, s, r.options.locales[t]);
      }), r.offset = 0, r._create(), r;
    }

    return _n(i, [{
      key: "_create",
      value: function value() {
        var t = document.createElement("div");
        t.className = "vis-current-time", t.style.position = "absolute", t.style.top = "0px", t.style.height = "100%", this.bar = t;
      }
    }, {
      key: "destroy",
      value: function value() {
        this.options.showCurrentTime = !1, this.redraw(), this.body = null;
      }
    }, {
      key: "setOptions",
      value: function value(t) {
        t && od.selectiveExtend(["rtl", "showCurrentTime", "alignCurrentTime", "moment", "locale", "locales"], this.options, t);
      }
    }, {
      key: "redraw",
      value: function value() {
        if (this.options.showCurrentTime) {
          var t,
              e,
              i = this.body.dom.backgroundVertical;
          this.bar.parentNode != i && (this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), i.appendChild(this.bar), this.start());
          var n = this.options.moment(Wr() + this.offset);
          this.options.alignCurrentTime && (n = n.startOf(this.options.alignCurrentTime));
          var o = this.body.util.toScreen(n),
              r = this.options.locales[this.options.locale];
          r || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), r = this.options.locales.en);
          var s = us(t = us(e = "".concat(r.current, " ")).call(e, r.time, ": ")).call(t, n.format("dddd, MMMM Do YYYY, H:mm:ss"));
          s = s.charAt(0).toUpperCase() + s.substring(1), this.options.rtl ? this.bar.style.transform = "translateX(".concat(-1 * o, "px)") : this.bar.style.transform = "translateX(".concat(o, "px)"), this.bar.title = s;
        } else this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), this.stop();

        return !1;
      }
    }, {
      key: "start",
      value: function value() {
        var t = this;
        !function e() {
          t.stop();
          var i = 1 / t.body.range.conversion(t.body.domProps.center.width).scale / 10;
          i < 30 && (i = 30), i > 1e3 && (i = 1e3), t.redraw(), t.body.emitter.emit("currentTimeTick"), t.currentTimeTimer = hn(e, i);
        }();
      }
    }, {
      key: "stop",
      value: function value() {
        void 0 !== this.currentTimeTimer && (clearTimeout(this.currentTimeTimer), delete this.currentTimeTimer);
      }
    }, {
      key: "setCurrentTime",
      value: function value(t) {
        var e = od.convert(t, "Date").valueOf(),
            i = Wr();
        this.offset = e - i, this.redraw();
      }
    }, {
      key: "getCurrentTime",
      value: function value() {
        return new Date(Wr() + this.offset);
      }
    }]), i;
  }(hd),
      op = Te.find,
      rp = "find",
      sp = !0,
      ap = Hn(rp);

  rp in [] && Array(1).find(function () {
    sp = !1;
  }), U({
    target: "Array",
    proto: !0,
    forced: sp || !ap
  }, {
    find: function find(t) {
      return op(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var lp = tn("Array").find,
      hp = Array.prototype,
      up = function up(t) {
    var e = t.find;
    return t === hp || t instanceof Array && e === hp.find ? lp : e;
  },
      cp = .001;

  function dp(t) {
    $h(t).call(t, function (t, e) {
      return t.data.start - e.data.start;
    });
  }

  function pp(t) {
    $h(t).call(t, function (t, e) {
      return ("end" in t.data ? t.data.end : t.data.start) - ("end" in e.data ? e.data.end : e.data.start);
    });
  }

  function fp(t, e, i, n) {
    if (i) for (var o = 0; o < t.length; o++) {
      t[o].top = null;
    }

    for (o = 0; o < t.length; o++) {
      var r = t[o];

      if (r.stack && null === r.top) {
        r.top = e.axis;
        var s = !1;

        do {
          for (var a = null, l = 0, h = t.length; l < h; l++) {
            var u = t[l];
            if (s = n() || !1) return !0;

            if (null !== u.top && u !== r && u.stack && bp(r, u, e.item, u.options.rtl)) {
              a = u;
              break;
            }
          }

          null != a && (r.top = a.top + a.height + e.item.vertical);
        } while (a);
      }
    }

    return s;
  }

  function mp(t, e, i) {
    for (var n = 0; n < t.length; n++) {
      t[n].top = null;
    }

    var o = i.height;

    for (n = 0; n < t.length; n++) {
      var r = t[n];

      if (r.stack && null === r.top) {
        r.top = r.baseTop;

        do {
          for (var s = null, a = 0, l = t.length; a < l; a++) {
            var h = t[a];

            if (null !== h.top && h !== r && bp(r, h, e.item, h.options.rtl)) {
              s = h;
              break;
            }
          }

          null != s && (r.top = s.top + s.height + e.item.vertical), r.top + r.height > o && (o = r.top + r.height);
        } while (s);
      }
    }

    i.height = o - i.top + .5 * e.item.vertical;
  }

  function vp(t, e, i, n) {
    for (var o = 0; o < t.length; o++) {
      if (null == t[o].data.subgroup) t[o].top = e.item.vertical;else if (void 0 !== t[o].data.subgroup && n) {
        var r = 0;

        for (var s in i) {
          i.hasOwnProperty(s) && 1 == i[s].visible && i[s].index < i[t[o].data.subgroup].index && (r += i[s].height, i[t[o].data.subgroup].top = r);
        }

        t[o].top = r + .5 * e.item.vertical;
      }
    }

    n || gp(t, e, i);
  }

  function gp(t, e, i) {
    for (var n in i) {
      if (i.hasOwnProperty(n)) {
        i[n].top = 0;

        do {
          var o = null;

          for (var r in i) {
            if (null !== i[r].top && r !== n && i[n].index > i[r].index && _p(i[n], i[r])) {
              o = i[r];
              break;
            }
          }

          null != o && (i[n].top = o.top + o.height);
        } while (o);
      }
    }

    for (var s = 0; s < t.length; s++) {
      void 0 !== t[s].data.subgroup && (t[s].top = i[t[s].data.subgroup].top + .5 * e.item.vertical);
    }
  }

  function yp(t, e, i) {
    var n = !1,
        o = [];

    for (var r in i) {
      i[r].hasOwnProperty("index") ? o[i[r].index] = r : o.push(r);
    }

    for (var s = 0; s < o.length; s++) {
      if (r = o[s], i.hasOwnProperty(r)) {
        for (var a in n = n || i[r].stack, i[r].top = 0, i) {
          i[a].visible && i[r].index > i[a].index && (i[r].top += i[a].height);
        }

        for (var l = t[r], h = 0; h < l.length; h++) {
          void 0 !== l[h].data.subgroup && (l[h].top = i[l[h].data.subgroup].top + .5 * e.item.vertical, i[r].stack && (l[h].baseTop = l[h].top));
        }

        n && i[r].stack && mp(t[r], e, i[r]);
      }
    }
  }

  function bp(t, e, i, n) {
    return n ? t.right - i.horizontal + cp < e.right + e.width && t.right + t.width + i.horizontal - cp > e.right && t.top - i.vertical + cp < e.top + e.height && t.top + t.height + i.vertical - cp > e.top : t.left - i.horizontal + cp < e.left + e.width && t.left + t.width + i.horizontal - cp > e.left && t.top - i.vertical + cp < e.top + e.height && t.top + t.height + i.vertical - cp > e.top;
  }

  function _p(t, e) {
    var i = t.start < e.end && t.end > e.start,
        n = t.top < e.top + e.height && t.top + t.height > e.top;
    return i && n;
  }

  var wp = Object.freeze({
    __proto__: null,
    orderByStart: dp,
    orderByEnd: pp,
    stack: fp,
    substack: mp,
    nostack: vp,
    stackSubgroups: gp,
    stackSubgroupsWithInnerStack: yp,
    collision: bp,
    collisionByTimes: _p
  }),
      kp = "__background__",
      xp = function () {
    function t(e, i, n) {
      var o = this;
      if (gn(this, t), this.groupId = e, this.subgroups = {}, this.subgroupStack = {}, this.subgroupStackAll = !1, this.subgroupVisibility = {}, this.doInnerStack = !1, this.shouldBailStackItems = !1, this.subgroupIndex = 0, this.subgroupOrderer = i && i.subgroupOrder, this.itemSet = n, this.isVisible = null, this.stackDirty = !0, this._disposeCallbacks = [], i && i.nestedGroups && (this.nestedGroups = i.nestedGroups, 0 == i.showNested ? this.showNested = !1 : this.showNested = !0), i && i.subgroupStack) if ("boolean" == typeof i.subgroupStack) this.doInnerStack = i.subgroupStack, this.subgroupStackAll = i.subgroupStack;else for (var r in i.subgroupStack) {
        this.subgroupStack[r] = i.subgroupStack[r], this.doInnerStack = this.doInnerStack || i.subgroupStack[r];
      }
      i && i.heightMode ? this.heightMode = i.heightMode : this.heightMode = n.options.groupHeightMode, this.nestedInGroup = null, this.dom = {}, this.props = {
        label: {
          width: 0,
          height: 0
        }
      }, this.className = null, this.items = {}, this.visibleItems = [], this.itemsInRange = [], this.orderedItems = {
        byStart: [],
        byEnd: []
      }, this.checkRangedItems = !1;

      var s = function s() {
        o.checkRangedItems = !0;
      };

      this.itemSet.body.emitter.on("checkRangedItems", s), this._disposeCallbacks.push(function () {
        o.itemSet.body.emitter.off("checkRangedItems", s);
      }), this._create(), this.setData(i);
    }

    return _n(t, [{
      key: "_create",
      value: function value() {
        var t = document.createElement("div");
        this.itemSet.options.groupEditable.order ? t.className = "vis-label draggable" : t.className = "vis-label", this.dom.label = t;
        var e = document.createElement("div");
        e.className = "vis-inner", t.appendChild(e), this.dom.inner = e;
        var i = document.createElement("div");
        i.className = "vis-group", i["vis-group"] = this, this.dom.foreground = i, this.dom.background = document.createElement("div"), this.dom.background.className = "vis-group", this.dom.axis = document.createElement("div"), this.dom.axis.className = "vis-group", this.dom.marker = document.createElement("div"), this.dom.marker.style.visibility = "hidden", this.dom.marker.style.position = "absolute", this.dom.marker.innerHTML = "", this.dom.background.appendChild(this.dom.marker);
      }
    }, {
      key: "setData",
      value: function value(t) {
        if (!this.itemSet.groupTouchParams.isDragging) {
          var e, i, n;
          if (t && t.subgroupVisibility) for (var o in t.subgroupVisibility) {
            this.subgroupVisibility[o] = t.subgroupVisibility[o];
          }
          if (this.itemSet.options && this.itemSet.options.groupTemplate) e = (i = ur(n = this.itemSet.options.groupTemplate).call(n, this))(t, this.dom.inner);else e = t && t.content;

          if (e instanceof Element) {
            for (; this.dom.inner.firstChild;) {
              this.dom.inner.removeChild(this.dom.inner.firstChild);
            }

            this.dom.inner.appendChild(e);
          } else e instanceof Object && e.isReactComponent || (e instanceof Object ? i(t, this.dom.inner) : this.dom.inner.innerHTML = null != e ? od.xss(e) : od.xss(this.groupId || ""));

          this.dom.label.title = t && t.title || "", this.dom.inner.firstChild ? od.removeClassName(this.dom.inner, "vis-hidden") : od.addClassName(this.dom.inner, "vis-hidden"), t && t.nestedGroups ? (this.nestedGroups && this.nestedGroups == t.nestedGroups || (this.nestedGroups = t.nestedGroups), void 0 === t.showNested && void 0 !== this.showNested || (0 == t.showNested ? this.showNested = !1 : this.showNested = !0), od.addClassName(this.dom.label, "vis-nesting-group"), this.showNested ? (od.removeClassName(this.dom.label, "collapsed"), od.addClassName(this.dom.label, "expanded")) : (od.removeClassName(this.dom.label, "expanded"), od.addClassName(this.dom.label, "collapsed"))) : this.nestedGroups && (this.nestedGroups = null, od.removeClassName(this.dom.label, "collapsed"), od.removeClassName(this.dom.label, "expanded"), od.removeClassName(this.dom.label, "vis-nesting-group")), t && (t.treeLevel || t.nestedInGroup) ? (od.addClassName(this.dom.label, "vis-nested-group"), t.treeLevel ? od.addClassName(this.dom.label, "vis-group-level-" + t.treeLevel) : od.addClassName(this.dom.label, "vis-group-level-unknown-but-gte1")) : od.addClassName(this.dom.label, "vis-group-level-0");
          var r = t && t.className || null;
          r != this.className && (this.className && (od.removeClassName(this.dom.label, this.className), od.removeClassName(this.dom.foreground, this.className), od.removeClassName(this.dom.background, this.className), od.removeClassName(this.dom.axis, this.className)), od.addClassName(this.dom.label, r), od.addClassName(this.dom.foreground, r), od.addClassName(this.dom.background, r), od.addClassName(this.dom.axis, r), this.className = r), this.style && (od.removeCssText(this.dom.label, this.style), this.style = null), t && t.style && (od.addCssText(this.dom.label, t.style), this.style = t.style);
        }
      }
    }, {
      key: "getLabelWidth",
      value: function value() {
        return this.props.label.width;
      }
    }, {
      key: "_didMarkerHeightChange",
      value: function value() {
        var t = this.dom.marker.clientHeight;

        if (t != this.lastMarkerHeight) {
          this.lastMarkerHeight = t;
          var e = {},
              i = 0;
          if (nr(od).call(od, this.items, function (t, n) {
            if (t.dirty = !0, t.displayed) {
              e[n] = t.redraw(!0), i = e[n].length;
            }
          }), i > 0) for (var n = function n(t) {
            nr(od).call(od, e, function (e) {
              e[t]();
            });
          }, o = 0; o < i; o++) {
            n(o);
          }
          return !0;
        }

        return !1;
      }
    }, {
      key: "_calculateGroupSizeAndPosition",
      value: function value() {
        var t = this.dom.foreground,
            e = t.offsetTop,
            i = t.offsetLeft,
            n = t.offsetWidth;
        this.top = e, this.right = i, this.width = n;
      }
    }, {
      key: "_shouldBailItemsRedraw",
      value: function value() {
        var t = this,
            e = this.itemSet.options.onTimeout,
            i = {
          relativeBailingTime: this.itemSet.itemsSettingTime,
          bailTimeMs: e && e.timeoutMs,
          userBailFunction: e && e.callback,
          shouldBailStackItems: this.shouldBailStackItems
        },
            n = null;

        if (!this.itemSet.initialDrawDone) {
          if (i.shouldBailStackItems) return !0;
          Math.abs(Wr() - new Date(i.relativeBailingTime)) > i.bailTimeMs && (i.userBailFunction && null == this.itemSet.userContinueNotBail ? i.userBailFunction(function (e) {
            t.itemSet.userContinueNotBail = e, n = !e;
          }) : n = 0 == t.itemSet.userContinueNotBail);
        }

        return n;
      }
    }, {
      key: "_redrawItems",
      value: function value(t, e, i, n) {
        var o = this;

        if (t || this.stackDirty || this.isVisible && !e) {
          var r,
              s,
              a,
              l,
              h,
              u,
              c = {
            byEnd: yo(r = this.orderedItems.byEnd).call(r, function (t) {
              return !t.isCluster;
            }),
            byStart: yo(s = this.orderedItems.byStart).call(s, function (t) {
              return !t.isCluster;
            })
          },
              d = {
            byEnd: as(new fu(yo(a = Kr(l = this.orderedItems.byEnd).call(l, function (t) {
              return t.cluster;
            })).call(a, function (t) {
              return !!t;
            }))),
            byStart: as(new fu(yo(h = Kr(u = this.orderedItems.byStart).call(u, function (t) {
              return t.cluster;
            })).call(h, function (t) {
              return !!t;
            })))
          },
              p = function p() {
            var t,
                e,
                i,
                r = o._updateItemsInRange(c, yo(t = o.visibleItems).call(t, function (t) {
              return !t.isCluster;
            }), n),
                s = o._updateClustersInRange(d, yo(e = o.visibleItems).call(e, function (t) {
              return t.isCluster;
            }), n);

            return us(i = []).call(i, as(r), as(s));
          },
              f = function f(t) {
            var e = {},
                i = function i(_i2) {
              var n,
                  r = yo(n = o.visibleItems).call(n, function (t) {
                return t.data.subgroup === _i2;
              });
              e[_i2] = t ? $h(r).call(r, function (e, i) {
                return t(e.data, i.data);
              }) : r;
            };

            for (var n in o.subgroups) {
              i(n);
            }

            return e;
          };

          if ("function" == typeof this.itemSet.options.order) {
            var m = this;

            if (this.doInnerStack && this.itemSet.options.stackSubgroups) {
              yp(f(this.itemSet.options.order), i, this.subgroups), this.visibleItems = p(), this._updateSubGroupHeights(i);
            } else {
              var v, g, y, b;
              this.visibleItems = p(), this._updateSubGroupHeights(i);

              var _ = $h(v = yo(g = ns(y = this.visibleItems).call(y)).call(g, function (t) {
                return t.isCluster || !t.isCluster && !t.cluster;
              })).call(v, function (t, e) {
                return m.itemSet.options.order(t.data, e.data);
              });

              this.shouldBailStackItems = fp(_, i, !0, ur(b = this._shouldBailItemsRedraw).call(b, this));
            }
          } else {
            var w;
            if (this.visibleItems = p(), this._updateSubGroupHeights(i), this.itemSet.options.stack) {
              if (this.doInnerStack && this.itemSet.options.stackSubgroups) yp(f(), i, this.subgroups);else this.shouldBailStackItems = fp(this.visibleItems, i, !0, ur(w = this._shouldBailItemsRedraw).call(w, this));
            } else vp(this.visibleItems, i, this.subgroups, this.itemSet.options.stackSubgroups);
          }

          for (var k = 0; k < this.visibleItems.length; k++) {
            this.visibleItems[k].repositionX(), void 0 !== this.subgroupVisibility[this.visibleItems[k].data.subgroup] && (this.subgroupVisibility[this.visibleItems[k].data.subgroup] || this.visibleItems[k].hide());
          }

          this.itemSet.options.cluster && nr(od).call(od, this.items, function (t) {
            t.cluster && t.displayed && t.hide();
          }), this.shouldBailStackItems && this.itemSet.body.emitter.emit("destroyTimeline"), this.stackDirty = !1;
        }
      }
    }, {
      key: "_didResize",
      value: function value(t, e) {
        t = od.updateProperty(this, "height", e) || t;
        var i = this.dom.inner.clientWidth,
            n = this.dom.inner.clientHeight;
        return t = od.updateProperty(this.props.label, "width", i) || t, t = od.updateProperty(this.props.label, "height", n) || t;
      }
    }, {
      key: "_applyGroupHeight",
      value: function value(t) {
        this.dom.background.style.height = "".concat(t, "px"), this.dom.foreground.style.height = "".concat(t, "px"), this.dom.label.style.height = "".concat(t, "px");
      }
    }, {
      key: "_updateItemsVerticalPosition",
      value: function value(t) {
        for (var e = 0, i = this.visibleItems.length; e < i; e++) {
          var n = this.visibleItems[e];
          n.repositionY(t), this.isVisible || this.groupId == kp || n.displayed && n.hide();
        }
      }
    }, {
      key: "redraw",
      value: function value(t, e, i, n) {
        var o,
            r,
            s,
            a,
            l,
            h,
            u,
            c = this,
            d = !1,
            p = this.isVisible,
            f = [function () {
          i = c._didMarkerHeightChange.call(c) || i;
        }, ur(o = this._updateSubGroupHeights).call(o, this, e), ur(r = this._calculateGroupSizeAndPosition).call(r, this), function () {
          var i;
          c.isVisible = ur(i = c._isGroupVisible).call(i, c)(t, e);
        }, function () {
          var n;
          ur(n = c._redrawItems).call(n, c)(i, p, e, t);
        }, ur(s = this._updateSubgroupsSizes).call(s, this), function () {
          var t;
          h = ur(t = c._calculateHeight).call(t, c)(e);
        }, ur(a = this._calculateGroupSizeAndPosition).call(a, this), function () {
          var t;
          d = ur(t = c._didResize).call(t, c)(d, h);
        }, function () {
          var t;
          ur(t = c._applyGroupHeight).call(t, c)(h);
        }, function () {
          var t;
          ur(t = c._updateItemsVerticalPosition).call(t, c)(e);
        }, ur(l = function l() {
          return !c.isVisible && c.height && (d = !1), d;
        }).call(l, this)];
        return n ? f : (nr(f).call(f, function (t) {
          u = t();
        }), u);
      }
    }, {
      key: "_updateSubGroupHeights",
      value: function value(t) {
        var e = this;

        if (Vr(this.subgroups).length > 0) {
          var i = this;
          this._resetSubgroups(), nr(od).call(od, this.visibleItems, function (n) {
            void 0 !== n.data.subgroup && (i.subgroups[n.data.subgroup].height = Math.max(i.subgroups[n.data.subgroup].height, n.height + t.item.vertical), i.subgroups[n.data.subgroup].visible = void 0 === e.subgroupVisibility[n.data.subgroup] || Boolean(e.subgroupVisibility[n.data.subgroup]));
          });
        }
      }
    }, {
      key: "_isGroupVisible",
      value: function value(t, e) {
        return this.top <= t.body.domProps.centerContainer.height - t.body.domProps.scrollTop + e.axis && this.top + this.height + e.axis >= -t.body.domProps.scrollTop;
      }
    }, {
      key: "_calculateHeight",
      value: function value(t) {
        var e, i;

        if ((i = "fixed" === this.heightMode ? od.toArray(this.items) : this.visibleItems).length > 0) {
          var n = i[0].top,
              o = i[0].top + i[0].height;

          if (nr(od).call(od, i, function (t) {
            n = Math.min(n, t.top), o = Math.max(o, t.top + t.height);
          }), n > t.axis) {
            var r = n - t.axis;
            o -= r, nr(od).call(od, i, function (t) {
              t.top -= r;
            });
          }

          e = Math.ceil(o + t.item.vertical / 2), "fitItems" !== this.heightMode && (e = Math.max(e, this.props.label.height));
        } else e = this.props.label.height;

        return e;
      }
    }, {
      key: "show",
      value: function value() {
        this.dom.label.parentNode || this.itemSet.dom.labelSet.appendChild(this.dom.label), this.dom.foreground.parentNode || this.itemSet.dom.foreground.appendChild(this.dom.foreground), this.dom.background.parentNode || this.itemSet.dom.background.appendChild(this.dom.background), this.dom.axis.parentNode || this.itemSet.dom.axis.appendChild(this.dom.axis);
      }
    }, {
      key: "hide",
      value: function value() {
        var t = this.dom.label;
        t.parentNode && t.parentNode.removeChild(t);
        var e = this.dom.foreground;
        e.parentNode && e.parentNode.removeChild(e);
        var i = this.dom.background;
        i.parentNode && i.parentNode.removeChild(i);
        var n = this.dom.axis;
        n.parentNode && n.parentNode.removeChild(n);
      }
    }, {
      key: "add",
      value: function value(t) {
        var e;

        if (this.items[t.id] = t, t.setParent(this), this.stackDirty = !0, void 0 !== t.data.subgroup && (this._addToSubgroup(t), this.orderSubgroups()), !Po(e = this.visibleItems).call(e, t)) {
          var i = this.itemSet.body.range;

          this._checkIfVisible(t, this.visibleItems, i);
        }
      }
    }, {
      key: "_addToSubgroup",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.data.subgroup;
        null != e && void 0 === this.subgroups[e] && (this.subgroups[e] = {
          height: 0,
          top: 0,
          start: t.data.start,
          end: t.data.end || t.data.start,
          visible: !1,
          index: this.subgroupIndex,
          items: [],
          stack: this.subgroupStackAll || this.subgroupStack[e] || !1
        }, this.subgroupIndex++), new Date(t.data.start) < new Date(this.subgroups[e].start) && (this.subgroups[e].start = t.data.start);
        var i = t.data.end || t.data.start;
        new Date(i) > new Date(this.subgroups[e].end) && (this.subgroups[e].end = i), this.subgroups[e].items.push(t);
      }
    }, {
      key: "_updateSubgroupsSizes",
      value: function value() {
        var t = this;

        if (t.subgroups) {
          var e = function e(_e5) {
            var i,
                n = t.subgroups[_e5].items[0].data.end || t.subgroups[_e5].items[0].data.start,
                o = t.subgroups[_e5].items[0].data.start,
                r = n - 1;
            nr(i = t.subgroups[_e5].items).call(i, function (t) {
              new Date(t.data.start) < new Date(o) && (o = t.data.start);
              var e = t.data.end || t.data.start;
              new Date(e) > new Date(r) && (r = e);
            }), t.subgroups[_e5].start = o, t.subgroups[_e5].end = new Date(r - 1);
          };

          for (var i in t.subgroups) {
            e(i);
          }
        }
      }
    }, {
      key: "orderSubgroups",
      value: function value() {
        if (void 0 !== this.subgroupOrderer) {
          var t = [];

          if ("string" == typeof this.subgroupOrderer) {
            for (var e in this.subgroups) {
              t.push({
                subgroup: e,
                sortField: this.subgroups[e].items[0].data[this.subgroupOrderer]
              });
            }

            $h(t).call(t, function (t, e) {
              return t.sortField - e.sortField;
            });
          } else if ("function" == typeof this.subgroupOrderer) {
            for (var i in this.subgroups) {
              t.push(this.subgroups[i].items[0].data);
            }

            $h(t).call(t, this.subgroupOrderer);
          }

          if (t.length > 0) for (var n = 0; n < t.length; n++) {
            this.subgroups[t[n].subgroup].index = n;
          }
        }
      }
    }, {
      key: "_resetSubgroups",
      value: function value() {
        for (var t in this.subgroups) {
          this.subgroups.hasOwnProperty(t) && (this.subgroups[t].visible = !1, this.subgroups[t].height = 0);
        }
      }
    }, {
      key: "remove",
      value: function value(t) {
        var e, i;
        delete this.items[t.id], t.setParent(null), this.stackDirty = !0;
        var n = qn(e = this.visibleItems).call(e, t);
        -1 != n && Bo(i = this.visibleItems).call(i, n, 1), void 0 !== t.data.subgroup && (this._removeFromSubgroup(t), this.orderSubgroups());
      }
    }, {
      key: "_removeFromSubgroup",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.data.subgroup;

        if (null != e) {
          var i = this.subgroups[e];

          if (i) {
            var n,
                o,
                r = qn(n = i.items).call(n, t);
            if (r >= 0) Bo(o = i.items).call(o, r, 1), i.items.length ? this._updateSubgroupsSizes() : delete this.subgroups[e];
          }
        }
      }
    }, {
      key: "removeFromDataSet",
      value: function value(t) {
        this.itemSet.removeItem(t.id);
      }
    }, {
      key: "order",
      value: function value() {
        for (var t = od.toArray(this.items), e = [], i = [], n = 0; n < t.length; n++) {
          void 0 !== t[n].data.end && i.push(t[n]), e.push(t[n]);
        }

        this.orderedItems = {
          byStart: e,
          byEnd: i
        }, dp(this.orderedItems.byStart), pp(this.orderedItems.byEnd);
      }
    }, {
      key: "_updateItemsInRange",
      value: function value(t, e, i) {
        var n = [],
            o = {};

        if (!this.isVisible && this.groupId != kp) {
          for (var r = 0; r < e.length; r++) {
            var s = e[r];
            s.displayed && s.hide();
          }

          return n;
        }

        var a = (i.end - i.start) / 4,
            l = i.start - a,
            h = i.end + a;
        if (e.length > 0) for (var u = 0; u < e.length; u++) {
          this._checkIfVisibleWithReference(e[u], n, o, i);
        }
        var c = od.binarySearchCustom(t.byStart, function (t) {
          return t < l ? -1 : t <= h ? 0 : 1;
        }, "data", "start");

        if (this._traceVisible(c, t.byStart, n, o, function (t) {
          return t.data.start < l || t.data.start > h;
        }), 1 == this.checkRangedItems) {
          this.checkRangedItems = !1;

          for (var d = 0; d < t.byEnd.length; d++) {
            this._checkIfVisibleWithReference(t.byEnd[d], n, o, i);
          }
        } else {
          var p = od.binarySearchCustom(t.byEnd, function (t) {
            var e = t.start;
            return t.end < l ? -1 : e <= h ? 0 : 1;
          }, "data");

          this._traceVisible(p, t.byEnd, n, o, function (t) {
            return t.data.end < l || t.data.start > h;
          });
        }

        for (var f = {}, m = 0, v = 0; v < n.length; v++) {
          var g = n[v];

          if (!g.displayed) {
            f[v] = g.redraw(!0), m = f[v].length;
          }
        }

        if (m > 0) for (var y = function y(t) {
          nr(od).call(od, f, function (e) {
            e[t]();
          });
        }, b = 0; b < m; b++) {
          y(b);
        }

        for (var _ = 0; _ < n.length; _++) {
          n[_].repositionX();
        }

        return n;
      }
    }, {
      key: "_traceVisible",
      value: function value(t, e, i, n, o) {
        if (-1 != t) {
          for (var r = t; r >= 0; r--) {
            var s = e[r];
            if (o(s)) break;
            s.isCluster && !s.hasItems() || s.cluster || void 0 === n[s.id] && (n[s.id] = !0, i.push(s));
          }

          for (var a = t + 1; a < e.length; a++) {
            var l = e[a];
            if (o(l)) break;
            l.isCluster && !l.hasItems() || l.cluster || void 0 === n[l.id] && (n[l.id] = !0, i.push(l));
          }
        }
      }
    }, {
      key: "_checkIfVisible",
      value: function value(t, e, i) {
        t.isVisible(i) ? (t.displayed || t.show(), t.repositionX(), e.push(t)) : t.displayed && t.hide();
      }
    }, {
      key: "_checkIfVisibleWithReference",
      value: function value(t, e, i, n) {
        t.isVisible(n) ? void 0 === i[t.id] && (i[t.id] = !0, e.push(t)) : t.displayed && t.hide();
      }
    }, {
      key: "_updateClustersInRange",
      value: function value(t, e, i) {
        var n = [],
            o = {};
        if (e.length > 0) for (var r = 0; r < e.length; r++) {
          this._checkIfVisibleWithReference(e[r], n, o, i);
        }

        for (var s = 0; s < t.byStart.length; s++) {
          this._checkIfVisibleWithReference(t.byStart[s], n, o, i);
        }

        for (var a = 0; a < t.byEnd.length; a++) {
          this._checkIfVisibleWithReference(t.byEnd[a], n, o, i);
        }

        for (var l = {}, h = 0, u = 0; u < n.length; u++) {
          var c = n[u];

          if (!c.displayed) {
            l[u] = c.redraw(!0), h = l[u].length;
          }
        }

        if (h > 0) for (var d = 0; d < h; d++) {
          nr(od).call(od, l, function (t) {
            t[d]();
          });
        }

        for (var p = 0; p < n.length; p++) {
          n[p].repositionX();
        }

        return n;
      }
    }, {
      key: "changeSubgroup",
      value: function value(t, e, i) {
        this._removeFromSubgroup(t, e), this._addToSubgroup(t, i), this.orderSubgroups();
      }
    }, {
      key: "dispose",
      value: function value() {
        var t;

        for (this.hide(); t = this._disposeCallbacks.pop();) {
          t();
        }
      }
    }]), t;
  }();

  function Dp(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var Sp = function (t) {
    jh(i, t);
    var e = Dp(i);

    function i(t, n, o) {
      var r;
      return gn(this, i), (r = e.call(this, t, n, o)).width = 0, r.height = 0, r.top = 0, r.left = 0, r;
    }

    return _n(i, [{
      key: "redraw",
      value: function value(t, e, i) {
        this.visibleItems = this._updateItemsInRange(this.orderedItems, this.visibleItems, t), this.width = this.dom.background.offsetWidth, this.dom.background.style.height = "0";

        for (var n = 0, o = this.visibleItems.length; n < o; n++) {
          this.visibleItems[n].repositionY(e);
        }

        return !1;
      }
    }, {
      key: "show",
      value: function value() {
        this.dom.background.parentNode || this.itemSet.dom.background.appendChild(this.dom.background);
      }
    }]), i;
  }(xp);

  function Cp(t, e) {
    var i;

    if (void 0 === cs || null == zi(t)) {
      if (Jr(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return Tp(t, e);
        var n = ns(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Qi(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Tp(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);

        var _n4 = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n4 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n4++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var r,
        s = !0,
        a = !1;
    return {
      s: function s() {
        i = Hi(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i.return || i.return();
        } finally {
          if (a) throw r;
        }
      }
    };
  }

  function Tp(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, n = new Array(e); i < e; i++) {
      n[i] = t[i];
    }

    return n;
  }

  var Mp = function () {
    function t(e, i, n) {
      var o,
          r = this;
      gn(this, t), this.id = null, this.parent = null, this.data = e, this.dom = null, this.conversion = i || {}, this.defaultOptions = {
        locales: Jd,
        locale: "en"
      }, this.options = od.extend({}, this.defaultOptions, n), this.options.locales = od.extend({}, Jd, this.options.locales);
      var s = this.defaultOptions.locales[this.defaultOptions.locale];
      nr(o = Vr(this.options.locales)).call(o, function (t) {
        r.options.locales[t] = od.extend({}, s, r.options.locales[t]);
      }), this.selected = !1, this.displayed = !1, this.groupShowing = !0, this.selectable = n && n.selectable || !1, this.dirty = !0, this.top = null, this.right = null, this.left = null, this.width = null, this.height = null, this.setSelectability(e), this.editable = null, this._updateEditStatus();
    }

    return _n(t, [{
      key: "select",
      value: function value() {
        this.selectable && (this.selected = !0, this.dirty = !0, this.displayed && this.redraw());
      }
    }, {
      key: "unselect",
      value: function value() {
        this.selected = !1, this.dirty = !0, this.displayed && this.redraw();
      }
    }, {
      key: "setData",
      value: function value(t) {
        null != t.group && this.data.group != t.group && null != this.parent && this.parent.itemSet._moveToGroup(this, t.group), this.setSelectability(t), this.parent && (this.parent.stackDirty = !0), null != t.subgroup && this.data.subgroup != t.subgroup && null != this.parent && this.parent.changeSubgroup(this, this.data.subgroup, t.subgroup), this.data = t, this._updateEditStatus(), this.dirty = !0, this.displayed && this.redraw();
      }
    }, {
      key: "setSelectability",
      value: function value(t) {
        t && (this.selectable = void 0 === t.selectable || Boolean(t.selectable));
      }
    }, {
      key: "setParent",
      value: function value(t) {
        this.displayed ? (this.hide(), this.parent = t, this.parent && this.show()) : this.parent = t;
      }
    }, {
      key: "isVisible",
      value: function value(t) {
        return !1;
      }
    }, {
      key: "show",
      value: function value() {
        return !1;
      }
    }, {
      key: "hide",
      value: function value() {
        return !1;
      }
    }, {
      key: "redraw",
      value: function value() {}
    }, {
      key: "repositionX",
      value: function value() {}
    }, {
      key: "repositionY",
      value: function value() {}
    }, {
      key: "_repaintDragCenter",
      value: function value() {
        if (this.selected && this.editable.updateTime && !this.dom.dragCenter) {
          var t,
              e,
              i = this,
              n = document.createElement("div");
          n.className = "vis-drag-center", n.dragCenterItem = this, this.hammerDragCenter = new Ld(n), this.hammerDragCenter.on("tap", function (t) {
            i.parent.itemSet.body.emitter.emit("click", {
              event: t,
              item: i.id
            });
          }), this.hammerDragCenter.on("doubletap", function (t) {
            t.stopPropagation(), i.parent.itemSet._onUpdateItem(i), i.parent.itemSet.body.emitter.emit("doubleClick", {
              event: t,
              item: i.id
            });
          }), this.hammerDragCenter.on("panstart", function (t) {
            t.stopPropagation(), i.parent.itemSet._onDragStart(t);
          }), this.hammerDragCenter.on("panmove", ur(t = i.parent.itemSet._onDrag).call(t, i.parent.itemSet)), this.hammerDragCenter.on("panend", ur(e = i.parent.itemSet._onDragEnd).call(e, i.parent.itemSet)), this.dom.box ? this.dom.dragLeft ? this.dom.box.insertBefore(n, this.dom.dragLeft) : this.dom.box.appendChild(n) : this.dom.point && this.dom.point.appendChild(n), this.dom.dragCenter = n;
        } else !this.selected && this.dom.dragCenter && (this.dom.dragCenter.parentNode && this.dom.dragCenter.parentNode.removeChild(this.dom.dragCenter), this.dom.dragCenter = null, this.hammerDragCenter && (this.hammerDragCenter.destroy(), this.hammerDragCenter = null));
      }
    }, {
      key: "_repaintDeleteButton",
      value: function value(t) {
        var e = (this.options.editable.overrideItems || null == this.editable) && this.options.editable.remove || !this.options.editable.overrideItems && null != this.editable && this.editable.remove;

        if (this.selected && e && !this.dom.deleteButton) {
          var i = this,
              n = document.createElement("div");
          this.options.rtl ? n.className = "vis-delete-rtl" : n.className = "vis-delete";
          var o = this.options.locales[this.options.locale];
          o || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), o = this.options.locales.en), n.title = o.deleteSelected, this.hammerDeleteButton = new Ld(n).on("tap", function (t) {
            t.stopPropagation(), i.parent.removeFromDataSet(i);
          }), t.appendChild(n), this.dom.deleteButton = n;
        } else !this.selected && this.dom.deleteButton && (this.dom.deleteButton.parentNode && this.dom.deleteButton.parentNode.removeChild(this.dom.deleteButton), this.dom.deleteButton = null, this.hammerDeleteButton && (this.hammerDeleteButton.destroy(), this.hammerDeleteButton = null));
      }
    }, {
      key: "_repaintOnItemUpdateTimeTooltip",
      value: function value(t) {
        if (this.options.tooltipOnItemUpdateTime) {
          var e = (this.options.editable.updateTime || !0 === this.data.editable) && !1 !== this.data.editable;

          if (this.selected && e && !this.dom.onItemUpdateTimeTooltip) {
            var i = document.createElement("div");
            i.className = "vis-onUpdateTime-tooltip", t.appendChild(i), this.dom.onItemUpdateTimeTooltip = i;
          } else !this.selected && this.dom.onItemUpdateTimeTooltip && (this.dom.onItemUpdateTimeTooltip.parentNode && this.dom.onItemUpdateTimeTooltip.parentNode.removeChild(this.dom.onItemUpdateTimeTooltip), this.dom.onItemUpdateTimeTooltip = null);

          if (this.dom.onItemUpdateTimeTooltip) {
            this.dom.onItemUpdateTimeTooltip.style.visibility = this.parent.itemSet.touchParams.itemIsDragging ? "visible" : "hidden", this.dom.onItemUpdateTimeTooltip.style.transform = "translateX(-50%)", this.dom.onItemUpdateTimeTooltip.style.left = "50%";
            var n,
                o,
                r = this.parent.itemSet.body.domProps.scrollTop;
            if (("top" == this.options.orientation.item ? this.top : this.parent.height - this.top - this.height) + this.parent.top - 50 < -r ? (this.dom.onItemUpdateTimeTooltip.style.bottom = "", this.dom.onItemUpdateTimeTooltip.style.top = "".concat(this.height + 2, "px")) : (this.dom.onItemUpdateTimeTooltip.style.top = "", this.dom.onItemUpdateTimeTooltip.style.bottom = "".concat(this.height + 2, "px")), this.options.tooltipOnItemUpdateTime && this.options.tooltipOnItemUpdateTime.template) n = ur(o = this.options.tooltipOnItemUpdateTime.template).call(o, this)(this.data);else n = "start: ".concat(Qu(this.data.start).format("MM/DD/YYYY hh:mm")), this.data.end && (n += "<br> end: ".concat(Qu(this.data.end).format("MM/DD/YYYY hh:mm")));
            this.dom.onItemUpdateTimeTooltip.innerHTML = od.xss(n);
          }
        }
      }
    }, {
      key: "_getItemData",
      value: function value() {
        return this.parent.itemSet.itemsData.get(this.id);
      }
    }, {
      key: "_updateContents",
      value: function value(t) {
        var e,
            i,
            n,
            o,
            r,
            s,
            a = this._getItemData(),
            l = (this.dom.box || this.dom.point).getElementsByClassName("vis-item-visible-frame")[0];

        this.options.visibleFrameTemplate ? (o = ur(r = this.options.visibleFrameTemplate).call(r, this), n = od.xss(o(a, l))) : n = "";
        if (l) if (n instanceof Object && !(n instanceof Element)) o(a, l);else if (this._contentToString(this.itemVisibleFrameContent) !== this._contentToString(n)) {
          if (n instanceof Element) l.innerHTML = "", l.appendChild(n);else if (null != n) l.innerHTML = od.xss(n);else if ("background" != this.data.type || void 0 !== this.data.content) throw new Error('Property "content" missing in item '.concat(this.id));
          this.itemVisibleFrameContent = n;
        }
        this.options.template ? e = (i = ur(s = this.options.template).call(s, this))(a, t, this.data) : e = this.data.content;
        if (e instanceof Object && !(e instanceof Element)) i(a, t);else if (this._contentToString(this.content) !== this._contentToString(e)) {
          if (e instanceof Element) t.innerHTML = "", t.appendChild(e);else if (null != e) t.innerHTML = od.xss(e);else if ("background" != this.data.type || void 0 !== this.data.content) throw new Error('Property "content" missing in item '.concat(this.id));
          this.content = e;
        }
      }
    }, {
      key: "_updateDataAttributes",
      value: function value(t) {
        if (this.options.dataAttributes && this.options.dataAttributes.length > 0) {
          var e = [];
          if (Jr(this.options.dataAttributes)) e = this.options.dataAttributes;else {
            if ("all" != this.options.dataAttributes) return;
            e = Vr(this.data);
          }
          var i,
              n = Cp(e);

          try {
            for (n.s(); !(i = n.n()).done;) {
              var o = i.value,
                  r = this.data[o];
              null != r ? t.setAttribute("data-".concat(o), r) : t.removeAttribute("data-".concat(o));
            }
          } catch (t) {
            n.e(t);
          } finally {
            n.f();
          }
        }
      }
    }, {
      key: "_updateStyle",
      value: function value(t) {
        this.style && (od.removeCssText(t, this.style), this.style = null), this.data.style && (od.addCssText(t, this.data.style), this.style = this.data.style);
      }
    }, {
      key: "_contentToString",
      value: function value(t) {
        return "string" == typeof t ? t : t && "outerHTML" in t ? t.outerHTML : t;
      }
    }, {
      key: "_updateEditStatus",
      value: function value() {
        this.options && ("boolean" == typeof this.options.editable ? this.editable = {
          updateTime: this.options.editable,
          updateGroup: this.options.editable,
          remove: this.options.editable
        } : "object" === es(this.options.editable) && (this.editable = {}, od.selectiveExtend(["updateTime", "updateGroup", "remove"], this.editable, this.options.editable))), this.options && this.options.editable && !0 === this.options.editable.overrideItems || this.data && ("boolean" == typeof this.data.editable ? this.editable = {
          updateTime: this.data.editable,
          updateGroup: this.data.editable,
          remove: this.data.editable
        } : "object" === es(this.data.editable) && (this.editable = {}, od.selectiveExtend(["updateTime", "updateGroup", "remove"], this.editable, this.data.editable)));
      }
    }, {
      key: "getWidthLeft",
      value: function value() {
        return 0;
      }
    }, {
      key: "getWidthRight",
      value: function value() {
        return 0;
      }
    }, {
      key: "getTitle",
      value: function value() {
        var t;
        return this.options.tooltip && this.options.tooltip.template ? ur(t = this.options.tooltip.template).call(t, this)(this._getItemData(), this.data) : this.data.title;
      }
    }]), t;
  }();

  function Op(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  Mp.prototype.stack = !0;

  var Ep = function (t) {
    jh(i, t);
    var e = Op(i);

    function i(t, n, o) {
      var r;
      if (gn(this, i), (r = e.call(this, t, n, o)).props = {
        dot: {
          width: 0,
          height: 0
        },
        line: {
          width: 0,
          height: 0
        }
      }, t && null == t.start) throw new Error('Property "start" missing in item '.concat(t));
      return r;
    }

    return _n(i, [{
      key: "isVisible",
      value: function value(t) {
        if (this.cluster) return !1;
        var e,
            i = this.data.align || this.options.align,
            n = this.width * t.getMillisecondsPerPixel();
        return e = "right" == i ? this.data.start.getTime() > t.start && this.data.start.getTime() - n < t.end : "left" == i ? this.data.start.getTime() + n > t.start && this.data.start.getTime() < t.end : this.data.start.getTime() + n / 2 > t.start && this.data.start.getTime() - n / 2 < t.end, e;
      }
    }, {
      key: "_createDomElement",
      value: function value() {
        this.dom || (this.dom = {}, this.dom.box = document.createElement("DIV"), this.dom.content = document.createElement("DIV"), this.dom.content.className = "vis-item-content", this.dom.box.appendChild(this.dom.content), this.dom.line = document.createElement("DIV"), this.dom.line.className = "vis-line", this.dom.dot = document.createElement("DIV"), this.dom.dot.className = "vis-dot", this.dom.box["vis-item"] = this, this.dirty = !0);
      }
    }, {
      key: "_appendDomElement",
      value: function value() {
        if (!this.parent) throw new Error("Cannot redraw item: no parent attached");

        if (!this.dom.box.parentNode) {
          var t = this.parent.dom.foreground;
          if (!t) throw new Error("Cannot redraw item: parent has no foreground container element");
          t.appendChild(this.dom.box);
        }

        if (!this.dom.line.parentNode) {
          var e = this.parent.dom.background;
          if (!e) throw new Error("Cannot redraw item: parent has no background container element");
          e.appendChild(this.dom.line);
        }

        if (!this.dom.dot.parentNode) {
          var i = this.parent.dom.axis;
          if (!e) throw new Error("Cannot redraw item: parent has no axis container element");
          i.appendChild(this.dom.dot);
        }

        this.displayed = !0;
      }
    }, {
      key: "_updateDirtyDomComponents",
      value: function value() {
        if (this.dirty) {
          this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
          var t = this.editable.updateTime || this.editable.updateGroup,
              e = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (t ? " vis-editable" : " vis-readonly");
          this.dom.box.className = "vis-item vis-box".concat(e), this.dom.line.className = "vis-item vis-line".concat(e), this.dom.dot.className = "vis-item vis-dot".concat(e);
        }
      }
    }, {
      key: "_getDomComponentsSizes",
      value: function value() {
        return {
          previous: {
            right: this.dom.box.style.right,
            left: this.dom.box.style.left
          },
          dot: {
            height: this.dom.dot.offsetHeight,
            width: this.dom.dot.offsetWidth
          },
          line: {
            width: this.dom.line.offsetWidth
          },
          box: {
            width: this.dom.box.offsetWidth,
            height: this.dom.box.offsetHeight
          }
        };
      }
    }, {
      key: "_updateDomComponentsSizes",
      value: function value(t) {
        this.options.rtl ? this.dom.box.style.right = "0px" : this.dom.box.style.left = "0px", this.props.dot.height = t.dot.height, this.props.dot.width = t.dot.width, this.props.line.width = t.line.width, this.width = t.box.width, this.height = t.box.height, this.options.rtl ? this.dom.box.style.right = t.previous.right : this.dom.box.style.left = t.previous.left, this.dirty = !1;
      }
    }, {
      key: "_repaintDomAdditionals",
      value: function value() {
        this._repaintOnItemUpdateTimeTooltip(this.dom.box), this._repaintDragCenter(), this._repaintDeleteButton(this.dom.box);
      }
    }, {
      key: "redraw",
      value: function value(t) {
        var e,
            i,
            n,
            o,
            r,
            s,
            a = this,
            l = [ur(e = this._createDomElement).call(e, this), ur(i = this._appendDomElement).call(i, this), ur(n = this._updateDirtyDomComponents).call(n, this), function () {
          a.dirty && (r = a._getDomComponentsSizes());
        }, function () {
          var t;
          a.dirty && ur(t = a._updateDomComponentsSizes).call(t, a)(r);
        }, ur(o = this._repaintDomAdditionals).call(o, this)];
        return t ? l : (nr(l).call(l, function (t) {
          s = t();
        }), s);
      }
    }, {
      key: "show",
      value: function value(t) {
        if (!this.displayed) return this.redraw(t);
      }
    }, {
      key: "hide",
      value: function value() {
        if (this.displayed) {
          var t = this.dom;
          t.box.remove ? t.box.remove() : t.box.parentNode && t.box.parentNode.removeChild(t.box), t.line.remove ? t.line.remove() : t.line.parentNode && t.line.parentNode.removeChild(t.line), t.dot.remove ? t.dot.remove() : t.dot.parentNode && t.dot.parentNode.removeChild(t.dot), this.displayed = !1;
        }
      }
    }, {
      key: "repositionXY",
      value: function value() {
        var t = this.options.rtl,
            e = function e(t, _e6, i) {
          var n,
              o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];

          if (void 0 !== _e6 || void 0 !== i) {
            var r = o ? -1 * _e6 : _e6;
            t.style.transform = void 0 !== i ? void 0 !== _e6 ? us(n = "translate(".concat(r, "px, ")).call(n, i, "px)") : "translateY(".concat(i, "px)") : "translateX(".concat(r, "px)");
          }
        };

        e(this.dom.box, this.boxX, this.boxY, t), e(this.dom.dot, this.dotX, this.dotY, t), e(this.dom.line, this.lineX, this.lineY, t);
      }
    }, {
      key: "repositionX",
      value: function value() {
        var t = this.conversion.toScreen(this.data.start),
            e = void 0 === this.data.align ? this.options.align : this.data.align,
            i = this.props.line.width,
            n = this.props.dot.width;
        "right" == e ? (this.boxX = t - this.width, this.lineX = t - i, this.dotX = t - i / 2 - n / 2) : "left" == e ? (this.boxX = t, this.lineX = t, this.dotX = t + i / 2 - n / 2) : (this.boxX = t - this.width / 2, this.lineX = this.options.rtl ? t - i : t - i / 2, this.dotX = t - n / 2), this.options.rtl ? this.right = this.boxX : this.left = this.boxX, this.repositionXY();
      }
    }, {
      key: "repositionY",
      value: function value() {
        var t = this.options.orientation.item,
            e = this.dom.line.style;

        if ("top" == t) {
          var i = this.parent.top + this.top + 1;
          this.boxY = this.top || 0, e.height = "".concat(i, "px"), e.bottom = "", e.top = "0";
        } else {
          var n = this.parent.itemSet.props.height - this.parent.top - this.parent.height + this.top;
          this.boxY = this.parent.height - this.top - (this.height || 0), e.height = "".concat(n, "px"), e.top = "", e.bottom = "0";
        }

        this.dotY = -this.props.dot.height / 2, this.repositionXY();
      }
    }, {
      key: "getWidthLeft",
      value: function value() {
        return this.width / 2;
      }
    }, {
      key: "getWidthRight",
      value: function value() {
        return this.width / 2;
      }
    }]), i;
  }(Mp);

  function Pp(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var Ap = function (t) {
    jh(i, t);
    var e = Pp(i);

    function i(t, n, o) {
      var r;
      if (gn(this, i), (r = e.call(this, t, n, o)).props = {
        dot: {
          top: 0,
          width: 0,
          height: 0
        },
        content: {
          height: 0,
          marginLeft: 0,
          marginRight: 0
        }
      }, t && null == t.start) throw new Error('Property "start" missing in item '.concat(t));
      return r;
    }

    return _n(i, [{
      key: "isVisible",
      value: function value(t) {
        if (this.cluster) return !1;
        var e = this.width * t.getMillisecondsPerPixel();
        return this.data.start.getTime() + e > t.start && this.data.start < t.end;
      }
    }, {
      key: "_createDomElement",
      value: function value() {
        this.dom || (this.dom = {}, this.dom.point = document.createElement("div"), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.point.appendChild(this.dom.content), this.dom.dot = document.createElement("div"), this.dom.point.appendChild(this.dom.dot), this.dom.point["vis-item"] = this, this.dirty = !0);
      }
    }, {
      key: "_appendDomElement",
      value: function value() {
        if (!this.parent) throw new Error("Cannot redraw item: no parent attached");

        if (!this.dom.point.parentNode) {
          var t = this.parent.dom.foreground;
          if (!t) throw new Error("Cannot redraw item: parent has no foreground container element");
          t.appendChild(this.dom.point);
        }

        this.displayed = !0;
      }
    }, {
      key: "_updateDirtyDomComponents",
      value: function value() {
        if (this.dirty) {
          this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.point), this._updateStyle(this.dom.point);
          var t = this.editable.updateTime || this.editable.updateGroup,
              e = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (t ? " vis-editable" : " vis-readonly");
          this.dom.point.className = "vis-item vis-point".concat(e), this.dom.dot.className = "vis-item vis-dot".concat(e);
        }
      }
    }, {
      key: "_getDomComponentsSizes",
      value: function value() {
        return {
          dot: {
            width: this.dom.dot.offsetWidth,
            height: this.dom.dot.offsetHeight
          },
          content: {
            width: this.dom.content.offsetWidth,
            height: this.dom.content.offsetHeight
          },
          point: {
            width: this.dom.point.offsetWidth,
            height: this.dom.point.offsetHeight
          }
        };
      }
    }, {
      key: "_updateDomComponentsSizes",
      value: function value(t) {
        this.props.dot.width = t.dot.width, this.props.dot.height = t.dot.height, this.props.content.height = t.content.height, this.options.rtl ? this.dom.content.style.marginRight = "".concat(2 * this.props.dot.width, "px") : this.dom.content.style.marginLeft = "".concat(2 * this.props.dot.width, "px"), this.width = t.point.width, this.height = t.point.height, this.dom.dot.style.top = "".concat((this.height - this.props.dot.height) / 2, "px");
        var e = this.props.dot.width,
            i = this.options.rtl ? e / 2 * -1 : e / 2;
        this.dom.dot.style.transform = "translateX(".concat(i, "px"), this.dirty = !1;
      }
    }, {
      key: "_repaintDomAdditionals",
      value: function value() {
        this._repaintOnItemUpdateTimeTooltip(this.dom.point), this._repaintDragCenter(), this._repaintDeleteButton(this.dom.point);
      }
    }, {
      key: "redraw",
      value: function value(t) {
        var e,
            i,
            n,
            o,
            r,
            s,
            a = this,
            l = [ur(e = this._createDomElement).call(e, this), ur(i = this._appendDomElement).call(i, this), ur(n = this._updateDirtyDomComponents).call(n, this), function () {
          a.dirty && (r = a._getDomComponentsSizes());
        }, function () {
          var t;
          a.dirty && ur(t = a._updateDomComponentsSizes).call(t, a)(r);
        }, ur(o = this._repaintDomAdditionals).call(o, this)];
        return t ? l : (nr(l).call(l, function (t) {
          s = t();
        }), s);
      }
    }, {
      key: "repositionXY",
      value: function value() {
        var t = this.options.rtl,
            e = function e(t, _e7, i) {
          var n,
              o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];

          if (void 0 !== _e7 || void 0 !== i) {
            var r = o ? -1 * _e7 : _e7;
            t.style.transform = void 0 !== i ? void 0 !== _e7 ? us(n = "translate(".concat(r, "px, ")).call(n, i, "px)") : "translateY(".concat(i, "px)") : "translateX(".concat(r, "px)");
          }
        };

        e(this.dom.point, this.pointX, this.pointY, t);
      }
    }, {
      key: "show",
      value: function value(t) {
        if (!this.displayed) return this.redraw(t);
      }
    }, {
      key: "hide",
      value: function value() {
        this.displayed && (this.dom.point.parentNode && this.dom.point.parentNode.removeChild(this.dom.point), this.displayed = !1);
      }
    }, {
      key: "repositionX",
      value: function value() {
        var t = this.conversion.toScreen(this.data.start);
        this.pointX = t, this.options.rtl ? this.right = t - this.props.dot.width : this.left = t - this.props.dot.width, this.repositionXY();
      }
    }, {
      key: "repositionY",
      value: function value() {
        var t = this.options.orientation.item;
        this.pointY = "top" == t ? this.top : this.parent.height - this.top - this.height, this.repositionXY();
      }
    }, {
      key: "getWidthLeft",
      value: function value() {
        return this.props.dot.width;
      }
    }, {
      key: "getWidthRight",
      value: function value() {
        return this.props.dot.width;
      }
    }]), i;
  }(Mp);

  function Lp(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var Ip = function (t) {
    jh(i, t);
    var e = Lp(i);

    function i(t, n, o) {
      var r;

      if (gn(this, i), (r = e.call(this, t, n, o)).props = {
        content: {
          width: 0
        }
      }, r.overflow = !1, t) {
        if (null == t.start) throw new Error('Property "start" missing in item '.concat(t.id));
        if (null == t.end) throw new Error('Property "end" missing in item '.concat(t.id));
      }

      return r;
    }

    return _n(i, [{
      key: "isVisible",
      value: function value(t) {
        return !this.cluster && this.data.start < t.end && this.data.end > t.start;
      }
    }, {
      key: "_createDomElement",
      value: function value() {
        this.dom || (this.dom = {}, this.dom.box = document.createElement("div"), this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-item-overflow", this.dom.box.appendChild(this.dom.frame), this.dom.visibleFrame = document.createElement("div"), this.dom.visibleFrame.className = "vis-item-visible-frame", this.dom.box.appendChild(this.dom.visibleFrame), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.frame.appendChild(this.dom.content), this.dom.box["vis-item"] = this, this.dirty = !0);
      }
    }, {
      key: "_appendDomElement",
      value: function value() {
        if (!this.parent) throw new Error("Cannot redraw item: no parent attached");

        if (!this.dom.box.parentNode) {
          var t = this.parent.dom.foreground;
          if (!t) throw new Error("Cannot redraw item: parent has no foreground container element");
          t.appendChild(this.dom.box);
        }

        this.displayed = !0;
      }
    }, {
      key: "_updateDirtyDomComponents",
      value: function value() {
        if (this.dirty) {
          this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
          var t = this.editable.updateTime || this.editable.updateGroup,
              e = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (t ? " vis-editable" : " vis-readonly");
          this.dom.box.className = this.baseClassName + e, this.dom.content.style.maxWidth = "none";
        }
      }
    }, {
      key: "_getDomComponentsSizes",
      value: function value() {
        return this.overflow = "hidden" !== window.getComputedStyle(this.dom.frame).overflow, this.whiteSpace = "nowrap" !== window.getComputedStyle(this.dom.content).whiteSpace, {
          content: {
            width: this.dom.content.offsetWidth
          },
          box: {
            height: this.dom.box.offsetHeight
          }
        };
      }
    }, {
      key: "_updateDomComponentsSizes",
      value: function value(t) {
        this.props.content.width = t.content.width, this.height = t.box.height, this.dom.content.style.maxWidth = "", this.dirty = !1;
      }
    }, {
      key: "_repaintDomAdditionals",
      value: function value() {
        this._repaintOnItemUpdateTimeTooltip(this.dom.box), this._repaintDeleteButton(this.dom.box), this._repaintDragCenter(), this._repaintDragLeft(), this._repaintDragRight();
      }
    }, {
      key: "redraw",
      value: function value(t) {
        var e,
            i,
            n,
            o,
            r,
            s,
            a = this,
            l = [ur(e = this._createDomElement).call(e, this), ur(i = this._appendDomElement).call(i, this), ur(n = this._updateDirtyDomComponents).call(n, this), function () {
          var t;
          a.dirty && (r = ur(t = a._getDomComponentsSizes).call(t, a)());
        }, function () {
          var t;
          a.dirty && ur(t = a._updateDomComponentsSizes).call(t, a)(r);
        }, ur(o = this._repaintDomAdditionals).call(o, this)];
        return t ? l : (nr(l).call(l, function (t) {
          s = t();
        }), s);
      }
    }, {
      key: "show",
      value: function value(t) {
        if (!this.displayed) return this.redraw(t);
      }
    }, {
      key: "hide",
      value: function value() {
        if (this.displayed) {
          var t = this.dom.box;
          t.parentNode && t.parentNode.removeChild(t), this.displayed = !1;
        }
      }
    }, {
      key: "repositionX",
      value: function value(t) {
        var e,
            i,
            n = this.parent.width,
            o = this.conversion.toScreen(this.data.start),
            r = this.conversion.toScreen(this.data.end),
            s = void 0 === this.data.align ? this.options.align : this.data.align;
        !1 === this.data.limitSize || void 0 !== t && !0 !== t || (o < -n && (o = -n), r > 2 * n && (r = 2 * n));
        var a = Math.max(Math.round(1e3 * (r - o)) / 1e3, 1);

        switch (this.overflow ? (this.options.rtl ? this.right = o : this.left = o, this.width = a + this.props.content.width, i = this.props.content.width) : (this.options.rtl ? this.right = o : this.left = o, this.width = a, i = Math.min(r - o, this.props.content.width)), this.options.rtl ? this.dom.box.style.transform = "translateX(".concat(-1 * this.right, "px)") : this.dom.box.style.transform = "translateX(".concat(this.left, "px)"), this.dom.box.style.width = "".concat(a, "px"), this.whiteSpace && (this.height = this.dom.box.offsetHeight), s) {
          case "left":
            this.dom.content.style.transform = "translateX(0)";
            break;

          case "right":
            if (this.options.rtl) {
              var l = -1 * Math.max(a - i, 0);
              this.dom.content.style.transform = "translateX(".concat(l, "px)");
            } else this.dom.content.style.transform = "translateX(".concat(Math.max(a - i, 0), "px)");

            break;

          case "center":
            if (this.options.rtl) {
              var h = -1 * Math.max((a - i) / 2, 0);
              this.dom.content.style.transform = "translateX(".concat(h, "px)");
            } else this.dom.content.style.transform = "translateX(".concat(Math.max((a - i) / 2, 0), "px)");

            break;

          default:
            if (e = this.overflow ? r > 0 ? Math.max(-o, 0) : -i : o < 0 ? -o : 0, this.options.rtl) {
              var u = -1 * e;
              this.dom.content.style.transform = "translateX(".concat(u, "px)");
            } else this.dom.content.style.transform = "translateX(".concat(e, "px)");

        }
      }
    }, {
      key: "repositionY",
      value: function value() {
        var t = this.options.orientation.item,
            e = this.dom.box;
        e.style.top = "".concat("top" == t ? this.top : this.parent.height - this.top - this.height, "px");
      }
    }, {
      key: "_repaintDragLeft",
      value: function value() {
        if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.editable.updateTime && !this.dom.dragLeft) {
          var t = document.createElement("div");
          t.className = "vis-drag-left", t.dragLeftItem = this, this.dom.box.appendChild(t), this.dom.dragLeft = t;
        } else this.selected || this.options.itemsAlwaysDraggable.range || !this.dom.dragLeft || (this.dom.dragLeft.parentNode && this.dom.dragLeft.parentNode.removeChild(this.dom.dragLeft), this.dom.dragLeft = null);
      }
    }, {
      key: "_repaintDragRight",
      value: function value() {
        if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.editable.updateTime && !this.dom.dragRight) {
          var t = document.createElement("div");
          t.className = "vis-drag-right", t.dragRightItem = this, this.dom.box.appendChild(t), this.dom.dragRight = t;
        } else this.selected || this.options.itemsAlwaysDraggable.range || !this.dom.dragRight || (this.dom.dragRight.parentNode && this.dom.dragRight.parentNode.removeChild(this.dom.dragRight), this.dom.dragRight = null);
      }
    }]), i;
  }(Mp);

  function Np(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  Ip.prototype.baseClassName = "vis-item vis-range";

  var Rp = function (t) {
    jh(i, t);
    var e = Np(i);

    function i(t, n, o) {
      var r;

      if (gn(this, i), (r = e.call(this, t, n, o)).props = {
        content: {
          width: 0
        }
      }, r.overflow = !1, t) {
        if (null == t.start) throw new Error('Property "start" missing in item '.concat(t.id));
        if (null == t.end) throw new Error('Property "end" missing in item '.concat(t.id));
      }

      return r;
    }

    return _n(i, [{
      key: "isVisible",
      value: function value(t) {
        return this.data.start < t.end && this.data.end > t.start;
      }
    }, {
      key: "_createDomElement",
      value: function value() {
        this.dom || (this.dom = {}, this.dom.box = document.createElement("div"), this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-item-overflow", this.dom.box.appendChild(this.dom.frame), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.frame.appendChild(this.dom.content), this.dirty = !0);
      }
    }, {
      key: "_appendDomElement",
      value: function value() {
        if (!this.parent) throw new Error("Cannot redraw item: no parent attached");

        if (!this.dom.box.parentNode) {
          var t = this.parent.dom.background;
          if (!t) throw new Error("Cannot redraw item: parent has no background container element");
          t.appendChild(this.dom.box);
        }

        this.displayed = !0;
      }
    }, {
      key: "_updateDirtyDomComponents",
      value: function value() {
        if (this.dirty) {
          this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.content), this._updateStyle(this.dom.box);
          var t = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "");
          this.dom.box.className = this.baseClassName + t;
        }
      }
    }, {
      key: "_getDomComponentsSizes",
      value: function value() {
        return this.overflow = "hidden" !== window.getComputedStyle(this.dom.content).overflow, {
          content: {
            width: this.dom.content.offsetWidth
          }
        };
      }
    }, {
      key: "_updateDomComponentsSizes",
      value: function value(t) {
        this.props.content.width = t.content.width, this.height = 0, this.dirty = !1;
      }
    }, {
      key: "_repaintDomAdditionals",
      value: function value() {}
    }, {
      key: "redraw",
      value: function value(t) {
        var e,
            i,
            n,
            o,
            r,
            s,
            a = this,
            l = [ur(e = this._createDomElement).call(e, this), ur(i = this._appendDomElement).call(i, this), ur(n = this._updateDirtyDomComponents).call(n, this), function () {
          var t;
          a.dirty && (r = ur(t = a._getDomComponentsSizes).call(t, a)());
        }, function () {
          var t;
          a.dirty && ur(t = a._updateDomComponentsSizes).call(t, a)(r);
        }, ur(o = this._repaintDomAdditionals).call(o, this)];
        return t ? l : (nr(l).call(l, function (t) {
          s = t();
        }), s);
      }
    }, {
      key: "repositionY",
      value: function value(t) {
        var e,
            i = this.options.orientation.item;

        if (void 0 !== this.data.subgroup) {
          var n = this.data.subgroup;
          this.dom.box.style.height = "".concat(this.parent.subgroups[n].height, "px"), this.dom.box.style.top = "".concat("top" == i ? this.parent.top + this.parent.subgroups[n].top : this.parent.top + this.parent.height - this.parent.subgroups[n].top - this.parent.subgroups[n].height, "px"), this.dom.box.style.bottom = "";
        } else this.parent instanceof Sp ? (e = Math.max(this.parent.height, this.parent.itemSet.body.domProps.center.height, this.parent.itemSet.body.domProps.centerContainer.height), this.dom.box.style.bottom = "bottom" == i ? "0" : "", this.dom.box.style.top = "top" == i ? "0" : "") : (e = this.parent.height, this.dom.box.style.top = "".concat(this.parent.top, "px"), this.dom.box.style.bottom = "");

        this.dom.box.style.height = "".concat(e, "px");
      }
    }]), i;
  }(Mp);

  Rp.prototype.baseClassName = "vis-item vis-background", Rp.prototype.stack = !1, Rp.prototype.show = Ip.prototype.show, Rp.prototype.hide = Ip.prototype.hide, Rp.prototype.repositionX = Ip.prototype.repositionX;

  var Fp = function () {
    function t(e, i) {
      gn(this, t), this.container = e, this.overflowMethod = i || "cap", this.x = 0, this.y = 0, this.padding = 5, this.hidden = !1, this.frame = document.createElement("div"), this.frame.className = "vis-tooltip", this.container.appendChild(this.frame);
    }

    return _n(t, [{
      key: "setPosition",
      value: function value(t, e) {
        this.x = Qn(t), this.y = Qn(e);
      }
    }, {
      key: "setText",
      value: function value(t) {
        t instanceof Element ? (this.frame.innerHTML = "", this.frame.appendChild(t)) : this.frame.innerHTML = od.xss(t);
      }
    }, {
      key: "show",
      value: function value(t) {
        if (void 0 === t && (t = !0), !0 === t) {
          var e = this.frame.clientHeight,
              i = this.frame.clientWidth,
              n = this.frame.parentNode.clientHeight,
              o = this.frame.parentNode.clientWidth,
              r = 0,
              s = 0;

          if ("flip" == this.overflowMethod || "none" == this.overflowMethod) {
            var a = !1,
                l = !0;
            "flip" == this.overflowMethod && (this.y - e < this.padding && (l = !1), this.x + i > o - this.padding && (a = !0)), r = a ? this.x - i : this.x, s = l ? this.y - e : this.y;
          } else (s = this.y - e) + e + this.padding > n && (s = n - e - this.padding), s < this.padding && (s = this.padding), (r = this.x) + i + this.padding > o && (r = o - i - this.padding), r < this.padding && (r = this.padding);

          this.frame.style.left = r + "px", this.frame.style.top = s + "px", this.frame.style.visibility = "visible", this.hidden = !1;
        } else this.hide();
      }
    }, {
      key: "hide",
      value: function value() {
        this.hidden = !0, this.frame.style.left = "0", this.frame.style.top = "0", this.frame.style.visibility = "hidden";
      }
    }, {
      key: "destroy",
      value: function value() {
        this.frame.parentNode.removeChild(this.frame);
      }
    }]), t;
  }(),
      Yp = Te.every,
      jp = Rn("every"),
      Hp = Hn("every");

  U({
    target: "Array",
    proto: !0,
    forced: !jp || !Hp
  }, {
    every: function every(t) {
      return Yp(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var zp = tn("Array").every,
      Gp = Array.prototype,
      Wp = function Wp(t) {
    var e = t.every;
    return t === Gp || t instanceof Array && e === Gp.every ? zp : e;
  };

  function Bp(t, e) {
    var i;

    if (void 0 === cs || null == zi(t)) {
      if (Jr(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return Vp(t, e);
        var n = ns(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Qi(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Vp(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);

        var _n5 = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n5 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n5++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var r,
        s = !0,
        a = !1;
    return {
      s: function s() {
        i = Hi(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i.return || i.return();
        } finally {
          if (a) throw r;
        }
      }
    };
  }

  function Vp(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, n = new Array(e); i < e; i++) {
      n[i] = t[i];
    }

    return n;
  }

  function Up(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var Xp = function (t) {
    jh(i, t);
    var e = Up(i);

    function i(t, n, o) {
      var r;
      gn(this, i);
      var s = No({}, {
        fitOnDoubleClick: !0
      }, o, {
        editable: !1
      });
      if ((r = e.call(this, t, n, s)).props = {
        content: {
          width: 0,
          height: 0
        }
      }, !t || null == t.uiItems) throw new Error('Property "uiItems" missing in item ' + t.id);
      return r.id = Fu(), r.group = t.group, r._setupRange(), r.emitter = r.data.eventEmitter, r.range = r.data.range, r.attached = !1, r.isCluster = !0, r.data.isCluster = !0, r;
    }

    return _n(i, [{
      key: "hasItems",
      value: function value() {
        return this.data.uiItems && this.data.uiItems.length && this.attached;
      }
    }, {
      key: "setUiItems",
      value: function value(t) {
        this.detach(), this.data.uiItems = t, this._setupRange(), this.attach();
      }
    }, {
      key: "isVisible",
      value: function value(t) {
        var e = this.data.end ? this.data.end - this.data.start : 0,
            i = this.width * t.getMillisecondsPerPixel(),
            n = Math.max(this.data.start.getTime() + e, this.data.start.getTime() + i);
        return this.data.start < t.end && n > t.start && this.hasItems();
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          isCluster: !0,
          id: this.id,
          items: this.data.items || [],
          data: this.data
        };
      }
    }, {
      key: "redraw",
      value: function value(t) {
        var e,
            i,
            n,
            o,
            r,
            s,
            a,
            l,
            h = [ur(e = this._createDomElement).call(e, this), ur(i = this._appendDomElement).call(i, this), ur(n = this._updateDirtyDomComponents).call(n, this), ur(o = function o() {
          this.dirty && (a = this._getDomComponentsSizes());
        }).call(o, this), ur(r = function r() {
          var t;
          this.dirty && ur(t = this._updateDomComponentsSizes).call(t, this)(a);
        }).call(r, this), ur(s = this._repaintDomAdditionals).call(s, this)];
        return t ? h : (nr(h).call(h, function (t) {
          l = t();
        }), l);
      }
    }, {
      key: "show",
      value: function value() {
        this.displayed || this.redraw();
      }
    }, {
      key: "hide",
      value: function value() {
        if (this.displayed) {
          var t = this.dom;
          t.box.parentNode && t.box.parentNode.removeChild(t.box), this.options.showStipes && (t.line.parentNode && t.line.parentNode.removeChild(t.line), t.dot.parentNode && t.dot.parentNode.removeChild(t.dot)), this.displayed = !1;
        }
      }
    }, {
      key: "repositionX",
      value: function value() {
        var t = this.conversion.toScreen(this.data.start),
            e = this.data.end ? this.conversion.toScreen(this.data.end) : 0;
        if (e) this.repositionXWithRanges(t, e);else {
          var i = void 0 === this.data.align ? this.options.align : this.data.align;
          this.repositionXWithoutRanges(t, i);
        }
        this.options.showStipes && (this.dom.line.style.display = this._isStipeVisible() ? "block" : "none", this.dom.dot.style.display = this._isStipeVisible() ? "block" : "none", this._isStipeVisible() && this.repositionStype(t, e));
      }
    }, {
      key: "repositionStype",
      value: function value(t, e) {
        this.dom.line.style.display = "block", this.dom.dot.style.display = "block";
        var i = this.dom.line.offsetWidth,
            n = this.dom.dot.offsetWidth;

        if (e) {
          var o = i + t + (e - t) / 2,
              r = o - n / 2,
              s = this.options.rtl ? -1 * o : o,
              a = this.options.rtl ? -1 * r : r;
          this.dom.line.style.transform = "translateX(".concat(s, "px)"), this.dom.dot.style.transform = "translateX(".concat(a, "px)");
        } else {
          var l = this.options.rtl ? -1 * t : t,
              h = this.options.rtl ? -1 * (t - n / 2) : t - n / 2;
          this.dom.line.style.transform = "translateX(".concat(l, "px)"), this.dom.dot.style.transform = "translateX(".concat(h, "px)");
        }
      }
    }, {
      key: "repositionXWithoutRanges",
      value: function value(t, e) {
        "right" == e ? this.options.rtl ? (this.right = t - this.width, this.dom.box.style.right = this.right + "px") : (this.left = t - this.width, this.dom.box.style.left = this.left + "px") : "left" == e ? this.options.rtl ? (this.right = t, this.dom.box.style.right = this.right + "px") : (this.left = t, this.dom.box.style.left = this.left + "px") : this.options.rtl ? (this.right = t - this.width / 2, this.dom.box.style.right = this.right + "px") : (this.left = t - this.width / 2, this.dom.box.style.left = this.left + "px");
      }
    }, {
      key: "repositionXWithRanges",
      value: function value(t, e) {
        var i = Math.round(Math.max(e - t + .5, 1));
        this.options.rtl ? this.right = t : this.left = t, this.width = Math.max(i, this.minWidth || 0), this.options.rtl ? this.dom.box.style.right = this.right + "px" : this.dom.box.style.left = this.left + "px", this.dom.box.style.width = i + "px";
      }
    }, {
      key: "repositionY",
      value: function value() {
        var t = this.options.orientation.item,
            e = this.dom.box;

        if (e.style.top = "top" == t ? (this.top || 0) + "px" : (this.parent.height - this.top - this.height || 0) + "px", this.options.showStipes) {
          if ("top" == t) this.dom.line.style.top = "0", this.dom.line.style.height = this.parent.top + this.top + 1 + "px", this.dom.line.style.bottom = "";else {
            var i = this.parent.itemSet.props.height,
                n = i - this.parent.top - this.parent.height + this.top;
            this.dom.line.style.top = i - n + "px", this.dom.line.style.bottom = "0";
          }
          this.dom.dot.style.top = -this.dom.dot.offsetHeight / 2 + "px";
        }
      }
    }, {
      key: "getWidthLeft",
      value: function value() {
        return this.width / 2;
      }
    }, {
      key: "getWidthRight",
      value: function value() {
        return this.width / 2;
      }
    }, {
      key: "move",
      value: function value() {
        this.repositionX(), this.repositionY();
      }
    }, {
      key: "attach",
      value: function value() {
        var t,
            e,
            i = Bp(this.data.uiItems);

        try {
          for (i.s(); !(e = i.n()).done;) {
            e.value.cluster = this;
          }
        } catch (t) {
          i.e(t);
        } finally {
          i.f();
        }

        this.data.items = Kr(t = this.data.uiItems).call(t, function (t) {
          return t.data;
        }), this.attached = !0, this.dirty = !0;
      }
    }, {
      key: "detach",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];

        if (this.hasItems()) {
          var e,
              i = Bp(this.data.uiItems);

          try {
            for (i.s(); !(e = i.n()).done;) {
              var n = e.value;
              delete n.cluster;
            }
          } catch (t) {
            i.e(t);
          } finally {
            i.f();
          }

          this.attached = !1, t && this.group && (this.group.remove(this), this.group = null), this.data.items = [], this.dirty = !0;
        }
      }
    }, {
      key: "_onDoubleClick",
      value: function value() {
        this._fit();
      }
    }, {
      key: "_setupRange",
      value: function value() {
        var t,
            e,
            i,
            n = Kr(t = this.data.uiItems).call(t, function (t) {
          return {
            start: t.data.start.valueOf(),
            end: t.data.end ? t.data.end.valueOf() : t.data.start.valueOf()
          };
        });
        this.data.min = Math.min.apply(Math, as(Kr(n).call(n, function (t) {
          return Math.min(t.start, t.end || t.start);
        }))), this.data.max = Math.max.apply(Math, as(Kr(n).call(n, function (t) {
          return Math.max(t.start, t.end || t.start);
        })));
        var o = Kr(e = this.data.uiItems).call(e, function (t) {
          return t.center;
        }),
            r = Pu(o).call(o, function (t, e) {
          return t + e;
        }, 0) / this.data.uiItems.length;
        Nh(i = this.data.uiItems).call(i, function (t) {
          return t.data.end;
        }) ? (this.data.start = new Date(this.data.min), this.data.end = new Date(this.data.max)) : (this.data.start = new Date(r), this.data.end = null);
      }
    }, {
      key: "_getUiItems",
      value: function value() {
        var t,
            e = this;
        return this.data.uiItems && this.data.uiItems.length ? yo(t = this.data.uiItems).call(t, function (t) {
          return t.cluster === e;
        }) : [];
      }
    }, {
      key: "_createDomElement",
      value: function value() {
        if (!this.dom) {
          var t;
          if (this.dom = {}, this.dom.box = document.createElement("DIV"), this.dom.content = document.createElement("DIV"), this.dom.content.className = "vis-item-content", this.dom.box.appendChild(this.dom.content), this.options.showStipes && (this.dom.line = document.createElement("DIV"), this.dom.line.className = "vis-cluster-line", this.dom.line.style.display = "none", this.dom.dot = document.createElement("DIV"), this.dom.dot.className = "vis-cluster-dot", this.dom.dot.style.display = "none"), this.options.fitOnDoubleClick) this.dom.box.ondblclick = ur(t = i.prototype._onDoubleClick).call(t, this);
          this.dom.box["vis-item"] = this, this.dirty = !0;
        }
      }
    }, {
      key: "_appendDomElement",
      value: function value() {
        if (!this.parent) throw new Error("Cannot redraw item: no parent attached");

        if (!this.dom.box.parentNode) {
          var t = this.parent.dom.foreground;
          if (!t) throw new Error("Cannot redraw item: parent has no foreground container element");
          t.appendChild(this.dom.box);
        }

        var e = this.parent.dom.background;

        if (this.options.showStipes) {
          if (!this.dom.line.parentNode) {
            if (!e) throw new Error("Cannot redraw item: parent has no background container element");
            e.appendChild(this.dom.line);
          }

          if (!this.dom.dot.parentNode) {
            var i = this.parent.dom.axis;
            if (!e) throw new Error("Cannot redraw item: parent has no axis container element");
            i.appendChild(this.dom.dot);
          }
        }

        this.displayed = !0;
      }
    }, {
      key: "_updateDirtyDomComponents",
      value: function value() {
        if (this.dirty) {
          this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
          var t = this.baseClassName + " " + (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + " vis-readonly";
          this.dom.box.className = "vis-item " + t, this.options.showStipes && (this.dom.line.className = "vis-item vis-cluster-line " + (this.selected ? " vis-selected" : ""), this.dom.dot.className = "vis-item vis-cluster-dot " + (this.selected ? " vis-selected" : "")), this.data.end && (this.dom.content.style.maxWidth = "none");
        }
      }
    }, {
      key: "_getDomComponentsSizes",
      value: function value() {
        var t = {
          previous: {
            right: this.dom.box.style.right,
            left: this.dom.box.style.left
          },
          box: {
            width: this.dom.box.offsetWidth,
            height: this.dom.box.offsetHeight
          }
        };
        return this.options.showStipes && (t.dot = {
          height: this.dom.dot.offsetHeight,
          width: this.dom.dot.offsetWidth
        }, t.line = {
          width: this.dom.line.offsetWidth
        }), t;
      }
    }, {
      key: "_updateDomComponentsSizes",
      value: function value(t) {
        this.options.rtl ? this.dom.box.style.right = "0px" : this.dom.box.style.left = "0px", this.data.end ? this.minWidth = t.box.width : this.width = t.box.width, this.height = t.box.height, this.options.rtl ? this.dom.box.style.right = t.previous.right : this.dom.box.style.left = t.previous.left, this.dirty = !1;
      }
    }, {
      key: "_repaintDomAdditionals",
      value: function value() {
        this._repaintOnItemUpdateTimeTooltip(this.dom.box);
      }
    }, {
      key: "_isStipeVisible",
      value: function value() {
        return this.minWidth >= this.width || !this.data.end;
      }
    }, {
      key: "_getFitRange",
      value: function value() {
        var t = .05 * (this.data.max - this.data.min) / 2;
        return {
          fitStart: this.data.min - t,
          fitEnd: this.data.max + t
        };
      }
    }, {
      key: "_fit",
      value: function value() {
        if (this.emitter) {
          var t = this._getFitRange(),
              e = t.fitStart,
              i = t.fitEnd,
              n = {
            start: new Date(e),
            end: new Date(i),
            animation: !0
          };

          this.emitter.emit("fit", n);
        }
      }
    }, {
      key: "_getItemData",
      value: function value() {
        return this.data;
      }
    }]), i;
  }(Mp);

  function qp(t, e) {
    var i;

    if (void 0 === cs || null == zi(t)) {
      if (Jr(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return Zp(t, e);
        var n = ns(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Qi(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Zp(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);

        var _n6 = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n6 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n6++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var r,
        s = !0,
        a = !1;
    return {
      s: function s() {
        i = Hi(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i.return || i.return();
        } finally {
          if (a) throw r;
        }
      }
    };
  }

  function Zp(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, n = new Array(e); i < e; i++) {
      n[i] = t[i];
    }

    return n;
  }

  Xp.prototype.baseClassName = "vis-item vis-range vis-cluster";

  var $p = "__ungrouped__",
      Kp = function () {
    function t(e) {
      gn(this, t), this.itemSet = e, this.groups = {}, this.cache = {}, this.cache[-1] = [];
    }

    return _n(t, [{
      key: "createClusterItem",
      value: function value(t, e, i) {
        return new Xp(t, e, i);
      }
    }, {
      key: "setItems",
      value: function value(t, e) {
        this.items = t || [], this.dataChanged = !0, this.applyOnChangedLevel = !1, e && e.applyOnChangedLevel && (this.applyOnChangedLevel = e.applyOnChangedLevel);
      }
    }, {
      key: "updateData",
      value: function value() {
        this.dataChanged = !0, this.applyOnChangedLevel = !1;
      }
    }, {
      key: "getClusters",
      value: function value(t, e, i) {
        var n = "boolean" == typeof i ? {} : i,
            o = n.maxItems,
            r = n.clusterCriteria;
        r || (r = function r() {
          return !0;
        }), o = o || 1;
        var s = -1,
            a = 0;

        if (e > 0) {
          if (e >= 1) return [];
          s = Math.abs(Math.round(Math.log(100 / e) / Math.log(2))), a = Math.abs(Math.pow(2, s));
        }

        if (this.dataChanged) {
          var l = s != this.cacheLevel;
          (!this.applyOnChangedLevel || l) && (this._dropLevelsCache(), this._filterData());
        }

        this.cacheLevel = s;
        var h = this.cache[s];

        if (!h) {
          for (var u in h = [], this.groups) {
            if (this.groups.hasOwnProperty(u)) for (var c = this.groups[u], d = c.length, p = 0; p < d;) {
              for (var f = c[p], m = 1, v = p - 1; v >= 0 && f.center - c[v].center < a / 2;) {
                !c[v].cluster && r(f.data, c[v].data) && m++, v--;
              }

              for (var g = p + 1; g < c.length && c[g].center - f.center < a / 2;) {
                r(f.data, c[g].data) && m++, g++;
              }

              for (var y = h.length - 1; y >= 0 && f.center - h[y].center < a;) {
                f.group == h[y].group && r(f.data, h[y].data) && m++, y--;
              }

              if (m > o) {
                for (var b = m - o + 1, _ = [], w = p; _.length < b && w < c.length;) {
                  r(c[p].data, c[w].data) && _.push(c[w]), w++;
                }

                var k = this.itemSet.getGroupId(f.data),
                    x = this.itemSet.groups[k] || this.itemSet.groups[$p],
                    D = this._getClusterForItems(_, x, t, i);

                h.push(D), p += b;
              } else delete f.cluster, p += 1;
            }
          }

          this.cache[s] = h;
        }

        return h;
      }
    }, {
      key: "_filterData",
      value: function value() {
        var t = {};
        this.groups = t;

        for (var e = 0, i = ro(this.items); e < i.length; e++) {
          var n = i[e],
              o = n.parent ? n.parent.groupId : "",
              r = t[o];
          r || (r = [], t[o] = r), r.push(n), n.data.start && (n.data.end ? n.center = (n.data.start.valueOf() + n.data.end.valueOf()) / 2 : n.center = n.data.start.valueOf());
        }

        for (var s in t) {
          var a;
          if (t.hasOwnProperty(s)) $h(a = t[s]).call(a, function (t, e) {
            return t.center - e.center;
          });
        }

        this.dataChanged = !1;
      }
    }, {
      key: "_getClusterForItems",
      value: function value(t, e, i, n) {
        var o,
            r,
            s = Kr(o = i || []).call(o, function (t) {
          var e;
          return {
            cluster: t,
            itemsIds: new fu(Kr(e = t.data.uiItems).call(e, function (t) {
              return t.id;
            }))
          };
        });

        if (s.length) {
          var a,
              l = qp(s);

          try {
            var h = function h() {
              var e = a.value;
              if (e.itemsIds.size === t.length && Wp(t).call(t, function (t) {
                return e.itemsIds.has(t.id);
              })) return r = e.cluster, "break";
            };

            for (l.s(); !(a = l.n()).done;) {
              if ("break" === h()) break;
            }
          } catch (t) {
            l.e(t);
          } finally {
            l.f();
          }
        }

        if (r) return r.setUiItems(t), r.group !== e && (r.group && r.group.remove(r), e && (e.add(r), r.group = e)), r;
        var u = n.titleTemplate || "",
            c = {
          toScreen: this.itemSet.body.util.toScreen,
          toTime: this.itemSet.body.util.toTime
        },
            d = u.replace(/{count}/, t.length),
            p = '<div title="' + d + '">' + t.length + "</div>",
            f = No({}, n, this.itemSet.options),
            m = {
          content: p,
          title: d,
          group: e,
          uiItems: t,
          eventEmitter: this.itemSet.body.emitter,
          range: this.itemSet.body.range
        };
        return r = this.createClusterItem(m, c, f), e && (e.add(r), r.group = e), r.attach(), r;
      }
    }, {
      key: "_dropLevelsCache",
      value: function value() {
        this.cache = {}, this.cacheLevel = -1, this.cache[this.cacheLevel] = [];
      }
    }]), t;
  }();

  function Jp(t, e) {
    var i;

    if (void 0 === cs || null == zi(t)) {
      if (Jr(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return Qp(t, e);
        var n = ns(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Qi(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Qp(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);

        var _n7 = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n7 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n7++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var r,
        s = !0,
        a = !1;
    return {
      s: function s() {
        i = Hi(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i.return || i.return();
        } finally {
          if (a) throw r;
        }
      }
    };
  }

  function Qp(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, n = new Array(e); i < e; i++) {
      n[i] = t[i];
    }

    return n;
  }

  function tf(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var ef = "__ungrouped__",
      nf = "__background__",
      of = function (t) {
    jh(i, t);
    var e = tf(i);

    function i(t, n) {
      var o;
      gn(this, i), (o = e.call(this)).body = t, o.defaultOptions = {
        type: null,
        orientation: {
          item: "bottom"
        },
        align: "auto",
        stack: !0,
        stackSubgroups: !0,
        groupOrderSwap: function groupOrderSwap(t, e, i) {
          var n = e.order;
          e.order = t.order, t.order = n;
        },
        groupOrder: "order",
        selectable: !0,
        multiselect: !1,
        longSelectPressTime: 251,
        itemsAlwaysDraggable: {
          item: !1,
          range: !1
        },
        editable: {
          updateTime: !1,
          updateGroup: !1,
          add: !1,
          remove: !1,
          overrideItems: !1
        },
        groupEditable: {
          order: !1,
          add: !1,
          remove: !1
        },
        snap: Nd.snap,
        onDropObjectOnItem: function onDropObjectOnItem(t, e, i) {
          i(e);
        },
        onAdd: function onAdd(t, e) {
          e(t);
        },
        onUpdate: function onUpdate(t, e) {
          e(t);
        },
        onMove: function onMove(t, e) {
          e(t);
        },
        onRemove: function onRemove(t, e) {
          e(t);
        },
        onMoving: function onMoving(t, e) {
          e(t);
        },
        onAddGroup: function onAddGroup(t, e) {
          e(t);
        },
        onMoveGroup: function onMoveGroup(t, e) {
          e(t);
        },
        onRemoveGroup: function onRemoveGroup(t, e) {
          e(t);
        },
        margin: {
          item: {
            horizontal: 10,
            vertical: 10
          },
          axis: 20
        },
        showTooltips: !0,
        tooltip: {
          followMouse: !1,
          overflowMethod: "flip",
          delay: 500
        },
        tooltipOnItemUpdateTime: !1
      }, o.options = od.extend({}, o.defaultOptions), o.options.rtl = n.rtl, o.options.onTimeout = n.onTimeout, o.conversion = {
        toScreen: t.util.toScreen,
        toTime: t.util.toTime
      }, o.dom = {}, o.props = {}, o.hammer = null;
      var r = gh(o);
      return o.itemsData = null, o.groupsData = null, o.itemsSettingTime = null, o.initialItemSetDrawn = !1, o.userContinueNotBail = null, o.sequentialSelection = !1, o.itemListeners = {
        add: function add(t, e, i) {
          r._onAdd(e.items), r.options.cluster && r.clusterGenerator.setItems(r.items, {
            applyOnChangedLevel: !1
          }), r.redraw();
        },
        update: function update(t, e, i) {
          r._onUpdate(e.items), r.options.cluster && r.clusterGenerator.setItems(r.items, {
            applyOnChangedLevel: !1
          }), r.redraw();
        },
        remove: function remove(t, e, i) {
          r._onRemove(e.items), r.options.cluster && r.clusterGenerator.setItems(r.items, {
            applyOnChangedLevel: !1
          }), r.redraw();
        }
      }, o.groupListeners = {
        add: function add(t, e, i) {
          if (r._onAddGroups(e.items), r.groupsData && r.groupsData.length > 0) {
            var n,
                o = r.groupsData.getDataSet();
            nr(n = o.get()).call(n, function (t) {
              if (t.nestedGroups) {
                var e;
                0 != t.showNested && (t.showNested = !0);
                var n = [];
                nr(e = t.nestedGroups).call(e, function (e) {
                  var i = o.get(e);
                  i && (i.nestedInGroup = t.id, 0 == t.showNested && (i.visible = !1), n = us(n).call(n, i));
                }), o.update(n, i);
              }
            });
          }
        },
        update: function update(t, e, i) {
          r._onUpdateGroups(e.items);
        },
        remove: function remove(t, e, i) {
          r._onRemoveGroups(e.items);
        }
      }, o.items = {}, o.groups = {}, o.groupIds = [], o.selection = [], o.popup = null, o.popupTimer = null, o.touchParams = {}, o.groupTouchParams = {
        group: null,
        isDragging: !1
      }, o._create(), o.setOptions(n), o.clusters = [], o;
    }

    return _n(i, [{
      key: "_create",
      value: function value() {
        var t,
            e,
            i,
            n,
            o,
            r,
            s,
            a,
            l,
            h,
            u,
            c,
            d,
            p,
            f,
            m = this,
            v = document.createElement("div");
        v.className = "vis-itemset", v["vis-itemset"] = this, this.dom.frame = v;
        var g = document.createElement("div");
        g.className = "vis-background", v.appendChild(g), this.dom.background = g;
        var y = document.createElement("div");
        y.className = "vis-foreground", v.appendChild(y), this.dom.foreground = y;
        var b = document.createElement("div");
        b.className = "vis-axis", this.dom.axis = b;

        var _ = document.createElement("div");

        _.className = "vis-labelset", this.dom.labelSet = _, this._updateUngrouped();
        var w = new Sp(nf, null, this);
        w.show(), this.groups[nf] = w, this.hammer = new Ld(this.body.dom.centerContainer), this.hammer.on("hammer.input", function (t) {
          t.isFirst && m._onTouch(t);
        }), this.hammer.on("panstart", ur(t = this._onDragStart).call(t, this)), this.hammer.on("panmove", ur(e = this._onDrag).call(e, this)), this.hammer.on("panend", ur(i = this._onDragEnd).call(i, this)), this.hammer.get("pan").set({
          threshold: 5,
          direction: Ld.ALL
        }), this.hammer.on("tap", ur(n = this._onSelectItem).call(n, this)), this.hammer.on("press", ur(o = this._onMultiSelectItem).call(o, this)), this.hammer.on("doubletap", ur(r = this._onAddItem).call(r, this)), this.options.rtl ? this.groupHammer = new Ld(this.body.dom.rightContainer) : this.groupHammer = new Ld(this.body.dom.leftContainer), this.groupHammer.on("tap", ur(s = this._onGroupClick).call(s, this)), this.groupHammer.on("panstart", ur(a = this._onGroupDragStart).call(a, this)), this.groupHammer.on("panmove", ur(l = this._onGroupDrag).call(l, this)), this.groupHammer.on("panend", ur(h = this._onGroupDragEnd).call(h, this)), this.groupHammer.get("pan").set({
          threshold: 5,
          direction: Ld.DIRECTION_VERTICAL
        }), this.body.dom.centerContainer.addEventListener("mouseover", ur(u = this._onMouseOver).call(u, this)), this.body.dom.centerContainer.addEventListener("mouseout", ur(c = this._onMouseOut).call(c, this)), this.body.dom.centerContainer.addEventListener("mousemove", ur(d = this._onMouseMove).call(d, this)), this.body.dom.centerContainer.addEventListener("contextmenu", ur(p = this._onDragEnd).call(p, this)), this.body.dom.centerContainer.addEventListener("mousewheel", ur(f = this._onMouseWheel).call(f, this)), this.show();
      }
    }, {
      key: "setOptions",
      value: function value(t) {
        var e = this;

        if (t) {
          var i, n;
          od.selectiveExtend(["type", "rtl", "align", "order", "stack", "stackSubgroups", "selectable", "multiselect", "sequentialSelection", "multiselectPerGroup", "longSelectPressTime", "groupOrder", "dataAttributes", "template", "groupTemplate", "visibleFrameTemplate", "hide", "snap", "groupOrderSwap", "showTooltips", "tooltip", "tooltipOnItemUpdateTime", "groupHeightMode", "onTimeout"], this.options, t), "itemsAlwaysDraggable" in t && ("boolean" == typeof t.itemsAlwaysDraggable ? (this.options.itemsAlwaysDraggable.item = t.itemsAlwaysDraggable, this.options.itemsAlwaysDraggable.range = !1) : "object" === es(t.itemsAlwaysDraggable) && (od.selectiveExtend(["item", "range"], this.options.itemsAlwaysDraggable, t.itemsAlwaysDraggable), this.options.itemsAlwaysDraggable.item || (this.options.itemsAlwaysDraggable.range = !1))), "sequentialSelection" in t && "boolean" == typeof t.sequentialSelection && (this.options.sequentialSelection = t.sequentialSelection), "orientation" in t && ("string" == typeof t.orientation ? this.options.orientation.item = "top" === t.orientation ? "top" : "bottom" : "object" === es(t.orientation) && "item" in t.orientation && (this.options.orientation.item = t.orientation.item)), "margin" in t && ("number" == typeof t.margin ? (this.options.margin.axis = t.margin, this.options.margin.item.horizontal = t.margin, this.options.margin.item.vertical = t.margin) : "object" === es(t.margin) && (od.selectiveExtend(["axis"], this.options.margin, t.margin), "item" in t.margin && ("number" == typeof t.margin.item ? (this.options.margin.item.horizontal = t.margin.item, this.options.margin.item.vertical = t.margin.item) : "object" === es(t.margin.item) && od.selectiveExtend(["horizontal", "vertical"], this.options.margin.item, t.margin.item)))), nr(i = ["locale", "locales"]).call(i, function (i) {
            i in t && (e.options[i] = t[i]);
          }), "editable" in t && ("boolean" == typeof t.editable ? (this.options.editable.updateTime = t.editable, this.options.editable.updateGroup = t.editable, this.options.editable.add = t.editable, this.options.editable.remove = t.editable, this.options.editable.overrideItems = !1) : "object" === es(t.editable) && od.selectiveExtend(["updateTime", "updateGroup", "add", "remove", "overrideItems"], this.options.editable, t.editable)), "groupEditable" in t && ("boolean" == typeof t.groupEditable ? (this.options.groupEditable.order = t.groupEditable, this.options.groupEditable.add = t.groupEditable, this.options.groupEditable.remove = t.groupEditable) : "object" === es(t.groupEditable) && od.selectiveExtend(["order", "add", "remove"], this.options.groupEditable, t.groupEditable));
          nr(n = ["onDropObjectOnItem", "onAdd", "onUpdate", "onRemove", "onMove", "onMoving", "onAddGroup", "onMoveGroup", "onRemoveGroup"]).call(n, function (i) {
            var n = t[i];

            if (n) {
              var o;
              if ("function" != typeof n) throw new Error(us(o = "option ".concat(i, " must be a function ")).call(o, i, "(item, callback)"));
              e.options[i] = n;
            }
          }), t.cluster ? (No(this.options, {
            cluster: t.cluster
          }), this.clusterGenerator || (this.clusterGenerator = new Kp(this)), this.clusterGenerator.setItems(this.items, {
            applyOnChangedLevel: !1
          }), this.markDirty({
            refreshItems: !0,
            restackGroups: !0
          }), this.redraw()) : this.clusterGenerator ? (this._detachAllClusters(), this.clusters = [], this.clusterGenerator = null, this.options.cluster = void 0, this.markDirty({
            refreshItems: !0,
            restackGroups: !0
          }), this.redraw()) : this.markDirty();
        }
      }
    }, {
      key: "markDirty",
      value: function value(t) {
        this.groupIds = [], t && (t.refreshItems && nr(od).call(od, this.items, function (t) {
          t.dirty = !0, t.displayed && t.redraw();
        }), t.restackGroups && nr(od).call(od, this.groups, function (t, e) {
          e !== nf && (t.stackDirty = !0);
        }));
      }
    }, {
      key: "destroy",
      value: function value() {
        this.clearPopupTimer(), this.hide(), this.setItems(null), this.setGroups(null), this.hammer && this.hammer.destroy(), this.groupHammer && this.groupHammer.destroy(), this.hammer = null, this.body = null, this.conversion = null;
      }
    }, {
      key: "hide",
      value: function value() {
        this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame), this.dom.axis.parentNode && this.dom.axis.parentNode.removeChild(this.dom.axis), this.dom.labelSet.parentNode && this.dom.labelSet.parentNode.removeChild(this.dom.labelSet);
      }
    }, {
      key: "show",
      value: function value() {
        this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame), this.dom.axis.parentNode || this.body.dom.backgroundVertical.appendChild(this.dom.axis), this.dom.labelSet.parentNode || (this.options.rtl ? this.body.dom.right.appendChild(this.dom.labelSet) : this.body.dom.left.appendChild(this.dom.labelSet));
      }
    }, {
      key: "setPopupTimer",
      value: function value(t) {
        if (this.clearPopupTimer(), t) {
          var e = this.options.tooltip.delay || "number" == typeof this.options.tooltip.delay ? this.options.tooltip.delay : 500;
          this.popupTimer = hn(function () {
            t.show();
          }, e);
        }
      }
    }, {
      key: "clearPopupTimer",
      value: function value() {
        null != this.popupTimer && (clearTimeout(this.popupTimer), this.popupTimer = null);
      }
    }, {
      key: "setSelection",
      value: function value(t) {
        var e;
        null == t && (t = []), Jr(t) || (t = [t]);
        var i,
            n = Jp(yo(e = this.selection).call(e, function (e) {
          return -1 === qn(t).call(t, e);
        }));

        try {
          for (n.s(); !(i = n.n()).done;) {
            var o = i.value,
                r = this.getItemById(o);
            r && r.unselect();
          }
        } catch (t) {
          n.e(t);
        } finally {
          n.f();
        }

        this.selection = as(t);
        var s,
            a = Jp(t);

        try {
          for (a.s(); !(s = a.n()).done;) {
            var l = s.value,
                h = this.getItemById(l);
            h && h.select();
          }
        } catch (t) {
          a.e(t);
        } finally {
          a.f();
        }
      }
    }, {
      key: "getSelection",
      value: function value() {
        var t;
        return us(t = this.selection).call(t, []);
      }
    }, {
      key: "getVisibleItems",
      value: function value() {
        var t,
            e,
            i = this.body.range.getRange();
        this.options.rtl ? (t = this.body.util.toScreen(i.start), e = this.body.util.toScreen(i.end)) : (e = this.body.util.toScreen(i.start), t = this.body.util.toScreen(i.end));
        var n = [];

        for (var o in this.groups) {
          if (this.groups.hasOwnProperty(o)) {
            var r,
                s = this.groups[o],
                a = Jp(s.isVisible ? s.visibleItems : []);

            try {
              for (a.s(); !(r = a.n()).done;) {
                var l = r.value;
                this.options.rtl ? l.right < e && l.right + l.width > t && n.push(l.id) : l.left < t && l.left + l.width > e && n.push(l.id);
              }
            } catch (t) {
              a.e(t);
            } finally {
              a.f();
            }
          }
        }

        return n;
      }
    }, {
      key: "getVisibleGroups",
      value: function value() {
        var t = [];

        for (var e in this.groups) {
          if (this.groups.hasOwnProperty(e)) this.groups[e].isVisible && t.push(e);
        }

        return t;
      }
    }, {
      key: "getItemById",
      value: function value(t) {
        var e;
        return this.items[t] || up(e = this.clusters).call(e, function (e) {
          return e.id === t;
        });
      }
    }, {
      key: "_deselect",
      value: function value(t) {
        for (var e = this.selection, i = 0, n = e.length; i < n; i++) {
          if (e[i] == t) {
            Bo(e).call(e, i, 1);
            break;
          }
        }
      }
    }, {
      key: "redraw",
      value: function value() {
        var t = this,
            e = this.options.margin,
            i = this.body.range,
            n = od.option.asSize,
            o = this.options,
            r = o.orientation.item,
            s = !1,
            a = this.dom.frame;
        this.props.top = this.body.domProps.top.height + this.body.domProps.border.top, this.options.rtl ? this.props.right = this.body.domProps.right.width + this.body.domProps.border.right : this.props.left = this.body.domProps.left.width + this.body.domProps.border.left, a.className = "vis-itemset", this.options.cluster && this._clusterItems(), s = this._orderGroups() || s;
        var l = i.end - i.start,
            h = l != this.lastVisibleInterval || this.props.width != this.props.lastWidth,
            u = i.start != this.lastRangeStart,
            c = o.stack != this.lastStack,
            d = o.stackSubgroups != this.lastStackSubgroups,
            p = h || u || c || d;
        this.lastVisibleInterval = l, this.lastRangeStart = i.start, this.lastStack = o.stack, this.lastStackSubgroups = o.stackSubgroups, this.props.lastWidth = this.props.width;

        var f = this._firstGroup(),
            m = {
          item: e.item,
          axis: e.axis
        },
            v = {
          item: e.item,
          axis: e.item.vertical / 2
        },
            g = 0,
            y = e.axis + e.item.vertical;

        this.groups[nf].redraw(i, v, p);
        var b = {},
            _ = 0;
        return nr(od).call(od, this.groups, function (t, e) {
          if (e !== nf) {
            var n = t == f ? m : v;
            b[e] = t.redraw(i, n, p, !0), _ = b[e].length;
          }
        }), _ > 0 && function () {
          for (var e = {}, i = function i(t) {
            nr(od).call(od, b, function (i, n) {
              e[n] = i[t]();
            });
          }, n = 0; n < _; n++) {
            i(n);
          }

          nr(od).call(od, t.groups, function (t, i) {
            if (i !== nf) {
              var n = e[i];
              s = n || s, g += t.height;
            }
          }), g = Math.max(g, y);
        }(), g = Math.max(g, y), a.style.height = n(g), this.props.width = a.offsetWidth, this.props.height = g, this.dom.axis.style.top = n("top" == r ? this.body.domProps.top.height + this.body.domProps.border.top : this.body.domProps.top.height + this.body.domProps.centerContainer.height), this.options.rtl ? this.dom.axis.style.right = "0" : this.dom.axis.style.left = "0", this.hammer.get("press").set({
          time: this.options.longSelectPressTime
        }), this.initialItemSetDrawn = !0, s = this._isResized() || s;
      }
    }, {
      key: "_firstGroup",
      value: function value() {
        var t = "top" == this.options.orientation.item ? 0 : this.groupIds.length - 1,
            e = this.groupIds[t];
        return this.groups[e] || this.groups[ef] || null;
      }
    }, {
      key: "_updateUngrouped",
      value: function value() {
        var t,
            e,
            i = this.groups[ef];

        if (this.groupsData) {
          if (i) for (e in i.dispose(), delete this.groups[ef], this.items) {
            if (this.items.hasOwnProperty(e)) {
              (t = this.items[e]).parent && t.parent.remove(t);
              var n = this.getGroupId(t.data),
                  o = this.groups[n];
              o && o.add(t) || t.hide();
            }
          }
        } else if (!i) {
          for (e in i = new xp(null, null, this), this.groups[ef] = i, this.items) {
            this.items.hasOwnProperty(e) && (t = this.items[e], i.add(t));
          }

          i.show();
        }
      }
    }, {
      key: "getLabelSet",
      value: function value() {
        return this.dom.labelSet;
      }
    }, {
      key: "setItems",
      value: function value(t) {
        this.itemsSettingTime = new Date();
        var e,
            i = this,
            n = this.itemsData;

        if (t) {
          if (!Ju("id", t)) throw new TypeError("Data must implement the interface of DataSet or DataView");
          this.itemsData = nd(t);
        } else this.itemsData = null;

        if (n && (nr(od).call(od, this.itemListeners, function (t, e) {
          n.off(e, t);
        }), n.dispose(), e = n.getIds(), this._onRemove(e)), this.itemsData) {
          var o = this.id;
          nr(od).call(od, this.itemListeners, function (t, e) {
            i.itemsData.on(e, t, o);
          }), e = this.itemsData.getIds(), this._onAdd(e), this._updateUngrouped();
        }

        this.body.emitter.emit("_change", {
          queue: !0
        });
      }
    }, {
      key: "getItems",
      value: function value() {
        return null != this.itemsData ? this.itemsData.rawDS : null;
      }
    }, {
      key: "setGroups",
      value: function value(t) {
        var e,
            i = this;

        if (this.groupsData && (nr(od).call(od, this.groupListeners, function (t, e) {
          i.groupsData.off(e, t);
        }), e = this.groupsData.getIds(), this.groupsData = null, this._onRemoveGroups(e)), t) {
          if (!Ju("id", t)) throw new TypeError("Data must implement the interface of DataSet or DataView");
          this.groupsData = t;
        } else this.groupsData = null;

        if (this.groupsData) {
          var n,
              o = this.groupsData.getDataSet();
          nr(n = o.get()).call(n, function (t) {
            var e;
            t.nestedGroups && nr(e = t.nestedGroups).call(e, function (e) {
              var i = o.get(e);
              i.nestedInGroup = t.id, 0 == t.showNested && (i.visible = !1), o.update(i);
            });
          });
          var r = this.id;
          nr(od).call(od, this.groupListeners, function (t, e) {
            i.groupsData.on(e, t, r);
          }), e = this.groupsData.getIds(), this._onAddGroups(e);
        }

        this._updateUngrouped(), this._order(), this.options.cluster && (this.clusterGenerator.updateData(), this._clusterItems(), this.markDirty({
          refreshItems: !0,
          restackGroups: !0
        })), this.body.emitter.emit("_change", {
          queue: !0
        });
      }
    }, {
      key: "getGroups",
      value: function value() {
        return this.groupsData;
      }
    }, {
      key: "removeItem",
      value: function value(t) {
        var e = this,
            i = this.itemsData.get(t);
        i && this.options.onRemove(i, function (i) {
          i && e.itemsData.remove(t);
        });
      }
    }, {
      key: "_getType",
      value: function value(t) {
        return t.type || this.options.type || (t.end ? "range" : "box");
      }
    }, {
      key: "getGroupId",
      value: function value(t) {
        return "background" == this._getType(t) && null == t.group ? nf : this.groupsData ? t.group : ef;
      }
    }, {
      key: "_onUpdate",
      value: function value(t) {
        var e = this,
            n = this;
        nr(t).call(t, function (t) {
          var o,
              r = n.itemsData.get(t),
              s = n.items[t],
              a = r ? n._getType(r) : null,
              l = i.types[a];

          if (s && (l && s instanceof l ? n._updateItem(s, r) : (o = s.selected, n._removeItem(s), s = null)), !s && r) {
            if (!l) throw new TypeError('Unknown item type "'.concat(a, '"'));
            (s = new l(r, n.conversion, n.options)).id = t, n._addItem(s), o && (e.selection.push(t), s.select());
          }
        }), this._order(), this.options.cluster && (this.clusterGenerator.setItems(this.items, {
          applyOnChangedLevel: !1
        }), this._clusterItems()), this.body.emitter.emit("_change", {
          queue: !0
        });
      }
    }, {
      key: "_onRemove",
      value: function value(t) {
        var e = 0,
            i = this;
        nr(t).call(t, function (t) {
          var n = i.items[t];
          n && (e++, i._removeItem(n));
        }), e && (this._order(), this.body.emitter.emit("_change", {
          queue: !0
        }));
      }
    }, {
      key: "_order",
      value: function value() {
        nr(od).call(od, this.groups, function (t) {
          t.order();
        });
      }
    }, {
      key: "_onUpdateGroups",
      value: function value(t) {
        this._onAddGroups(t);
      }
    }, {
      key: "_onAddGroups",
      value: function value(t) {
        var e = this;
        nr(t).call(t, function (t) {
          var i = e.groupsData.get(t),
              n = e.groups[t];
          if (n) n.setData(i);else {
            if (t == ef || t == nf) throw new Error("Illegal group id. ".concat(t, " is a reserved id."));
            var o = xn(e.options);

            for (var r in od.extend(o, {
              height: null
            }), n = new xp(t, i, e), e.groups[t] = n, e.items) {
              if (e.items.hasOwnProperty(r)) {
                var s = e.items[r];
                s.data.group == t && n.add(s);
              }
            }

            n.order(), n.show();
          }
        }), this.body.emitter.emit("_change", {
          queue: !0
        });
      }
    }, {
      key: "_onRemoveGroups",
      value: function value(t) {
        var e = this;
        nr(t).call(t, function (t) {
          var i = e.groups[t];
          i && (i.dispose(), delete e.groups[t]);
        }), this.options.cluster && (this.clusterGenerator.updateData(), this._clusterItems()), this.markDirty({
          restackGroups: !!this.options.cluster
        }), this.body.emitter.emit("_change", {
          queue: !0
        });
      }
    }, {
      key: "_orderGroups",
      value: function value() {
        if (this.groupsData) {
          var t = this.groupsData.getIds({
            order: this.options.groupOrder
          });
          t = this._orderNestedGroups(t);
          var e = !od.equalArray(t, this.groupIds);

          if (e) {
            var i = this.groups;
            nr(t).call(t, function (t) {
              i[t].hide();
            }), nr(t).call(t, function (t) {
              i[t].show();
            }), this.groupIds = t;
          }

          return e;
        }

        return !1;
      }
    }, {
      key: "_orderNestedGroups",
      value: function value(t) {
        var e = this;
        return function t(e, i) {
          var n = [];
          return nr(i).call(i, function (i) {
            if (n.push(i), e.groupsData.get(i).nestedGroups) {
              var o,
                  r = Kr(o = e.groupsData.get({
                filter: function filter(t) {
                  return t.nestedInGroup == i;
                },
                order: e.options.groupOrder
              })).call(o, function (t) {
                return t.id;
              });
              n = us(n).call(n, t(e, r));
            }
          }), n;
        }(this, yo(t).call(t, function (t) {
          return !e.groupsData.get(t).nestedInGroup;
        }));
      }
    }, {
      key: "_addItem",
      value: function value(t) {
        this.items[t.id] = t;
        var e = this.getGroupId(t.data),
            i = this.groups[e];
        i ? i && i.data && i.data.showNested && (t.groupShowing = !0) : t.groupShowing = !1, i && i.add(t);
      }
    }, {
      key: "_updateItem",
      value: function value(t, e) {
        t.setData(e);
        var i = this.getGroupId(t.data),
            n = this.groups[i];
        n ? n && n.data && n.data.showNested && (t.groupShowing = !0) : t.groupShowing = !1;
      }
    }, {
      key: "_removeItem",
      value: function value(t) {
        var e, i;
        t.hide(), delete this.items[t.id];
        var n = qn(e = this.selection).call(e, t.id);
        -1 != n && Bo(i = this.selection).call(i, n, 1), t.parent && t.parent.remove(t), null != this.popup && this.popup.hide();
      }
    }, {
      key: "_constructByEndArray",
      value: function value(t) {
        for (var e = [], i = 0; i < t.length; i++) {
          t[i] instanceof Ip && e.push(t[i]);
        }

        return e;
      }
    }, {
      key: "_onTouch",
      value: function value(t) {
        this.touchParams.item = this.itemFromTarget(t), this.touchParams.dragLeftItem = t.target.dragLeftItem || !1, this.touchParams.dragRightItem = t.target.dragRightItem || !1, this.touchParams.itemProps = null;
      }
    }, {
      key: "_getGroupIndex",
      value: function value(t) {
        for (var e = 0; e < this.groupIds.length; e++) {
          if (t == this.groupIds[e]) return e;
        }
      }
    }, {
      key: "_onDragStart",
      value: function value(t) {
        var e = this;

        if (!this.touchParams.itemIsDragging) {
          var i,
              n = this.touchParams.item || null,
              o = this;

          if (n && (n.selected || this.options.itemsAlwaysDraggable.item)) {
            if (this.options.editable.overrideItems && !this.options.editable.updateTime && !this.options.editable.updateGroup) return;
            if (null != n.editable && !n.editable.updateTime && !n.editable.updateGroup && !this.options.editable.overrideItems) return;
            var r = this.touchParams.dragLeftItem,
                s = this.touchParams.dragRightItem;
            if (this.touchParams.itemIsDragging = !0, this.touchParams.selectedItem = n, r) i = {
              item: r,
              initialX: t.center.x,
              dragLeft: !0,
              data: this._cloneItemData(n.data)
            }, this.touchParams.itemProps = [i];else if (s) i = {
              item: s,
              initialX: t.center.x,
              dragRight: !0,
              data: this._cloneItemData(n.data)
            }, this.touchParams.itemProps = [i];else if (this.options.editable.add && (t.srcEvent.ctrlKey || t.srcEvent.metaKey)) this._onDragStartAddItem(t);else {
              this.groupIds.length < 1 && this.redraw();

              var a = this._getGroupIndex(n.data.group),
                  l = this.options.itemsAlwaysDraggable.item && !n.selected ? [n.id] : this.getSelection();

              this.touchParams.itemProps = Kr(l).call(l, function (i) {
                var n = o.items[i],
                    r = o._getGroupIndex(n.data.group);

                return {
                  item: n,
                  initialX: t.center.x,
                  groupOffset: a - r,
                  data: e._cloneItemData(n.data)
                };
              });
            }
            t.stopPropagation();
          } else this.options.editable.add && (t.srcEvent.ctrlKey || t.srcEvent.metaKey) && this._onDragStartAddItem(t);
        }
      }
    }, {
      key: "_onDragStartAddItem",
      value: function value(t) {
        var e = this.options.snap || null,
            i = this.dom.frame.getBoundingClientRect(),
            n = this.options.rtl ? i.right - t.center.x + 10 : t.center.x - i.left - 10,
            o = this.body.util.toTime(n),
            r = this.body.util.getScale(),
            s = this.body.util.getStep(),
            a = e ? e(o, r, s) : o,
            l = {
          type: "range",
          start: a,
          end: a,
          content: "new item"
        },
            h = Fu();
        l[this.itemsData.idProp] = h;
        var u = this.groupFromTarget(t);
        u && (l.group = u.groupId);
        var c = new Ip(l, this.conversion, this.options);
        c.id = h, c.data = this._cloneItemData(l), this._addItem(c), this.touchParams.selectedItem = c;
        var d = {
          item: c,
          initialX: t.center.x,
          data: c.data
        };
        this.options.rtl ? d.dragLeft = !0 : d.dragRight = !0, this.touchParams.itemProps = [d], t.stopPropagation();
      }
    }, {
      key: "_onDrag",
      value: function value(t) {
        var e = this;

        if (null != this.popup && this.options.showTooltips && !this.popup.hidden) {
          var i = this.body.dom.centerContainer,
              n = i.getBoundingClientRect();
          this.popup.setPosition(t.center.x - n.left + i.offsetLeft, t.center.y - n.top + i.offsetTop), this.popup.show();
        }

        if (this.touchParams.itemProps) {
          var o;
          t.stopPropagation();
          var r = this,
              s = this.options.snap || null,
              a = this.body.dom.root.offsetLeft,
              l = this.options.rtl ? a + this.body.domProps.right.width : a + this.body.domProps.left.width,
              h = this.body.util.getScale(),
              u = this.body.util.getStep(),
              c = this.touchParams.selectedItem,
              d = (this.options.editable.overrideItems || null == c.editable) && this.options.editable.updateGroup || !this.options.editable.overrideItems && null != c.editable && c.editable.updateGroup,
              p = null;

          if (d && c && null != c.data.group) {
            var f = r.groupFromTarget(t);
            f && (p = this._getGroupIndex(f.groupId));
          }

          nr(o = this.touchParams.itemProps).call(o, function (i) {
            var n,
                o,
                a,
                f,
                m,
                v = r.body.util.toTime(t.center.x - l),
                g = r.body.util.toTime(i.initialX - l);
            n = e.options.rtl ? -(v - g) : v - g;

            var y = e._cloneItemData(i.item.data);

            if (null == i.item.editable || i.item.editable.updateTime || i.item.editable.updateGroup || r.options.editable.overrideItems) {
              if ((e.options.editable.overrideItems || null == c.editable) && e.options.editable.updateTime || !e.options.editable.overrideItems && null != c.editable && c.editable.updateTime) if (i.dragLeft) e.options.rtl ? null != y.end && (a = od.convert(i.data.end, "Date"), m = new Date(a.valueOf() + n), y.end = s ? s(m, h, u) : m) : null != y.start && (o = od.convert(i.data.start, "Date"), f = new Date(o.valueOf() + n), y.start = s ? s(f, h, u) : f);else if (i.dragRight) e.options.rtl ? null != y.start && (o = od.convert(i.data.start, "Date"), f = new Date(o.valueOf() + n), y.start = s ? s(f, h, u) : f) : null != y.end && (a = od.convert(i.data.end, "Date"), m = new Date(a.valueOf() + n), y.end = s ? s(m, h, u) : m);else if (null != y.start) if (o = od.convert(i.data.start, "Date").valueOf(), f = new Date(o + n), null != y.end) {
                var b = (a = od.convert(i.data.end, "Date")).valueOf() - o.valueOf();
                y.start = s ? s(f, h, u) : f, y.end = new Date(y.start.valueOf() + b);
              } else y.start = s ? s(f, h, u) : f;

              if (d && !i.dragLeft && !i.dragRight && null != p && null != y.group) {
                var _ = p - i.groupOffset;

                _ = Math.max(0, _), _ = Math.min(r.groupIds.length - 1, _), y.group = r.groupIds[_];
              }

              y = e._cloneItemData(y), r.options.onMoving(y, function (t) {
                t && i.item.setData(e._cloneItemData(t, "Date"));
              });
            }
          }), this.body.emitter.emit("_change");
        }
      }
    }, {
      key: "_moveToGroup",
      value: function value(t, e) {
        var i = this.groups[e];

        if (i && i.groupId != t.data.group) {
          var n = t.parent;
          n.remove(t), n.order(), t.data.group = i.groupId, i.add(t), i.order();
        }
      }
    }, {
      key: "_onDragEnd",
      value: function value(t) {
        var e = this;

        if (this.touchParams.itemIsDragging = !1, this.touchParams.itemProps) {
          t.stopPropagation();
          var i = this,
              n = this.touchParams.itemProps;
          this.touchParams.itemProps = null, nr(n).call(n, function (t) {
            var n = t.item.id;

            if (null != i.itemsData.get(n)) {
              var o = e._cloneItemData(t.item.data);

              i.options.onMove(o, function (o) {
                o ? (o[e.itemsData.idProp] = n, e.itemsData.update(o)) : (t.item.setData(t.data), i.body.emitter.emit("_change"));
              });
            } else i.options.onAdd(t.item.data, function (e) {
              i._removeItem(t.item), e && i.itemsData.add(e), i.body.emitter.emit("_change");
            });
          });
        }
      }
    }, {
      key: "_onGroupClick",
      value: function value(t) {
        var e = this,
            i = this.groupFromTarget(t);
        hn(function () {
          e.toggleGroupShowNested(i);
        }, 1);
      }
    }, {
      key: "toggleGroupShowNested",
      value: function value(t) {
        var e,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;

        if (t && t.nestedGroups) {
          var n = this.groupsData.getDataSet();
          t.showNested = null != i ? !!i : !t.showNested;
          var o = n.get(t.groupId);
          o.showNested = t.showNested;

          for (var r = t.nestedGroups, s = r; s.length > 0;) {
            var a = s;
            s = [];

            for (var l = 0; l < a.length; l++) {
              var h = n.get(a[l]);
              h.nestedGroups && (s = us(s).call(s, h.nestedGroups));
            }

            s.length > 0 && (r = us(r).call(r, s));
          }

          var u = Kr(e = n.get(r)).call(e, function (t) {
            return null == t.visible && (t.visible = !0), t.visible = !!o.showNested, t;
          });
          n.update(us(u).call(u, o)), o.showNested ? (od.removeClassName(t.dom.label, "collapsed"), od.addClassName(t.dom.label, "expanded")) : (od.removeClassName(t.dom.label, "expanded"), od.addClassName(t.dom.label, "collapsed"));
        }
      }
    }, {
      key: "toggleGroupDragClassName",
      value: function value(t) {
        t.dom.label.classList.toggle("vis-group-is-dragging"), t.dom.foreground.classList.toggle("vis-group-is-dragging");
      }
    }, {
      key: "_onGroupDragStart",
      value: function value(t) {
        this.groupTouchParams.isDragging || this.options.groupEditable.order && (this.groupTouchParams.group = this.groupFromTarget(t), this.groupTouchParams.group && (t.stopPropagation(), this.groupTouchParams.isDragging = !0, this.toggleGroupDragClassName(this.groupTouchParams.group), this.groupTouchParams.originalOrder = this.groupsData.getIds({
          order: this.options.groupOrder
        })));
      }
    }, {
      key: "_onGroupDrag",
      value: function value(t) {
        if (this.options.groupEditable.order && this.groupTouchParams.group) {
          t.stopPropagation();
          var e = this.groupsData.getDataSet(),
              i = this.groupFromTarget(t);

          if (i && i.height != this.groupTouchParams.group.height) {
            var n = i.top < this.groupTouchParams.group.top,
                o = t.center ? t.center.y : t.clientY,
                r = i.dom.foreground.getBoundingClientRect(),
                s = this.groupTouchParams.group.height;

            if (n) {
              if (r.top + s < o) return;
            } else {
              var a = i.height;
              if (r.top + a - s > o) return;
            }
          }

          if (i && i != this.groupTouchParams.group) {
            var l = e.get(i.groupId),
                h = e.get(this.groupTouchParams.group.groupId);
            h && l && (this.options.groupOrderSwap(h, l, e), e.update(h), e.update(l));
            var u = e.getIds({
              order: this.options.groupOrder
            });
            if (!od.equalArray(u, this.groupTouchParams.originalOrder)) for (var c = this.groupTouchParams.originalOrder, d = this.groupTouchParams.group.groupId, p = Math.min(c.length, u.length), f = 0, m = 0, v = 0; f < p;) {
              for (; f + m < p && f + v < p && u[f + m] == c[f + v];) {
                f++;
              }

              if (f + m >= p) break;
              if (u[f + m] == d) m = 1;else if (c[f + v] == d) v = 1;else {
                var g = qn(u).call(u, c[f + v]),
                    y = e.get(u[f + m]),
                    b = e.get(c[f + v]);
                this.options.groupOrderSwap(y, b, e), e.update(y), e.update(b);
                var _ = u[f + m];
                u[f + m] = c[f + v], u[g] = _, f++;
              }
            }
          }
        }
      }
    }, {
      key: "_onGroupDragEnd",
      value: function value(t) {
        if (this.groupTouchParams.isDragging = !1, this.options.groupEditable.order && this.groupTouchParams.group) {
          t.stopPropagation();
          var e = this,
              i = e.groupTouchParams.group.groupId,
              n = e.groupsData.getDataSet(),
              o = od.extend({}, n.get(i));
          e.options.onMoveGroup(o, function (t) {
            if (t) t[n._idProp] = i, n.update(t);else {
              var o = n.getIds({
                order: e.options.groupOrder
              });
              if (!od.equalArray(o, e.groupTouchParams.originalOrder)) for (var r = e.groupTouchParams.originalOrder, s = Math.min(r.length, o.length), a = 0; a < s;) {
                for (; a < s && o[a] == r[a];) {
                  a++;
                }

                if (a >= s) break;
                var l = qn(o).call(o, r[a]),
                    h = n.get(o[a]),
                    u = n.get(r[a]);
                e.options.groupOrderSwap(h, u, n), n.update(h), n.update(u);
                var c = o[a];
                o[a] = r[a], o[l] = c, a++;
              }
            }
          }), e.body.emitter.emit("groupDragged", {
            groupId: i
          }), this.toggleGroupDragClassName(this.groupTouchParams.group), this.groupTouchParams.group = null;
        }
      }
    }, {
      key: "_onSelectItem",
      value: function value(t) {
        if (this.options.selectable) {
          var e = t.srcEvent && (t.srcEvent.ctrlKey || t.srcEvent.metaKey),
              i = t.srcEvent && t.srcEvent.shiftKey;
          if (e || i) this._onMultiSelectItem(t);else {
            var n = this.getSelection(),
                o = this.itemFromTarget(t),
                r = o && o.selectable ? [o.id] : [];
            this.setSelection(r);
            var s = this.getSelection();
            (s.length > 0 || n.length > 0) && this.body.emitter.emit("select", {
              items: s,
              event: t
            });
          }
        }
      }
    }, {
      key: "_onMouseOver",
      value: function value(t) {
        var e = this.itemFromTarget(t);

        if (e && e !== this.itemFromRelatedTarget(t)) {
          var i = e.getTitle();

          if (this.options.showTooltips && i) {
            null == this.popup && (this.popup = new Fp(this.body.dom.root, this.options.tooltip.overflowMethod || "flip")), this.popup.setText(i);
            var n = this.body.dom.centerContainer,
                o = n.getBoundingClientRect();
            this.popup.setPosition(t.clientX - o.left + n.offsetLeft, t.clientY - o.top + n.offsetTop), this.setPopupTimer(this.popup);
          } else this.clearPopupTimer(), null != this.popup && this.popup.hide();

          this.body.emitter.emit("itemover", {
            item: e.id,
            event: t
          });
        }
      }
    }, {
      key: "_onMouseOut",
      value: function value(t) {
        var e = this.itemFromTarget(t);
        e && e !== this.itemFromRelatedTarget(t) && (this.clearPopupTimer(), null != this.popup && this.popup.hide(), this.body.emitter.emit("itemout", {
          item: e.id,
          event: t
        }));
      }
    }, {
      key: "_onMouseMove",
      value: function value(t) {
        if (this.itemFromTarget(t) && (null != this.popupTimer && this.setPopupTimer(this.popup), this.options.showTooltips && this.options.tooltip.followMouse && this.popup && !this.popup.hidden)) {
          var e = this.body.dom.centerContainer,
              i = e.getBoundingClientRect();
          this.popup.setPosition(t.clientX - i.left + e.offsetLeft, t.clientY - i.top + e.offsetTop), this.popup.show();
        }
      }
    }, {
      key: "_onMouseWheel",
      value: function value(t) {
        this.touchParams.itemIsDragging && this._onDragEnd(t);
      }
    }, {
      key: "_onUpdateItem",
      value: function value(t) {
        if (this.options.selectable && (this.options.editable.updateTime || this.options.editable.updateGroup)) {
          var e = this;

          if (t) {
            var i = e.itemsData.get(t.id);
            this.options.onUpdate(i, function (t) {
              t && e.itemsData.update(t);
            });
          }
        }
      }
    }, {
      key: "_onDropObjectOnItem",
      value: function value(t) {
        var e = this.itemFromTarget(t),
            i = JSON.parse(t.dataTransfer.getData("text"));
        this.options.onDropObjectOnItem(i, e);
      }
    }, {
      key: "_onAddItem",
      value: function value(t) {
        if (this.options.selectable && this.options.editable.add) {
          var e,
              i,
              n = this,
              o = this.options.snap || null,
              r = this.dom.frame.getBoundingClientRect(),
              s = this.options.rtl ? r.right - t.center.x : t.center.x - r.left,
              a = this.body.util.toTime(s),
              l = this.body.util.getScale(),
              h = this.body.util.getStep();
          "drop" == t.type ? ((i = JSON.parse(t.dataTransfer.getData("text"))).content = i.content ? i.content : "new item", i.start = i.start ? i.start : o ? o(a, l, h) : a, i.type = i.type || "box", i[this.itemsData.idProp] = i.id || Fu(), "range" != i.type || i.end || (e = this.body.util.toTime(s + this.props.width / 5), i.end = o ? o(e, l, h) : e)) : ((i = {
            start: o ? o(a, l, h) : a,
            content: "new item"
          })[this.itemsData.idProp] = Fu(), "range" === this.options.type && (e = this.body.util.toTime(s + this.props.width / 5), i.end = o ? o(e, l, h) : e));
          var u = this.groupFromTarget(t);
          u && (i.group = u.groupId), i = this._cloneItemData(i), this.options.onAdd(i, function (e) {
            e && (n.itemsData.add(e), "drop" == t.type && n.setSelection([e.id]));
          });
        }
      }
    }, {
      key: "_onMultiSelectItem",
      value: function value(t) {
        var e = this;

        if (this.options.selectable) {
          var n = this.itemFromTarget(t);

          if (n) {
            var o = this.options.multiselect ? this.getSelection() : [];

            if ((t.srcEvent && t.srcEvent.shiftKey || !1 || this.options.sequentialSelection) && this.options.multiselect) {
              var r = this.itemsData.get(n.id).group,
                  s = void 0;
              this.options.multiselectPerGroup && o.length > 0 && (s = this.itemsData.get(o[0]).group), this.options.multiselectPerGroup && null != s && s != r || o.push(n.id);

              var a = i._getItemRange(this.itemsData.get(o));

              if (!this.options.multiselectPerGroup || s == r) for (var l in o = [], this.items) {
                if (this.items.hasOwnProperty(l)) {
                  var h = this.items[l],
                      u = h.data.start,
                      c = void 0 !== h.data.end ? h.data.end : u;
                  !(u >= a.min && c <= a.max) || this.options.multiselectPerGroup && s != this.itemsData.get(h.id).group || h instanceof Rp || o.push(h.id);
                }
              }
            } else {
              var d = qn(o).call(o, n.id);
              -1 == d ? o.push(n.id) : Bo(o).call(o, d, 1);
            }

            var p = yo(o).call(o, function (t) {
              return e.getItemById(t).selectable;
            });
            this.setSelection(p), this.body.emitter.emit("select", {
              items: this.getSelection(),
              event: t
            });
          }
        }
      }
    }, {
      key: "itemFromElement",
      value: function value(t) {
        for (var e = t; e;) {
          if (e.hasOwnProperty("vis-item")) return e["vis-item"];
          e = e.parentNode;
        }

        return null;
      }
    }, {
      key: "itemFromTarget",
      value: function value(t) {
        return this.itemFromElement(t.target);
      }
    }, {
      key: "itemFromRelatedTarget",
      value: function value(t) {
        return this.itemFromElement(t.relatedTarget);
      }
    }, {
      key: "groupFromTarget",
      value: function value(t) {
        var e = t.center ? t.center.y : t.clientY,
            i = this.groupIds;
        i.length <= 0 && this.groupsData && (i = this.groupsData.getIds({
          order: this.options.groupOrder
        }));

        for (var n = 0; n < i.length; n++) {
          var o = i[n],
              r = this.groups[o],
              s = r.dom.foreground,
              a = s.getBoundingClientRect();
          if (e >= a.top && e < a.top + s.offsetHeight) return r;

          if ("top" === this.options.orientation.item) {
            if (n === this.groupIds.length - 1 && e > a.top) return r;
          } else if (0 === n && e < a.top + s.offset) return r;
        }

        return null;
      }
    }, {
      key: "_cloneItemData",
      value: function value(t, e) {
        var i = od.extend({}, t);
        return e || (e = this.itemsData.type), null != i.start && (i.start = od.convert(i.start, e && e.start || "Date")), null != i.end && (i.end = od.convert(i.end, e && e.end || "Date")), i;
      }
    }, {
      key: "_clusterItems",
      value: function value() {
        if (this.options.cluster) {
          var t = this.body.range.conversion(this.body.domProps.center.width).scale,
              e = this.clusterGenerator.getClusters(this.clusters, t, this.options.cluster);

          if (this.clusters != e) {
            if (this._detachAllClusters(), e) {
              var i,
                  n = Jp(e);

              try {
                for (n.s(); !(i = n.n()).done;) {
                  i.value.attach();
                }
              } catch (t) {
                n.e(t);
              } finally {
                n.f();
              }

              this.clusters = e;
            }

            this._updateClusters(e);
          }
        }
      }
    }, {
      key: "_detachAllClusters",
      value: function value() {
        if (this.options.cluster && this.clusters && this.clusters.length) {
          var t,
              e = Jp(this.clusters);

          try {
            for (e.s(); !(t = e.n()).done;) {
              t.value.detach();
            }
          } catch (t) {
            e.e(t);
          } finally {
            e.f();
          }
        }
      }
    }, {
      key: "_updateClusters",
      value: function value(t) {
        if (this.clusters && this.clusters.length) {
          var e,
              i,
              n = new fu(Kr(t).call(t, function (t) {
            return t.id;
          })),
              o = !1,
              r = Jp(yo(e = this.clusters).call(e, function (t) {
            return !n.has(t.id);
          }));

          try {
            for (r.s(); !(i = r.n()).done;) {
              var s,
                  a,
                  l = i.value,
                  h = qn(s = this.selection).call(s, l.id);
              if (-1 !== h) l.unselect(), Bo(a = this.selection).call(a, h, 1), o = !0;
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }

          if (o) {
            var u = this.getSelection();
            this.body.emitter.emit("select", {
              items: u,
              event: event
            });
          }
        }

        this.clusters = t || [];
      }
    }], [{
      key: "_getItemRange",
      value: function value(t) {
        var e = null,
            i = null;
        return nr(t).call(t, function (t) {
          (null == i || t.start < i) && (i = t.start), null != t.end ? (null == e || t.end > e) && (e = t.end) : (null == e || t.start > e) && (e = t.start);
        }), {
          min: i,
          max: e
        };
      }
    }, {
      key: "itemSetFromTarget",
      value: function value(t) {
        for (var e = t.target; e;) {
          if (e.hasOwnProperty("vis-itemset")) return e["vis-itemset"];
          e = e.parentNode;
        }

        return null;
      }
    }]), i;
  }(hd);

  of.types = {
    background: Rp,
    box: Ep,
    range: Ip,
    point: Ap
  }, of.prototype._onAdd = of.prototype._onUpdate;

  var rf,
      sf = !1,
      af = "background: #FFeeee; color: #dd0000",
      lf = function () {
    function t() {
      gn(this, t);
    }

    return _n(t, null, [{
      key: "validate",
      value: function value(e, i, n) {
        sf = !1, rf = i;
        var o = i;
        return void 0 !== n && (o = i[n]), t.parse(e, o, []), sf;
      }
    }, {
      key: "parse",
      value: function value(e, i, n) {
        for (var o in e) {
          e.hasOwnProperty(o) && t.check(o, e, i, n);
        }
      }
    }, {
      key: "check",
      value: function value(e, i, n, o) {
        if (void 0 !== n[e] || void 0 !== n.__any__) {
          var r = e,
              s = !0;
          void 0 === n[e] && void 0 !== n.__any__ && (r = "__any__", s = "object" === t.getType(i[e]));
          var a = n[r];
          s && void 0 !== a.__type__ && (a = a.__type__), t.checkFields(e, i, n, r, a, o);
        } else t.getSuggestion(e, n, o);
      }
    }, {
      key: "checkFields",
      value: function value(e, i, n, o, r, s) {
        var a = function a(i) {
          console.log("%c" + i + t.printLocation(s, e), af);
        },
            l = t.getType(i[e]),
            h = r[l];

        void 0 !== h ? "array" === t.getType(h) && -1 === qn(h).call(h, i[e]) ? (a('Invalid option detected in "' + e + '". Allowed values are:' + t.print(h) + ' not "' + i[e] + '". '), sf = !0) : "object" === l && "__any__" !== o && (s = od.copyAndExtendArray(s, e), t.parse(i[e], n[o], s)) : void 0 === r.any && (a('Invalid type received for "' + e + '". Expected: ' + t.print(Vr(r)) + ". Received [" + l + '] "' + i[e] + '"'), sf = !0);
      }
    }, {
      key: "getType",
      value: function value(t) {
        var e = es(t);
        return "object" === e ? null === t ? "null" : t instanceof Boolean ? "boolean" : t instanceof Number ? "number" : t instanceof String ? "string" : Jr(t) ? "array" : t instanceof Date ? "date" : void 0 !== t.nodeType ? "dom" : !0 === t._isAMomentObject ? "moment" : "object" : "number" === e ? "number" : "boolean" === e ? "boolean" : "string" === e ? "string" : void 0 === e ? "undefined" : e;
      }
    }, {
      key: "getSuggestion",
      value: function value(e, i, n) {
        var o,
            r = t.findInOptions(e, i, n, !1),
            s = t.findInOptions(e, rf, [], !0);
        o = void 0 !== r.indexMatch ? " in " + t.printLocation(r.path, e, "") + 'Perhaps it was incomplete? Did you mean: "' + r.indexMatch + '"?\n\n' : s.distance <= 4 && r.distance > s.distance ? " in " + t.printLocation(r.path, e, "") + "Perhaps it was misplaced? Matching option found at: " + t.printLocation(s.path, s.closestMatch, "") : r.distance <= 8 ? '. Did you mean "' + r.closestMatch + '"?' + t.printLocation(r.path, e) : ". Did you mean one of these: " + t.print(Vr(i)) + t.printLocation(n, e), console.log('%cUnknown option detected: "' + e + '"' + o, af), sf = !0;
      }
    }, {
      key: "findInOptions",
      value: function value(e, i, n) {
        var o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            r = 1e9,
            s = "",
            a = [],
            l = e.toLowerCase(),
            h = void 0;

        for (var u in i) {
          var c = void 0;

          if (void 0 !== i[u].__type__ && !0 === o) {
            var d = t.findInOptions(e, i[u], od.copyAndExtendArray(n, u));
            r > d.distance && (s = d.closestMatch, a = d.path, r = d.distance, h = d.indexMatch);
          } else {
            var p;
            -1 !== qn(p = u.toLowerCase()).call(p, l) && (h = u), r > (c = t.levenshteinDistance(e, u)) && (s = u, a = od.copyArray(n), r = c);
          }
        }

        return {
          closestMatch: s,
          path: a,
          distance: r,
          indexMatch: h
        };
      }
    }, {
      key: "printLocation",
      value: function value(t, e) {
        for (var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Problem value found at: \n", n = "\n\n" + i + "options = {\n", o = 0; o < t.length; o++) {
          for (var r = 0; r < o + 1; r++) {
            n += "  ";
          }

          n += t[o] + ": {\n";
        }

        for (var s = 0; s < t.length + 1; s++) {
          n += "  ";
        }

        n += e + "\n";

        for (var a = 0; a < t.length + 1; a++) {
          for (var l = 0; l < t.length - a; l++) {
            n += "  ";
          }

          n += "}\n";
        }

        return n + "\n\n";
      }
    }, {
      key: "print",
      value: function value(t) {
        return vn(t).replace(/(\")|(\[)|(\])|(,"__type__")/g, "").replace(/(\,)/g, ", ");
      }
    }, {
      key: "levenshteinDistance",
      value: function value(t, e) {
        if (0 === t.length) return e.length;
        if (0 === e.length) return t.length;
        var i,
            n,
            o = [];

        for (i = 0; i <= e.length; i++) {
          o[i] = [i];
        }

        for (n = 0; n <= t.length; n++) {
          o[0][n] = n;
        }

        for (i = 1; i <= e.length; i++) {
          for (n = 1; n <= t.length; n++) {
            e.charAt(i - 1) == t.charAt(n - 1) ? o[i][n] = o[i - 1][n - 1] : o[i][n] = Math.min(o[i - 1][n - 1] + 1, Math.min(o[i][n - 1] + 1, o[i - 1][n] + 1));
          }
        }

        return o[e.length][t.length];
      }
    }]), t;
  }(),
      hf = "string",
      uf = "boolean",
      cf = "number",
      df = "array",
      pf = "date",
      ff = "object",
      mf = "moment",
      vf = {
    configure: {
      enabled: {
        boolean: uf
      },
      filter: {
        boolean: uf,
        function: "function"
      },
      container: {
        dom: "dom"
      },
      __type__: {
        object: ff,
        boolean: uf,
        function: "function"
      }
    },
    align: {
      string: hf
    },
    alignCurrentTime: {
      string: hf,
      undefined: "undefined"
    },
    rtl: {
      boolean: uf,
      undefined: "undefined"
    },
    rollingMode: {
      follow: {
        boolean: uf
      },
      offset: {
        number: cf,
        undefined: "undefined"
      },
      __type__: {
        object: ff
      }
    },
    onTimeout: {
      timeoutMs: {
        number: cf
      },
      callback: {
        function: "function"
      },
      __type__: {
        object: ff
      }
    },
    verticalScroll: {
      boolean: uf,
      undefined: "undefined"
    },
    horizontalScroll: {
      boolean: uf,
      undefined: "undefined"
    },
    autoResize: {
      boolean: uf
    },
    throttleRedraw: {
      number: cf
    },
    clickToUse: {
      boolean: uf
    },
    dataAttributes: {
      string: hf,
      array: df
    },
    editable: {
      add: {
        boolean: uf,
        undefined: "undefined"
      },
      remove: {
        boolean: uf,
        undefined: "undefined"
      },
      updateGroup: {
        boolean: uf,
        undefined: "undefined"
      },
      updateTime: {
        boolean: uf,
        undefined: "undefined"
      },
      overrideItems: {
        boolean: uf,
        undefined: "undefined"
      },
      __type__: {
        boolean: uf,
        object: ff
      }
    },
    end: {
      number: cf,
      date: pf,
      string: hf,
      moment: mf
    },
    format: {
      minorLabels: {
        millisecond: {
          string: hf,
          undefined: "undefined"
        },
        second: {
          string: hf,
          undefined: "undefined"
        },
        minute: {
          string: hf,
          undefined: "undefined"
        },
        hour: {
          string: hf,
          undefined: "undefined"
        },
        weekday: {
          string: hf,
          undefined: "undefined"
        },
        day: {
          string: hf,
          undefined: "undefined"
        },
        week: {
          string: hf,
          undefined: "undefined"
        },
        month: {
          string: hf,
          undefined: "undefined"
        },
        year: {
          string: hf,
          undefined: "undefined"
        },
        __type__: {
          object: ff,
          function: "function"
        }
      },
      majorLabels: {
        millisecond: {
          string: hf,
          undefined: "undefined"
        },
        second: {
          string: hf,
          undefined: "undefined"
        },
        minute: {
          string: hf,
          undefined: "undefined"
        },
        hour: {
          string: hf,
          undefined: "undefined"
        },
        weekday: {
          string: hf,
          undefined: "undefined"
        },
        day: {
          string: hf,
          undefined: "undefined"
        },
        week: {
          string: hf,
          undefined: "undefined"
        },
        month: {
          string: hf,
          undefined: "undefined"
        },
        year: {
          string: hf,
          undefined: "undefined"
        },
        __type__: {
          object: ff,
          function: "function"
        }
      },
      __type__: {
        object: ff
      }
    },
    moment: {
      function: "function"
    },
    groupHeightMode: {
      string: hf
    },
    groupOrder: {
      string: hf,
      function: "function"
    },
    groupEditable: {
      add: {
        boolean: uf,
        undefined: "undefined"
      },
      remove: {
        boolean: uf,
        undefined: "undefined"
      },
      order: {
        boolean: uf,
        undefined: "undefined"
      },
      __type__: {
        boolean: uf,
        object: ff
      }
    },
    groupOrderSwap: {
      function: "function"
    },
    height: {
      string: hf,
      number: cf
    },
    hiddenDates: {
      start: {
        date: pf,
        number: cf,
        string: hf,
        moment: mf
      },
      end: {
        date: pf,
        number: cf,
        string: hf,
        moment: mf
      },
      repeat: {
        string: hf
      },
      __type__: {
        object: ff,
        array: df
      }
    },
    itemsAlwaysDraggable: {
      item: {
        boolean: uf,
        undefined: "undefined"
      },
      range: {
        boolean: uf,
        undefined: "undefined"
      },
      __type__: {
        boolean: uf,
        object: ff
      }
    },
    limitSize: {
      boolean: uf
    },
    locale: {
      string: hf
    },
    locales: {
      __any__: {
        any: "any"
      },
      __type__: {
        object: ff
      }
    },
    longSelectPressTime: {
      number: cf
    },
    margin: {
      axis: {
        number: cf
      },
      item: {
        horizontal: {
          number: cf,
          undefined: "undefined"
        },
        vertical: {
          number: cf,
          undefined: "undefined"
        },
        __type__: {
          object: ff,
          number: cf
        }
      },
      __type__: {
        object: ff,
        number: cf
      }
    },
    max: {
      date: pf,
      number: cf,
      string: hf,
      moment: mf
    },
    maxHeight: {
      number: cf,
      string: hf
    },
    maxMinorChars: {
      number: cf
    },
    min: {
      date: pf,
      number: cf,
      string: hf,
      moment: mf
    },
    minHeight: {
      number: cf,
      string: hf
    },
    moveable: {
      boolean: uf
    },
    multiselect: {
      boolean: uf
    },
    multiselectPerGroup: {
      boolean: uf
    },
    onAdd: {
      function: "function"
    },
    onDropObjectOnItem: {
      function: "function"
    },
    onUpdate: {
      function: "function"
    },
    onMove: {
      function: "function"
    },
    onMoving: {
      function: "function"
    },
    onRemove: {
      function: "function"
    },
    onAddGroup: {
      function: "function"
    },
    onMoveGroup: {
      function: "function"
    },
    onRemoveGroup: {
      function: "function"
    },
    onInitialDrawComplete: {
      function: "function"
    },
    order: {
      function: "function"
    },
    orientation: {
      axis: {
        string: hf,
        undefined: "undefined"
      },
      item: {
        string: hf,
        undefined: "undefined"
      },
      __type__: {
        string: hf,
        object: ff
      }
    },
    selectable: {
      boolean: uf
    },
    sequentialSelection: {
      boolean: uf
    },
    showCurrentTime: {
      boolean: uf
    },
    showMajorLabels: {
      boolean: uf
    },
    showMinorLabels: {
      boolean: uf
    },
    showWeekScale: {
      boolean: uf
    },
    stack: {
      boolean: uf
    },
    stackSubgroups: {
      boolean: uf
    },
    cluster: {
      maxItems: {
        number: cf,
        undefined: "undefined"
      },
      titleTemplate: {
        string: hf,
        undefined: "undefined"
      },
      clusterCriteria: {
        function: "function",
        undefined: "undefined"
      },
      showStipes: {
        boolean: uf,
        undefined: "undefined"
      },
      fitOnDoubleClick: {
        boolean: uf,
        undefined: "undefined"
      },
      __type__: {
        boolean: uf,
        object: ff
      }
    },
    snap: {
      function: "function",
      null: "null"
    },
    start: {
      date: pf,
      number: cf,
      string: hf,
      moment: mf
    },
    template: {
      function: "function"
    },
    loadingScreenTemplate: {
      function: "function"
    },
    groupTemplate: {
      function: "function"
    },
    visibleFrameTemplate: {
      string: hf,
      function: "function"
    },
    showTooltips: {
      boolean: uf
    },
    tooltip: {
      followMouse: {
        boolean: uf
      },
      overflowMethod: {
        string: ["cap", "flip", "none"]
      },
      delay: {
        number: cf
      },
      template: {
        function: "function"
      },
      __type__: {
        object: ff
      }
    },
    tooltipOnItemUpdateTime: {
      template: {
        function: "function"
      },
      __type__: {
        boolean: uf,
        object: ff
      }
    },
    timeAxis: {
      scale: {
        string: hf,
        undefined: "undefined"
      },
      step: {
        number: cf,
        undefined: "undefined"
      },
      __type__: {
        object: ff
      }
    },
    type: {
      string: hf
    },
    width: {
      string: hf,
      number: cf
    },
    preferZoom: {
      boolean: uf
    },
    zoomable: {
      boolean: uf
    },
    zoomKey: {
      string: ["ctrlKey", "altKey", "shiftKey", "metaKey", ""]
    },
    zoomFriction: {
      number: cf
    },
    zoomMax: {
      number: cf
    },
    zoomMin: {
      number: cf
    },
    __type__: {
      object: ff
    }
  },
      gf = {
    global: {
      align: ["center", "left", "right"],
      alignCurrentTime: ["none", "year", "month", "quarter", "week", "isoWeek", "day", "date", "hour", "minute", "second"],
      direction: !1,
      autoResize: !0,
      clickToUse: !1,
      editable: {
        add: !1,
        remove: !1,
        updateGroup: !1,
        updateTime: !1
      },
      end: "",
      format: {
        minorLabels: {
          millisecond: "SSS",
          second: "s",
          minute: "HH:mm",
          hour: "HH:mm",
          weekday: "ddd D",
          day: "D",
          week: "w",
          month: "MMM",
          year: "YYYY"
        },
        majorLabels: {
          millisecond: "HH:mm:ss",
          second: "D MMMM HH:mm",
          minute: "ddd D MMMM",
          hour: "ddd D MMMM",
          weekday: "MMMM YYYY",
          day: "MMMM YYYY",
          week: "MMMM YYYY",
          month: "YYYY",
          year: ""
        }
      },
      groupHeightMode: ["auto", "fixed", "fitItems"],
      groupsDraggable: !1,
      height: "",
      locale: "",
      longSelectPressTime: 251,
      margin: {
        axis: [20, 0, 100, 1],
        item: {
          horizontal: [10, 0, 100, 1],
          vertical: [10, 0, 100, 1]
        }
      },
      max: "",
      maxHeight: "",
      maxMinorChars: [7, 0, 20, 1],
      min: "",
      minHeight: "",
      moveable: !1,
      multiselect: !1,
      multiselectPerGroup: !1,
      orientation: {
        axis: ["both", "bottom", "top"],
        item: ["bottom", "top"]
      },
      preferZoom: !1,
      selectable: !0,
      showCurrentTime: !1,
      showMajorLabels: !0,
      showMinorLabels: !0,
      stack: !0,
      stackSubgroups: !0,
      cluster: !1,
      start: "",
      showTooltips: !0,
      tooltip: {
        followMouse: !1,
        overflowMethod: "flip",
        delay: [500, 0, 99999, 100]
      },
      tooltipOnItemUpdateTime: !1,
      type: ["box", "point", "range", "background"],
      width: "100%",
      zoomable: !0,
      zoomKey: ["ctrlKey", "altKey", "shiftKey", "metaKey", ""],
      zoomMax: [31536e10, 10, 31536e10, 1],
      zoomMin: [10, 10, 31536e10, 1]
    }
  },
      yf = {
    black: "#000000",
    navy: "#000080",
    darkblue: "#00008B",
    mediumblue: "#0000CD",
    blue: "#0000FF",
    darkgreen: "#006400",
    green: "#008000",
    teal: "#008080",
    darkcyan: "#008B8B",
    deepskyblue: "#00BFFF",
    darkturquoise: "#00CED1",
    mediumspringgreen: "#00FA9A",
    lime: "#00FF00",
    springgreen: "#00FF7F",
    aqua: "#00FFFF",
    cyan: "#00FFFF",
    midnightblue: "#191970",
    dodgerblue: "#1E90FF",
    lightseagreen: "#20B2AA",
    forestgreen: "#228B22",
    seagreen: "#2E8B57",
    darkslategray: "#2F4F4F",
    limegreen: "#32CD32",
    mediumseagreen: "#3CB371",
    turquoise: "#40E0D0",
    royalblue: "#4169E1",
    steelblue: "#4682B4",
    darkslateblue: "#483D8B",
    mediumturquoise: "#48D1CC",
    indigo: "#4B0082",
    darkolivegreen: "#556B2F",
    cadetblue: "#5F9EA0",
    cornflowerblue: "#6495ED",
    mediumaquamarine: "#66CDAA",
    dimgray: "#696969",
    slateblue: "#6A5ACD",
    olivedrab: "#6B8E23",
    slategray: "#708090",
    lightslategray: "#778899",
    mediumslateblue: "#7B68EE",
    lawngreen: "#7CFC00",
    chartreuse: "#7FFF00",
    aquamarine: "#7FFFD4",
    maroon: "#800000",
    purple: "#800080",
    olive: "#808000",
    gray: "#808080",
    skyblue: "#87CEEB",
    lightskyblue: "#87CEFA",
    blueviolet: "#8A2BE2",
    darkred: "#8B0000",
    darkmagenta: "#8B008B",
    saddlebrown: "#8B4513",
    darkseagreen: "#8FBC8F",
    lightgreen: "#90EE90",
    mediumpurple: "#9370D8",
    darkviolet: "#9400D3",
    palegreen: "#98FB98",
    darkorchid: "#9932CC",
    yellowgreen: "#9ACD32",
    sienna: "#A0522D",
    brown: "#A52A2A",
    darkgray: "#A9A9A9",
    lightblue: "#ADD8E6",
    greenyellow: "#ADFF2F",
    paleturquoise: "#AFEEEE",
    lightsteelblue: "#B0C4DE",
    powderblue: "#B0E0E6",
    firebrick: "#B22222",
    darkgoldenrod: "#B8860B",
    mediumorchid: "#BA55D3",
    rosybrown: "#BC8F8F",
    darkkhaki: "#BDB76B",
    silver: "#C0C0C0",
    mediumvioletred: "#C71585",
    indianred: "#CD5C5C",
    peru: "#CD853F",
    chocolate: "#D2691E",
    tan: "#D2B48C",
    lightgrey: "#D3D3D3",
    palevioletred: "#D87093",
    thistle: "#D8BFD8",
    orchid: "#DA70D6",
    goldenrod: "#DAA520",
    crimson: "#DC143C",
    gainsboro: "#DCDCDC",
    plum: "#DDA0DD",
    burlywood: "#DEB887",
    lightcyan: "#E0FFFF",
    lavender: "#E6E6FA",
    darksalmon: "#E9967A",
    violet: "#EE82EE",
    palegoldenrod: "#EEE8AA",
    lightcoral: "#F08080",
    khaki: "#F0E68C",
    aliceblue: "#F0F8FF",
    honeydew: "#F0FFF0",
    azure: "#F0FFFF",
    sandybrown: "#F4A460",
    wheat: "#F5DEB3",
    beige: "#F5F5DC",
    whitesmoke: "#F5F5F5",
    mintcream: "#F5FFFA",
    ghostwhite: "#F8F8FF",
    salmon: "#FA8072",
    antiquewhite: "#FAEBD7",
    linen: "#FAF0E6",
    lightgoldenrodyellow: "#FAFAD2",
    oldlace: "#FDF5E6",
    red: "#FF0000",
    fuchsia: "#FF00FF",
    magenta: "#FF00FF",
    deeppink: "#FF1493",
    orangered: "#FF4500",
    tomato: "#FF6347",
    hotpink: "#FF69B4",
    coral: "#FF7F50",
    darkorange: "#FF8C00",
    lightsalmon: "#FFA07A",
    orange: "#FFA500",
    lightpink: "#FFB6C1",
    pink: "#FFC0CB",
    gold: "#FFD700",
    peachpuff: "#FFDAB9",
    navajowhite: "#FFDEAD",
    moccasin: "#FFE4B5",
    bisque: "#FFE4C4",
    mistyrose: "#FFE4E1",
    blanchedalmond: "#FFEBCD",
    papayawhip: "#FFEFD5",
    lavenderblush: "#FFF0F5",
    seashell: "#FFF5EE",
    cornsilk: "#FFF8DC",
    lemonchiffon: "#FFFACD",
    floralwhite: "#FFFAF0",
    snow: "#FFFAFA",
    yellow: "#FFFF00",
    lightyellow: "#FFFFE0",
    ivory: "#FFFFF0",
    white: "#FFFFFF"
  },
      bf = function () {
    function t() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
      gn(this, t), this.pixelRatio = e, this.generated = !1, this.centerCoordinates = {
        x: 144.5,
        y: 144.5
      }, this.r = 289 * .49, this.color = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      }, this.hueCircle = void 0, this.initialColor = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      }, this.previousColor = void 0, this.applied = !1, this.updateCallback = function () {}, this.closeCallback = function () {}, this._create();
    }

    return _n(t, [{
      key: "insertTo",
      value: function value(t) {
        void 0 !== this.hammer && (this.hammer.destroy(), this.hammer = void 0), this.container = t, this.container.appendChild(this.frame), this._bindHammer(), this._setSize();
      }
    }, {
      key: "setUpdateCallback",
      value: function value(t) {
        if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker update callback is not a function.");
        this.updateCallback = t;
      }
    }, {
      key: "setCloseCallback",
      value: function value(t) {
        if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
        this.closeCallback = t;
      }
    }, {
      key: "_isColorString",
      value: function value(t) {
        if ("string" == typeof t) return yf[t];
      }
    }, {
      key: "setColor",
      value: function value(t) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

        if ("none" !== t) {
          var i,
              n = this._isColorString(t);

          if (void 0 !== n && (t = n), !0 === od.isString(t)) {
            if (!0 === od.isValidRGB(t)) {
              var o = t.substr(4).substr(0, t.length - 5).split(",");
              i = {
                r: o[0],
                g: o[1],
                b: o[2],
                a: 1
              };
            } else if (!0 === od.isValidRGBA(t)) {
              var r = t.substr(5).substr(0, t.length - 6).split(",");
              i = {
                r: r[0],
                g: r[1],
                b: r[2],
                a: r[3]
              };
            } else if (!0 === od.isValidHex(t)) {
              var s = od.hexToRGB(t);
              i = {
                r: s.r,
                g: s.g,
                b: s.b,
                a: 1
              };
            }
          } else if (t instanceof Object && void 0 !== t.r && void 0 !== t.g && void 0 !== t.b) {
            var a = void 0 !== t.a ? t.a : "1.0";
            i = {
              r: t.r,
              g: t.g,
              b: t.b,
              a: a
            };
          }

          if (void 0 === i) throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + vn(t));

          this._setColor(i, e);
        }
      }
    }, {
      key: "show",
      value: function value() {
        void 0 !== this.closeCallback && (this.closeCallback(), this.closeCallback = void 0), this.applied = !1, this.frame.style.display = "block", this._generateHueCircle();
      }
    }, {
      key: "_hide",
      value: function value() {
        var t = this,
            e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        !0 === e && (this.previousColor = od.extend({}, this.color)), !0 === this.applied && this.updateCallback(this.initialColor), this.frame.style.display = "none", hn(function () {
          void 0 !== t.closeCallback && (t.closeCallback(), t.closeCallback = void 0);
        }, 0);
      }
    }, {
      key: "_save",
      value: function value() {
        this.updateCallback(this.color), this.applied = !1, this._hide();
      }
    }, {
      key: "_apply",
      value: function value() {
        this.applied = !0, this.updateCallback(this.color), this._updatePicker(this.color);
      }
    }, {
      key: "_loadLast",
      value: function value() {
        void 0 !== this.previousColor ? this.setColor(this.previousColor, !1) : alert("There is no last color to load...");
      }
    }, {
      key: "_setColor",
      value: function value(t) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        !0 === e && (this.initialColor = od.extend({}, t)), this.color = t;
        var i = od.RGBToHSV(t.r, t.g, t.b),
            n = 2 * Math.PI,
            o = this.r * i.s,
            r = this.centerCoordinates.x + o * Math.sin(n * i.h),
            s = this.centerCoordinates.y + o * Math.cos(n * i.h);
        this.colorPickerSelector.style.left = r - .5 * this.colorPickerSelector.clientWidth + "px", this.colorPickerSelector.style.top = s - .5 * this.colorPickerSelector.clientHeight + "px", this._updatePicker(t);
      }
    }, {
      key: "_setOpacity",
      value: function value(t) {
        this.color.a = t / 100, this._updatePicker(this.color);
      }
    }, {
      key: "_setBrightness",
      value: function value(t) {
        var e = od.RGBToHSV(this.color.r, this.color.g, this.color.b);
        e.v = t / 100;
        var i = od.HSVToRGB(e.h, e.s, e.v);
        i.a = this.color.a, this.color = i, this._updatePicker();
      }
    }, {
      key: "_updatePicker",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.color,
            e = od.RGBToHSV(t.r, t.g, t.b),
            i = this.colorPickerCanvas.getContext("2d");
        void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (i.webkitBackingStorePixelRatio || i.mozBackingStorePixelRatio || i.msBackingStorePixelRatio || i.oBackingStorePixelRatio || i.backingStorePixelRatio || 1)), i.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        var n = this.colorPickerCanvas.clientWidth,
            o = this.colorPickerCanvas.clientHeight;
        i.clearRect(0, 0, n, o), i.putImageData(this.hueCircle, 0, 0), i.fillStyle = "rgba(0,0,0," + (1 - e.v) + ")", i.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), on(i).call(i), this.brightnessRange.value = 100 * e.v, this.opacityRange.value = 100 * t.a, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
      }
    }, {
      key: "_setSize",
      value: function value() {
        this.colorPickerCanvas.style.width = "100%", this.colorPickerCanvas.style.height = "100%", this.colorPickerCanvas.width = 289 * this.pixelRatio, this.colorPickerCanvas.height = 289 * this.pixelRatio;
      }
    }, {
      key: "_create",
      value: function value() {
        var t, e, i, n;

        if (this.frame = document.createElement("div"), this.frame.className = "vis-color-picker", this.colorPickerDiv = document.createElement("div"), this.colorPickerSelector = document.createElement("div"), this.colorPickerSelector.className = "vis-selector", this.colorPickerDiv.appendChild(this.colorPickerSelector), this.colorPickerCanvas = document.createElement("canvas"), this.colorPickerDiv.appendChild(this.colorPickerCanvas), this.colorPickerCanvas.getContext) {
          var o = this.colorPickerCanvas.getContext("2d");
          this.pixelRatio = (window.devicePixelRatio || 1) / (o.webkitBackingStorePixelRatio || o.mozBackingStorePixelRatio || o.msBackingStorePixelRatio || o.oBackingStorePixelRatio || o.backingStorePixelRatio || 1), this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        } else {
          var r = document.createElement("DIV");
          r.style.color = "red", r.style.fontWeight = "bold", r.style.padding = "10px", r.innerHTML = "Error: your browser does not support HTML canvas", this.colorPickerCanvas.appendChild(r);
        }

        this.colorPickerDiv.className = "vis-color", this.opacityDiv = document.createElement("div"), this.opacityDiv.className = "vis-opacity", this.brightnessDiv = document.createElement("div"), this.brightnessDiv.className = "vis-brightness", this.arrowDiv = document.createElement("div"), this.arrowDiv.className = "vis-arrow", this.opacityRange = document.createElement("input");

        try {
          this.opacityRange.type = "range", this.opacityRange.min = "0", this.opacityRange.max = "100";
        } catch (t) {}

        this.opacityRange.value = "100", this.opacityRange.className = "vis-range", this.brightnessRange = document.createElement("input");

        try {
          this.brightnessRange.type = "range", this.brightnessRange.min = "0", this.brightnessRange.max = "100";
        } catch (t) {}

        this.brightnessRange.value = "100", this.brightnessRange.className = "vis-range", this.opacityDiv.appendChild(this.opacityRange), this.brightnessDiv.appendChild(this.brightnessRange);
        var s = this;
        this.opacityRange.onchange = function () {
          s._setOpacity(this.value);
        }, this.opacityRange.oninput = function () {
          s._setOpacity(this.value);
        }, this.brightnessRange.onchange = function () {
          s._setBrightness(this.value);
        }, this.brightnessRange.oninput = function () {
          s._setBrightness(this.value);
        }, this.brightnessLabel = document.createElement("div"), this.brightnessLabel.className = "vis-label vis-brightness", this.brightnessLabel.innerHTML = "brightness:", this.opacityLabel = document.createElement("div"), this.opacityLabel.className = "vis-label vis-opacity", this.opacityLabel.innerHTML = "opacity:", this.newColorDiv = document.createElement("div"), this.newColorDiv.className = "vis-new-color", this.newColorDiv.innerHTML = "new", this.initialColorDiv = document.createElement("div"), this.initialColorDiv.className = "vis-initial-color", this.initialColorDiv.innerHTML = "initial", this.cancelButton = document.createElement("div"), this.cancelButton.className = "vis-button vis-cancel", this.cancelButton.innerHTML = "cancel", this.cancelButton.onclick = ur(t = this._hide).call(t, this, !1), this.applyButton = document.createElement("div"), this.applyButton.className = "vis-button vis-apply", this.applyButton.innerHTML = "apply", this.applyButton.onclick = ur(e = this._apply).call(e, this), this.saveButton = document.createElement("div"), this.saveButton.className = "vis-button vis-save", this.saveButton.innerHTML = "save", this.saveButton.onclick = ur(i = this._save).call(i, this), this.loadButton = document.createElement("div"), this.loadButton.className = "vis-button vis-load", this.loadButton.innerHTML = "load last", this.loadButton.onclick = ur(n = this._loadLast).call(n, this), this.frame.appendChild(this.colorPickerDiv), this.frame.appendChild(this.arrowDiv), this.frame.appendChild(this.brightnessLabel), this.frame.appendChild(this.brightnessDiv), this.frame.appendChild(this.opacityLabel), this.frame.appendChild(this.opacityDiv), this.frame.appendChild(this.newColorDiv), this.frame.appendChild(this.initialColorDiv), this.frame.appendChild(this.cancelButton), this.frame.appendChild(this.applyButton), this.frame.appendChild(this.saveButton), this.frame.appendChild(this.loadButton);
      }
    }, {
      key: "_bindHammer",
      value: function value() {
        var t = this;
        this.drag = {}, this.pinch = {}, this.hammer = new Ld(this.colorPickerCanvas), this.hammer.get("pinch").set({
          enable: !0
        }), Id(this.hammer, function (e) {
          t._moveSelector(e);
        }), this.hammer.on("tap", function (e) {
          t._moveSelector(e);
        }), this.hammer.on("panstart", function (e) {
          t._moveSelector(e);
        }), this.hammer.on("panmove", function (e) {
          t._moveSelector(e);
        }), this.hammer.on("panend", function (e) {
          t._moveSelector(e);
        });
      }
    }, {
      key: "_generateHueCircle",
      value: function value() {
        if (!1 === this.generated) {
          var t = this.colorPickerCanvas.getContext("2d");
          void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1)), t.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
          var e,
              i,
              n,
              o,
              r = this.colorPickerCanvas.clientWidth,
              s = this.colorPickerCanvas.clientHeight;
          t.clearRect(0, 0, r, s), this.centerCoordinates = {
            x: .5 * r,
            y: .5 * s
          }, this.r = .49 * r;
          var a,
              l = 2 * Math.PI / 360,
              h = 1 / this.r;

          for (n = 0; n < 360; n++) {
            for (o = 0; o < this.r; o++) {
              e = this.centerCoordinates.x + o * Math.sin(l * n), i = this.centerCoordinates.y + o * Math.cos(l * n), a = od.HSVToRGB(.002777777777777778 * n, o * h, 1), t.fillStyle = "rgb(" + a.r + "," + a.g + "," + a.b + ")", t.fillRect(e - .5, i - .5, 2, 2);
            }
          }

          t.strokeStyle = "rgba(0,0,0,1)", t.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), t.stroke(), this.hueCircle = t.getImageData(0, 0, r, s);
        }

        this.generated = !0;
      }
    }, {
      key: "_moveSelector",
      value: function value(t) {
        var e = this.colorPickerDiv.getBoundingClientRect(),
            i = t.center.x - e.left,
            n = t.center.y - e.top,
            o = .5 * this.colorPickerDiv.clientHeight,
            r = .5 * this.colorPickerDiv.clientWidth,
            s = i - r,
            a = n - o,
            l = Math.atan2(s, a),
            h = .98 * Math.min(Math.sqrt(s * s + a * a), r),
            u = Math.cos(l) * h + o,
            c = Math.sin(l) * h + r;
        this.colorPickerSelector.style.top = u - .5 * this.colorPickerSelector.clientHeight + "px", this.colorPickerSelector.style.left = c - .5 * this.colorPickerSelector.clientWidth + "px";
        var d = l / (2 * Math.PI);
        d = d < 0 ? d + 1 : d;
        var p = h / this.r,
            f = od.RGBToHSV(this.color.r, this.color.g, this.color.b);
        f.h = d, f.s = p;
        var m = od.HSVToRGB(f.h, f.s, f.v);
        m.a = this.color.a, this.color = m, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
      }
    }]), t;
  }(),
      _f = function () {
    function t(e, i, n) {
      var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
      gn(this, t), this.parent = e, this.changedOptions = [], this.container = i, this.allowCreation = !1, this.options = {}, this.initialized = !1, this.popupCounter = 0, this.defaultOptions = {
        enabled: !1,
        filter: !0,
        container: void 0,
        showButton: !0
      }, od.extend(this.options, this.defaultOptions), this.configureOptions = n, this.moduleOptions = {}, this.domElements = [], this.popupDiv = {}, this.popupLimit = 5, this.popupHistory = {}, this.colorPicker = new bf(o), this.wrapper = void 0;
    }

    return _n(t, [{
      key: "setOptions",
      value: function value(t) {
        if (void 0 !== t) {
          this.popupHistory = {}, this._removePopup();
          var e = !0;
          if ("string" == typeof t) this.options.filter = t;else if (Jr(t)) this.options.filter = t.join();else if ("object" === es(t)) {
            if (null == t) throw new TypeError("options cannot be null");
            void 0 !== t.container && (this.options.container = t.container), void 0 !== yo(t) && (this.options.filter = yo(t)), void 0 !== t.showButton && (this.options.showButton = t.showButton), void 0 !== t.enabled && (e = t.enabled);
          } else "boolean" == typeof t ? (this.options.filter = !0, e = t) : "function" == typeof t && (this.options.filter = t, e = !0);
          !1 === yo(this.options) && (e = !1), this.options.enabled = e;
        }

        this._clean();
      }
    }, {
      key: "setModuleOptions",
      value: function value(t) {
        this.moduleOptions = t, !0 === this.options.enabled && (this._clean(), void 0 !== this.options.container && (this.container = this.options.container), this._create());
      }
    }, {
      key: "_create",
      value: function value() {
        this._clean(), this.changedOptions = [];
        var t = yo(this.options),
            e = 0,
            i = !1;

        for (var n in this.configureOptions) {
          this.configureOptions.hasOwnProperty(n) && (this.allowCreation = !1, i = !1, "function" == typeof t ? i = (i = t(n, [])) || this._handleObject(this.configureOptions[n], [n], !0) : !0 !== t && -1 === qn(t).call(t, n) || (i = !0), !1 !== i && (this.allowCreation = !0, e > 0 && this._makeItem([]), this._makeHeader(n), this._handleObject(this.configureOptions[n], [n])), e++);
        }

        this._makeButton(), this._push();
      }
    }, {
      key: "_push",
      value: function value() {
        this.wrapper = document.createElement("div"), this.wrapper.className = "vis-configuration-wrapper", this.container.appendChild(this.wrapper);

        for (var t = 0; t < this.domElements.length; t++) {
          this.wrapper.appendChild(this.domElements[t]);
        }

        this._showPopupIfNeeded();
      }
    }, {
      key: "_clean",
      value: function value() {
        for (var t = 0; t < this.domElements.length; t++) {
          this.wrapper.removeChild(this.domElements[t]);
        }

        void 0 !== this.wrapper && (this.container.removeChild(this.wrapper), this.wrapper = void 0), this.domElements = [], this._removePopup();
      }
    }, {
      key: "_getValue",
      value: function value(t) {
        for (var e = this.moduleOptions, i = 0; i < t.length; i++) {
          if (void 0 === e[t[i]]) {
            e = void 0;
            break;
          }

          e = e[t[i]];
        }

        return e;
      }
    }, {
      key: "_makeItem",
      value: function value(t) {
        if (!0 === this.allowCreation) {
          var e = document.createElement("div");
          e.className = "vis-configuration vis-config-item vis-config-s" + t.length;

          for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) {
            n[o - 1] = arguments[o];
          }

          return nr(n).call(n, function (t) {
            e.appendChild(t);
          }), this.domElements.push(e), this.domElements.length;
        }

        return 0;
      }
    }, {
      key: "_makeHeader",
      value: function value(t) {
        var e = document.createElement("div");
        e.className = "vis-configuration vis-config-header", e.innerHTML = od.xss(t), this._makeItem([], e);
      }
    }, {
      key: "_makeLabel",
      value: function value(t, e) {
        var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = document.createElement("div");
        return n.className = "vis-configuration vis-config-label vis-config-s" + e.length, n.innerHTML = !0 === i ? od.xss("<i><b>" + t + ":</b></i>") : od.xss(t + ":"), n;
      }
    }, {
      key: "_makeDropdown",
      value: function value(t, e, i) {
        var n = document.createElement("select");
        n.className = "vis-configuration vis-config-select";
        var o = 0;
        void 0 !== e && -1 !== qn(t).call(t, e) && (o = qn(t).call(t, e));

        for (var r = 0; r < t.length; r++) {
          var s = document.createElement("option");
          s.value = t[r], r === o && (s.selected = "selected"), s.innerHTML = t[r], n.appendChild(s);
        }

        var a = this;

        n.onchange = function () {
          a._update(this.value, i);
        };

        var l = this._makeLabel(i[i.length - 1], i);

        this._makeItem(i, l, n);
      }
    }, {
      key: "_makeRange",
      value: function value(t, e, i) {
        var n = t[0],
            o = t[1],
            r = t[2],
            s = t[3],
            a = document.createElement("input");
        a.className = "vis-configuration vis-config-range";

        try {
          a.type = "range", a.min = o, a.max = r;
        } catch (t) {}

        a.step = s;
        var l = "",
            h = 0;

        if (void 0 !== e) {
          var u = 1.2;
          e < 0 && e * u < o ? (a.min = Math.ceil(e * u), h = a.min, l = "range increased") : e / u < o && (a.min = Math.ceil(e / u), h = a.min, l = "range increased"), e * u > r && 1 !== r && (a.max = Math.ceil(e * u), h = a.max, l = "range increased"), a.value = e;
        } else a.value = n;

        var c = document.createElement("input");
        c.className = "vis-configuration vis-config-rangeinput", c.value = Number(a.value);
        var d = this;
        a.onchange = function () {
          c.value = this.value, d._update(Number(this.value), i);
        }, a.oninput = function () {
          c.value = this.value;
        };

        var p = this._makeLabel(i[i.length - 1], i),
            f = this._makeItem(i, p, a, c);

        "" !== l && this.popupHistory[f] !== h && (this.popupHistory[f] = h, this._setupPopup(l, f));
      }
    }, {
      key: "_makeButton",
      value: function value() {
        var t = this;

        if (!0 === this.options.showButton) {
          var e = document.createElement("div");
          e.className = "vis-configuration vis-config-button", e.innerHTML = "generate options", e.onclick = function () {
            t._printOptions();
          }, e.onmouseover = function () {
            e.className = "vis-configuration vis-config-button hover";
          }, e.onmouseout = function () {
            e.className = "vis-configuration vis-config-button";
          }, this.optionsContainer = document.createElement("div"), this.optionsContainer.className = "vis-configuration vis-config-option-container", this.domElements.push(this.optionsContainer), this.domElements.push(e);
        }
      }
    }, {
      key: "_setupPopup",
      value: function value(t, e) {
        var i = this;

        if (!0 === this.initialized && !0 === this.allowCreation && this.popupCounter < this.popupLimit) {
          var n = document.createElement("div");
          n.id = "vis-configuration-popup", n.className = "vis-configuration-popup", n.innerHTML = od.xss(t), n.onclick = function () {
            i._removePopup();
          }, this.popupCounter += 1, this.popupDiv = {
            html: n,
            index: e
          };
        }
      }
    }, {
      key: "_removePopup",
      value: function value() {
        void 0 !== this.popupDiv.html && (this.popupDiv.html.parentNode.removeChild(this.popupDiv.html), clearTimeout(this.popupDiv.hideTimeout), clearTimeout(this.popupDiv.deleteTimeout), this.popupDiv = {});
      }
    }, {
      key: "_showPopupIfNeeded",
      value: function value() {
        var t = this;

        if (void 0 !== this.popupDiv.html) {
          var e = this.domElements[this.popupDiv.index].getBoundingClientRect();
          this.popupDiv.html.style.left = e.left + "px", this.popupDiv.html.style.top = e.top - 30 + "px", document.body.appendChild(this.popupDiv.html), this.popupDiv.hideTimeout = hn(function () {
            t.popupDiv.html.style.opacity = 0;
          }, 1500), this.popupDiv.deleteTimeout = hn(function () {
            t._removePopup();
          }, 1800);
        }
      }
    }, {
      key: "_makeCheckbox",
      value: function value(t, e, i) {
        var n = document.createElement("input");
        n.type = "checkbox", n.className = "vis-configuration vis-config-checkbox", n.checked = t, void 0 !== e && (n.checked = e, e !== t && ("object" === es(t) ? e !== t.enabled && this.changedOptions.push({
          path: i,
          value: e
        }) : this.changedOptions.push({
          path: i,
          value: e
        })));
        var o = this;

        n.onchange = function () {
          o._update(this.checked, i);
        };

        var r = this._makeLabel(i[i.length - 1], i);

        this._makeItem(i, r, n);
      }
    }, {
      key: "_makeTextInput",
      value: function value(t, e, i) {
        var n = document.createElement("input");
        n.type = "text", n.className = "vis-configuration vis-config-text", n.value = e, e !== t && this.changedOptions.push({
          path: i,
          value: e
        });
        var o = this;

        n.onchange = function () {
          o._update(this.value, i);
        };

        var r = this._makeLabel(i[i.length - 1], i);

        this._makeItem(i, r, n);
      }
    }, {
      key: "_makeColorField",
      value: function value(t, e, i) {
        var n = this,
            o = t[1],
            r = document.createElement("div");
        "none" !== (e = void 0 === e ? o : e) ? (r.className = "vis-configuration vis-config-colorBlock", r.style.backgroundColor = e) : r.className = "vis-configuration vis-config-colorBlock none", e = void 0 === e ? o : e, r.onclick = function () {
          n._showColorPicker(e, r, i);
        };

        var s = this._makeLabel(i[i.length - 1], i);

        this._makeItem(i, s, r);
      }
    }, {
      key: "_showColorPicker",
      value: function value(t, e, i) {
        var n = this;
        e.onclick = function () {}, this.colorPicker.insertTo(e), this.colorPicker.show(), this.colorPicker.setColor(t), this.colorPicker.setUpdateCallback(function (t) {
          var o = "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
          e.style.backgroundColor = o, n._update(o, i);
        }), this.colorPicker.setCloseCallback(function () {
          e.onclick = function () {
            n._showColorPicker(t, e, i);
          };
        });
      }
    }, {
      key: "_handleObject",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = !1,
            o = yo(this.options),
            r = !1;

        for (var s in t) {
          if (t.hasOwnProperty(s)) {
            n = !0;
            var a = t[s],
                l = od.copyAndExtendArray(e, s);

            if ("function" == typeof o && !1 === (n = o(s, e)) && !Jr(a) && "string" != typeof a && "boolean" != typeof a && a instanceof Object && (this.allowCreation = !1, n = this._handleObject(a, l, !0), this.allowCreation = !1 === i), !1 !== n) {
              r = !0;

              var h = this._getValue(l);

              if (Jr(a)) this._handleArray(a, h, l);else if ("string" == typeof a) this._makeTextInput(a, h, l);else if ("boolean" == typeof a) this._makeCheckbox(a, h, l);else if (a instanceof Object) {
                var u = !0;
                if (-1 !== qn(e).call(e, "physics") && this.moduleOptions.physics.solver !== s && (u = !1), !0 === u) if (void 0 !== a.enabled) {
                  var c = od.copyAndExtendArray(l, "enabled"),
                      d = this._getValue(c);

                  if (!0 === d) {
                    var p = this._makeLabel(s, l, !0);

                    this._makeItem(l, p), r = this._handleObject(a, l) || r;
                  } else this._makeCheckbox(a, d, l);
                } else {
                  var f = this._makeLabel(s, l, !0);

                  this._makeItem(l, f), r = this._handleObject(a, l) || r;
                }
              } else console.error("dont know how to handle", a, s, l);
            }
          }
        }

        return r;
      }
    }, {
      key: "_handleArray",
      value: function value(t, e, i) {
        "string" == typeof t[0] && "color" === t[0] ? (this._makeColorField(t, e, i), t[1] !== e && this.changedOptions.push({
          path: i,
          value: e
        })) : "string" == typeof t[0] ? (this._makeDropdown(t, e, i), t[0] !== e && this.changedOptions.push({
          path: i,
          value: e
        })) : "number" == typeof t[0] && (this._makeRange(t, e, i), t[0] !== e && this.changedOptions.push({
          path: i,
          value: Number(e)
        }));
      }
    }, {
      key: "_update",
      value: function value(t, e) {
        var i = this._constructOptions(t, e);

        this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit && this.parent.body.emitter.emit("configChange", i), this.initialized = !0, this.parent.setOptions(i);
      }
    }, {
      key: "_constructOptions",
      value: function value(t, e) {
        var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = i;
        t = "false" !== (t = "true" === t || t) && t;

        for (var o = 0; o < e.length; o++) {
          "global" !== e[o] && (void 0 === n[e[o]] && (n[e[o]] = {}), o !== e.length - 1 ? n = n[e[o]] : n[e[o]] = t);
        }

        return i;
      }
    }, {
      key: "_printOptions",
      value: function value() {
        var t = this.getOptions();
        this.optionsContainer.innerHTML = "<pre>var options = " + vn(t, null, 2) + "</pre>";
      }
    }, {
      key: "getOptions",
      value: function value() {
        for (var t = {}, e = 0; e < this.changedOptions.length; e++) {
          this._constructOptions(this.changedOptions[e].value, this.changedOptions[e].path, t);
        }

        return t;
      }
    }]), t;
  }();

  function wf(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var kf = function (t) {
    jh(i, t);
    var e = wf(i);

    function i(t, n, o, r) {
      var s, a, l, h, u, c, d, p;
      if (gn(this, i), (p = e.call(this)).initTime = new Date(), p.itemsDone = !1, !(gh(p) instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");

      if (!Jr(o) && !Ju("id", o) && o instanceof Object) {
        var f = r;
        r = o, o = f;
      }

      r && r.throttleRedraw && console.warn('Timeline option "throttleRedraw" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.');
      var m = gh(p);

      if (p.defaultOptions = {
        autoResize: !0,
        longSelectPressTime: 251,
        orientation: {
          axis: "bottom",
          item: "bottom"
        },
        moment: Qu
      }, p.options = od.deepExtend({}, p.defaultOptions), p._create(t), !r || r && void 0 === r.rtl) {
        var v;
        p.dom.root.style.visibility = "hidden";

        for (var g = p.dom.root; !v && g;) {
          v = window.getComputedStyle(g, null).direction, g = g.parentElement;
        }

        p.options.rtl = v && "rtl" == v.toLowerCase();
      } else p.options.rtl = r.rtl;

      r && (r.rollingMode && (p.options.rollingMode = r.rollingMode), r.onInitialDrawComplete && (p.options.onInitialDrawComplete = r.onInitialDrawComplete), r.onTimeout && (p.options.onTimeout = r.onTimeout), r.loadingScreenTemplate && (p.options.loadingScreenTemplate = r.loadingScreenTemplate));
      var y = document.createElement("div");

      if (p.options.loadingScreenTemplate) {
        var b,
            _ = ur(b = p.options.loadingScreenTemplate).call(b, gh(p)),
            w = _(p.dom.loadingScreen);

        w instanceof Object && !(w instanceof Element) ? _(y) : w instanceof Element ? (y.innerHTML = "", y.appendChild(w)) : null != w && (y.innerHTML = od.xss(w));
      }

      function k(t, e) {
        m.hasListeners(t) && m.emit(t, m.getEventProperties(e));
      }

      return p.dom.loadingScreen.appendChild(y), p.components = [], p.body = {
        dom: p.dom,
        domProps: p.props,
        emitter: {
          on: ur(s = p.on).call(s, gh(p)),
          off: ur(a = p.off).call(a, gh(p)),
          emit: ur(l = p.emit).call(l, gh(p))
        },
        hiddenDates: [],
        util: {
          getScale: function getScale() {
            return m.timeAxis.step.scale;
          },
          getStep: function getStep() {
            return m.timeAxis.step.step;
          },
          toScreen: ur(h = m._toScreen).call(h, m),
          toGlobalScreen: ur(u = m._toGlobalScreen).call(u, m),
          toTime: ur(c = m._toTime).call(c, m),
          toGlobalTime: ur(d = m._toGlobalTime).call(d, m)
        }
      }, p.range = new Md(p.body, p.options), p.components.push(p.range), p.body.range = p.range, p.timeAxis = new Fd(p.body, p.options), p.timeAxis2 = null, p.components.push(p.timeAxis), p.currentTime = new np(p.body, p.options), p.components.push(p.currentTime), p.itemSet = new of(p.body, p.options), p.components.push(p.itemSet), p.itemsData = null, p.groupsData = null, p.dom.root.onclick = function (t) {
        k("click", t);
      }, p.dom.root.ondblclick = function (t) {
        k("doubleClick", t);
      }, p.dom.root.oncontextmenu = function (t) {
        k("contextmenu", t);
      }, p.dom.root.onmouseover = function (t) {
        k("mouseOver", t);
      }, window.PointerEvent ? (p.dom.root.onpointerdown = function (t) {
        k("mouseDown", t);
      }, p.dom.root.onpointermove = function (t) {
        k("mouseMove", t);
      }, p.dom.root.onpointerup = function (t) {
        k("mouseUp", t);
      }) : (p.dom.root.onmousemove = function (t) {
        k("mouseMove", t);
      }, p.dom.root.onmousedown = function (t) {
        k("mouseDown", t);
      }, p.dom.root.onmouseup = function (t) {
        k("mouseUp", t);
      }), p.initialFitDone = !1, p.on("changed", function () {
        if (null != m.itemsData) {
          if (!m.initialFitDone && !m.options.rollingMode) if (m.initialFitDone = !0, null != m.options.start || null != m.options.end) {
            if (null == m.options.start || null == m.options.end) var t = m.getItemRange();
            var e = null != m.options.start ? m.options.start : t.min,
                i = null != m.options.end ? m.options.end : t.max;
            m.setWindow(e, i, {
              animation: !1
            });
          } else m.fit({
            animation: !1
          });
          m.initialDrawDone || !m.initialRangeChangeDone && (m.options.start || m.options.end) && !m.options.rollingMode || (m.initialDrawDone = !0, m.itemSet.initialDrawDone = !0, m.dom.root.style.visibility = "visible", m.dom.loadingScreen.parentNode.removeChild(m.dom.loadingScreen), m.options.onInitialDrawComplete && hn(function () {
            return m.options.onInitialDrawComplete();
          }, 0));
        }
      }), p.on("destroyTimeline", function () {
        m.destroy();
      }), r && p.setOptions(r), p.body.emitter.on("fit", function (t) {
        p._onFit(t), p.redraw();
      }), o && p.setGroups(o), n && p.setItems(n), p._redraw(), p;
    }

    return _n(i, [{
      key: "_createConfigurator",
      value: function value() {
        return new _f(this, this.dom.container, gf);
      }
    }, {
      key: "redraw",
      value: function value() {
        this.itemSet && this.itemSet.markDirty({
          refreshItems: !0
        }), this._redraw();
      }
    }, {
      key: "setOptions",
      value: function value(t) {
        if (!0 === lf.validate(t, vf) && console.log("%cErrors have been found in the supplied options object.", af), ep.prototype.setOptions.call(this, t), "type" in t && t.type !== this.options.type) {
          this.options.type = t.type;
          var e = this.itemsData;

          if (e) {
            var i = this.getSelection();
            this.setItems(null), this.setItems(e.rawDS), this.setSelection(i);
          }
        }
      }
    }, {
      key: "setItems",
      value: function value(t) {
        var e;
        this.itemsDone = !1, e = t ? Ju("id", t) ? nd(t) : nd(new $u(t)) : null, this.itemsData && this.itemsData.dispose(), this.itemsData = e, this.itemSet && this.itemSet.setItems(null != e ? e.rawDS : null);
      }
    }, {
      key: "setGroups",
      value: function value(t) {
        var e;
        t ? (Jr(t) && (t = new $u(t)), e = new Ku(t, {
          filter: function filter(t) {
            return !1 !== t.visible;
          }
        })) : e = null, null != this.groupsData && "function" == typeof this.groupsData.setData && this.groupsData.setData(null), this.groupsData = e, this.itemSet.setGroups(e);
      }
    }, {
      key: "setData",
      value: function value(t) {
        t && t.groups && this.setGroups(t.groups), t && t.items && this.setItems(t.items);
      }
    }, {
      key: "setSelection",
      value: function value(t, e) {
        this.itemSet && this.itemSet.setSelection(t), e && e.focus && this.focus(t, e);
      }
    }, {
      key: "getSelection",
      value: function value() {
        return this.itemSet && this.itemSet.getSelection() || [];
      }
    }, {
      key: "focus",
      value: function value(t, e) {
        if (this.itemsData && null != t) {
          var i = Jr(t) ? t : [t],
              n = this.itemsData.get(i),
              o = null,
              r = null;

          if (nr(n).call(n, function (t) {
            var e = t.start.valueOf(),
                i = "end" in t ? t.end.valueOf() : t.start.valueOf();
            (null === o || e < o) && (o = e), (null === r || i > r) && (r = i);
          }), null !== o && null !== r) {
            var s = this,
                a = this.itemSet.items[i[0]],
                l = -1 * this._getScrollTop(),
                h = null,
                u = function u() {
              var t = Sf(s, a);
              t.shouldScroll && t.itemTop != h.itemTop && (s._setScrollTop(-t.scrollOffset), s._redraw());
            },
                c = !e || void 0 === e.zoom || e.zoom,
                d = (o + r) / 2,
                p = c ? 1.1 * (r - o) : Math.max(this.range.end - this.range.start, 1.1 * (r - o)),
                f = !e || void 0 === e.animation || e.animation;

            f || (h = {
              shouldScroll: !1,
              scrollOffset: -1,
              itemTop: -1
            }), this.range.setRange(d - p / 2, d + p / 2, {
              animation: f
            }, function () {
              u(), hn(u, 100);
            }, function (t, e, i) {
              var n = Sf(s, a);

              if (!1 !== n && (h || (h = n), h.itemTop != n.itemTop || h.shouldScroll)) {
                h.itemTop != n.itemTop && n.shouldScroll && (h = n, l = -1 * s._getScrollTop());
                var o = l,
                    r = h.scrollOffset,
                    u = i ? r : o + (r - o) * t;
                s._setScrollTop(-u), e || s._redraw();
              }
            });
          }
        }
      }
    }, {
      key: "fit",
      value: function value(t, e) {
        var i,
            n = !t || void 0 === t.animation || t.animation;
        1 === this.itemsData.length && void 0 === this.itemsData.get()[0].end ? (i = this.getDataRange(), this.moveTo(i.min.valueOf(), {
          animation: n
        }, e)) : (i = this.getItemRange(), this.range.setRange(i.min, i.max, {
          animation: n
        }, e));
      }
    }, {
      key: "getItemRange",
      value: function value() {
        var t = this,
            e = this.getDataRange(),
            i = null !== e.min ? e.min.valueOf() : null,
            n = null !== e.max ? e.max.valueOf() : null,
            o = null,
            r = null;

        if (null != i && null != n) {
          var s = n - i;
          s <= 0 && (s = 10);
          var a = s / this.props.center.width,
              l = {},
              h = 0;
          if (nr(od).call(od, this.itemSet.items, function (t, e) {
            if (t.groupShowing) {
              l[e] = t.redraw(!0), h = l[e].length;
            }
          }), h > 0) for (var u = function u(t) {
            nr(od).call(od, l, function (e) {
              e[t]();
            });
          }, c = 0; c < h; c++) {
            u(c);
          }

          if (nr(od).call(od, this.itemSet.items, function (e) {
            var s,
                l,
                h = xf(e),
                u = Df(e);
            t.options.rtl ? (s = h - (e.getWidthRight() + 10) * a, l = u + (e.getWidthLeft() + 10) * a) : (s = h - (e.getWidthLeft() + 10) * a, l = u + (e.getWidthRight() + 10) * a), s < i && (i = s, o = e), l > n && (n = l, r = e);
          }), o && r) {
            var d = o.getWidthLeft() + 10,
                p = r.getWidthRight() + 10,
                f = this.props.center.width - d - p;
            f > 0 && (this.options.rtl ? (i = xf(o) - p * s / f, n = Df(r) + d * s / f) : (i = xf(o) - d * s / f, n = Df(r) + p * s / f));
          }
        }

        return {
          min: null != i ? new Date(i) : null,
          max: null != n ? new Date(n) : null
        };
      }
    }, {
      key: "getDataRange",
      value: function value() {
        var t,
            e = null,
            i = null;
        this.itemsData && nr(t = this.itemsData).call(t, function (t) {
          var n = od.convert(t.start, "Date").valueOf(),
              o = od.convert(null != t.end ? t.end : t.start, "Date").valueOf();
          (null === e || n < e) && (e = n), (null === i || o > i) && (i = o);
        });
        return {
          min: null != e ? new Date(e) : null,
          max: null != i ? new Date(i) : null
        };
      }
    }, {
      key: "getEventProperties",
      value: function value(t) {
        var e = t.center ? t.center.x : t.clientX,
            i = t.center ? t.center.y : t.clientY,
            n = this.dom.centerContainer.getBoundingClientRect(),
            o = this.options.rtl ? n.right - e : e - n.left,
            r = i - n.top,
            s = this.itemSet.itemFromTarget(t),
            a = this.itemSet.groupFromTarget(t),
            l = tp.customTimeFromTarget(t),
            h = this.itemSet.options.snap || null,
            u = this.body.util.getScale(),
            c = this.body.util.getStep(),
            d = this._toTime(o),
            p = h ? h(d, u, c) : d,
            f = od.getTarget(t),
            m = null;

        return null != s ? m = "item" : null != l ? m = "custom-time" : od.hasParent(f, this.timeAxis.dom.foreground) || this.timeAxis2 && od.hasParent(f, this.timeAxis2.dom.foreground) ? m = "axis" : od.hasParent(f, this.itemSet.dom.labelSet) ? m = "group-label" : od.hasParent(f, this.currentTime.bar) ? m = "current-time" : od.hasParent(f, this.dom.center) && (m = "background"), {
          event: t,
          item: s ? s.id : null,
          isCluster: !!s && !!s.isCluster,
          items: s ? s.items || [] : null,
          group: a ? a.groupId : null,
          customTime: l ? l.options.id : null,
          what: m,
          pageX: t.srcEvent ? t.srcEvent.pageX : t.pageX,
          pageY: t.srcEvent ? t.srcEvent.pageY : t.pageY,
          x: o,
          y: r,
          time: d,
          snappedTime: p
        };
      }
    }, {
      key: "toggleRollingMode",
      value: function value() {
        this.range.rolling ? this.range.stopRolling() : (null == this.options.rollingMode && this.setOptions(this.options), this.range.startRolling());
      }
    }, {
      key: "_redraw",
      value: function value() {
        ep.prototype._redraw.call(this);
      }
    }, {
      key: "_onFit",
      value: function value(t) {
        var e = t.start,
            i = t.end,
            n = t.animation;
        i ? this.range.setRange(e, i, {
          animation: n
        }) : this.moveTo(e.valueOf(), {
          animation: n
        });
      }
    }]), i;
  }(ep);

  function xf(t) {
    return od.convert(t.data.start, "Date").valueOf();
  }

  function Df(t) {
    var e = null != t.data.end ? t.data.end : t.data.start;
    return od.convert(e, "Date").valueOf();
  }

  function Sf(t, e) {
    if (!e.parent) return !1;

    var i = t.options.rtl ? t.props.rightContainer.height : t.props.leftContainer.height,
        n = t.props.center.height,
        o = e.parent,
        r = o.top,
        s = !0,
        a = t.timeAxis.options.orientation.axis,
        l = function l() {
      return "bottom" == a ? o.height - e.top - e.height : e.top;
    },
        h = -1 * t._getScrollTop(),
        u = r + l(),
        c = e.height;

    return u < h ? r + i <= r + l() + c && (r += l() - t.itemSet.options.margin.item.vertical) : u + c > h + i ? r += l() + c - i + t.itemSet.options.margin.item.vertical : s = !1, {
      shouldScroll: s,
      scrollOffset: r = Math.min(r, n - i),
      itemTop: u
    };
  }

  var Cf = function () {
    function t(e, i, n, o, r, s) {
      var a = arguments.length > 6 && void 0 !== arguments[6] && arguments[6],
          l = arguments.length > 7 && void 0 !== arguments[7] && arguments[7];

      if (gn(this, t), this.majorSteps = [1, 2, 5, 10], this.minorSteps = [.25, .5, 1, 2], this.customLines = null, this.containerHeight = r, this.majorCharHeight = s, this._start = e, this._end = i, this.scale = 1, this.minorStepIdx = -1, this.magnitudefactor = 1, this.determineScale(), this.zeroAlign = a, this.autoScaleStart = n, this.autoScaleEnd = o, this.formattingFunction = l, n || o) {
        var h = this,
            u = function u(t) {
          var e = t - t % (h.magnitudefactor * h.minorSteps[h.minorStepIdx]);
          return t % (h.magnitudefactor * h.minorSteps[h.minorStepIdx]) > h.magnitudefactor * h.minorSteps[h.minorStepIdx] * .5 ? e + h.magnitudefactor * h.minorSteps[h.minorStepIdx] : e;
        };

        n && (this._start -= 2 * this.magnitudefactor * this.minorSteps[this.minorStepIdx], this._start = u(this._start)), o && (this._end += this.magnitudefactor * this.minorSteps[this.minorStepIdx], this._end = u(this._end)), this.determineScale();
      }
    }

    return _n(t, [{
      key: "setCharHeight",
      value: function value(t) {
        this.majorCharHeight = t;
      }
    }, {
      key: "setHeight",
      value: function value(t) {
        this.containerHeight = t;
      }
    }, {
      key: "determineScale",
      value: function value() {
        var t = this._end - this._start;
        this.scale = this.containerHeight / t;
        var e = this.majorCharHeight / this.scale,
            i = t > 0 ? Math.round(Math.log(t) / Math.LN10) : 0;
        this.minorStepIdx = -1, this.magnitudefactor = Math.pow(10, i);
        var n = 0;
        i < 0 && (n = i);

        for (var o = !1, r = n; Math.abs(r) <= Math.abs(i); r++) {
          this.magnitudefactor = Math.pow(10, r);

          for (var s = 0; s < this.minorSteps.length; s++) {
            if (this.magnitudefactor * this.minorSteps[s] >= e) {
              o = !0, this.minorStepIdx = s;
              break;
            }
          }

          if (!0 === o) break;
        }
      }
    }, {
      key: "is_major",
      value: function value(t) {
        return t % (this.magnitudefactor * this.majorSteps[this.minorStepIdx]) == 0;
      }
    }, {
      key: "getStep",
      value: function value() {
        return this.magnitudefactor * this.minorSteps[this.minorStepIdx];
      }
    }, {
      key: "getFirstMajor",
      value: function value() {
        var t = this.magnitudefactor * this.majorSteps[this.minorStepIdx];
        return this.convertValue(this._start + (t - this._start % t) % t);
      }
    }, {
      key: "formatValue",
      value: function value(t) {
        var e = t.toPrecision(5);
        return "function" == typeof this.formattingFunction && (e = this.formattingFunction(t)), "number" == typeof e ? "".concat(e) : "string" == typeof e ? e : t.toPrecision(5);
      }
    }, {
      key: "getLines",
      value: function value() {
        for (var t = [], e = this.getStep(), i = (e - this._start % e) % e, n = this._start + i; this._end - n > 1e-5; n += e) {
          n != this._start && t.push({
            major: this.is_major(n),
            y: this.convertValue(n),
            val: this.formatValue(n)
          });
        }

        return t;
      }
    }, {
      key: "followScale",
      value: function value(t) {
        var e = this.minorStepIdx,
            i = this._start,
            n = this._end,
            o = this,
            r = function r() {
          o.magnitudefactor *= 2;
        },
            s = function s() {
          o.magnitudefactor /= 2;
        };

        t.minorStepIdx <= 1 && this.minorStepIdx <= 1 || t.minorStepIdx > 1 && this.minorStepIdx > 1 || (t.minorStepIdx < this.minorStepIdx ? (this.minorStepIdx = 1, 2 == e || r(), r()) : (this.minorStepIdx = 2, 1 == e || s(), s()));

        for (var a = t.convertValue(0), l = t.getStep() * t.scale, h = !1, u = 0; !h && u++ < 5;) {
          this.scale = l / (this.minorSteps[this.minorStepIdx] * this.magnitudefactor);
          var c = this.containerHeight / this.scale;
          this._start = i, this._end = this._start + c;
          var d = this._end * this.scale,
              p = this.magnitudefactor * this.majorSteps[this.minorStepIdx],
              f = this.getFirstMajor() - t.getFirstMajor();

          if (this.zeroAlign) {
            var m = a - d;
            this._end += m / this.scale, this._start = this._end - c;
          } else this.autoScaleStart ? (this._start -= f / this.scale, this._end = this._start + c) : (this._start += p - f / this.scale, this._end = this._start + c);

          if (!this.autoScaleEnd && this._end > n + 1e-5) s(), h = !1;else {
            if (!this.autoScaleStart && this._start < i - 1e-5) {
              if (!(this.zeroAlign && i >= 0)) {
                s(), h = !1;
                continue;
              }

              console.warn("Can't adhere to given 'min' range, due to zeroalign");
            }

            this.autoScaleStart && this.autoScaleEnd && c < n - i ? (r(), h = !1) : h = !0;
          }
        }
      }
    }, {
      key: "convertValue",
      value: function value(t) {
        return this.containerHeight - (t - this._start) * this.scale;
      }
    }, {
      key: "screenToValue",
      value: function value(t) {
        return (this.containerHeight - t) / this.scale + this._start;
      }
    }]), t;
  }();

  function Tf(t, e) {
    var i;

    if (void 0 === cs || null == zi(t)) {
      if (Jr(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return Mf(t, e);
        var n = ns(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Qi(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Mf(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);

        var _n8 = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n8 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n8++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var r,
        s = !0,
        a = !1;
    return {
      s: function s() {
        i = Hi(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i.return || i.return();
        } finally {
          if (a) throw r;
        }
      }
    };
  }

  function Mf(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, n = new Array(e); i < e; i++) {
      n[i] = t[i];
    }

    return n;
  }

  function Of(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !vh) return !1;
      if (vh.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(vh(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var i,
          n = Gh(t);

      if (e) {
        var o = Gh(this).constructor;
        i = vh(n, arguments, o);
      } else i = n.apply(this, arguments);

      return Hh(this, i);
    };
  }

  var Ef = function (t) {
    jh(i, t);
    var e = Of(i);

    function i(t, n, o, r) {
      var s;
      gn(this, i), (s = e.call(this)).id = Fu(), s.body = t, s.defaultOptions = {
        orientation: "left",
        showMinorLabels: !0,
        showMajorLabels: !0,
        showWeekScale: !1,
        icons: !1,
        majorLinesOffset: 7,
        minorLinesOffset: 4,
        labelOffsetX: 10,
        labelOffsetY: 2,
        iconWidth: 20,
        width: "40px",
        visible: !0,
        alignZeros: !0,
        left: {
          range: {
            min: void 0,
            max: void 0
          },
          format: function format(t) {
            return "".concat(ld(t.toPrecision(3)));
          },
          title: {
            text: void 0,
            style: void 0
          }
        },
        right: {
          range: {
            min: void 0,
            max: void 0
          },
          format: function format(t) {
            return "".concat(ld(t.toPrecision(3)));
          },
          title: {
            text: void 0,
            style: void 0
          }
        }
      }, s.linegraphOptions = r, s.linegraphSVG = o, s.props = {}, s.DOMelements = {
        lines: {},
        labels: {},
        title: {}
      }, s.dom = {}, s.scale = void 0, s.range = {
        start: 0,
        end: 0
      }, s.options = od.extend({}, s.defaultOptions), s.conversionFactor = 1, s.setOptions(n), s.width = Number("".concat(s.options.width).replace("px", "")), s.minWidth = s.width, s.height = s.linegraphSVG.getBoundingClientRect().height, s.hidden = !1, s.stepPixels = 25, s.zeroCrossing = -1, s.amountOfSteps = -1, s.lineOffset = 0, s.master = !0, s.masterAxis = null, s.svgElements = {}, s.iconsRemoved = !1, s.groups = {}, s.amountOfGroups = 0, s._create(), null == s.scale && s._redrawLabels(), s.framework = {
        svg: s.svg,
        svgElements: s.svgElements,
        options: s.options,
        groups: s.groups
      };
      var a = gh(s);
      return s.body.emitter.on("verticalDrag", function () {
        a.dom.lineContainer.style.top = "".concat(a.body.domProps.scrollTop, "px");
      }), s;
    }

    return _n(i, [{
      key: "addGroup",
      value: function value(t, e) {
        this.groups.hasOwnProperty(t) || (this.groups[t] = e), this.amountOfGroups += 1;
      }
    }, {
      key: "updateGroup",
      value: function value(t, e) {
        this.groups.hasOwnProperty(t) || (this.amountOfGroups += 1), this.groups[t] = e;
      }
    }, {
      key: "removeGroup",
      value: function value(t) {
        this.groups.hasOwnProperty(t) && (delete this.groups[t], this.amountOfGroups -= 1);
      }
    }, {
      key: "setOptions",
      value: function value(t) {
        if (t) {
          var e = !1;
          this.options.orientation != t.orientation && void 0 !== t.orientation && (e = !0);
          od.selectiveDeepExtend(["orientation", "showMinorLabels", "showMajorLabels", "icons", "majorLinesOffset", "minorLinesOffset", "labelOffsetX", "labelOffsetY", "iconWidth", "width", "visible", "left", "right", "alignZeros"], this.options, t), this.minWidth = Number("".concat(this.options.width).replace("px", "")), !0 === e && this.dom.frame && (this.hide(), this.show());
        }
      }
    }, {
      key: "_create",
      value: function value() {
        this.dom.frame = document.createElement("div"), this.dom.frame.style.width = this.options.width, this.dom.frame.style.height = this.height, this.dom.lineContainer = document.createElement("div"), this.dom.lineContainer.style.width = "100%", this.dom.lineContainer.style.height = this.height, this.dom.lineContainer.style.position = "relative", this.dom.lineContainer.style.visibility = "visible", this.dom.lineContainer.style.display = "block", this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "absolute", this.svg.style.top = "0px", this.svg.style.height = "100%", this.svg.style.width = "100%", this.svg.style.display = "block", this.dom.frame.appendChild(this.svg);
      }
    }, {
      key: "_redrawGroupIcons",
      value: function value() {
        var t;
        nh(this.svgElements);
        var e = this.options.iconWidth,
            i = 11.5;
        t = "left" === this.options.orientation ? 4 : this.width - e - 4;
        var n = Vr(this.groups);
        $h(n).call(n, function (t, e) {
          return t < e ? -1 : 1;
        });
        var o,
            r = Tf(n);

        try {
          for (r.s(); !(o = r.n()).done;) {
            var s = o.value;
            !0 !== this.groups[s].visible || void 0 !== this.linegraphOptions.visibility[s] && !0 !== this.linegraphOptions.visibility[s] || (this.groups[s].getLegend(e, 15, this.framework, t, i), i += 19);
          }
        } catch (t) {
          r.e(t);
        } finally {
          r.f();
        }

        oh(this.svgElements), this.iconsRemoved = !1;
      }
    }, {
      key: "_cleanupIcons",
      value: function value() {
        !1 === this.iconsRemoved && (nh(this.svgElements), oh(this.svgElements), this.iconsRemoved = !0);
      }
    }, {
      key: "show",
      value: function value() {
        this.hidden = !1, this.dom.frame.parentNode || ("left" === this.options.orientation ? this.body.dom.left.appendChild(this.dom.frame) : this.body.dom.right.appendChild(this.dom.frame)), this.dom.lineContainer.parentNode || this.body.dom.backgroundHorizontal.appendChild(this.dom.lineContainer), this.dom.lineContainer.style.display = "block";
      }
    }, {
      key: "hide",
      value: function value() {
        this.hidden = !0, this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame), this.dom.lineContainer.style.display = "none";
      }
    }, {
      key: "setRange",
      value: function value(t, e) {
        this.range.start = t, this.range.end = e;
      }
    }, {
      key: "redraw",
      value: function value() {
        var t = !1,
            e = 0;

        for (var i in this.dom.lineContainer.style.top = "".concat(this.body.domProps.scrollTop, "px"), this.groups) {
          this.groups.hasOwnProperty(i) && (!0 !== this.groups[i].visible || void 0 !== this.linegraphOptions.visibility[i] && !0 !== this.linegraphOptions.visibility[i] || e++);
        }

        if (0 === this.amountOfGroups || 0 === e) this.hide();else {
          this.show(), this.height = Number(this.linegraphSVG.style.height.replace("px", "")), this.dom.lineContainer.style.height = "".concat(this.height, "px"), this.width = !0 === this.options.visible ? Number("".concat(this.options.width).replace("px", "")) : 0;
          var n = this.props,
              o = this.dom.frame;
          o.className = "vis-data-axis", this._calculateCharSize();
          var r = this.options.orientation,
              s = this.options.showMinorLabels,
              a = this.options.showMajorLabels,
              l = this.body.dom.backgroundHorizontal.offsetWidth;
          n.minorLabelHeight = s ? n.minorCharHeight : 0, n.majorLabelHeight = a ? n.majorCharHeight : 0, n.minorLineWidth = l - this.lineOffset - this.width + 2 * this.options.minorLinesOffset, n.minorLineHeight = 1, n.majorLineWidth = l - this.lineOffset - this.width + 2 * this.options.majorLinesOffset, n.majorLineHeight = 1, "left" === r ? (o.style.top = "0", o.style.left = "0", o.style.bottom = "", o.style.width = "".concat(this.width, "px"), o.style.height = "".concat(this.height, "px"), this.props.width = this.body.domProps.left.width, this.props.height = this.body.domProps.left.height) : (o.style.top = "", o.style.bottom = "0", o.style.left = "0", o.style.width = "".concat(this.width, "px"), o.style.height = "".concat(this.height, "px"), this.props.width = this.body.domProps.right.width, this.props.height = this.body.domProps.right.height), t = this._redrawLabels(), t = this._isResized() || t, !0 === this.options.icons ? this._redrawGroupIcons() : this._cleanupIcons(), this._redrawTitle(r);
        }
        return t;
      }
    }, {
      key: "_redrawLabels",
      value: function value() {
        var t = this,
            e = !1;
        nh(this.DOMelements.lines), nh(this.DOMelements.labels);
        var i = this.options.orientation,
            n = null != this.options[i].range ? this.options[i].range : {},
            o = !0;
        null != n.max && (this.range.end = n.max, o = !1);
        var r = !0;
        null != n.min && (this.range.start = n.min, r = !1), this.scale = new Cf(this.range.start, this.range.end, r, o, this.dom.frame.offsetHeight, this.props.majorCharHeight, this.options.alignZeros, this.options[i].format), !1 === this.master && null != this.masterAxis ? (this.scale.followScale(this.masterAxis.scale), this.dom.lineContainer.style.display = "none") : this.dom.lineContainer.style.display = "block", this.maxLabelSize = 0;
        var s = this.scale.getLines();
        nr(s).call(s, function (e) {
          var n = e.y,
              o = e.major;
          t.options.showMinorLabels && !1 === o && t._redrawLabel(n - 2, e.val, i, "vis-y-axis vis-minor", t.props.minorCharHeight), o && n >= 0 && t._redrawLabel(n - 2, e.val, i, "vis-y-axis vis-major", t.props.majorCharHeight), !0 === t.master && (o ? t._redrawLine(n, i, "vis-grid vis-horizontal vis-major", t.options.majorLinesOffset, t.props.majorLineWidth) : t._redrawLine(n, i, "vis-grid vis-horizontal vis-minor", t.options.minorLinesOffset, t.props.minorLineWidth));
        });
        var a = 0;
        void 0 !== this.options[i].title && void 0 !== this.options[i].title.text && (a = this.props.titleCharHeight);
        var l = !0 === this.options.icons ? Math.max(this.options.iconWidth, a) + this.options.labelOffsetX + 15 : a + this.options.labelOffsetX + 15;
        return this.maxLabelSize > this.width - l && !0 === this.options.visible ? (this.width = this.maxLabelSize + l, this.options.width = "".concat(this.width, "px"), oh(this.DOMelements.lines), oh(this.DOMelements.labels), this.redraw(), e = !0) : this.maxLabelSize < this.width - l && !0 === this.options.visible && this.width > this.minWidth ? (this.width = Math.max(this.minWidth, this.maxLabelSize + l), this.options.width = "".concat(this.width, "px"), oh(this.DOMelements.lines), oh(this.DOMelements.labels), this.redraw(), e = !0) : (oh(this.DOMelements.lines), oh(this.DOMelements.labels), e = !1), e;
      }
    }, {
      key: "convertValue",
      value: function value(t) {
        return this.scale.convertValue(t);
      }
    }, {
      key: "screenToValue",
      value: function value(t) {
        return this.scale.screenToValue(t);
      }
    }, {
      key: "_redrawLabel",
      value: function value(t, e, i, n, o) {
        var r = ah("div", this.DOMelements.labels, this.dom.frame);
        r.className = n, r.innerHTML = od.xss(e), "left" === i ? (r.style.left = "-".concat(this.options.labelOffsetX, "px"), r.style.textAlign = "right") : (r.style.right = "-".concat(this.options.labelOffsetX, "px"), r.style.textAlign = "left"), r.style.top = "".concat(t - .5 * o + this.options.labelOffsetY, "px"), e += "";
        var s = Math.max(this.props.majorCharWidth, this.props.minorCharWidth);
        this.maxLabelSize < e.length * s && (this.maxLabelSize = e.length * s);
      }
    }, {
      key: "_redrawLine",
      value: function value(t, e, i, n, o) {
        if (!0 === this.master) {
          var r = ah("div", this.DOMelements.lines, this.dom.lineContainer);
          r.className = i, r.innerHTML = "", "left" === e ? r.style.left = "".concat(this.width - n, "px") : r.style.right = "".concat(this.width - n, "px"), r.style.width = "".concat(o, "px"), r.style.top = "".concat(t, "px");
        }
      }
    }, {
      key: "_redrawTitle",
      value: function value(t) {
        if (nh(this.DOMelements.title), void 0 !== this.options[t].title && void 0 !== this.options[t].title.text) {
          var e = ah("div", this.DOMelements.title, this.dom.frame);
          e.className = "vis-y-axis vis-title vis-".concat(t), e.innerHTML = od.xss(this.options[t].title.text), void 0 !== this.options[t].title.style && od.addCssText(e, this.options[t].title.style), "left" === t ? e.style.left = "".concat(this.props.titleCharHeight, "px") : e.style.right = "".concat(this.props.titleCharHeight, "px"), e.style.width = "".concat(this.height, "px");
        }

        oh(this.DOMelements.title);
      }
    }, {
      key: "_calculateCharSize",
      value: function value() {
        if (!("minorCharHeight" in this.props)) {
          var t = document.createTextNode("0"),
              e = document.createElement("div");
          e.className = "vis-y-axis vis-minor vis-measure", e.appendChild(t), this.dom.frame.appendChild(e), this.props.minorCharHeight = e.clientHeight, this.props.minorCharWidth = e.clientWidth, this.dom.frame.removeChild(e);
        }

        if (!("majorCharHeight" in this.props)) {
          var i = document.createTextNode("0"),
              n = document.createElement("div");
          n.className = "vis-y-axis vis-major vis-measure", n.appendChild(i), this.dom.frame.appendChild(n), this.props.majorCharHeight = n.clientHeight, this.props.majorCharWidth = n.clientWidth, this.dom.frame.removeChild(n);
        }

        if (!("titleCharHeight" in this.props)) {
          var o = document.createTextNode("0"),
              r = document.createElement("div");
          r.className = "vis-y-axis vis-title vis-measure", r.appendChild(o), this.dom.frame.appendChild(r), this.props.titleCharHeight = r.clientHeight, this.props.titleCharWidth = r.clientWidth, this.dom.frame.removeChild(r);
        }
      }
    }]), i;
  }(hd);

  function Pf(t, e) {}

  function Af(t, e) {
    return {
      style: (e = void 0 === e ? {} : e).style || t.options.drawPoints.style,
      styles: e.styles || t.options.drawPoints.styles,
      size: e.size || t.options.drawPoints.size,
      className: e.className || t.className
    };
  }

  function Lf(t, e) {}

  function If(t, e) {}

  function Nf(t, e, i, n) {
    this.id = e;
    this.options = od.selectiveBridgeObject(["sampling", "style", "sort", "yAxisOrientation", "barChart", "drawPoints", "shaded", "interpolation", "zIndex", "excludeFromStacking", "excludeFromLegend"], i), this.usingDefaultStyle = void 0 === t.className, this.groupsUsingDefaultStyles = n, this.zeroPosition = 0, this.update(t), 1 == this.usingDefaultStyle && (this.groupsUsingDefaultStyles[0] += 1), this.itemsData = [], this.visible = void 0 === t.visible || t.visible;
  }

  function Rf(t, e, i, n) {
    this.body = t, this.defaultOptions = {
      enabled: !1,
      icons: !0,
      iconSize: 20,
      iconSpacing: 6,
      left: {
        visible: !0,
        position: "top-left"
      },
      right: {
        visible: !0,
        position: "top-right"
      }
    }, this.side = i, this.options = od.extend({}, this.defaultOptions), this.linegraphOptions = n, this.svgElements = {}, this.dom = {}, this.groups = {}, this.amountOfGroups = 0, this._create(), this.framework = {
      svg: this.svg,
      svgElements: this.svgElements,
      options: this.options,
      groups: this.groups
    }, this.setOptions(e);
  }

  Pf.draw = function (t, e, i, n) {
    n = n || 0;

    for (var o = function (t, e) {
      var i = void 0;
      t.options && t.options.drawPoints && t.options.drawPoints.onRender && "function" == typeof t.options.drawPoints.onRender && (i = t.options.drawPoints.onRender);
      e.group.options && e.group.options.drawPoints && e.group.options.drawPoints.onRender && "function" == typeof e.group.options.drawPoints.onRender && (i = e.group.options.drawPoints.onRender);
      return i;
    }(i, e), r = 0; r < t.length; r++) {
      if (o) {
        var s = o(t[r], e);
        !0 !== s && "object" !== es(s) || lh(t[r].screen_x + n, t[r].screen_y, Af(e, s), i.svgElements, i.svg, t[r].label);
      } else lh(t[r].screen_x + n, t[r].screen_y, Af(e), i.svgElements, i.svg, t[r].label);
    }
  }, Pf.drawIcon = function (t, e, i, n, o, r) {
    var s = .5 * o,
        a = sh("rect", r.svgElements, r.svg);
    a.setAttributeNS(null, "x", e), a.setAttributeNS(null, "y", i - s), a.setAttributeNS(null, "width", n), a.setAttributeNS(null, "height", 2 * s), a.setAttributeNS(null, "class", "vis-outline"), lh(e + .5 * n, i, Af(t), r.svgElements, r.svg);
  }, Lf.drawIcon = function (t, e, i, n, o, r) {
    var s = .5 * o,
        a = sh("rect", r.svgElements, r.svg);
    a.setAttributeNS(null, "x", e), a.setAttributeNS(null, "y", i - s), a.setAttributeNS(null, "width", n), a.setAttributeNS(null, "height", 2 * s), a.setAttributeNS(null, "class", "vis-outline");
    var l = Math.round(.3 * n),
        h = t.options.barChart.width / l,
        u = Math.round(.4 * o),
        c = Math.round(.75 * o),
        d = Math.round((n - 2 * l) / 3);

    if (hh(e + .5 * l + d, i + s - u - 1, l, u, t.className + " vis-bar", r.svgElements, r.svg, t.style), hh(e + 1.5 * l + d + 2, i + s - c - 1, l, c, t.className + " vis-bar", r.svgElements, r.svg, t.style), 1 == t.options.drawPoints.enabled) {
      var p = {
        style: t.options.drawPoints.style,
        styles: t.options.drawPoints.styles,
        size: t.options.drawPoints.size / h,
        className: t.className
      };
      lh(e + .5 * l + d, i + s - u - 1, p, r.svgElements, r.svg), lh(e + 1.5 * l + d + 2, i + s - c - 1, p, r.svgElements, r.svg);
    }
  }, Lf.draw = function (t, e, i) {
    var n,
        o,
        r,
        s,
        a,
        l,
        h = [],
        u = {},
        c = 0;

    for (a = 0; a < t.length; a++) {
      if ("bar" === (s = i.groups[t[a]]).options.style && !0 === s.visible && (void 0 === i.options.groups.visibility[t[a]] || !0 === i.options.groups.visibility[t[a]])) for (l = 0; l < e[t[a]].length; l++) {
        h.push({
          screen_x: e[t[a]][l].screen_x,
          screen_end: e[t[a]][l].screen_end,
          screen_y: e[t[a]][l].screen_y,
          x: e[t[a]][l].x,
          end: e[t[a]][l].end,
          y: e[t[a]][l].y,
          groupId: t[a],
          label: e[t[a]][l].label
        }), c += 1;
      }
    }

    if (0 !== c) for ($h(h).call(h, function (t, e) {
      return t.screen_x === e.screen_x ? t.groupId < e.groupId ? -1 : 1 : t.screen_x - e.screen_x;
    }), Lf._getDataIntersections(u, h), a = 0; a < h.length; a++) {
      var d = null != (s = i.groups[h[a].groupId]).options.barChart.minWidth ? s.options.barChart.minWidth : .1 * s.options.barChart.width,
          p = 0;
      if (void 0 === u[o = h[a].screen_x]) a + 1 < h.length && (n = Math.abs(h[a + 1].screen_x - o)), r = Lf._getSafeDrawData(n, s, d);else {
        var f = a + (u[o].amount - u[o].resolved);
        f < h.length && (n = Math.abs(h[f].screen_x - o)), r = Lf._getSafeDrawData(n, s, d), u[o].resolved += 1, !0 === s.options.stack && !0 !== s.options.excludeFromStacking ? h[a].screen_y < s.zeroPosition ? (p = u[o].accumulatedNegative, u[o].accumulatedNegative += s.zeroPosition - h[a].screen_y) : (p = u[o].accumulatedPositive, u[o].accumulatedPositive += s.zeroPosition - h[a].screen_y) : !0 === s.options.barChart.sideBySide && (r.width = r.width / u[o].amount, r.offset += u[o].resolved * r.width - .5 * r.width * (u[o].amount + 1));
      }
      var m = r.width,
          v = h[a].screen_x;

      if (null != h[a].screen_end ? v += .5 * (m = h[a].screen_end - h[a].screen_x) : v += r.offset, hh(v, h[a].screen_y - p, m, s.zeroPosition - h[a].screen_y, s.className + " vis-bar", i.svgElements, i.svg, s.style), !0 === s.options.drawPoints.enabled) {
        var g = {
          screen_x: h[a].screen_x,
          screen_y: h[a].screen_y - p,
          x: h[a].x,
          y: h[a].y,
          groupId: h[a].groupId,
          label: h[a].label
        };
        Pf.draw([g], s, i, r.offset);
      }
    }
  }, Lf._getDataIntersections = function (t, e) {
    for (var i, n = 0; n < e.length; n++) {
      n + 1 < e.length && (i = Math.abs(e[n + 1].screen_x - e[n].screen_x)), n > 0 && (i = Math.min(i, Math.abs(e[n - 1].screen_x - e[n].screen_x))), 0 === i && (void 0 === t[e[n].screen_x] && (t[e[n].screen_x] = {
        amount: 0,
        resolved: 0,
        accumulatedPositive: 0,
        accumulatedNegative: 0
      }), t[e[n].screen_x].amount += 1);
    }
  }, Lf._getSafeDrawData = function (t, e, i) {
    var n, o;
    return t < e.options.barChart.width && t > 0 ? (n = t < i ? i : t, o = 0, "left" === e.options.barChart.align ? o -= .5 * t : "right" === e.options.barChart.align && (o += .5 * t)) : (n = e.options.barChart.width, o = 0, "left" === e.options.barChart.align ? o -= .5 * e.options.barChart.width : "right" === e.options.barChart.align && (o += .5 * e.options.barChart.width)), {
      width: n,
      offset: o
    };
  }, Lf.getStackedYRange = function (t, e, i, n, o) {
    if (t.length > 0) {
      $h(t).call(t, function (t, e) {
        return t.screen_x === e.screen_x ? t.groupId < e.groupId ? -1 : 1 : t.screen_x - e.screen_x;
      });
      var r = {};
      Lf._getDataIntersections(r, t), e[n] = Lf._getStackedYRange(r, t), e[n].yAxisOrientation = o, i.push(n);
    }
  }, Lf._getStackedYRange = function (t, e) {
    for (var i, n = e[0].screen_y, o = e[0].screen_y, r = 0; r < e.length; r++) {
      void 0 === t[i = e[r].screen_x] ? (n = n > e[r].screen_y ? e[r].screen_y : n, o = o < e[r].screen_y ? e[r].screen_y : o) : e[r].screen_y < 0 ? t[i].accumulatedNegative += e[r].screen_y : t[i].accumulatedPositive += e[r].screen_y;
    }

    for (var s in t) {
      t.hasOwnProperty(s) && (n = (n = n > t[s].accumulatedNegative ? t[s].accumulatedNegative : n) > t[s].accumulatedPositive ? t[s].accumulatedPositive : n, o = (o = o < t[s].accumulatedNegative ? t[s].accumulatedNegative : o) < t[s].accumulatedPositive ? t[s].accumulatedPositive : o);
    }

    return {
      min: n,
      max: o
    };
  }, If.calcPath = function (t, e) {
    if (null != t && t.length > 0) {
      return 1 == e.options.interpolation.enabled ? If._catmullRom(t, e) : If._linear(t);
    }
  }, If.drawIcon = function (t, e, i, n, o, r) {
    var s,
        a,
        l = .5 * o,
        h = sh("rect", r.svgElements, r.svg);
    (h.setAttributeNS(null, "x", e), h.setAttributeNS(null, "y", i - l), h.setAttributeNS(null, "width", n), h.setAttributeNS(null, "height", 2 * l), h.setAttributeNS(null, "class", "vis-outline"), (s = sh("path", r.svgElements, r.svg)).setAttributeNS(null, "class", t.className), void 0 !== t.style && s.setAttributeNS(null, "style", t.style), s.setAttributeNS(null, "d", "M" + e + "," + i + " L" + (e + n) + "," + i), 1 == t.options.shaded.enabled && (a = sh("path", r.svgElements, r.svg), "top" == t.options.shaded.orientation ? a.setAttributeNS(null, "d", "M" + e + ", " + (i - l) + "L" + e + "," + i + " L" + (e + n) + "," + i + " L" + (e + n) + "," + (i - l)) : a.setAttributeNS(null, "d", "M" + e + "," + i + " L" + e + "," + (i + l) + " L" + (e + n) + "," + (i + l) + "L" + (e + n) + "," + i), a.setAttributeNS(null, "class", t.className + " vis-icon-fill"), void 0 !== t.options.shaded.style && "" !== t.options.shaded.style && a.setAttributeNS(null, "style", t.options.shaded.style)), 1 == t.options.drawPoints.enabled) && lh(e + .5 * n, i, {
      style: t.options.drawPoints.style,
      styles: t.options.drawPoints.styles,
      size: t.options.drawPoints.size,
      className: t.className
    }, r.svgElements, r.svg);
  }, If.drawShading = function (t, e, i, n) {
    if (1 == e.options.shaded.enabled) {
      var o,
          r = Number(n.svg.style.height.replace("px", "")),
          s = sh("path", n.svgElements, n.svg),
          a = "L";
      1 == e.options.interpolation.enabled && (a = "C");
      var l = 0;
      l = "top" == e.options.shaded.orientation ? 0 : "bottom" == e.options.shaded.orientation ? r : Math.min(Math.max(0, e.zeroPosition), r), o = "group" == e.options.shaded.orientation && null != i && null != i ? "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, a, !1) + " L" + i[i.length - 1][0] + "," + i[i.length - 1][1] + " " + this.serializePath(i, a, !0) + i[0][0] + "," + i[0][1] + " Z" : "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, a, !1) + " V" + l + " H" + t[0][0] + " Z", s.setAttributeNS(null, "class", e.className + " vis-fill"), void 0 !== e.options.shaded.style && s.setAttributeNS(null, "style", e.options.shaded.style), s.setAttributeNS(null, "d", o);
    }
  }, If.draw = function (t, e, i) {
    if (null != t && null != t) {
      var n = sh("path", i.svgElements, i.svg);
      n.setAttributeNS(null, "class", e.className), void 0 !== e.style && n.setAttributeNS(null, "style", e.style);
      var o = "L";
      1 == e.options.interpolation.enabled && (o = "C"), n.setAttributeNS(null, "d", "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, o, !1));
    }
  }, If.serializePath = function (t, e, i) {
    if (t.length < 2) return "";
    var n,
        o = e;
    if (i) for (n = t.length - 2; n > 0; n--) {
      o += t[n][0] + "," + t[n][1] + " ";
    } else for (n = 1; n < t.length; n++) {
      o += t[n][0] + "," + t[n][1] + " ";
    }
    return o;
  }, If._catmullRomUniform = function (t) {
    var e,
        i,
        n,
        o,
        r,
        s,
        a = [];
    a.push([Math.round(t[0].screen_x), Math.round(t[0].screen_y)]);

    for (var l = 1 / 6, h = t.length, u = 0; u < h - 1; u++) {
      e = 0 == u ? t[0] : t[u - 1], i = t[u], n = t[u + 1], o = u + 2 < h ? t[u + 2] : n, r = {
        screen_x: (-e.screen_x + 6 * i.screen_x + n.screen_x) * l,
        screen_y: (-e.screen_y + 6 * i.screen_y + n.screen_y) * l
      }, s = {
        screen_x: (i.screen_x + 6 * n.screen_x - o.screen_x) * l,
        screen_y: (i.screen_y + 6 * n.screen_y - o.screen_y) * l
      }, a.push([r.screen_x, r.screen_y]), a.push([s.screen_x, s.screen_y]), a.push([n.screen_x, n.screen_y]);
    }

    return a;
  }, If._catmullRom = function (t, e) {
    var i = e.options.interpolation.alpha;
    if (0 == i || void 0 === i) return this._catmullRomUniform(t);

    var n,
        o,
        r,
        s,
        a,
        l,
        h,
        u,
        c,
        d,
        p,
        f,
        m,
        v,
        g,
        y,
        b,
        _,
        w,
        k = [];

    k.push([Math.round(t[0].screen_x), Math.round(t[0].screen_y)]);

    for (var x = t.length, D = 0; D < x - 1; D++) {
      n = 0 == D ? t[0] : t[D - 1], o = t[D], r = t[D + 1], s = D + 2 < x ? t[D + 2] : r, h = Math.sqrt(Math.pow(n.screen_x - o.screen_x, 2) + Math.pow(n.screen_y - o.screen_y, 2)), u = Math.sqrt(Math.pow(o.screen_x - r.screen_x, 2) + Math.pow(o.screen_y - r.screen_y, 2)), c = Math.sqrt(Math.pow(r.screen_x - s.screen_x, 2) + Math.pow(r.screen_y - s.screen_y, 2)), v = Math.pow(c, i), y = Math.pow(c, 2 * i), g = Math.pow(u, i), b = Math.pow(u, 2 * i), w = Math.pow(h, i), d = 2 * (_ = Math.pow(h, 2 * i)) + 3 * w * g + b, p = 2 * y + 3 * v * g + b, (f = 3 * w * (w + g)) > 0 && (f = 1 / f), (m = 3 * v * (v + g)) > 0 && (m = 1 / m), a = {
        screen_x: (-b * n.screen_x + d * o.screen_x + _ * r.screen_x) * f,
        screen_y: (-b * n.screen_y + d * o.screen_y + _ * r.screen_y) * f
      }, l = {
        screen_x: (y * o.screen_x + p * r.screen_x - b * s.screen_x) * m,
        screen_y: (y * o.screen_y + p * r.screen_y - b * s.screen_y) * m
      }, 0 == a.screen_x && 0 == a.screen_y && (a = o), 0 == l.screen_x && 0 == l.screen_y && (l = r), k.push([a.screen_x, a.screen_y]), k.push([l.screen_x, l.screen_y]), k.push([r.screen_x, r.screen_y]);
    }

    return k;
  }, If._linear = function (t) {
    for (var e = [], i = 0; i < t.length; i++) {
      e.push([t[i].screen_x, t[i].screen_y]);
    }

    return e;
  }, Nf.prototype.setItems = function (t) {
    null != t ? (this.itemsData = t, 1 == $h(this.options) && od.insertSort(this.itemsData, function (t, e) {
      return t.x > e.x ? 1 : -1;
    })) : this.itemsData = [];
  }, Nf.prototype.getItems = function () {
    return this.itemsData;
  }, Nf.prototype.setZeroPosition = function (t) {
    this.zeroPosition = t;
  }, Nf.prototype.setOptions = function (t) {
    if (void 0 !== t) {
      od.selectiveDeepExtend(["sampling", "style", "sort", "yAxisOrientation", "barChart", "zIndex", "excludeFromStacking", "excludeFromLegend"], this.options, t), "function" == typeof t.drawPoints && (t.drawPoints = {
        onRender: t.drawPoints
      }), od.mergeOptions(this.options, t, "interpolation"), od.mergeOptions(this.options, t, "drawPoints"), od.mergeOptions(this.options, t, "shaded"), t.interpolation && "object" == es(t.interpolation) && t.interpolation.parametrization && ("uniform" == t.interpolation.parametrization ? this.options.interpolation.alpha = 0 : "chordal" == t.interpolation.parametrization ? this.options.interpolation.alpha = 1 : (this.options.interpolation.parametrization = "centripetal", this.options.interpolation.alpha = .5));
    }
  }, Nf.prototype.update = function (t) {
    this.group = t, this.content = t.content || "graph", this.className = t.className || this.className || "vis-graph-group" + this.groupsUsingDefaultStyles[0] % 10, this.visible = void 0 === t.visible || t.visible, this.style = t.style, this.setOptions(t.options);
  }, Nf.prototype.getLegend = function (t, e, i, n, o) {
    null != i && null != i || (i = {
      svg: document.createElementNS("http://www.w3.org/2000/svg", "svg"),
      svgElements: {},
      options: this.options,
      groups: [this]
    });

    switch (null != n && null != n || (n = 0), null != o && null != o || (o = .5 * e), this.options.style) {
      case "line":
        If.drawIcon(this, n, o, t, e, i);
        break;

      case "points":
      case "point":
        Pf.drawIcon(this, n, o, t, e, i);
        break;

      case "bar":
        Lf.drawIcon(this, n, o, t, e, i);
    }

    return {
      icon: i.svg,
      label: this.content,
      orientation: this.options.yAxisOrientation
    };
  }, Nf.prototype.getYRange = function (t) {
    for (var e = t[0].y, i = t[0].y, n = 0; n < t.length; n++) {
      e = e > t[n].y ? t[n].y : e, i = i < t[n].y ? t[n].y : i;
    }

    return {
      min: e,
      max: i,
      yAxisOrientation: this.options.yAxisOrientation
    };
  }, Rf.prototype = new hd(), Rf.prototype.clear = function () {
    this.groups = {}, this.amountOfGroups = 0;
  }, Rf.prototype.addGroup = function (t, e) {
    1 != e.options.excludeFromLegend && (this.groups.hasOwnProperty(t) || (this.groups[t] = e), this.amountOfGroups += 1);
  }, Rf.prototype.updateGroup = function (t, e) {
    this.groups[t] = e;
  }, Rf.prototype.removeGroup = function (t) {
    this.groups.hasOwnProperty(t) && (delete this.groups[t], this.amountOfGroups -= 1);
  }, Rf.prototype._create = function () {
    this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-legend", this.dom.frame.style.position = "absolute", this.dom.frame.style.top = "10px", this.dom.frame.style.display = "block", this.dom.textArea = document.createElement("div"), this.dom.textArea.className = "vis-legend-text", this.dom.textArea.style.position = "relative", this.dom.textArea.style.top = "0px", this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "absolute", this.svg.style.top = "0px", this.svg.style.width = this.options.iconSize + 5 + "px", this.svg.style.height = "100%", this.dom.frame.appendChild(this.svg), this.dom.frame.appendChild(this.dom.textArea);
  }, Rf.prototype.hide = function () {
    this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame);
  }, Rf.prototype.show = function () {
    this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame);
  }, Rf.prototype.setOptions = function (t) {
    od.selectiveDeepExtend(["enabled", "orientation", "icons", "left", "right"], this.options, t);
  }, Rf.prototype.redraw = function () {
    var t = 0,
        e = Vr(this.groups);
    $h(e).call(e, function (t, e) {
      return t < e ? -1 : 1;
    });

    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      1 != this.groups[n].visible || void 0 !== this.linegraphOptions.visibility[n] && 1 != this.linegraphOptions.visibility[n] || t++;
    }

    if (0 == this.options[this.side].visible || 0 == this.amountOfGroups || 0 == this.options.enabled || 0 == t) this.hide();else {
      if (this.show(), "top-left" == this.options[this.side].position || "bottom-left" == this.options[this.side].position ? (this.dom.frame.style.left = "4px", this.dom.frame.style.textAlign = "left", this.dom.textArea.style.textAlign = "left", this.dom.textArea.style.left = this.options.iconSize + 15 + "px", this.dom.textArea.style.right = "", this.svg.style.left = "0px", this.svg.style.right = "") : (this.dom.frame.style.right = "4px", this.dom.frame.style.textAlign = "right", this.dom.textArea.style.textAlign = "right", this.dom.textArea.style.right = this.options.iconSize + 15 + "px", this.dom.textArea.style.left = "", this.svg.style.right = "0px", this.svg.style.left = ""), "top-left" == this.options[this.side].position || "top-right" == this.options[this.side].position) this.dom.frame.style.top = 4 - Number(this.body.dom.center.style.top.replace("px", "")) + "px", this.dom.frame.style.bottom = "";else {
        var o = this.body.domProps.center.height - this.body.domProps.centerContainer.height;
        this.dom.frame.style.bottom = 4 + o + Number(this.body.dom.center.style.top.replace("px", "")) + "px", this.dom.frame.style.top = "";
      }
      0 == this.options.icons ? (this.dom.frame.style.width = this.dom.textArea.offsetWidth + 10 + "px", this.dom.textArea.style.right = "", this.dom.textArea.style.left = "", this.svg.style.width = "0px") : (this.dom.frame.style.width = this.options.iconSize + 15 + this.dom.textArea.offsetWidth + 10 + "px", this.drawLegendIcons());
      var r = "";

      for (i = 0; i < e.length; i++) {
        n = e[i], 1 != this.groups[n].visible || void 0 !== this.linegraphOptions.visibility[n] && 1 != this.linegraphOptions.visibility[n] || (r += this.groups[n].content + "<br />");
      }

      this.dom.textArea.innerHTML = od.xss(r), this.dom.textArea.style.lineHeight = .75 * this.options.iconSize + this.options.iconSpacing + "px";
    }
  }, Rf.prototype.drawLegendIcons = function () {
    if (this.dom.frame.parentNode) {
      var t = Vr(this.groups);
      $h(t).call(t, function (t, e) {
        return t < e ? -1 : 1;
      }), rh(this.svgElements);
      var e = window.getComputedStyle(this.dom.frame).paddingTop,
          i = Number(e.replace("px", "")),
          n = i,
          o = this.options.iconSize,
          r = .75 * this.options.iconSize,
          s = i + .5 * r + 3;
      this.svg.style.width = o + 5 + i + "px";

      for (var a = 0; a < t.length; a++) {
        var l = t[a];
        1 != this.groups[l].visible || void 0 !== this.linegraphOptions.visibility[l] && 1 != this.linegraphOptions.visibility[l] || (this.groups[l].getLegend(o, r, this.framework, n, s), s += r + this.options.iconSpacing);
      }
    }
  };
  var Ff = "__ungrouped__";

  function Yf(t, e) {
    this.id = Fu(), this.body = t, this.defaultOptions = {
      yAxisOrientation: "left",
      defaultGroup: "default",
      sort: !0,
      sampling: !0,
      stack: !1,
      graphHeight: "400px",
      shaded: {
        enabled: !1,
        orientation: "bottom"
      },
      style: "line",
      barChart: {
        width: 50,
        sideBySide: !1,
        align: "center"
      },
      interpolation: {
        enabled: !0,
        parametrization: "centripetal",
        alpha: .5
      },
      drawPoints: {
        enabled: !0,
        size: 6,
        style: "square"
      },
      dataAxis: {},
      legend: {},
      groups: {
        visibility: {}
      }
    }, this.options = od.extend({}, this.defaultOptions), this.dom = {}, this.props = {}, this.hammer = null, this.groups = {}, this.abortedGraphUpdate = !1, this.updateSVGheight = !1, this.updateSVGheightOnResize = !1, this.forceGraphUpdate = !0;
    var i = this;
    this.itemsData = null, this.groupsData = null, this.itemListeners = {
      add: function add(t, e, n) {
        i._onAdd(e.items);
      },
      update: function update(t, e, n) {
        i._onUpdate(e.items);
      },
      remove: function remove(t, e, n) {
        i._onRemove(e.items);
      }
    }, this.groupListeners = {
      add: function add(t, e, n) {
        i._onAddGroups(e.items);
      },
      update: function update(t, e, n) {
        i._onUpdateGroups(e.items);
      },
      remove: function remove(t, e, n) {
        i._onRemoveGroups(e.items);
      }
    }, this.items = {}, this.selection = [], this.lastStart = this.body.range.start, this.touchParams = {}, this.svgElements = {}, this.setOptions(e), this.groupsUsingDefaultStyles = [0], this.body.emitter.on("rangechanged", function () {
      i.svg.style.left = od.option.asSize(-i.props.width), i.forceGraphUpdate = !0, i.redraw.call(i);
    }), this._create(), this.framework = {
      svg: this.svg,
      svgElements: this.svgElements,
      options: this.options,
      groups: this.groups
    };
  }

  Yf.prototype = new hd(), Yf.prototype._create = function () {
    var t = document.createElement("div");
    t.className = "vis-line-graph", this.dom.frame = t, this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "relative", this.svg.style.height = ("" + this.options.graphHeight).replace("px", "") + "px", this.svg.style.display = "block", t.appendChild(this.svg), this.options.dataAxis.orientation = "left", this.yAxisLeft = new Ef(this.body, this.options.dataAxis, this.svg, this.options.groups), this.options.dataAxis.orientation = "right", this.yAxisRight = new Ef(this.body, this.options.dataAxis, this.svg, this.options.groups), delete this.options.dataAxis.orientation, this.legendLeft = new Rf(this.body, this.options.legend, "left", this.options.groups), this.legendRight = new Rf(this.body, this.options.legend, "right", this.options.groups), this.show();
  }, Yf.prototype.setOptions = function (t) {
    if (t) {
      void 0 === t.graphHeight && void 0 !== t.height ? (this.updateSVGheight = !0, this.updateSVGheightOnResize = !0) : void 0 !== this.body.domProps.centerContainer.height && void 0 !== t.graphHeight && Qn((t.graphHeight + "").replace("px", "")) < this.body.domProps.centerContainer.height && (this.updateSVGheight = !0), od.selectiveDeepExtend(["sampling", "defaultGroup", "stack", "height", "graphHeight", "yAxisOrientation", "style", "barChart", "dataAxis", "sort", "groups"], this.options, t), od.mergeOptions(this.options, t, "interpolation"), od.mergeOptions(this.options, t, "drawPoints"), od.mergeOptions(this.options, t, "shaded"), od.mergeOptions(this.options, t, "legend"), t.interpolation && "object" == es(t.interpolation) && t.interpolation.parametrization && ("uniform" == t.interpolation.parametrization ? this.options.interpolation.alpha = 0 : "chordal" == t.interpolation.parametrization ? this.options.interpolation.alpha = 1 : (this.options.interpolation.parametrization = "centripetal", this.options.interpolation.alpha = .5)), this.yAxisLeft && void 0 !== t.dataAxis && (this.yAxisLeft.setOptions(this.options.dataAxis), this.yAxisRight.setOptions(this.options.dataAxis)), this.legendLeft && void 0 !== t.legend && (this.legendLeft.setOptions(this.options.legend), this.legendRight.setOptions(this.options.legend)), this.groups.hasOwnProperty(Ff) && this.groups[Ff].setOptions(t);
    }

    this.dom.frame && (this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
      queue: !0
    }));
  }, Yf.prototype.hide = function () {
    this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame);
  }, Yf.prototype.show = function () {
    this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame);
  }, Yf.prototype.setItems = function (t) {
    var e,
        i = this,
        n = this.itemsData;

    if (t) {
      if (!Ju("id", t)) throw new TypeError("Data must implement the interface of DataSet or DataView");
      this.itemsData = nd(t);
    } else this.itemsData = null;

    if (n && (nr(od).call(od, this.itemListeners, function (t, e) {
      n.off(e, t);
    }), n.dispose(), e = n.getIds(), this._onRemove(e)), this.itemsData) {
      var o = this.id;
      nr(od).call(od, this.itemListeners, function (t, e) {
        i.itemsData.on(e, t, o);
      }), e = this.itemsData.getIds(), this._onAdd(e);
    }
  }, Yf.prototype.setGroups = function (t) {
    var e,
        i = this;

    if (this.groupsData) {
      nr(od).call(od, this.groupListeners, function (t, e) {
        i.groupsData.off(e, t);
      }), e = this.groupsData.getIds(), this.groupsData = null;

      for (var n = 0; n < e.length; n++) {
        this._removeGroup(e[n]);
      }
    }

    if (t) {
      if (!Ju("id", t)) throw new TypeError("Data must implement the interface of DataSet or DataView");
      this.groupsData = t;
    } else this.groupsData = null;

    if (this.groupsData) {
      var o = this.id;
      nr(od).call(od, this.groupListeners, function (t, e) {
        i.groupsData.on(e, t, o);
      }), e = this.groupsData.getIds(), this._onAddGroups(e);
    }
  }, Yf.prototype._onUpdate = function (t) {
    this._updateAllGroupData(t);
  }, Yf.prototype._onAdd = function (t) {
    this._onUpdate(t);
  }, Yf.prototype._onRemove = function (t) {
    this._onUpdate(t);
  }, Yf.prototype._onUpdateGroups = function (t) {
    this._updateAllGroupData(null, t);
  }, Yf.prototype._onAddGroups = function (t) {
    this._onUpdateGroups(t);
  }, Yf.prototype._onRemoveGroups = function (t) {
    for (var e = 0; e < t.length; e++) {
      this._removeGroup(t[e]);
    }

    this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
      queue: !0
    });
  }, Yf.prototype._removeGroup = function (t) {
    this.groups.hasOwnProperty(t) && ("right" == this.groups[t].options.yAxisOrientation ? (this.yAxisRight.removeGroup(t), this.legendRight.removeGroup(t), this.legendRight.redraw()) : (this.yAxisLeft.removeGroup(t), this.legendLeft.removeGroup(t), this.legendLeft.redraw()), delete this.groups[t]);
  }, Yf.prototype._updateGroup = function (t, e) {
    this.groups.hasOwnProperty(e) ? (this.groups[e].update(t), "right" == this.groups[e].options.yAxisOrientation ? (this.yAxisRight.updateGroup(e, this.groups[e]), this.legendRight.updateGroup(e, this.groups[e]), this.yAxisLeft.removeGroup(e), this.legendLeft.removeGroup(e)) : (this.yAxisLeft.updateGroup(e, this.groups[e]), this.legendLeft.updateGroup(e, this.groups[e]), this.yAxisRight.removeGroup(e), this.legendRight.removeGroup(e))) : (this.groups[e] = new Nf(t, e, this.options, this.groupsUsingDefaultStyles), "right" == this.groups[e].options.yAxisOrientation ? (this.yAxisRight.addGroup(e, this.groups[e]), this.legendRight.addGroup(e, this.groups[e])) : (this.yAxisLeft.addGroup(e, this.groups[e]), this.legendLeft.addGroup(e, this.groups[e]))), this.legendLeft.redraw(), this.legendRight.redraw();
  }, Yf.prototype._updateAllGroupData = function (t, e) {
    if (null != this.itemsData) {
      var i = {},
          n = this.itemsData.get(),
          o = this.itemsData.idProp,
          r = {};
      t && Kr(t).call(t, function (t) {
        r[t] = t;
      });

      for (var s = {}, a = 0; a < n.length; a++) {
        var l = n[a],
            h = l.group;
        null == h && (h = Ff), s.hasOwnProperty(h) ? s[h]++ : s[h] = 1;
      }

      var u = {};
      if (!e && t) for (h in this.groups) {
        if (this.groups.hasOwnProperty(h)) {
          var c = (m = this.groups[h]).getItems();
          i[h] = yo(c).call(c, function (t) {
            return u[t[o]] = t[o], t[o] !== r[t[o]];
          });
          var d = s[h];
          s[h] -= i[h].length, i[h].length < d && (i[h][d - 1] = {});
        }
      }

      for (a = 0; a < n.length; a++) {
        if (null == (h = (l = n[a]).group) && (h = Ff), e || !t || l[o] === r[l[o]] || !u.hasOwnProperty(l[o])) {
          i.hasOwnProperty(h) || (i[h] = new Array(s[h]));
          var p = od.bridgeObject(l);
          p.x = od.convert(l.x, "Date"), p.end = od.convert(l.end, "Date"), p.orginalY = l.y, p.y = Number(l.y), p[o] = l[o];
          var f = i[h].length - s[h]--;
          i[h][f] = p;
        }
      }

      for (h in this.groups) {
        this.groups.hasOwnProperty(h) && (i.hasOwnProperty(h) || (i[h] = new Array(0)));
      }

      for (h in i) {
        if (i.hasOwnProperty(h)) if (0 == i[h].length) this.groups.hasOwnProperty(h) && this._removeGroup(h);else {
          var m = void 0;
          null != this.groupsData && (m = this.groupsData.get(h)), null == m && (m = {
            id: h,
            content: this.options.defaultGroup + h
          }), this._updateGroup(m, h), this.groups[h].setItems(i[h]);
        }
      }

      this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
        queue: !0
      });
    }
  }, Yf.prototype.redraw = function () {
    var t = !1;
    this.props.width = this.dom.frame.offsetWidth, this.props.height = this.body.domProps.centerContainer.height - this.body.domProps.border.top - this.body.domProps.border.bottom, t = this._isResized() || t;
    var e,
        i = this.body.range.end - this.body.range.start,
        n = i != this.lastVisibleInterval;
    (this.lastVisibleInterval = i, 1 == t) && (this.svg.style.width = od.option.asSize(3 * this.props.width), this.svg.style.left = od.option.asSize(-this.props.width), -1 == qn(e = this.options.height + "").call(e, "%") && 1 != this.updateSVGheightOnResize || (this.updateSVGheight = !0));
    if (1 == this.updateSVGheight ? (this.options.graphHeight != this.props.height + "px" && (this.options.graphHeight = this.props.height + "px", this.svg.style.height = this.props.height + "px"), this.updateSVGheight = !1) : this.svg.style.height = ("" + this.options.graphHeight).replace("px", "") + "px", 1 == t || 1 == n || 1 == this.abortedGraphUpdate || 1 == this.forceGraphUpdate) t = this._updateGraph() || t, this.forceGraphUpdate = !1, this.lastStart = this.body.range.start, this.svg.style.left = -this.props.width + "px";else if (0 != this.lastStart) {
      var o = this.body.range.start - this.lastStart,
          r = this.body.range.end - this.body.range.start;

      if (0 != this.props.width) {
        var s = o * (this.props.width / r);
        this.svg.style.left = -this.props.width - s + "px";
      }
    }
    return this.legendLeft.redraw(), this.legendRight.redraw(), t;
  }, Yf.prototype._getSortedGroupIds = function () {
    var t = [];

    for (var e in this.groups) {
      if (this.groups.hasOwnProperty(e)) {
        var i = this.groups[e];
        1 != i.visible || void 0 !== this.options.groups.visibility[e] && 1 != this.options.groups.visibility[e] || t.push({
          id: e,
          zIndex: i.options.zIndex
        });
      }
    }

    od.insertSort(t, function (t, e) {
      var i = t.zIndex,
          n = e.zIndex;
      return void 0 === i && (i = 0), void 0 === n && (n = 0), i == n ? 0 : i < n ? -1 : 1;
    });

    for (var n = new Array(t.length), o = 0; o < t.length; o++) {
      n[o] = t[o].id;
    }

    return n;
  }, Yf.prototype._updateGraph = function () {
    if (nh(this.svgElements), 0 != this.props.width && null != this.itemsData) {
      var t,
          e,
          i = {},
          n = this.body.util.toGlobalTime(-this.body.domProps.root.width),
          o = this.body.util.toGlobalTime(2 * this.body.domProps.root.width),
          r = this._getSortedGroupIds();

      if (r.length > 0) {
        var s = {};

        for (this._getRelevantData(r, s, n, o), this._applySampling(r, s), e = 0; e < r.length; e++) {
          this._convertXcoordinates(s[r[e]]);
        }

        if (this._getYRanges(r, s, i), 1 == this._updateYAxis(r, i)) return oh(this.svgElements), this.abortedGraphUpdate = !0, !0;
        this.abortedGraphUpdate = !1;
        var a = void 0;

        for (e = 0; e < r.length; e++) {
          t = this.groups[r[e]], !0 === this.options.stack && "line" === this.options.style && (null != t.options.excludeFromStacking && t.options.excludeFromStacking || (null != a && (this._stack(s[t.id], s[a.id]), 1 == t.options.shaded.enabled && "group" !== t.options.shaded.orientation && ("top" == t.options.shaded.orientation && "group" !== a.options.shaded.orientation ? (a.options.shaded.orientation = "group", a.options.shaded.groupId = t.id) : (t.options.shaded.orientation = "group", t.options.shaded.groupId = a.id))), a = t)), this._convertYcoordinates(s[r[e]], t);
        }

        var l = {};

        for (e = 0; e < r.length; e++) {
          if ("line" === (t = this.groups[r[e]]).options.style && 1 == t.options.shaded.enabled) {
            var h = s[r[e]];
            if (null == h || 0 == h.length) continue;

            if (l.hasOwnProperty(r[e]) || (l[r[e]] = If.calcPath(h, t)), "group" === t.options.shaded.orientation) {
              var u = t.options.shaded.groupId;

              if (-1 === qn(r).call(r, u)) {
                console.log(t.id + ": Unknown shading group target given:" + u);
                continue;
              }

              l.hasOwnProperty(u) || (l[u] = If.calcPath(s[u], this.groups[u])), If.drawShading(l[r[e]], t, l[u], this.framework);
            } else If.drawShading(l[r[e]], t, void 0, this.framework);
          }
        }

        for (Lf.draw(r, s, this.framework), e = 0; e < r.length; e++) {
          if (t = this.groups[r[e]], s[r[e]].length > 0) switch (t.options.style) {
            case "line":
              l.hasOwnProperty(r[e]) || (l[r[e]] = If.calcPath(s[r[e]], t)), If.draw(l[r[e]], t, this.framework);

            case "point":
            case "points":
              "point" != t.options.style && "points" != t.options.style && 1 != t.options.drawPoints.enabled || Pf.draw(s[r[e]], t, this.framework);
          }
        }
      }
    }

    return oh(this.svgElements), !1;
  }, Yf.prototype._stack = function (t, e) {
    var i, n, o, r, s;
    i = 0;

    for (var a = 0; a < t.length; a++) {
      r = void 0, s = void 0;

      for (var l = i; l < e.length; l++) {
        if (e[l].x === t[a].x) {
          r = e[l], s = e[l], i = l;
          break;
        }

        if (e[l].x > t[a].x) {
          s = e[l], r = 0 == l ? s : e[l - 1], i = l;
          break;
        }
      }

      void 0 === s && (r = e[e.length - 1], s = e[e.length - 1]), n = s.x - r.x, o = s.y - r.y, t[a].y = 0 == n ? t[a].orginalY + s.y : t[a].orginalY + o / n * (t[a].x - r.x) + r.y;
    }
  }, Yf.prototype._getRelevantData = function (t, e, i, n) {
    var o, r, s, a;
    if (t.length > 0) for (r = 0; r < t.length; r++) {
      var l = (o = this.groups[t[r]]).getItems();

      if (1 == $h(o.options)) {
        var h = function h(t, e) {
          return t.getTime() == e.getTime() ? 0 : t < e ? -1 : 1;
        },
            u = Math.max(0, od.binarySearchValue(l, i, "x", "before", h)),
            c = Math.min(l.length, od.binarySearchValue(l, n, "x", "after", h) + 1);

        c <= 0 && (c = l.length);
        var d = new Array(c - u);

        for (s = u; s < c; s++) {
          a = o.itemsData[s], d[s - u] = a;
        }

        e[t[r]] = d;
      } else e[t[r]] = o.itemsData;
    }
  }, Yf.prototype._applySampling = function (t, e) {
    if (t.length > 0) for (var i = 0; i < t.length; i++) {
      if (1 == this.groups[t[i]].options.sampling) {
        var n = e[t[i]];

        if (n.length > 0) {
          var o,
              r = n.length,
              s = r / (this.body.util.toGlobalScreen(n[n.length - 1].x) - this.body.util.toGlobalScreen(n[0].x));
          o = Math.min(Math.ceil(.2 * r), Math.max(1, Math.round(s)));

          for (var a = new Array(r), l = 0; l < r; l += o) {
            a[Math.round(l / o)] = n[l];
          }

          e[t[i]] = Bo(a).call(a, 0, Math.round(r / o));
        }
      }
    }
  }, Yf.prototype._getYRanges = function (t, e, i) {
    var n,
        o,
        r,
        s,
        a = [],
        l = [];

    if (t.length > 0) {
      for (r = 0; r < t.length; r++) {
        n = e[t[r]], s = this.groups[t[r]].options, n.length > 0 && (o = this.groups[t[r]], !0 === s.stack && "bar" === s.style ? "left" === s.yAxisOrientation ? a = us(a).call(a, n) : l = us(l).call(l, n) : i[t[r]] = o.getYRange(n, t[r]));
      }

      Lf.getStackedYRange(a, i, t, "__barStackLeft", "left"), Lf.getStackedYRange(l, i, t, "__barStackRight", "right");
    }
  }, Yf.prototype._updateYAxis = function (t, e) {
    var i,
        n,
        o = !1,
        r = !1,
        s = !1,
        a = 1e9,
        l = 1e9,
        h = -1e9,
        u = -1e9;

    if (t.length > 0) {
      for (var c = 0; c < t.length; c++) {
        var d = this.groups[t[c]];
        d && "right" != d.options.yAxisOrientation ? (r = !0, a = 1e9, h = -1e9) : d && d.options.yAxisOrientation && (s = !0, l = 1e9, u = -1e9);
      }

      for (c = 0; c < t.length; c++) {
        e.hasOwnProperty(t[c]) && !0 !== e[t[c]].ignore && (i = e[t[c]].min, n = e[t[c]].max, "right" != e[t[c]].yAxisOrientation ? (r = !0, a = a > i ? i : a, h = h < n ? n : h) : (s = !0, l = l > i ? i : l, u = u < n ? n : u));
      }

      1 == r && this.yAxisLeft.setRange(a, h), 1 == s && this.yAxisRight.setRange(l, u);
    }

    o = this._toggleAxisVisiblity(r, this.yAxisLeft) || o, o = this._toggleAxisVisiblity(s, this.yAxisRight) || o, 1 == s && 1 == r ? (this.yAxisLeft.drawIcons = !0, this.yAxisRight.drawIcons = !0) : (this.yAxisLeft.drawIcons = !1, this.yAxisRight.drawIcons = !1), this.yAxisRight.master = !r, this.yAxisRight.masterAxis = this.yAxisLeft, 0 == this.yAxisRight.master ? (this.yAxisLeft.lineOffset = 1 == s ? this.yAxisRight.width : 0, o = this.yAxisLeft.redraw() || o, o = this.yAxisRight.redraw() || o) : o = this.yAxisRight.redraw() || o;
    var p = ["__barStackLeft", "__barStackRight", "__lineStackLeft", "__lineStackRight"];

    for (c = 0; c < p.length; c++) {
      -1 != qn(t).call(t, p[c]) && Bo(t).call(t, qn(t).call(t, p[c]), 1);
    }

    return o;
  }, Yf.prototype._toggleAxisVisiblity = function (t, e) {
    var i = !1;
    return 0 == t ? e.dom.frame.parentNode && 0 == e.hidden && (e.hide(), i = !0) : e.dom.frame.parentNode || 1 != e.hidden || (e.show(), i = !0), i;
  }, Yf.prototype._convertXcoordinates = function (t) {
    for (var e = this.body.util.toScreen, i = 0; i < t.length; i++) {
      t[i].screen_x = e(t[i].x) + this.props.width, t[i].screen_y = t[i].y, null != t[i].end ? t[i].screen_end = e(t[i].end) + this.props.width : t[i].screen_end = void 0;
    }
  }, Yf.prototype._convertYcoordinates = function (t, e) {
    var i = this.yAxisLeft,
        n = Number(this.svg.style.height.replace("px", ""));
    "right" == e.options.yAxisOrientation && (i = this.yAxisRight);

    for (var o = 0; o < t.length; o++) {
      t[o].screen_y = Math.round(i.convertValue(t[o].y));
    }

    e.setZeroPosition(Math.min(n, i.convertValue(0)));
  };
  var jf = "string",
      Hf = "boolean",
      zf = "number",
      Gf = "date",
      Wf = "object",
      Bf = "moment",
      Vf = {
    configure: {
      enabled: {
        boolean: Hf
      },
      filter: {
        boolean: Hf,
        function: "function"
      },
      container: {
        dom: "dom"
      },
      __type__: {
        object: Wf,
        boolean: Hf,
        function: "function"
      }
    },
    alignCurrentTime: {
      string: jf,
      undefined: "undefined"
    },
    yAxisOrientation: {
      string: ["left", "right"]
    },
    defaultGroup: {
      string: jf
    },
    sort: {
      boolean: Hf
    },
    sampling: {
      boolean: Hf
    },
    stack: {
      boolean: Hf
    },
    graphHeight: {
      string: jf,
      number: zf
    },
    shaded: {
      enabled: {
        boolean: Hf
      },
      orientation: {
        string: ["bottom", "top", "zero", "group"]
      },
      groupId: {
        object: Wf
      },
      __type__: {
        boolean: Hf,
        object: Wf
      }
    },
    style: {
      string: ["line", "bar", "points"]
    },
    barChart: {
      width: {
        number: zf
      },
      minWidth: {
        number: zf
      },
      sideBySide: {
        boolean: Hf
      },
      align: {
        string: ["left", "center", "right"]
      },
      __type__: {
        object: Wf
      }
    },
    interpolation: {
      enabled: {
        boolean: Hf
      },
      parametrization: {
        string: ["centripetal", "chordal", "uniform"]
      },
      alpha: {
        number: zf
      },
      __type__: {
        object: Wf,
        boolean: Hf
      }
    },
    drawPoints: {
      enabled: {
        boolean: Hf
      },
      onRender: {
        function: "function"
      },
      size: {
        number: zf
      },
      style: {
        string: ["square", "circle"]
      },
      __type__: {
        object: Wf,
        boolean: Hf,
        function: "function"
      }
    },
    dataAxis: {
      showMinorLabels: {
        boolean: Hf
      },
      showMajorLabels: {
        boolean: Hf
      },
      showWeekScale: {
        boolean: Hf
      },
      icons: {
        boolean: Hf
      },
      width: {
        string: jf,
        number: zf
      },
      visible: {
        boolean: Hf
      },
      alignZeros: {
        boolean: Hf
      },
      left: {
        range: {
          min: {
            number: zf,
            undefined: "undefined"
          },
          max: {
            number: zf,
            undefined: "undefined"
          },
          __type__: {
            object: Wf
          }
        },
        format: {
          function: "function"
        },
        title: {
          text: {
            string: jf,
            number: zf,
            undefined: "undefined"
          },
          style: {
            string: jf,
            undefined: "undefined"
          },
          __type__: {
            object: Wf
          }
        },
        __type__: {
          object: Wf
        }
      },
      right: {
        range: {
          min: {
            number: zf,
            undefined: "undefined"
          },
          max: {
            number: zf,
            undefined: "undefined"
          },
          __type__: {
            object: Wf
          }
        },
        format: {
          function: "function"
        },
        title: {
          text: {
            string: jf,
            number: zf,
            undefined: "undefined"
          },
          style: {
            string: jf,
            undefined: "undefined"
          },
          __type__: {
            object: Wf
          }
        },
        __type__: {
          object: Wf
        }
      },
      __type__: {
        object: Wf
      }
    },
    legend: {
      enabled: {
        boolean: Hf
      },
      icons: {
        boolean: Hf
      },
      left: {
        visible: {
          boolean: Hf
        },
        position: {
          string: ["top-right", "bottom-right", "top-left", "bottom-left"]
        },
        __type__: {
          object: Wf
        }
      },
      right: {
        visible: {
          boolean: Hf
        },
        position: {
          string: ["top-right", "bottom-right", "top-left", "bottom-left"]
        },
        __type__: {
          object: Wf
        }
      },
      __type__: {
        object: Wf,
        boolean: Hf
      }
    },
    groups: {
      visibility: {
        any: "any"
      },
      __type__: {
        object: Wf
      }
    },
    autoResize: {
      boolean: Hf
    },
    throttleRedraw: {
      number: zf
    },
    clickToUse: {
      boolean: Hf
    },
    end: {
      number: zf,
      date: Gf,
      string: jf,
      moment: Bf
    },
    format: {
      minorLabels: {
        millisecond: {
          string: jf,
          undefined: "undefined"
        },
        second: {
          string: jf,
          undefined: "undefined"
        },
        minute: {
          string: jf,
          undefined: "undefined"
        },
        hour: {
          string: jf,
          undefined: "undefined"
        },
        weekday: {
          string: jf,
          undefined: "undefined"
        },
        day: {
          string: jf,
          undefined: "undefined"
        },
        week: {
          string: jf,
          undefined: "undefined"
        },
        month: {
          string: jf,
          undefined: "undefined"
        },
        quarter: {
          string: jf,
          undefined: "undefined"
        },
        year: {
          string: jf,
          undefined: "undefined"
        },
        __type__: {
          object: Wf
        }
      },
      majorLabels: {
        millisecond: {
          string: jf,
          undefined: "undefined"
        },
        second: {
          string: jf,
          undefined: "undefined"
        },
        minute: {
          string: jf,
          undefined: "undefined"
        },
        hour: {
          string: jf,
          undefined: "undefined"
        },
        weekday: {
          string: jf,
          undefined: "undefined"
        },
        day: {
          string: jf,
          undefined: "undefined"
        },
        week: {
          string: jf,
          undefined: "undefined"
        },
        month: {
          string: jf,
          undefined: "undefined"
        },
        quarter: {
          string: jf,
          undefined: "undefined"
        },
        year: {
          string: jf,
          undefined: "undefined"
        },
        __type__: {
          object: Wf
        }
      },
      __type__: {
        object: Wf
      }
    },
    moment: {
      function: "function"
    },
    height: {
      string: jf,
      number: zf
    },
    hiddenDates: {
      start: {
        date: Gf,
        number: zf,
        string: jf,
        moment: Bf
      },
      end: {
        date: Gf,
        number: zf,
        string: jf,
        moment: Bf
      },
      repeat: {
        string: jf
      },
      __type__: {
        object: Wf,
        array: "array"
      }
    },
    locale: {
      string: jf
    },
    locales: {
      __any__: {
        any: "any"
      },
      __type__: {
        object: Wf
      }
    },
    max: {
      date: Gf,
      number: zf,
      string: jf,
      moment: Bf
    },
    maxHeight: {
      number: zf,
      string: jf
    },
    maxMinorChars: {
      number: zf
    },
    min: {
      date: Gf,
      number: zf,
      string: jf,
      moment: Bf
    },
    minHeight: {
      number: zf,
      string: jf
    },
    moveable: {
      boolean: Hf
    },
    multiselect: {
      boolean: Hf
    },
    orientation: {
      string: jf
    },
    showCurrentTime: {
      boolean: Hf
    },
    showMajorLabels: {
      boolean: Hf
    },
    showMinorLabels: {
      boolean: Hf
    },
    showWeekScale: {
      boolean: Hf
    },
    snap: {
      function: "function",
      null: "null"
    },
    start: {
      date: Gf,
      number: zf,
      string: jf,
      moment: Bf
    },
    timeAxis: {
      scale: {
        string: jf,
        undefined: "undefined"
      },
      step: {
        number: zf,
        undefined: "undefined"
      },
      __type__: {
        object: Wf
      }
    },
    width: {
      string: jf,
      number: zf
    },
    zoomable: {
      boolean: Hf
    },
    zoomKey: {
      string: ["ctrlKey", "altKey", "metaKey", ""]
    },
    zoomMax: {
      number: zf
    },
    zoomMin: {
      number: zf
    },
    zIndex: {
      number: zf
    },
    __type__: {
      object: Wf
    }
  },
      Uf = {
    global: {
      alignCurrentTime: ["none", "year", "month", "quarter", "week", "isoWeek", "day", "date", "hour", "minute", "second"],
      sort: !0,
      sampling: !0,
      stack: !1,
      shaded: {
        enabled: !1,
        orientation: ["zero", "top", "bottom", "group"]
      },
      style: ["line", "bar", "points"],
      barChart: {
        width: [50, 5, 100, 5],
        minWidth: [50, 5, 100, 5],
        sideBySide: !1,
        align: ["left", "center", "right"]
      },
      interpolation: {
        enabled: !0,
        parametrization: ["centripetal", "chordal", "uniform"]
      },
      drawPoints: {
        enabled: !0,
        size: [6, 2, 30, 1],
        style: ["square", "circle"]
      },
      dataAxis: {
        showMinorLabels: !0,
        showMajorLabels: !0,
        showWeekScale: !1,
        icons: !1,
        width: [40, 0, 200, 1],
        visible: !0,
        alignZeros: !0,
        left: {
          title: {
            text: "",
            style: ""
          }
        },
        right: {
          title: {
            text: "",
            style: ""
          }
        }
      },
      legend: {
        enabled: !1,
        icons: !0,
        left: {
          visible: !0,
          position: ["top-right", "bottom-right", "top-left", "bottom-left"]
        },
        right: {
          visible: !0,
          position: ["top-right", "bottom-right", "top-left", "bottom-left"]
        }
      },
      autoResize: !0,
      clickToUse: !1,
      end: "",
      format: {
        minorLabels: {
          millisecond: "SSS",
          second: "s",
          minute: "HH:mm",
          hour: "HH:mm",
          weekday: "ddd D",
          day: "D",
          week: "w",
          month: "MMM",
          quarter: "[Q]Q",
          year: "YYYY"
        },
        majorLabels: {
          millisecond: "HH:mm:ss",
          second: "D MMMM HH:mm",
          minute: "ddd D MMMM",
          hour: "ddd D MMMM",
          weekday: "MMMM YYYY",
          day: "MMMM YYYY",
          week: "MMMM YYYY",
          month: "YYYY",
          quarter: "YYYY",
          year: ""
        }
      },
      height: "",
      locale: "",
      max: "",
      maxHeight: "",
      maxMinorChars: [7, 0, 20, 1],
      min: "",
      minHeight: "",
      moveable: !0,
      orientation: ["both", "bottom", "top"],
      showCurrentTime: !1,
      showMajorLabels: !0,
      showMinorLabels: !0,
      showWeekScale: !1,
      start: "",
      width: "100%",
      zoomable: !0,
      zoomKey: ["ctrlKey", "altKey", "metaKey", ""],
      zoomMax: [31536e10, 10, 31536e10, 1],
      zoomMin: [10, 10, 31536e10, 1],
      zIndex: 0
    }
  };

  function Xf(t, e, i, n) {
    var o, r, s, a, l, h, u;

    if (!Jr(i) && !Ju("id", i) && i instanceof Object) {
      var c = n;
      n = i, i = c;
    }

    n && n.throttleRedraw && console.warn('Graph2d option "throttleRedraw" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.');
    var d = this;
    this.defaultOptions = {
      start: null,
      end: null,
      autoResize: !0,
      orientation: {
        axis: "bottom",
        item: "bottom"
      },
      moment: Qu,
      width: null,
      height: null,
      maxHeight: null,
      minHeight: null
    }, this.options = od.deepExtend({}, this.defaultOptions), this._create(t), this.components = [], this.body = {
      dom: this.dom,
      domProps: this.props,
      emitter: {
        on: ur(o = this.on).call(o, this),
        off: ur(r = this.off).call(r, this),
        emit: ur(s = this.emit).call(s, this)
      },
      hiddenDates: [],
      util: {
        getScale: function getScale() {
          return d.timeAxis.step.scale;
        },
        getStep: function getStep() {
          return d.timeAxis.step.step;
        },
        toScreen: ur(a = d._toScreen).call(a, d),
        toGlobalScreen: ur(l = d._toGlobalScreen).call(l, d),
        toTime: ur(h = d._toTime).call(h, d),
        toGlobalTime: ur(u = d._toGlobalTime).call(u, d)
      }
    }, this.range = new Md(this.body), this.components.push(this.range), this.body.range = this.range, this.timeAxis = new Fd(this.body), this.components.push(this.timeAxis), this.currentTime = new np(this.body), this.components.push(this.currentTime), this.linegraph = new Yf(this.body), this.components.push(this.linegraph), this.itemsData = null, this.groupsData = null, this.on("tap", function (t) {
      d.emit("click", d.getEventProperties(t));
    }), this.on("doubletap", function (t) {
      d.emit("doubleClick", d.getEventProperties(t));
    }), this.dom.root.oncontextmenu = function (t) {
      d.emit("contextmenu", d.getEventProperties(t));
    }, this.initialFitDone = !1, this.on("changed", function () {
      if (null != d.itemsData) {
        if (!d.initialFitDone && !d.options.rollingMode) if (d.initialFitDone = !0, null != d.options.start || null != d.options.end) {
          if (null == d.options.start || null == d.options.end) var t = d.getItemRange();
          var e = null != d.options.start ? d.options.start : t.min,
              i = null != d.options.end ? d.options.end : t.max;
          d.setWindow(e, i, {
            animation: !1
          });
        } else d.fit({
          animation: !1
        });
        d.initialDrawDone || !d.initialRangeChangeDone && (d.options.start || d.options.end) && !d.options.rollingMode || (d.initialDrawDone = !0, d.dom.root.style.visibility = "visible", d.dom.loadingScreen.parentNode.removeChild(d.dom.loadingScreen), d.options.onInitialDrawComplete && hn(function () {
          return d.options.onInitialDrawComplete();
        }, 0));
      }
    }), n && this.setOptions(n), i && this.setGroups(i), e && this.setItems(e), this._redraw();
  }

  Xf.prototype = new ep(), Xf.prototype.setOptions = function (t) {
    !0 === lf.validate(t, Vf) && console.log("%cErrors have been found in the supplied options object.", af), ep.prototype.setOptions.call(this, t);
  }, Xf.prototype.setItems = function (t) {
    var e,
        i = null == this.itemsData;
    if (e = t ? Ju("id", e) ? nd(t) : nd(new $u(t)) : null, this.itemsData && this.itemsData.dispose(), this.itemsData = e, this.linegraph && this.linegraph.setItems(null != e ? e.rawDS : null), i) if (null != this.options.start || null != this.options.end) {
      var n = null != this.options.start ? this.options.start : null,
          o = null != this.options.end ? this.options.end : null;
      this.setWindow(n, o, {
        animation: !1
      });
    } else this.fit({
      animation: !1
    });
  }, Xf.prototype.setGroups = function (t) {
    var e;
    e = t ? Ju("id", t) ? t : new $u(t) : null, this.groupsData = e, this.linegraph.setGroups(e);
  }, Xf.prototype.getLegend = function (t, e, i) {
    return void 0 === e && (e = 15), void 0 === i && (i = 15), void 0 !== this.linegraph.groups[t] ? this.linegraph.groups[t].getLegend(e, i) : "cannot find group:'" + t + "'";
  }, Xf.prototype.isGroupVisible = function (t) {
    return void 0 !== this.linegraph.groups[t] && this.linegraph.groups[t].visible && (void 0 === this.linegraph.options.groups.visibility[t] || 1 == this.linegraph.options.groups.visibility[t]);
  }, Xf.prototype.getDataRange = function () {
    var t = null,
        e = null;

    for (var i in this.linegraph.groups) {
      if (this.linegraph.groups.hasOwnProperty(i) && 1 == this.linegraph.groups[i].visible) for (var n = 0; n < this.linegraph.groups[i].itemsData.length; n++) {
        var o = this.linegraph.groups[i].itemsData[n],
            r = od.convert(o.x, "Date").valueOf();
        t = null == t || t > r ? r : t, e = null == e || e < r ? r : e;
      }
    }

    return {
      min: null != t ? new Date(t) : null,
      max: null != e ? new Date(e) : null
    };
  }, Xf.prototype.getEventProperties = function (t) {
    var e = t.center ? t.center.x : t.clientX,
        i = t.center ? t.center.y : t.clientY,
        n = e - od.getAbsoluteLeft(this.dom.centerContainer),
        o = i - od.getAbsoluteTop(this.dom.centerContainer),
        r = this._toTime(n),
        s = tp.customTimeFromTarget(t),
        a = od.getTarget(t),
        l = null;

    od.hasParent(a, this.timeAxis.dom.foreground) || this.timeAxis2 && od.hasParent(a, this.timeAxis2.dom.foreground) ? l = "axis" : od.hasParent(a, this.linegraph.yAxisLeft.dom.frame) || od.hasParent(a, this.linegraph.yAxisRight.dom.frame) ? l = "data-axis" : od.hasParent(a, this.linegraph.legendLeft.dom.frame) || od.hasParent(a, this.linegraph.legendRight.dom.frame) ? l = "legend" : null != s ? l = "custom-time" : od.hasParent(a, this.currentTime.bar) ? l = "current-time" : od.hasParent(a, this.dom.center) && (l = "background");
    var h = [],
        u = this.linegraph.yAxisLeft,
        c = this.linegraph.yAxisRight;
    return !u.hidden && this.itemsData.length > 0 && h.push(u.screenToValue(o)), !c.hidden && this.itemsData.length > 0 && h.push(c.screenToValue(o)), {
      event: t,
      customTime: s ? s.options.id : null,
      what: l,
      pageX: t.srcEvent ? t.srcEvent.pageX : t.pageX,
      pageY: t.srcEvent ? t.srcEvent.pageY : t.pageY,
      x: n,
      y: o,
      time: r,
      value: h
    };
  }, Xf.prototype._createConfigurator = function () {
    return new _f(this, this.dom.container, Uf);
  }, console.warn(["This build has been deprecated.", "", "In case you are importing this through a URL it will result in a 404 eventually.", "In case you are importing this through Node it will be replaced by the peer build eventually.", "", "Please use the peer or standalone build instead.", "Peer: https://visjs.github.io/vis-timeline/examples/timeline/peer-build.html", "Standalone: https://visjs.github.io/vis-timeline/examples/timeline/standalone-build.html"].join("\n"));
  var qf = uh();
  Qu.locale(qf);
  var Zf = {
    Core: ep,
    DateUtil: Cd,
    Range: Md,
    stack: wp,
    TimeStep: Nd,
    components: {
      items: {
        Item: Mp,
        BackgroundItem: Rp,
        BoxItem: Ep,
        ClusterItem: Xp,
        PointItem: Ap,
        RangeItem: Ip
      },
      BackgroundGroup: Sp,
      Component: hd,
      CurrentTime: np,
      CustomTime: tp,
      DataAxis: Ef,
      DataScale: Cf,
      GraphGroup: Nf,
      Group: xp,
      ItemSet: of,
      Legend: Rf,
      LineGraph: Yf,
      TimeAxis: Fd
    }
  },
      $f = {
    util: ih,
    DOMutil: ch,
    DataSet: $u,
    DataView: Ku,
    Queue: Xu,
    Timeline: kf,
    Graph2d: Xf,
    timeline: Zf,
    moment: Qu,
    Hammer: Ld,
    keycharm: jd
  };
  t.DOMutil = ch, t.DataSet = $u, t.DataView = Ku, t.Graph2d = Xf, t.Hammer = Ld, t.Queue = Xu, t.Timeline = kf, t.default = $f, t.keycharm = jd, t.moment = Qu, t.timeline = Zf, t.util = ih, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});